/* J&M Electronics Andorra · la web (prototipo/v4, tema/construir.cjs). Contingut exclusiu de J&M / Contenido exclusivo de J&M. Web: SerVe Digital */
(() => {
const FACE_MAIN = window.__JM_D.FACE_MAIN;
const FACE_SKIN = window.__JM_D.FACE_SKIN;
const FACE_WINK = window.__JM_D.FACE_WINK;
const FACE_EYER = window.__JM_D.FACE_EYER;
const CAT = window.__JM_D.CATALOG;
/* ===== entorno.js ===== */
/* ---------- dónde corre la web: el simulador o la web de verdad (el tema de Shopify, tema/) ----------
   En el tema, la página trae window.JM_WEB (tema/layout/jm.liquid): dónde están las imágenes y la tienda en 3D, el idioma y la
   dirección de cada idioma, lo que pide la dirección abierta (un producto, una colección, una búsqueda…) y las páginas legales.
   En el simulador no está y todo sigue como siempre: las imágenes en sus carpetas, al lado, y lo que saldría de la web (WhatsApp,
   el mapa, la cuenta) solo enseña un aviso */
const REAL = (typeof window !== 'undefined' && window.JM_WEB) || null;
// una imagen de las que van con la web: en el simulador, en su carpeta (fotos/g, expositores/robo…); en el tema, en assets/ de
// Shopify, que no tiene carpetas: «jm-», la carpeta con guiones y el nombre (jm-expositores-robo-marca-apple.webp)
const recurso = (carpeta, nombre) => REAL ? `${REAL.assets}jm-${carpeta.replace(/\//g, '-')}-${nombre}.webp` : `${carpeta}/${nombre}.webp`;
// con el dedo (móvil o tableta), WhatsApp se abre directamente; con ratón, el QR (contacto.js)
const conDedo = () => !matchMedia('(hover: hover) and (pointer: fine)').matches;
// en el tema, la web ocupa la pantalla entera y se monta para móvil o para ordenador según el ancho al entrar (como el simulador
// en un móvil de verdad)
if (REAL) document.querySelectorAll('.jmx4 .site').forEach(site => {
  const movil = matchMedia('(max-width: 700px)').matches;
  site.classList.add(movil ? 'phone' : 'desk');
  site.dataset.inst = movil ? 'phone' : 'desk';
});

/* ===== i18n-fr.js ===== */
/* ---------- textos en francés (Sergio, 21 oct: «falta en francés y en inglés») ----------
   La misma forma que T.es de i18n.js (que los junta): si cambia un texto allí, cambia aquí.
   Los nombres de los productos, los de Shopify; los mensajes de WhatsApp, en francés (el bot contesta en el idioma del cliente) */
const T_FR = {
  z: {mobils:'Téléphones', tv:'Téléviseurs', tabrel:'Tablettes et montres', so:'Son', consoles:'Consoles', drons:'Drones et caméras', llar:'Maison et plus',
      port:'Ordinateurs portables', sobre:'Ordinateurs fixes et écrans', emmag:'Stockage', impr:'Imprimantes', comp:'Composants et accessoires',
      taulell:'Comptoir', taulell1:'Comptoir', marcas:'Marques',
      nov:'Nouveautés', apple:'Apple', acc:'Accessoires', mac:'Mac', sat:'Service technique', tel:'Andorra Telecom'},
  store:{pb:'Électronique', b1:'Informatique'}, fl:{pb:'Rez-de-chaussée', b1:'Étage −1'},
  s1:'On vous dit ce qui vous convient.', s2:'Pas le plus cher.', hsub:'Électronique et informatique à l\'Illa Carlemany.',
  wa:'Écrivez-nous sur WhatsApp', waS:'Écrivez-nous',
  open:c => `Ouvert aujourd'hui jusqu'à ${c}`, closed:o => `Fermé maintenant · nous ouvrons à ${o}`, where:'Où nous trouver',
  hint:'Descendez et la boutique se monte toute seule ↓',
  n:n => `${n} ${n === 1 ? 'produit' : 'produits'}`, nb:n => `${n} marques`,
  brandsCap:'Marques, de A à Z', brandsAll:n => `Voir les ${n} →`,
  sign:'Informatique −1', cap:'Touchez une zone pour entrer', capFloors:'En haut, le rez-de-chaussée. En bas, l\'étage −1.', capAll:'Nos deux boutiques de l\'Illa Carlemany', lang:'Langue', newT:'Nouveautés',
  ft1:'J&M · Électronique et Informatique · Andorre', ft2:'Site conçu par SerVe Digital',
  satSub:'Réparations',
  ven:'Seulement 4,5 % d\'IGI · Livraison en Espagne en 3-5 jours · Garantie de 2 ans',
  cuenta:'Votre compte',
  menu:'Menu', legales:'Conditions', noExiste:'Cette page n\'existe plus. Nous vous avons ramené à l\'accueil.',
  legal:[['envios-y-devoluciones', 'Livraison et retours'], ['formas-de-pago', 'Moyens de paiement'], ['informacion', 'Informations et garantie'], ['condiciones', 'Conditions de vente'], ['privacidad', 'Confidentialité']],
  ficha:{cap:'Capacité', color:'Couleur', igi:'IGI de 4,5 % inclus', chip:(chip, c, g) => `${chip ? `Puce ${chip} avec ` : ''}CPU ${c} cœurs et GPU ${g} cœurs`, wa:'Commander sur WhatsApp', waCorto:'Commander',
    msg:(que, precio) => `Bonjour, je suis intéressé par : ${que} (${precio}). Vous l'avez ?`,
    sinStock:'En rupture de stock pour le moment', sinStockCorto:'Rupture de stock', preguntar:'Demandez-nous sur WhatsApp', preguntarCorto:'Demandez-nous',
    msgSinStock:que => `Bonjour, je suis intéressé par : ${que}. Le site indique qu'il est en rupture de stock. Quand l'aurez-vous ?`,
    envio:'Livraison en Espagne en 3-5 jours.', garantia:'Garantie de 2 ans.', enTienda:'Vous préférez l\'acheter en boutique ?', tienda:'Voir où se trouve le comptoir →', saber:'Ce qu\'il faut savoir',
    protege:'Protégez-le dès le premier jour', un:'Un', una:'Une',
    lead:(n, pro, funda, tipo) => `Votre ${n} est un investissement : ${[pro && (tipo === 'plegable' ? 'un protecteur pour l\'écran extérieur ?' : tipo === 'reloj' ? 'des protecteurs d\'écran ? Vous en avez 9 pour le prix d\'un.' : 'un protecteur d\'écran ?'), funda && (pro ? 'Et une coque ?' : 'une coque ?')].filter(Boolean).join(' ')}`,
    pantalla:{reloj:'9 unités', plegable:'écran extérieur'}, clasesPantalla:{reloj:'Protecteur d\'écran (lot de 9)', plegable:'Protecteur de l\'écran extérieur'},
    razon:{protector:'Contre les rayures et les traces, sans perdre en netteté ni en toucher.', pack:'Coque et verre trempé en un pack : contre les chocs et les rayures du quotidien.', basica:'Contre les chocs du quotidien.',
      magnetica:'Magnétique : compatible avec les chargeurs et supports magnétiques.', anilla:'Avec anneau, pour le tenir d\'un doigt.', tapa:'À rabat : protège aussi l\'écran.', silicona:'Douce au toucher et fine.',
      uag:'Renforcée, pour les chocs violents.', apple:'Celle d\'Apple, en tissu et avec MagSafe.', medida:'Sur mesure pour votre téléphone.', watchcase:'Contre les chocs sur les bords et sur l\'écran.',
      teclado:'Avec clavier Bluetooth : pour écrire comme sur un ordinateur portable.', folio:'Le rabat se plie et sert de support pour la poser debout.',
      apple20:'Vous avez un chargeur ? La boîte de l\'iPhone ne contient que le câble.', apple40:m => `Charge rapide : jusqu'à 50 % en environ ${m} minutes, selon Apple.`, apple40mas:'Plus de puissance : il charge aussi l\'iPad ou le Mac.',
      cargador:'Vous avez un chargeur ? C\'est celui qu\'il lui faut.', samsungCable:'Vous avez un chargeur ? Celui-ci est livré avec son câble.', samsung45:'Charge ultra-rapide sur les Galaxy compatibles.',
      variantes:{'Protector Esencial':'Le basique : contre les rayures et les traces, sans perdre en netteté.', Hidrogel:'Film fin et souple qui couvre l\'écran jusqu\'au bord.', UltraShield:'Plus résistant aux chocs et aux rayures.',
        'Antiespía':'De côté, personne ne voit votre écran.', 'Hidrogel UV':'Hydrogel renforcé, plus ferme.', 'Hidrogel antiespía':'Hydrogel avec filtre de confidentialité : l\'écran ne se voit pas de côté.', 'Cristal Templado':'Verre trempé : dur et lisse au toucher.', 'Cristal templado':'Verre trempé : dur et lisse au toucher.'}},
    clases:{protector:'Protecteur d\'écran', phonecase:'Coque', tabletcase:'Étui', charger:'Chargeur', watchcase:'Coque de montre'},
    tipos:{pack:'Pack coque + verre', magnetica:'Magnétique', anilla:'Avec anneau', tapa:'À rabat', silicona:'En silicone', uag:'UAG renforcée', apple:'Apple avec MagSafe', teclado:'Avec clavier', folio:'Folio',
      basica:'Simple', medida:'Sur mesure', apple20:'Apple 20 W', apple40:'Apple 40 W', samsungCable:'Samsung avec câble', samsung45:'Samsung 45 W'},
    colores:{transparente:'transparente', negra:'noire', rosa:'rose', azul:'bleue', roja:'rouge', menta:'menthe', gris:'grise'},
    variante:o => ({'Protector Esencial':'Protecteur essentiel', Hidrogel:'Hydrogel', 'Antiespía':'Confidentialité', 'Hidrogel UV':'Hydrogel UV', 'Hidrogel antiespía':'Hydrogel confidentialité', 'Cristal Templado':'Verre trempé', 'Cristal templado':'Verre trempé'})[o] || o,
    anadir:'Ajouter', yaEnBolsa:'Dans votre sac', completa:'Pour le compléter', tambien:'Avec lui, aussi', otros:v => `Plus de ${v}`, volver:z => `← Retour à ${z}`, atras:'← Retour', busqueda:'la recherche'},
  ck:{titulo:'Cookies', txt:'Chez J&M, nous utilisons nos propres cookies et ceux de Shopify, la plateforme de la boutique : certains pour que le site fonctionne et d\'autres, si vous l\'acceptez, pour mesurer les visites.',
    no:'Refuser', si:'Accepter', cfg:'Paramétrer', mas:'Politique de cookies', guardar:'Enregistrer',
    nec:'Nécessaires', necT:'pour que le site fonctionne (toujours actifs)', est:'Statistiques', estT:'pour mesurer les visites'},
  tel:{crumb:'Boutique · Andorra Telecom', title:'Andorra Telecom', sub:'Cartes prépayées',
    lead:'Votre carte prépayée Andorra Telecom, dans notre boutique de l\'étage −1. Pour l\'activer, il nous faut votre carte d\'identité ou votre passeport.',
    what:'Forfaits prépayés', tarifas:[['Forfait S', '10 € par mois', '3 Go · 40 minutes · 10 SMS'], ['Forfait M', '20 € par mois', '12 Go · 100 minutes · 10 SMS']],
    nota:'Prix IGI inclus. Forfaits d\'Andorra Telecom en octobre 2026.', where:'Où l\'obtenir'},
  usado:{crumb:'Boutique · Occasion', title:'Occasion', lead:'Vous cherchez un appareil d\'occasion ? Dites-nous lequel et nous le cherchons pour vous.',
    how:'Comment ça marche', howL:[['1', 'Écrivez-nous sur WhatsApp avec l\'appareil que vous cherchez.'], ['2', 'Nous vous disons si nous pouvons l\'obtenir, combien il coûte et quand il arrive.'], ['3', 'Nous vous le réservons et vous le récupérez en boutique.']],
    wa:'Écrivez-nous sur WhatsApp', msg:'Bonjour, je cherche d\'occasion : …', link:'Vous le cherchez d\'occasion ? Écrivez-nous →'},
  sub:'Voir →', subT:'Écrivez-nous →', subSat:'Demandez un devis →',
  sat: {
    crumb:'Boutique · Étage −1 · Service technique', title:'Service technique',
    lead:'Nous le réparons ici, à l\'étage −1 (J&M Informàtica i Serveis). La plupart des réparations d\'iPhone, de Mac et d\'autres appareils se font le jour même.',
    img:'Un technicien de J&M en train de réparer un téléphone',
    what:'Ce que nous réparons', whatL:[['Téléphones', 'iPhone et autres marques. La plupart des réparations, le jour même.'], ['Tablettes', 'iPad et autres marques.'], ['Ordinateurs portables et fixes', 'Mac et PC de toutes marques.'], ['Téléviseurs', 'Nous réparons aussi les téléviseurs.'], ['Changement de disque dur', 'Nous vous en installons un neuf.'], ['Formatage et logiciels', 'Nous formatons le système et installons les logiciels dont vous avez besoin.']],
    how:'Comment demander un devis', howL:[['1', 'Écrivez-nous sur WhatsApp avec le modèle et la panne.'], ['2', 'Nous vous disons combien ça coûte et quand ce sera prêt.'], ['3', 'Vous l\'apportez à l\'étage −1 et nous nous y mettons.']],
    pb:'Écran ou batterie d\'iPhone', pbT:'Nous le changeons rapidement, avec des écrans et des batteries homologués et garantis. Demandez-nous le prix sur WhatsApp.',
    where:'Où nous trouver', wa:'Demandez un devis sur WhatsApp', msg:'Bonjour, je voudrais un devis pour une réparation. L\'appareil est : …'
  },
  back:'← Retour à la boutique', brand:'Marque', secL:'Rayon', all:'Toutes', sort:'Trier', sTop:'En vedette', sNew:'Nouveautés', sAsc:'Prix croissant', sDesc:'Prix décroissant',
  more:n => `Voir plus · encore ${n}`, ask:'Écrivez-nous →', shop:'Boutique',
  cnt:(n, b) => `${n} ${n === 1 ? 'produit' : 'produits'}${b ? ' de ' + b : ''}`,
  chip:'Ce que vous cherchez', whereB:'Où le trouver dans la boutique', dirSub:n => `${n} marques, de A à Z`,
  sres:q => `Résultats pour « ${q} »`, snone:'Nous ne l\'avons pas sur le site. Voulez-vous qu\'on vous le trouve ?',
  days:['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],

  about: {
    title:'Qui sommes-nous', crumb:'Boutique · Qui sommes-nous',
    lead:'J&M Electronics Store et J&M Informàtica i Serveis : deux espaces spécialisés au sein du centre commercial Illa Carlemany, le cœur commerçant de l\'Andorre.',
    hist:'Notre histoire',
    histP:'Depuis nos ouvertures en 2009 (Electronics) et en 2013 (Informàtica), nous avons accompagné des milliers de clients à la recherche de technologie officielle, de prix justes et d\'un service vraiment proche.',
    line:[['2009', 'Ouverture de J&M Electronics Store, au rez-de-chaussée de l\'Illa Carlemany.'], ['2013', 'Ouverture de J&M Informàtica i Serveis, à l\'étage −1.'], ['Aujourd\'hui', 'Deux boutiques et ce site, avec le même accueil.']],
    purpose:'Notre mission',
    purposeP:'Que vous vous sentiez comme chez vous, en boutique ou sur ce site, et que vous trouviez la solution à ce dont vous avez besoin : acheter, réserver, réparer ou simplement être conseillé.',
    diff:'Ce qui nous rend différents',
    diffL:[['Un service personnalisé', 'Une équipe experte qui répond vite et parle clair.'], ['Réparations express', 'La plupart des réparations d\'iPhone, de Mac et d\'autres appareils se font le jour même.'], ['Garantie de 2 ans', 'Nous nous chargeons de la gérer, directement avec les marques.'], ['Stock réel et recherche sur mesure', 'Si nous ne le voyons pas en rayon, nous le retrouvons en quelques minutes.'], ['Des prix andorrans transparents', 'Sans frais cachés ni petits caractères.'], ['Livraisons rapides et sûres', 'Coût raisonnable, emballage protégé et suivi en temps réel.']],
    nums:'Depuis 2009 · deux boutiques et un site · des dizaines de milliers d\'appareils vendus et réparés · des milliers de clients qui reviennent et nous recommandent.',
    where:'Où nous trouver',
    stores:[['J&M Electronics Store', 'Rez-de-chaussée nord, local B7', '+376 864 864', 'jmelectronicsstore@andorra.ad'], ['J&M Informàtica i Serveis', 'Étage −1, local S4', '+376 864 008', 'jminformatica@andorra.ad']],
    mall:'Centre commercial Illa Carlemany, Escaldes-Engordany', route:'Itinéraire →',
    hours:'Horaires', week:[['Du lundi au jeudi', '10:00 à 20:30'], ['Vendredi et samedi', '10:00 à 21:00'], ['Dimanche', '10:00 à 20:00']],
    closedP:'Nous fermons toute la journée le 1er janvier, le 14 mars, le 8 septembre et le 25 décembre. Les autres jours fériés, nous ouvrons.',
    special:'Prochains horaires spéciaux', specClosed:'fermé', specUntil:c => `de 10:00 à ${c}`, months:['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'],
    fecha:(dia, d, mes) => `${dia} ${d} ${mes}`,
    contact:'Écrivez-nous', contactP:'Sur WhatsApp, nous répondons plus vite : +376 322 501.',
    thanks:'Merci de votre confiance. Si vous ne nous connaissez pas encore, venez nous voir ou écrivez-nous et découvrez pourquoi tant de gens font confiance à J&M.', sign:'Toute l\'équipe de J&M'
  },
  moreInfo:'Voir plus →', links:[['hist', 'Qui sommes-nous'], ['where', 'Où nous trouver'], ['hours', 'Horaires']],
  hiFace:'Bonjour ! Demandez-moi ce que vous voulez.',
  cart:{envio:p => `Livraison en Espagne : <b>${p}</b> (3-5 jours ; commandes à partir de 100 €). Îles ou hors d'Espagne ? Écrivez-nous sur WhatsApp.`, add:'Ajouter au sac', added:(t, n) => `Ajouté à votre sac : ${t}. Vous en avez ${n}.`, title:'Votre sac', empty:'Votre sac est vide. Ce que vous ajoutez apparaît ici.', pay:'Payer', wa:'Le commander sur WhatsApp', msg:x => `Bonjour, je voudrais ceci : ${x}. Vous pouvez me le préparer ?`, total:'Total', remove:'Retirer', n:n => n === 1 ? '1 produit' : `${n} produits`, con:'avec'},
  qrWa:{titulo:'Écrivez-nous sur WhatsApp', cerrar:'Fermer', qr:'Scannez-le avec l\'appareil photo de votre téléphone : WhatsApp s\'ouvre avec votre commande déjà écrite.', web:a => `Vous utilisez déjà WhatsApp Web ? ${a}.`, aqui:'Ouvrez-le ici', alt:'Code QR : ouvre WhatsApp avec votre commande'},
  hs:{ph:'Cherchez un produit, une marque ou un rayon', hint:'Par exemple : « iPhone 18 », « Samsung 55 » ou « écouteurs ».', all:n => `Voir les ${n} résultats →`, none:q => `Nous n'avons pas « ${q} » sur le site, mais nous pouvons vous le trouver.`, get:'Le commander sur WhatsApp', close:'Fermer', clear:'Effacer'},
  closedToday:'Nous sommes fermés aujourd\'hui · demain nous ouvrons à 10:00',
  hi:'Bonjour ! ', q0:'J\'ai une question.', qp:t => `Je suis intéressé par : ${t}. Vous l'avez en boutique ?`,
  as: {
    greet:h => h < 6 ? 'Bonsoir.' : h < 18 ? 'Bonjour.' : 'Bonsoir.',
    hi:'Que cherchez-vous aujourd\'hui ?', sub:'Je vous aide à le trouver. Sinon, on continue sur WhatsApp.',
    ph:'Cherchez un produit ou une marque', close:'Fermer',
    root:{mobils:'Un téléphone', tv:'Une télé', tabrel:'Une tablette ou une montre', so:'Des écouteurs ou une enceinte', consoles:'Une console', drons:'Un drone ou une caméra', pc:'Un ordinateur ou des accessoires', llar:'Quelque chose pour la maison ou la voiture', otra:'Autre chose'},
    info:{horari:'Horaires du jour', on:'Où nous trouver', qui:'Qui sommes-nous'},
    pages:{sat:'Service technique', tel:'Andorra Telecom', usado:'Occasion'},
    back:'← Retour', restart:'Recommencer', human:'Continuer sur WhatsApp', any:'Peu importe',
    msgInfo:{horari:'Bonjour, j\'ai une question sur vos horaires.', on:'Bonjour, j\'ai une question sur l\'endroit où vous êtes.', qui:'Bonjour, j\'ai une question sur la boutique.'},
    res:'Je commencerais par ceux-ci :', seeAll:n => n === 1 ? 'Le voir en boutique' : `Voir les ${n} qui conviennent`, waAsk:'Écrivez-nous sur WhatsApp',
    none:'Pour l\'instant, nous n\'avons rien de tel sur le site. Nous pouvons vous le trouver : écrivez-nous et nous vous donnons le prix et le délai.',
    msg:(what, parts) => `Bonjour, je cherche ${what}${parts.length ? ' (' + parts.join(', ') + ')' : ''}. Que me conseillez-vous ?`,
    lt:n => `Moins de ${n} €`, gt:n => `Plus de ${n} €`, rg:(a, b) => `De ${a} à ${b} €`,
    slt:n => `moins de ${n} €`, sgt:n => `plus de ${n} €`, srg:(a, b) => `de ${a} à ${b} €`,
    found:n => `${n} ${n === 1 ? 'résultat' : 'résultats'}`, seeRes:n => `Voir les ${n} résultats`,
    sNone:q => `Nous n'avons pas « ${q} » sur le site. Si vous voulez, nous pouvons vous le trouver.`, sAsk:'Le commander sur WhatsApp',
    getIt:q => `Bonjour, je cherche : ${q}. Vous pouvez me le trouver ?`,
    what:{mobils:'un téléphone', tv:'une télé', tab:'une tablette', watch:'une montre connectée', ear:'des écouteurs', spk:'une enceinte', tvh:'un casque pour la télé',
          consoles:'une console', drone:'un drone', action:'une caméra d\'action', vlog:'une caméra pour les vidéos', secu:'une caméra de surveillance', pro:'du matériel de cinéma',
          port:'un ordinateur portable', desk:'un ordinateur fixe', mon:'un écran', emmag:'du stockage', impr:'une imprimante ou un scanner', comp:'des accessoires pour l\'ordinateur', llar:'quelque chose pour la maison ou la voiture'},
    mobils:{brand:'Vous avez une marque en tête ?', price:'Combien voulez-vous dépenser, à peu près ?', fold:'Vous le voulez pliable ?', fy:'Oui, pliable', fn:'Non, normal', sfy:'pliable', sfn:'normal'},
    tv:{room:'Où allez-vous la mettre ?', rs:'Dans une chambre ou la cuisine', rm:'Dans le salon', rl:'Dans un grand salon', rk:'Je connais déjà la taille',
        srs:'pour une chambre ou la cuisine', srm:'pour le salon', srl:'pour un grand salon',
        size:'De combien de pouces ?', ssize:n => `${n} pouces`,
        use:'À quoi va-t-elle surtout servir ?', ua:'La télé de tous les jours : séries, infos, foot', uc:'Le cinéma, une image spectaculaire', ug:'Jouer à la console',
        sua:'pour les séries et le foot', suc:'pour le cinéma', sug:'pour jouer',
        aa:'Pour les séries et le foot, pas besoin de la plus chère.', ac:'Pour le cinéma, mieux vaut une OLED ou une Mini LED : les noirs sont bien plus profonds.', ag:'Pour jouer, 120 Hz ou plus. Je ne vous montre que celles qui y arrivent.',
        price:'Et côté prix ?'},
    tabrel:{kind:'Que cherchez-vous ?', tab:'Une tablette', watch:'Une montre connectée', os:'iPad ou Android ?', sios:'iPad', sand:'Android', price:'Combien voulez-vous dépenser ?',
            who:'C\'est pour qui ?', me:'Pour moi', kid:'Pour un enfant', skid:'pour un enfant',
            phone:'Quel téléphone avez-vous ?', ios:'iPhone', and:'Android', spi:'pour iPhone', spa:'pour Android',
            akid:'Pour un enfant, une montre avec GPS et bouton SOS, pour toujours savoir où il est.', aios:'Avec un iPhone, c\'est l\'Apple Watch qui en tire le meilleur parti.', aand:'L\'Apple Watch ne fonctionne qu\'avec l\'iPhone : je vous montre celles qui vont avec Android.'},
    so:{kind:'Que cherchez-vous ?', ear:'Des écouteurs', spk:'Une enceinte', tvh:'Pour mieux entendre la télé',
        atv:'Pour entendre la télé sans monter le son pour tout le monde, un casque sans fil pour la télé.',
        type:'Vous les préférez comment ?', tin:'Intra-auriculaires', tov:'Casque, par-dessus l\'oreille', tsp:'Pour le sport', stin:'intra-auriculaires', stov:'casque', stsp:'pour le sport',
        phone:'Quel téléphone avez-vous ?', pi:'iPhone', ps:'Un Samsung', po:'Un autre', spi:'pour iPhone', sps:'pour Samsung',
        api:'Avec un iPhone, les AirPods se connectent tout seuls.', aps:'Avec un Samsung, les Galaxy Buds s\'appairent tout seuls.',
        where:'Où allez-vous l\'utiliser ?', wh:'À la maison', wg:'Pour l\'emporter partout', wp:'Pour une fête', swh:'pour la maison', swg:'à emporter', swp:'pour les fêtes'},
    consoles:{who:'C\'est pour qui ?', me:'Pour moi', kid:'Pour un enfant', fam:'Pour jouer en famille', sme:'pour moi', skid:'pour un enfant', sfam:'pour jouer en famille',
              which:'Vous en avez une en tête ?', ps:'PlayStation', nin:'Nintendo Switch', adv:'Je ne sais pas, conseillez-moi',
              anin:'Pour les enfants et pour jouer en famille, une Nintendo : on joue sur la télé et en mode portable.',
              aps:'Si vous jouez beaucoup et avez une grande télé 4K, la version Pro. Sinon, la normale suffit largement.'},
    drons:{what:'Que voulez-vous filmer ?', dr:'Depuis les airs, avec un drone', ac:'Sport et aventure', vl:'Voyages et vidéos pour les réseaux', se:'Surveiller la maison ou la voiture', pr:'Cinéma professionnel',
           exp:'Vous en avez déjà piloté un ?', ef:'Jamais, ce serait le premier', ea:'Oui, j\'en veux un meilleur', ep:'Je veux voler en immersion', sef:'le premier', sea:'un meilleur', sep:'pour voler en FPV',
           aef:'Pour commencer, mieux vaut un petit drone léger.', aep:'Pour voler en immersion, il faut des lunettes. Nous les avons aussi.',
           price:'Combien voulez-vous dépenser ?', a360:'Normale ou 360° ?', an:'Normale', a3:'360°, pour tout filmer', san:'normale', sa3:'360°'},
    pc:{what:'De quoi avez-vous besoin ?', port:'Un ordinateur portable', sobre:'Un ordinateur fixe ou un écran', emmag:'Un disque ou une mémoire', impr:'Une imprimante ou un scanner', comp:'Clavier, câbles et plus',
        use:'Pour quoi allez-vous l\'utiliser ?', ub:'L\'essentiel : internet, e-mails, cours', uw:'Travailler ou étudier à fond', ue:'Retoucher des photos ou monter des vidéos', ug:'Jouer',
        sub:'pour l\'essentiel', suw:'pour travailler ou étudier', sue:'pour la photo ou la vidéo',
        aub:'Pour l\'essentiel, pas besoin de dépenser beaucoup.', aue:'Pour le montage, c\'est la mémoire qui compte le plus : plus il y en a, mieux c\'est.',
        nog:'Pour l\'instant, nous n\'avons pas d\'ordinateurs portables gaming sur le site. Dites-nous ce que vous cherchez et nous vous le trouvons.',
        os:'Mac ou Windows ?', mac:'Mac', win:'Windows',
        dw:'Que cherchez-vous ?', desk:'Un ordinateur fixe', mon:'Un écran',
        mu:'Pour quoi le voulez-vous ?', mo:'Pour travailler ou étudier', mg:'Pour jouer', md:'Pour le design et la photo', smo:'pour travailler', smg:'pour jouer', smd:'pour le design',
        amg:'Pour jouer, plus il y a de hertz, mieux c\'est : à partir de 144 Hz, ça se voit vraiment.', amd:'Pour le design, mieux vaut un écran 4K ou ultra-large.',
        sk:'De quoi avez-vous besoin ?', sext:'Un disque externe', sint:'Un SSD pour l\'intérieur de l\'ordinateur', scard:'Une carte mémoire',
        pk:'Qu\'allez-vous surtout faire ?', pl:'Imprimer du texte', pi:'Imprimer en couleur et des photos', ps:'Numériser des documents',
        apl:'Si vous n\'imprimez que du texte, une laser.', api:'Si vous imprimez beaucoup en couleur, une imprimante à réservoirs revient moins cher à la longue.'},
    llar:{what:'Que cherchez-vous ?', robot:'Un robot aspirateur', afeit:'Un rasoir électrique', gps:'Un GPS pour la voiture', power:'Une batterie portable', other:'Autre chose du rayon'},
    otra:{q:'Dites-nous ce que vous cherchez et nous regardons. Si nous ne l\'avons pas, nous vous le trouvons.', ph:'Par exemple : coque pour iPhone 17', send:'Le commander sur WhatsApp'},
    horari:(d, o, c) => `Aujourd'hui, ${d}, nous sommes ouverts de ${o} à ${c}.`, isOpen:'Nous sommes ouverts en ce moment.', isClosed:'Nous sommes fermés en ce moment ; si vous nous écrivez, nous vous répondons à l\'ouverture.',
    dayOff:f => `Aujourd'hui nous sommes fermés toute la journée${f ? ' (' + f + ')' : ''}. Demain nous ouvrons à 10:00.`, fest:f => `C'est ${f}, mais nous sommes ouverts.`, early:'Aujourd\'hui nous fermons plus tôt que d\'habitude.',
    on:'Nous sommes au centre commercial Illa Carlemany, à Escaldes-Engordany : l\'électronique au rez-de-chaussée (local B7) et l\'informatique à l\'étage −1 (local S4).', map:'Ouvrir le plan', inside:'Voir la boutique de l\'intérieur',
    qui:'Nous sommes J&M : J&M Electronics Store, depuis 2009, et J&M Informàtica i Serveis, depuis 2013, toutes deux à l\'Illa Carlemany. On vous dit ce qui vous convient, pas le plus cher.',
    yes:'Ça m\'a aidé', no:'Je veux parler à quelqu\'un', bye:'Parfait ! À bientôt.'
  }
};

/* ===== i18n-en.js ===== */
/* ---------- textos en inglés (Sergio, 21 oct: «falta en francés y en inglés») ----------
   La misma forma que T.es de i18n.js (que los junta): si cambia un texto allí, cambia aquí. Inglés británico (Europa).
   Los nombres de los productos, los de Shopify; los mensajes de WhatsApp, en inglés (el bot contesta en el idioma del cliente) */
const T_EN = {
  z: {mobils:'Phones', tv:'TVs', tabrel:'Tablets and watches', so:'Sound', consoles:'Consoles', drons:'Drones and cameras', llar:'Home and more',
      port:'Laptops', sobre:'Desktops and monitors', emmag:'Storage', impr:'Printers', comp:'Components and accessories',
      taulell:'Counter', taulell1:'Counter', marcas:'Brands',
      nov:'New in', apple:'Apple', acc:'Accessories', mac:'Mac', sat:'Repair service', tel:'Andorra Telecom'},
  store:{pb:'Electronics', b1:'Computing'}, fl:{pb:'Ground floor', b1:'Floor −1'},
  s1:'We tell you what suits you.', s2:'Not the most expensive.', hsub:'Electronics and computing at Illa Carlemany.',
  wa:'Ask us on WhatsApp', waS:'Ask us',
  open:c => `Open today until ${c}`, closed:o => `Closed now · we open at ${o}`, where:'Where we are',
  hint:'Scroll down and the shop builds itself ↓',
  n:n => `${n} ${n === 1 ? 'product' : 'products'}`, nb:n => `${n} brands`,
  brandsCap:'Brands, A to Z', brandsAll:n => `See all ${n} →`,
  sign:'Computing −1', cap:'Tap an area to go in', capFloors:'Top, the ground floor. Bottom, floor −1.', capAll:'Our two shops at Illa Carlemany', lang:'Language', newT:'Just arrived',
  ft1:'J&M · Electronics and Computing · Andorra', ft2:'Website designed by SerVe Digital',
  satSub:'Repairs',
  ven:'Only 4.5% IGI · Shipping to Spain in 3-5 days · 2-year warranty',
  cuenta:'Your account',
  menu:'Menu', legales:'Terms', noExiste:'That page is no longer here. We have taken you to the home page.',
  legal:[['envios-y-devoluciones', 'Shipping and returns'], ['formas-de-pago', 'Payment methods'], ['informacion', 'Information and warranty'], ['condiciones', 'Terms of sale'], ['privacidad', 'Privacy']],
  ficha:{cap:'Capacity', color:'Colour', igi:'Including 4.5% IGI', chip:(chip, c, g) => `${chip ? `${chip} chip with ` : ''}${c}-core CPU and ${g}-core GPU`, wa:'Order on WhatsApp', waCorto:'Order',
    msg:(que, precio) => `Hello, I'm interested in: ${que} (${precio}). Do you have it?`,
    sinStock:'Out of stock right now', sinStockCorto:'Out of stock', preguntar:'Ask us on WhatsApp', preguntarCorto:'Ask us',
    msgSinStock:que => `Hello, I'm interested in: ${que}. The website says it's out of stock right now. When will you have it?`,
    envio:'Shipping to Spain in 3-5 days.', garantia:'2-year warranty.', enTienda:'Would you rather buy it in store?', tienda:'See where the counter is →', saber:'What you need to know',
    protege:'Protect it from day one', un:'A', una:'A',
    lead:(n, pro, funda, tipo) => `Your ${n} is an investment: ${[pro && (tipo === 'plegable' ? 'how about a protector for the outer screen?' : tipo === 'reloj' ? 'how about screen protectors? You get 9 for the price of one.' : 'how about a screen protector?'), funda && (pro ? 'And a case?' : 'how about a case?')].filter(Boolean).join(' ')}`,
    pantalla:{reloj:'9 units', plegable:'outer screen'}, clasesPantalla:{reloj:'Screen protector (pack of 9)', plegable:'Outer screen protector'},
    razon:{protector:'Against scratches and marks, without losing clarity or touch.', pack:'Case and tempered glass in one pack: for everyday knocks and scratches.', basica:'For everyday knocks.',
      magnetica:'Magnetic: works with magnetic chargers and mounts.', anilla:'With a ring, to hold it with one finger.', tapa:'With a cover: it protects the screen too.', silicona:'Soft to the touch and thin.',
      uag:'Reinforced, for hard knocks.', apple:'Apple\'s own, in fabric and with MagSafe.', medida:'Made to measure for your phone.', watchcase:'For knocks on the edges and on the screen.',
      teclado:'With a Bluetooth keyboard: type like on a laptop.', folio:'The cover folds into a stand so it stays upright.',
      apple20:'Do you have a charger? The iPhone box only comes with the cable.', apple40:m => `Fast charging: up to 50% in about ${m} minutes, according to Apple.`, apple40mas:'More power: it also charges an iPad or a Mac.',
      cargador:'Do you have a charger? This is the one it needs.', samsungCable:'Do you have a charger? This one comes with its cable.', samsung45:'Super-fast charging on the Galaxy models that support it.',
      variantes:{'Protector Esencial':'The basic one: against scratches and marks, without losing clarity.', Hidrogel:'A thin, flexible film that covers the screen to the edge.', UltraShield:'Tougher against knocks and scratches.',
        'Antiespía':'From the side, nobody can see your screen.', 'Hidrogel UV':'Reinforced hydrogel, firmer.', 'Hidrogel antiespía':'Hydrogel with a privacy filter: the screen cannot be seen from the side.', 'Cristal Templado':'Tempered glass: hard and smooth to the touch.', 'Cristal templado':'Tempered glass: hard and smooth to the touch.'}},
    clases:{protector:'Screen protector', phonecase:'Case', tabletcase:'Case', charger:'Charger', watchcase:'Watch case'},
    tipos:{pack:'Case + glass pack', magnetica:'Magnetic', anilla:'With ring', tapa:'With cover', silicona:'Silicone', uag:'UAG reinforced', apple:'Apple with MagSafe', teclado:'With keyboard', folio:'Folio',
      basica:'Simple', medida:'Made to measure', apple20:'Apple 20 W', apple40:'Apple 40 W', samsungCable:'Samsung with cable', samsung45:'Samsung 45 W'},
    colores:{transparente:'clear', negra:'black', rosa:'pink', azul:'blue', roja:'red', menta:'mint', gris:'grey'},
    variante:o => ({'Protector Esencial':'Essential protector', Hidrogel:'Hydrogel', 'Antiespía':'Privacy', 'Hidrogel UV':'UV hydrogel', 'Hidrogel antiespía':'Privacy hydrogel', 'Cristal Templado':'Tempered glass', 'Cristal templado':'Tempered glass'})[o] || o,
    anadir:'Add', yaEnBolsa:'In your bag', completa:'To complete it', tambien:'It goes well with', otros:v => `More from ${v}`, volver:z => `← Back to ${z}`, atras:'← Back', busqueda:'the search'},
  ck:{titulo:'Cookies', txt:'At J&M we use our own cookies and those of Shopify, the platform behind the shop: some so the website works and others, if you allow us, to measure visits.',
    no:'Reject', si:'Accept', cfg:'Settings', mas:'Cookie policy', guardar:'Save',
    nec:'Necessary', necT:'so the website works (always on)', est:'Statistics', estT:'to measure visits'},
  tel:{crumb:'Shop · Andorra Telecom', title:'Andorra Telecom', sub:'Prepaid cards',
    lead:'Your Andorra Telecom prepaid card, at our shop on floor −1. We need your ID card or passport to set it up.',
    what:'Prepaid plans', tarifas:[['Plan S', '€10 a month', '3 GB · 40 minutes · 10 SMS'], ['Plan M', '€20 a month', '12 GB · 100 minutes · 10 SMS']],
    nota:'Prices include IGI. Andorra Telecom plans as of October 2026.', where:'Where to get it'},
  usado:{crumb:'Shop · Second-hand', title:'Second-hand', lead:'Looking for a second-hand device? Tell us which one and we will look for it.',
    how:'How it works', howL:[['1', 'Message us on WhatsApp with the device you are looking for.'], ['2', 'We tell you whether we can get it, how much it costs and when it arrives.'], ['3', 'We reserve it for you and you pick it up in store.']],
    wa:'Ask us on WhatsApp', msg:'Hello, I am looking for a second-hand: …', link:'Looking for it second-hand? Ask us →'},
  sub:'See →', subT:'Ask us →', subSat:'Get a quote →',
  sat: {
    crumb:'Shop · Floor −1 · Repair service', title:'Repair service',
    lead:'We repair it here, on floor −1 (J&M Informàtica i Serveis). Most iPhone, Mac and other device repairs are done the same day.',
    img:'A J&M technician repairing a phone',
    what:'What we repair', whatL:[['Phones', 'iPhone and other brands. Most repairs, the same day.'], ['Tablets', 'iPad and other brands.'], ['Laptops and computers', 'Mac and PC of any brand.'], ['TVs', 'We repair TVs too.'], ['Hard drive replacement', 'We fit a new one.'], ['Formatting and software', 'We format the system and install the software you need.']],
    how:'How to get a quote', howL:[['1', 'Message us on WhatsApp with the model and what is wrong with it.'], ['2', 'We tell you how much it costs and when it can be ready.'], ['3', 'You bring it to floor −1 and we get to work.']],
    pb:'iPhone screen or battery', pbT:'We replace it quickly, with approved screens and batteries, under warranty. Ask us the price on WhatsApp.',
    where:'Where we are', wa:'Get a quote on WhatsApp', msg:'Hello, I would like a quote for a repair. The device is: …'
  },
  back:'← Back to the shop', brand:'Brand', secL:'Section', all:'All', sort:'Sort', sTop:'Featured', sNew:'Newest', sAsc:'Price, low to high', sDesc:'Price, high to low',
  more:n => `See more · ${n} left`, ask:'Ask us →', shop:'Shop',
  cnt:(n, b) => `${n} ${n === 1 ? 'product' : 'products'}${b ? ' from ' + b : ''}`,
  chip:'What you are looking for', whereB:'Where to find it in the shop', dirSub:n => `${n} brands, A to Z`,
  sres:q => `Results for “${q}”`, snone:'We don\'t have it on the website. Shall we get it for you?',
  days:['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],

  about: {
    title:'About us', crumb:'Shop · About us',
    lead:'J&M Electronics Store and J&M Informàtica i Serveis: two specialist shops in the Illa Carlemany shopping centre, the commercial heart of Andorra.',
    hist:'Our story',
    histP:'Since we opened in 2009 (Electronics) and 2013 (Computing), we have helped thousands of customers looking for official technology, fair prices and genuinely friendly service.',
    line:[['2009', 'J&M Electronics Store opens on the ground floor of Illa Carlemany.'], ['2013', 'J&M Informàtica i Serveis opens on floor −1.'], ['Today', 'Two shops and this website, with the same care.']],
    purpose:'Our purpose',
    purposeP:'That you feel at home, in the shop or on this website, and find the solution to what you need: buying, reserving, repairing or simply getting advice.',
    diff:'What makes us different',
    diffL:[['Personal service', 'An expert team that answers fast and speaks plainly.'], ['Express repairs', 'Most iPhone, Mac and other device repairs are done the same day.'], ['2-year warranty', 'We handle it for you, directly with the brands.'], ['Real stock and tailored search', 'If we can\'t see it on the shelf, we track it down in minutes.'], ['Transparent Andorran prices', 'No hidden surcharges or small print.'], ['Fast, safe shipping', 'Reasonable cost, protective packaging and real-time tracking.']],
    nums:'Since 2009 · two shops and a website · tens of thousands of devices sold and repaired · thousands of customers who come back and recommend us.',
    where:'Where we are',
    stores:[['J&M Electronics Store', 'Ground floor north, unit B7', '+376 864 864', 'jmelectronicsstore@andorra.ad'], ['J&M Informàtica i Serveis', 'Floor −1, unit S4', '+376 864 008', 'jminformatica@andorra.ad']],
    mall:'Illa Carlemany shopping centre, Escaldes-Engordany', route:'Get directions →',
    hours:'Opening hours', week:[['Monday to Thursday', '10:00 to 20:30'], ['Friday and Saturday', '10:00 to 21:00'], ['Sunday', '10:00 to 20:00']],
    closedP:'We close all day on 1 January, 14 March, 8 September and 25 December. We open on all other holidays.',
    special:'Upcoming special hours', specClosed:'closed', specUntil:c => `10:00 to ${c}`, months:['January','February','March','April','May','June','July','August','September','October','November','December'],
    fecha:(dia, d, mes) => `${dia} ${d} ${mes}`,
    contact:'Write to us', contactP:'On WhatsApp we answer faster: +376 322 501.',
    thanks:'Thank you for being with us. If you don\'t know us yet, come and see us or write to us and find out why so many people trust J&M.', sign:'The whole J&M team'
  },
  moreInfo:'See more →', links:[['hist', 'About us'], ['where', 'Where we are'], ['hours', 'Opening hours']],
  hiFace:'Hi! Ask me anything.',
  cart:{envio:p => `Shipping to Spain: <b>${p}</b> (3-5 days; orders from €100). Islands or outside Spain? Ask us on WhatsApp.`, add:'Add to bag', added:(t, n) => `Added to your bag: ${t}. You have ${n}.`, title:'Your bag', empty:'Your bag is empty. What you add appears here.', pay:'Pay', wa:'Order it on WhatsApp', msg:x => `Hello, I'd like this: ${x}. Can you get it ready for me?`, total:'Total', remove:'Remove', n:n => n === 1 ? '1 product' : `${n} products`, con:'with'},
  qrWa:{titulo:'Message us on WhatsApp', cerrar:'Close', qr:'Scan it with your phone camera: WhatsApp opens with your order already written.', web:a => `Already on WhatsApp Web? ${a}.`, aqui:'Open it here', alt:'QR code: opens WhatsApp with your order'},
  hs:{ph:'Search by product, brand or section', hint:'For example: “iPhone 18”, “Samsung 55” or “headphones”.', all:n => `See all ${n} results →`, none:q => `We don't have “${q}” on the website, but we can get it for you.`, get:'Order it on WhatsApp', close:'Close', clear:'Clear'},
  closedToday:'We are closed today · tomorrow we open at 10:00',
  hi:'Hello! ', q0:'I have a question.', qp:t => `I'm interested in: ${t}. Do you have it in store?`,
  as: {
    greet:h => h < 6 ? 'Good evening.' : h < 13 ? 'Good morning.' : h < 20 ? 'Good afternoon.' : 'Good evening.',
    hi:'What are you looking for today?', sub:'I\'ll help you find it. If not, we carry on over WhatsApp.',
    ph:'Search for a product or a brand', close:'Close',
    root:{mobils:'A phone', tv:'A TV', tabrel:'A tablet or a watch', so:'Headphones or a speaker', consoles:'A console', drons:'A drone or a camera', pc:'A computer or accessories', llar:'Something for the home or the car', otra:'Something else'},
    info:{horari:'Today\'s hours', on:'Where we are', qui:'About us'},
    pages:{sat:'Repair service', tel:'Andorra Telecom', usado:'Second-hand'},
    back:'← Back', restart:'Start again', human:'Continue on WhatsApp', any:'I don\'t mind',
    msgInfo:{horari:'Hello, I have a question about your opening hours.', on:'Hello, I have a question about where you are.', qui:'Hello, I have a question about the shop.'},
    res:'Here\'s where I would start:', seeAll:n => n === 1 ? 'See it in the shop' : `See the ${n} that fit`, waAsk:'Ask us on WhatsApp',
    none:'We don\'t have anything like that on the website right now. We can get it for you: write to us and we will tell you the price and delivery time.',
    msg:(what, parts) => `Hello, I'm looking for ${what}${parts.length ? ' (' + parts.join(', ') + ')' : ''}. What do you recommend?`,
    lt:n => `Under €${n}`, gt:n => `Over €${n}`, rg:(a, b) => `€${a} to €${b}`,
    slt:n => `under €${n}`, sgt:n => `over €${n}`, srg:(a, b) => `€${a} to €${b}`,
    found:n => `${n} ${n === 1 ? 'result' : 'results'}`, seeRes:n => `See the ${n} results`,
    sNone:q => `We don't have “${q}” on the website. If you like, we can get it for you.`, sAsk:'Order it on WhatsApp',
    getIt:q => `Hello, I'm looking for: ${q}. Can you get it for me?`,
    what:{mobils:'a phone', tv:'a TV', tab:'a tablet', watch:'a smartwatch', ear:'headphones', spk:'a speaker', tvh:'TV headphones',
          consoles:'a console', drone:'a drone', action:'an action camera', vlog:'a vlogging camera', secu:'a security camera', pro:'film equipment',
          port:'a laptop', desk:'a desktop computer', mon:'a monitor', emmag:'storage', impr:'a printer or a scanner', comp:'computer accessories', llar:'something for the home or the car'},
    mobils:{brand:'Do you have a brand in mind?', price:'Roughly how much do you want to spend?', fold:'Would you like a foldable?', fy:'Yes, foldable', fn:'No, a normal one', sfy:'foldable', sfn:'normal'},
    tv:{room:'Where will it go?', rs:'In a bedroom or the kitchen', rm:'In the living room', rl:'In a large living room', rk:'I already know the size',
        srs:'for a bedroom or the kitchen', srm:'for the living room', srl:'for a large living room',
        size:'How many inches?', ssize:n => `${n} inches`,
        use:'What will you use it for most?', ua:'Everyday TV: series, news, football', uc:'Films, looking spectacular', ug:'Gaming on a console',
        sua:'for series and football', suc:'for films', sug:'for gaming',
        aa:'For series and football you don\'t need the most expensive one.', ac:'For films, an OLED or a Mini LED: the blacks look much deeper.', ag:'For gaming, 120 Hz or more. I\'ll only show you the ones that get there.',
        price:'And price-wise?'},
    tabrel:{kind:'What are you looking for?', tab:'A tablet', watch:'A smartwatch', os:'iPad or Android?', sios:'iPad', sand:'Android', price:'How much do you want to spend?',
            who:'Who is it for?', me:'For me', kid:'For a child', skid:'for a child',
            phone:'Which phone do you have?', ios:'iPhone', and:'Android', spi:'for iPhone', spa:'for Android',
            akid:'For a child, one with GPS and an SOS button, so you always know where they are.', aios:'With an iPhone, the Apple Watch gets the most out of it.', aand:'The Apple Watch only works with iPhone, so I\'ll show you the ones that work with Android.'},
    so:{kind:'What are you looking for?', ear:'Headphones', spk:'A speaker', tvh:'To hear the TV better',
        atv:'To hear the TV without turning the volume up for everyone, wireless TV headphones.',
        type:'Which do you prefer?', tin:'Earbuds, in the ear', tov:'Over-ear, with a headband', tsp:'For sport', stin:'earbuds', stov:'over-ear', stsp:'for sport',
        phone:'Which phone do you have?', pi:'iPhone', ps:'A Samsung', po:'Another one', spi:'for iPhone', sps:'for Samsung',
        api:'With an iPhone, AirPods connect by themselves.', aps:'With a Samsung, Galaxy Buds pair by themselves.',
        where:'Where will you use it?', wh:'At home', wg:'To take everywhere', wp:'For a party', swh:'for home', swg:'to take along', swp:'for parties'},
    consoles:{who:'Who is it for?', me:'For me', kid:'For a child', fam:'To play as a family', sme:'for me', skid:'for a child', sfam:'to play as a family',
              which:'Do you have one in mind?', ps:'PlayStation', nin:'Nintendo Switch', adv:'I don\'t know, advise me',
              anin:'For children and for playing as a family, a Nintendo: you play on the TV and in your hands.',
              aps:'If you play a lot and have a big 4K TV, the Pro version. If not, the standard one is more than enough.'},
    drons:{what:'What do you want to film?', dr:'From the air, with a drone', ac:'Sport and adventure', vl:'Travel and videos for social media', se:'Keep an eye on the house or the car', pr:'Professional filmmaking',
           exp:'Have you flown one before?', ef:'Never, it would be my first', ea:'Yes, I want a better one', ep:'I want to fly first-person', sef:'the first one', sea:'a better one', sep:'to fly FPV',
           aef:'To start with, better a small, light one.', aep:'To fly first-person you need goggles. We have those too.',
           price:'How much do you want to spend?', a360:'Standard or 360°?', an:'Standard', a3:'360°, to film everything', san:'standard', sa3:'360°'},
    pc:{what:'What do you need?', port:'A laptop', sobre:'A desktop or a monitor', emmag:'A drive or a memory card', impr:'A printer or a scanner', comp:'Keyboard, cables and more',
        use:'What will you use it for?', ub:'The basics: internet, email, classes', uw:'Serious work or study', ue:'Photo or video editing', ug:'Gaming',
        sub:'for the basics', suw:'for work or study', sue:'for photo or video editing',
        aub:'For the basics you don\'t need to spend much.', aue:'For editing, memory makes the biggest difference: the more, the better.',
        nog:'We don\'t have gaming laptops on the website right now. Tell us what you are looking for and we will get it for you.',
        os:'Mac or Windows?', mac:'Mac', win:'Windows',
        dw:'What are you looking for?', desk:'A desktop computer', mon:'A monitor',
        mu:'What do you want it for?', mo:'For work or study', mg:'For gaming', md:'For design and photos', smo:'for work', smg:'for gaming', smd:'for design',
        amg:'For gaming, the more hertz, the better: from 144 Hz you really notice it.', amd:'For design, better 4K or an ultrawide screen.',
        sk:'What do you need?', sext:'An external drive', sint:'An SSD for inside the computer', scard:'A memory card',
        pk:'What will you mostly do?', pl:'Print text', pi:'Print in colour and photos', ps:'Scan documents',
        apl:'If you only print text, a laser printer.', api:'If you print a lot in colour, an ink tank printer works out cheaper in the long run.'},
    llar:{what:'What are you looking for?', robot:'A robot vacuum', afeit:'A shaver', gps:'A car GPS', power:'A portable power station', other:'Something else in the section'},
    otra:{q:'Tell us what you are looking for and we will check. If we don\'t have it, we will get it for you.', ph:'For example: case for iPhone 17', send:'Order it on WhatsApp'},
    horari:(d, o, c) => `Today, ${d}, we are open from ${o} to ${c}.`, isOpen:'We are open now.', isClosed:'We are closed now; if you write to us, we will answer when we open.',
    dayOff:f => `Today we are closed all day${f ? ' (' + f + ')' : ''}. Tomorrow we open at 10:00.`, fest:f => `It's ${f}, but we are open as usual.`, early:'Today we close earlier than usual.',
    on:'We are in the Illa Carlemany shopping centre, in Escaldes-Engordany: Electronics on the ground floor (unit B7) and Computing on floor −1 (unit S4).', map:'Open the map', inside:'See the shop inside',
    qui:'We are J&M: J&M Electronics Store, since 2009, and J&M Informàtica i Serveis, since 2013, both at Illa Carlemany. We tell you what suits you, not the most expensive.',
    yes:'That helped', no:'I\'d like to talk to someone', bye:'Great! See you soon.'
  }
};

/* ===== i18n.js ===== */
/* ---------- textos: castellano por defecto; catalán, francés (i18n-fr.js) e inglés (i18n-en.js) con el botón ---------- */
const PB_SECS = ['mobils', 'tv', 'tabrel', 'so', 'consoles', 'drons', 'llar'];
const B1_SECS = ['port', 'sobre', 'emmag', 'impr', 'comp'];
const SECS = [...PB_SECS, ...B1_SECS];
const floorOf = id => (B1_SECS.includes(id) || id === 'taulell1') ? 'b1' : 'pb';

const T = {
  es: {
    z: {mobils:'Móviles', tv:'Televisores', tabrel:'Tablets y relojes', so:'Sonido', consoles:'Consolas', drons:'Drones y cámaras', llar:'Hogar y más',
        port:'Portátiles', sobre:'Sobremesa y monitores', emmag:'Almacenamiento', impr:'Impresoras', comp:'Componentes y accesorios',
        taulell:'Mostrador', taulell1:'Mostrador', marcas:'Marcas',
        nov:'Novedades', apple:'Apple', acc:'Accesorios', mac:'Mac', sat:'Servicio técnico', tel:'Andorra Telecom'},
    store:{pb:'Electrónica', b1:'Informática'}, fl:{pb:'Planta baja', b1:'Planta −1'},
    s1:'Te decimos lo que te conviene.', s2:'No lo más caro.', hsub:'Electrónica e informática en la Illa Carlemany.',
    wa:'Pregúntanos por WhatsApp', waS:'Pregúntanos',
    open:c => `Abierto hoy hasta las ${c}`, closed:o => `Ahora cerrado · abrimos a las ${o}`, where:'Dónde estamos',
    hint:'Baja y la tienda se monta sola ↓',
    n:n => `${n} ${n === 1 ? 'producto' : 'productos'}`, nb:n => `${n} marcas`,
    brandsCap:'Marcas, de la A a la Z', brandsAll:n => `Ver las ${n} →`,
    sign:'Informática −1', cap:'Toca una zona para entrar', capFloors:'Arriba, la planta baja. Abajo, la −1.', capAll:'Las dos tiendas de la Illa Carlemany', lang:'Idioma', newT:'Recién llegados',
    ft1:'J&M · Electrónica e Informática · Andorra', ft2:'Web diseñada por SerVe Digital',
    satSub:'Reparaciones',
    // los argumentos de venta (los de la web de Shopify). «A España» a secas (Sergio, 22 oct; las islas, Ceuta y Melilla quedan fuera y
    // lo dicen las páginas de envíos y condiciones) y «garantía de 2 años» sin «oficial»: en Apple, el segundo año lo tramita la tienda
    ven:'Solo un 4,5 % de IGI · Envío a España en 3-5 días · Garantía de 2 años',
    cuenta:'Tu cuenta',
    // en la web de verdad (entorno.js: REAL): el menú del móvil, las páginas legales de Shopify (al pie y en el menú) y el aviso de
    // una dirección que ya no existe
    menu:'Menú', legales:'Condiciones', noExiste:'Esa página ya no está. Te dejamos en la portada.',
    legal:[['envios-y-devoluciones', 'Envíos y devoluciones'], ['formas-de-pago', 'Formas de pago'], ['informacion', 'Información y garantía'], ['condiciones', 'Condiciones de venta'], ['privacidad', 'Privacidad']],
    ficha:{cap:'Capacidad', color:'Color', igi:'Con el 4,5 % de IGI incluido', chip:(chip, c, g) => `${chip ? `Chip ${chip} con ` : ''}CPU de ${c} núcleos y GPU de ${g} núcleos`, wa:'Pídelo por WhatsApp', waCorto:'Pídelo',
      msg:(que, precio) => `Hola, me interesa: ${que} (${precio}). ¿Lo tenéis?`,
      sinStock:'Sin stock ahora mismo', sinStockCorto:'Sin stock', preguntar:'Pregúntanos por WhatsApp', preguntarCorto:'Pregúntanos',
      msgSinStock:que => `Hola, me interesa: ${que}. En la web pone que ahora mismo no hay stock. ¿Cuándo lo tendréis?`,
      envio:'Envío a España en 3-5 días.', garantia:'Garantía de 2 años.', enTienda:'¿Prefieres comprarlo en la tienda?', tienda:'Ver dónde está el mostrador →', saber:'Lo que tienes que saber',
      protege:'Protégelo desde el primer día', un:'Un', una:'Una',
      lead:(n, pro, funda, tipo, art) => `${art} ${n} es una inversión: ${[pro && (tipo === 'plegable' ? '¿le pones un protector en la pantalla de fuera?' : tipo === 'reloj' ? '¿le pones protectores de pantalla? Vienen 9 por el precio de uno.' : '¿le pones un protector de pantalla?'), funda && (pro ? '¿Y una funda?' : '¿le pones una funda?')].filter(Boolean).join(' ')}`,
      pantalla:{reloj:'9 unidades', plegable:'pantalla exterior'}, clasesPantalla:{reloj:'Protector de pantalla (vienen 9)', plegable:'Protector de la pantalla exterior'},
      razon:{protector:'Contra arañazos y marcas, sin perder nitidez ni tacto.', pack:'Funda y cristal templado en un pack: para los golpes y las rayas del día a día.', basica:'Para los golpes del día a día.',
        magnetica:'Con imán: va con los cargadores y soportes magnéticos.', anilla:'Con anilla, para sujetarlo con un dedo.', tapa:'Con tapa: protege también la pantalla.', silicona:'Suave al tacto y fina.',
        uag:'Reforzada, para los golpes fuertes.', apple:'La de Apple, de tejido y con MagSafe.', medida:'Hecho a medida para tu móvil.', watchcase:'Para los golpes en los cantos y en la pantalla.',
        teclado:'Con teclado Bluetooth: para escribir como en un portátil.', folio:'La tapa se dobla y hace de soporte para verla de pie.',
        apple20:'¿Tienes cargador? En la caja del iPhone solo viene el cable.', apple40:m => `Carga rápida: hasta el 50 % en unos ${m} minutos, según Apple.`, apple40mas:'Más potencia: también carga el iPad o el Mac.',
        cargador:'¿Tienes cargador? Este es el que le va.', samsungCable:'¿Tienes cargador? Este viene con su cable.', samsung45:'Carga súper rápida en los Galaxy que la admiten.',
        variantes:{'Protector Esencial':'El básico: contra arañazos y marcas, sin perder nitidez.', Hidrogel:'Lámina fina y flexible que cubre la pantalla hasta el borde.', UltraShield:'Más resistencia contra golpes y arañazos.',
          'Antiespía':'De lado no se ve lo que hay en tu pantalla.', 'Hidrogel UV':'Hidrogel reforzado, más firme.', 'Hidrogel antiespía':'Hidrogel con filtro antiespía: de lado no se ve la pantalla.', 'Cristal Templado':'Cristal templado: duro y liso al tacto.', 'Cristal templado':'Cristal templado: duro y liso al tacto.'}},
      clases:{protector:'Protector de pantalla', phonecase:'Funda', tabletcase:'Funda', charger:'Cargador', watchcase:'Funda del reloj'},
      tipos:{pack:'Pack funda + cristal', magnetica:'Magnética', anilla:'Con anilla', tapa:'Con tapa', silicona:'De silicona', uag:'UAG reforzada', apple:'Apple con MagSafe', teclado:'Con teclado', folio:'Tipo libro',
        basica:'Sencilla', medida:'A medida', apple20:'Apple 20 W', apple40:'Apple 40 W', samsungCable:'Samsung con cable', samsung45:'Samsung 45 W'},
      colores:{transparente:'transparente', negra:'negra', rosa:'rosa', azul:'azul', roja:'roja', menta:'menta', gris:'gris'}, variante:o => ({'Cristal Templado':'Cristal templado'})[o] || o,
      anadir:'Añadir', yaEnBolsa:'En tu bolsa', completa:'Y para completarlo', tambien:'Con él, también', otros:v => `Más de ${v}`, volver:z => `← Volver a ${z}`, atras:'← Volver', busqueda:'la búsqueda'},
    ck:{titulo:'Cookies', txt:'En J&M usamos cookies propias y de Shopify, la plataforma de la tienda: unas para que la web funcione y otras, si nos dejas, para medir las visitas.',
      no:'Rechazar', si:'Aceptar', cfg:'Configurar', mas:'Política de cookies', guardar:'Guardar',
      nec:'Necesarias', necT:'para que la web funcione (siempre activas)', est:'Estadísticas', estT:'para medir las visitas'},
    tel:{crumb:'Tienda · Andorra Telecom', title:'Andorra Telecom', sub:'Tarjetas de prepago',
      lead:'Tu tarjeta de prepago de Andorra Telecom, en nuestra tienda de la planta −1. Para hacerla necesitamos tu DNI o tu pasaporte.',
      what:'Tarifas de prepago', tarifas:[['Tarifa S', '10 € al mes', '3 GB · 40 minutos · 10 SMS'], ['Tarifa M', '20 € al mes', '12 GB · 100 minutos · 10 SMS']],
      nota:'Precios con el IGI incluido. Tarifas de Andorra Telecom en octubre de 2026.', where:'Dónde hacerla'},
    usado:{crumb:'Tienda · Segunda mano', title:'Segunda mano', lead:'¿Buscas un aparato de segunda mano? Dinos cuál y te lo buscamos.',
      how:'Cómo funciona', howL:[['1', 'Escríbenos por WhatsApp con el aparato que buscas.'], ['2', 'Te decimos si lo podemos conseguir, cuánto cuesta y cuándo llega.'], ['3', 'Te lo reservamos y lo recoges en la tienda.']],
      wa:'Pregúntanos por WhatsApp', msg:'Hola, busco de segunda mano: …', link:'¿Lo buscas de segunda mano? Pregúntanos →'},
    sub:'Ver →', subT:'Pregúntanos →', subSat:'Pide presupuesto →',
    // el servicio técnico (la puerta abierta de la −1): solo lo que ya dice la web de J&M; lo que reparan en concreto, que lo confirme Sergio
    sat: {
      crumb:'Tienda · Planta −1 · Servicio técnico', title:'Servicio técnico',
      lead:'Lo reparamos aquí, en la planta −1 (J&M Informàtica i Serveis). La mayoría de arreglos de iPhone, Mac y otros dispositivos se completan el mismo día.',
      img:'Un técnico de J&M reparando un móvil',
      what:'Qué reparamos', whatL:[['Móviles', 'iPhone y de otras marcas. La mayoría de arreglos, el mismo día.'], ['Tablets', 'iPad y de otras marcas.'], ['Portátiles y ordenadores', 'Mac y PC de cualquier marca.'], ['Televisores', 'También reparamos teles.'], ['Cambio de disco duro', 'Te ponemos uno nuevo.'], ['Formateo y programas', 'Formateamos el sistema e instalamos el software que necesites.']],
      how:'Cómo pedir presupuesto', howL:[['1', 'Escríbenos por WhatsApp con el modelo y qué le pasa.'], ['2', 'Te decimos cuánto cuesta y cuándo puede estar.'], ['3', 'Lo traes a la planta −1 y nos ponemos con él.']],
      pb:'Pantalla o batería de iPhone', pbT:'Te la cambiamos en poco tiempo, con pantallas y baterías homologadas y con garantía. Pregúntanos el precio por WhatsApp.',
      where:'Dónde estamos', wa:'Pide presupuesto por WhatsApp', msg:'Hola, quiero pedir presupuesto para una reparación. El aparato es: …'
    },
    back:'← Volver a la tienda', brand:'Marca', secL:'Sección', all:'Todas', sort:'Ordenar', sTop:'Destacados', sNew:'Novedades', sAsc:'Precio, de menor a mayor', sDesc:'Precio, de mayor a menor',
    more:n => `Ver más · quedan ${n}`, ask:'Pregúntanos →', shop:'Tienda',
    cnt:(n, b) => `${n} ${n === 1 ? 'producto' : 'productos'}${b ? ' de ' + b : ''}`,
    chip:'Lo que buscas', whereB:'Dónde la encuentras en la tienda', dirSub:n => `${n} marcas, de la A a la Z`,
    sres:q => `Resultados para «${q}»`, snone:'No lo tenemos en la web. ¿Te lo conseguimos?',
    days:['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],

    about: {
      title:'Quiénes somos', crumb:'Tienda · Quiénes somos',
      lead:'J&M Electronics Store y J&M Informàtica i Serveis: dos espacios especializados dentro del Centre Comercial Illa Carlemany, el corazón comercial de Andorra.',
      hist:'Nuestra historia',
      histP:'Desde nuestras aperturas en 2009 (Electronics) y 2013 (Informàtica) hemos acompañado a miles de clientes que buscan tecnología oficial, precios justos y un servicio realmente cercano.',
      line:[['2009', 'Abre J&M Electronics Store, en la planta baja de la Illa Carlemany.'], ['2013', 'Abre J&M Informàtica i Serveis, en la planta −1.'], ['Hoy', 'Dos tiendas y esta web, con el mismo trato.']],
      purpose:'Nuestro propósito',
      purposeP:'Que te sientas como en casa, en la tienda o en esta web, y que encuentres la solución a lo que necesitas: comprar, reservar, reparar o simplemente que te aconsejemos.',
      diff:'Lo que nos hace diferentes',
      diffL:[['Atención personalizada', 'Un equipo experto que responde rápido y habla claro.'], ['Reparaciones exprés', 'La mayoría de arreglos de iPhone, Mac y otros dispositivos se completan el mismo día.'], ['Garantía de 2 años', 'Nos encargamos de tramitarla, directamente con las marcas.'], ['Stock real y búsqueda a medida', 'Si no lo vemos en la estantería, lo rastreamos en minutos.'], ['Precios transparentes de Andorra', 'Sin recargos ocultos ni letra pequeña.'], ['Envíos ágiles y seguros', 'Coste razonable, embalaje protegido y seguimiento en tiempo real.']],
      nums:'Desde 2009 · dos tiendas y una web · decenas de miles de equipos vendidos y reparados · miles de clientes que repiten y nos recomiendan.',
      where:'Dónde estamos',
      stores:[['J&M Electronics Store', 'Planta baja norte, local B7', '+376 864 864', 'jmelectronicsstore@andorra.ad'], ['J&M Informàtica i Serveis', 'Planta −1, local S4', '+376 864 008', 'jminformatica@andorra.ad']],
      mall:'Centre Comercial Illa Carlemany, Escaldes-Engordany', route:'Cómo llegar →',
      hours:'Horario', week:[['De lunes a jueves', '10:00 a 20:30'], ['Viernes y sábado', '10:00 a 21:00'], ['Domingo', '10:00 a 20:00']],
      closedP:'Cerramos todo el día el 1 de enero, el 14 de marzo, el 8 de septiembre y el 25 de diciembre. Los demás festivos abrimos.',
      special:'Próximos horarios especiales', specClosed:'cerrado', specUntil:c => `de 10:00 a ${c}`, months:['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
      fecha:(dia, d, mes) => `${dia} ${d} de ${mes}`,
      contact:'Escríbenos', contactP:'Por WhatsApp te contestamos antes: +376 322 501.',
      thanks:'Gracias por acompañarnos. Si aún no nos conoces, ven a vernos o escríbenos y comprueba por qué tanta gente confía en J&M.', sign:'Todo el equipo de J&M'
    },
    moreInfo:'Ver más →', links:[['hist', 'Quiénes somos'], ['where', 'Dónde estamos'], ['hours', 'Horario']],
    hiFace:'¡Hola! Pregúntame lo que quieras.',
    cart:{envio:p => `Envío a España: <b>${p}</b> (3-5 días; pedidos desde 100 €). ¿Islas o fuera de España? Pregúntanos por WhatsApp.`, add:'Añadir a la bolsa', title:'Tu bolsa', empty:'Tu bolsa está vacía. Lo que añadas aparece aquí.', pay:'Pagar', wa:'Pedirla por WhatsApp', msg:x => `Hola, quiero esto: ${x}. ¿Me lo preparáis?`, total:'Total', remove:'Quitar', n:n => n === 1 ? '1 producto' : `${n} productos`, con:'con'},
    qrWa:{titulo:'Escríbenos por WhatsApp', cerrar:'Cerrar', qr:'Escanéalo con la cámara del móvil: se abre WhatsApp con tu pedido ya escrito.', web:a => `¿Ya tienes WhatsApp Web? ${a}.`, aqui:'Ábrelo aquí', alt:'Código QR: abre WhatsApp con tu pedido'},
    hs:{ph:'Busca por producto, marca o sección', hint:'Por ejemplo: «iPhone 18», «Samsung 55» o «auriculares».', all:n => `Ver los ${n} resultados →`, none:q => `«${q}» no lo tenemos en la web, pero te lo conseguimos.`, get:'Pídelo por WhatsApp', close:'Cerrar', clear:'Borrar'},
    closedToday:'Hoy cerramos · mañana abrimos a las 10:00',
    hi:'¡Hola! ', q0:'Tengo una pregunta.', qp:t => `Me interesa: ${t}. ¿Lo tenéis en la tienda?`,
    as: {
      greet:h => h < 6 ? 'Buenas noches.' : h < 13 ? 'Buenos días.' : h < 20 ? 'Buenas tardes.' : 'Buenas noches.',
      hi:'¿Qué buscas hoy?', sub:'Te ayudo a encontrarlo. Si no, seguimos por WhatsApp.',
      ph:'Busca un producto o una marca', close:'Cerrar',
      root:{mobils:'Un móvil', tv:'Una tele', tabrel:'Una tablet o un reloj', so:'Auriculares o un altavoz', consoles:'Una consola', drons:'Un dron o una cámara', pc:'Un ordenador o accesorios', llar:'Algo para casa o el coche', otra:'Otra cosa'},
      info:{horari:'Horario de hoy', on:'Dónde estamos', qui:'Quiénes somos'},
      pages:{sat:'Servicio técnico', tel:'Andorra Telecom', usado:'Segunda mano'},
      back:'← Atrás', restart:'Empezar de nuevo', human:'Seguir por WhatsApp', any:'Me da igual',
      msgInfo:{horari:'Hola, tengo una pregunta sobre el horario.', on:'Hola, tengo una pregunta sobre dónde estáis.', qui:'Hola, tengo una pregunta sobre la tienda.'},
      res:'Mira, yo empezaría por estos:', seeAll:n => n === 1 ? 'Verlo en la tienda' : `Ver los ${n} que encajan`, waAsk:'Pregúntanos por WhatsApp',
      none:'Con eso ahora mismo no tenemos nada en la web. Te lo conseguimos: escríbenos y te decimos precio y plazo.',
      msg:(what, parts) => `Hola, busco ${what}${parts.length ? ' (' + parts.join(', ') + ')' : ''}. ¿Qué me recomendáis?`,
      lt:n => `Menos de ${n} €`, gt:n => `Más de ${n} €`, rg:(a, b) => `De ${a} a ${b} €`,
      slt:n => `menos de ${n} €`, sgt:n => `más de ${n} €`, srg:(a, b) => `de ${a} a ${b} €`,
      found:n => `${n} ${n === 1 ? 'resultado' : 'resultados'}`, seeRes:n => `Ver los ${n} resultados`,
      sNone:q => `«${q}» no lo tenemos en la web. Si quieres, te lo conseguimos.`, sAsk:'Pedirlo por WhatsApp',
      getIt:q => `Hola, busco: ${q}. ¿Me lo podéis conseguir?`,
      what:{mobils:'un móvil', tv:'una tele', tab:'una tablet', watch:'un reloj inteligente', ear:'unos auriculares', spk:'un altavoz', tvh:'unos auriculares para la tele',
            consoles:'una consola', drone:'un dron', action:'una cámara de acción', vlog:'una cámara para vídeos', secu:'una cámara de vigilancia', pro:'equipo de cine',
            port:'un portátil', desk:'un ordenador de sobremesa', mon:'un monitor', emmag:'almacenamiento', impr:'una impresora o un escáner', comp:'accesorios para el ordenador', llar:'algo para casa o el coche'},
      mobils:{brand:'¿Tienes alguna marca en mente?', price:'¿Cuánto te quieres gastar, más o menos?', fold:'¿Lo quieres plegable?', fy:'Sí, plegable', fn:'No, normal', sfy:'plegable', sfn:'normal'},
      tv:{room:'¿Dónde la vas a poner?', rs:'En un dormitorio o la cocina', rm:'En el salón', rl:'En un salón grande', rk:'Ya sé las pulgadas',
          srs:'para un dormitorio o la cocina', srm:'para el salón', srl:'para un salón grande',
          size:'¿De cuántas pulgadas?', ssize:n => `${n} pulgadas`,
          use:'¿Para qué la vas a usar más?', ua:'Tele de siempre: series, noticias, fútbol', uc:'Cine, que se vea espectacular', ug:'Para jugar a la consola',
          sua:'para series y fútbol', suc:'para cine', sug:'para jugar',
          aa:'Para series y fútbol no te hace falta lo más caro.', ac:'Para cine te conviene una OLED o una Mini LED: los negros se ven mucho más profundos.', ag:'Para jugar, que vaya a 120 Hz o más. Te enseño solo las que llegan.',
          price:'¿Y de precio?'},
      tabrel:{kind:'¿Qué buscas?', tab:'Una tablet', watch:'Un reloj inteligente', os:'¿iPad o Android?', sios:'iPad', sand:'Android', price:'¿Cuánto te quieres gastar?',
              who:'¿Para quién es?', me:'Para mí', kid:'Para un niño o una niña', skid:'para un niño',
              phone:'¿Qué móvil tienes?', ios:'iPhone', and:'Android', spi:'para iPhone', spa:'para Android',
              akid:'Para un niño, uno con GPS y botón SOS, para saber siempre dónde está.', aios:'Con iPhone, el que más partido le saca es el Apple Watch.', aand:'El Apple Watch solo funciona con iPhone, así que te enseño los que van con Android.'},
      so:{kind:'¿Qué buscas?', ear:'Auriculares', spk:'Un altavoz', tvh:'Para oír mejor la tele',
          atv:'Para oír la tele sin subir el volumen a todos, unos auriculares inalámbricos para tele.',
          type:'¿Cómo los prefieres?', tin:'De botón, dentro de la oreja', tov:'De diadema, por encima de la oreja', tsp:'Para hacer deporte', stin:'de botón', stov:'de diadema', stsp:'para deporte',
          phone:'¿Qué móvil tienes?', pi:'iPhone', ps:'Un Samsung', po:'Otro', spi:'para iPhone', sps:'para Samsung',
          api:'Con iPhone, los AirPods se conectan solos.', aps:'Con un Samsung, los Galaxy Buds se emparejan solos.',
          where:'¿Dónde lo vas a usar?', wh:'En casa', wg:'Para llevarlo a todas partes', wp:'Para una fiesta', swh:'para casa', swg:'para llevar', swp:'para fiestas'},
      consoles:{who:'¿Para quién es?', me:'Para mí', kid:'Para un niño o una niña', fam:'Para jugar en familia', sme:'para mí', skid:'para un niño', sfam:'para jugar en familia',
                which:'¿Tienes alguna en mente?', ps:'PlayStation', nin:'Nintendo Switch', adv:'No lo sé, aconséjame',
                anin:'Para niños y para jugar en familia, una Nintendo: se juega en la tele y en la mano.',
                aps:'Si juegas mucho y tienes una tele 4K grande, la versión Pro. Si no, con la normal vas sobrado.'},
      drons:{what:'¿Qué quieres grabar?', dr:'Desde el aire, con un dron', ac:'Deporte y aventura', vl:'Viajes y vídeos para redes', se:'Vigilar la casa o el coche', pr:'Cine profesional',
             exp:'¿Has volado alguno antes?', ef:'Nunca, sería el primero', ea:'Sí, quiero uno mejor', ep:'Quiero volar en primera persona', sef:'el primero', sea:'uno mejor', sep:'para volar en FPV',
             aef:'Para empezar, mejor uno pequeño y ligero.', aep:'Para volar en primera persona hacen falta unas gafas. También las tenemos.',
             price:'¿Cuánto te quieres gastar?', a360:'¿Normal o 360°?', an:'Normal', a3:'360°, para grabarlo todo', san:'normal', sa3:'360°'},
      pc:{what:'¿Qué necesitas?', port:'Un portátil', sobre:'Un sobremesa o un monitor', emmag:'Un disco o una memoria', impr:'Una impresora o un escáner', comp:'Teclado, cables y más',
          use:'¿Para qué lo vas a usar?', ub:'Lo básico: internet, correo, clases', uw:'Trabajar o estudiar a fondo', ue:'Editar fotos o vídeo', ug:'Jugar',
          sub:'para lo básico', suw:'para trabajar o estudiar', sue:'para editar fotos o vídeo',
          aub:'Para lo básico no te hace falta gastar mucho.', aue:'Para editar, lo que más se nota es la memoria: cuanta más, mejor.',
          nog:'Ahora mismo no tenemos portátiles para jugar en la web. Dinos qué buscas y te lo conseguimos.',
          os:'¿Mac o Windows?', mac:'Mac', win:'Windows',
          dw:'¿Qué buscas?', desk:'Un ordenador de sobremesa', mon:'Un monitor',
          mu:'¿Para qué lo quieres?', mo:'Para trabajar o estudiar', mg:'Para jugar', md:'Para diseño y fotos', smo:'para trabajar', smg:'para jugar', smd:'para diseño',
          amg:'Para jugar, cuantos más hercios, mejor: a partir de 144 Hz se nota mucho.', amd:'Para diseño, mejor 4K o una pantalla ancha.',
          sk:'¿Qué necesitas?', sext:'Un disco externo', sint:'Un SSD para dentro del ordenador', scard:'Una tarjeta de memoria',
          pk:'¿Qué vas a hacer sobre todo?', pl:'Imprimir textos', pi:'Imprimir en color y fotos', ps:'Escanear documentos',
          apl:'Si solo imprimes textos, una láser.', api:'Si imprimes mucho en color, una de tanque de tinta te sale más barata a la larga.'},
      llar:{what:'¿Qué buscas?', robot:'Un robot aspirador', afeit:'Una afeitadora', gps:'Un GPS para el coche', power:'Una batería portátil', other:'Otra cosa de la sección'},
      otra:{q:'Dime qué buscas y lo miramos. Si no lo tenemos, te lo conseguimos.', ph:'Por ejemplo: funda para iPhone 17', send:'Pedirlo por WhatsApp'},
      horari:(d, o, c) => `Hoy, ${d}, abrimos de ${o} a ${c}.`, isOpen:'Ahora estamos abiertos.', isClosed:'Ahora estamos cerrados; si nos escribes, te contestamos al abrir.',
      dayOff:f => `Hoy cerramos todo el día${f ? ' (' + f + ')' : ''}. Mañana abrimos a las 10:00.`, fest:f => `Es ${f}, pero abrimos igual.`, early:'Hoy cerramos antes de lo habitual.',
      on:'Estamos en el centro comercial Illa Carlemany, en Escaldes-Engordany: Electrónica en la planta baja (local B7) e Informática en la planta −1 (local S4).', map:'Abrir el mapa', inside:'Ver la tienda por dentro',
      qui:'Somos J&M: J&M Electronics Store, desde 2009, y J&M Informàtica i Serveis, desde 2013, las dos en la Illa Carlemany. Te decimos lo que te conviene, no lo más caro.',
      yes:'Me ha servido', no:'Quiero hablar con alguien', bye:'¡Perfecto! Hasta pronto.'
    }
  },
  ca: {
    z: {mobils:'Mòbils', tv:'Televisors', tabrel:'Tauletes i rellotges', so:'So', consoles:'Consoles', drons:'Drons i càmeres', llar:'Llar i més',
        port:'Portàtils', sobre:'Sobretaula i monitors', emmag:'Emmagatzematge', impr:'Impressores', comp:'Components i accessoris',
        taulell:'Taulell', taulell1:'Taulell', marcas:'Marques',
        nov:'Novetats', apple:'Apple', acc:'Accessoris', mac:'Mac', sat:'Servei tècnic', tel:'Andorra Telecom'},
    store:{pb:'Electrònica', b1:'Informàtica'}, fl:{pb:'Planta baixa', b1:'Planta −1'},
    s1:'Et diem el que et convé.', s2:'No el més car.', hsub:"Electrònica i informàtica a l'Illa Carlemany.",
    wa:"Pregunta'ns per WhatsApp", waS:"Pregunta'ns",
    open:c => `Obert avui fins a les ${c}`, closed:o => `Ara tancat · obrim a les ${o}`, where:'On som',
    hint:'Baixa i la botiga es munta sola ↓',
    n:n => `${n} ${n === 1 ? 'producte' : 'productes'}`, nb:n => `${n} marques`,
    brandsCap:'Marques, de la A a la Z', brandsAll:n => `Veure-les totes (${n}) →`,
    sign:'Informàtica −1', cap:'Toca una zona per entrar', capFloors:'A dalt, la planta baixa. A baix, la −1.', capAll:"Les dues botigues de l'Illa Carlemany", lang:'Idioma', newT:"Acabats d'arribar",
    ft1:'J&M · Electrònica i Informàtica · Andorra', ft2:'Web dissenyada per SerVe Digital',
    satSub:'Reparacions',
    ven:"Només un 4,5 % d'IGI · Enviament a Espanya en 3-5 dies · Garantia de 2 anys",
    cuenta:'El teu compte',
    menu:'Menú', legales:'Condicions', noExiste:'Aquesta pàgina ja no hi és. Et deixem a la portada.',
    legal:[['envios-y-devoluciones', 'Enviaments i devolucions'], ['formas-de-pago', 'Formes de pagament'], ['informacion', 'Informació i garantia'], ['condiciones', 'Condicions de venda'], ['privacidad', 'Privacitat']],
    ficha:{cap:'Capacitat', color:'Color', igi:"Amb el 4,5 % d'IGI inclòs", chip:(chip, c, g) => `${chip ? `Xip ${chip} amb ` : ''}CPU de ${c} nuclis i GPU de ${g} nuclis`, wa:'Demana-ho per WhatsApp', waCorto:'Demana-ho',
      msg:(que, preu) => `Hola, m'interessa: ${que} (${preu}). El teniu?`,
      sinStock:'Sense estoc ara mateix', sinStockCorto:'Sense estoc', preguntar:"Pregunta'ns per WhatsApp", preguntarCorto:"Pregunta'ns",
      msgSinStock:que => `Hola, m'interessa: ${que}. A la web posa que ara mateix no hi ha estoc. Quan el tindreu?`,
      envio:'Enviament a Espanya en 3-5 dies.', garantia:'Garantia de 2 anys.', enTienda:'Prefereixes comprar-lo a la botiga?', tienda:'Veure on és el taulell →', saber:'El que has de saber',
      protege:'Protegeix-lo des del primer dia', un:'Un', una:'Una',
      lead:(n, pro, funda, tipo, art) => `${art} ${n} és una inversió: ${[pro && (tipo === 'plegable' ? 'li poses un protector a la pantalla de fora?' : tipo === 'reloj' ? "li poses protectors de pantalla? En vénen 9 pel preu d'un." : 'li poses un protector de pantalla?'), funda && (pro ? 'I una funda?' : 'li poses una funda?')].filter(Boolean).join(' ')}`,
      pantalla:{reloj:'9 unitats', plegable:'pantalla exterior'}, clasesPantalla:{reloj:'Protector de pantalla (en vénen 9)', plegable:'Protector de la pantalla exterior'},
      razon:{protector:'Contra ratllades i marques, sense perdre nitidesa ni tacte.', pack:'Funda i vidre temperat en un pack: per als cops i les ratllades del dia a dia.', basica:'Per als cops del dia a dia.',
        magnetica:'Amb imant: va amb els carregadors i suports magnètics.', anilla:'Amb anella, per subjectar-lo amb un dit.', tapa:'Amb tapa: protegeix també la pantalla.', silicona:'Suau al tacte i fina.',
        uag:'Reforçada, per als cops forts.', apple:"La d'Apple, de teixit i amb MagSafe.", medida:'Fet a mida per al teu mòbil.', watchcase:'Per als cops als cantells i a la pantalla.',
        teclado:'Amb teclat Bluetooth: per escriure com en un portàtil.', folio:'La tapa es plega i fa de suport per veure-la dreta.',
        apple20:"Tens carregador? A la caixa de l'iPhone només hi ve el cable.", apple40:m => `Càrrega ràpida: fins al 50 % en uns ${m} minuts, segons Apple.`, apple40mas:"Més potència: també carrega l'iPad o el Mac.",
        cargador:'Tens carregador? Aquest és el que li va.', samsungCable:'Tens carregador? Aquest ve amb el seu cable.', samsung45:"Càrrega superràpida als Galaxy que l'admeten.",
        variantes:{'Protector Esencial':'El bàsic: contra ratllades i marques, sense perdre nitidesa.', Hidrogel:'Làmina fina i flexible que cobreix la pantalla fins a la vora.', UltraShield:'Més resistència contra cops i ratllades.',
          'Antiespía':'De costat no es veu el que hi ha a la pantalla.', 'Hidrogel UV':'Hidrogel reforçat, més ferm.', 'Hidrogel antiespía':'Hidrogel amb filtre antiespia: de costat no es veu la pantalla.', 'Cristal Templado':'Vidre temperat: dur i llis al tacte.', 'Cristal templado':'Vidre temperat: dur i llis al tacte.'}},
      clases:{protector:'Protector de pantalla', phonecase:'Funda', tabletcase:'Funda', charger:'Carregador', watchcase:'Funda del rellotge'},
      tipos:{pack:'Pack funda + vidre', magnetica:'Magnètica', anilla:'Amb anella', tapa:'Amb tapa', silicona:'De silicona', uag:'UAG reforçada', apple:'Apple amb MagSafe', teclado:'Amb teclat', folio:'Tipus llibre',
        basica:'Senzilla', medida:'A mida', apple20:'Apple 20 W', apple40:'Apple 40 W', samsungCable:'Samsung amb cable', samsung45:'Samsung 45 W'},
      colores:{transparente:'transparent', negra:'negra', rosa:'rosa', azul:'blava', roja:'vermella', menta:'menta', gris:'gris'},
      variante:o => ({'Protector Esencial':'Protector Essencial', 'Antiespía':'Antiespia', 'Hidrogel antiespía':'Hidrogel antiespia', 'Cristal Templado':'Vidre temperat', 'Cristal templado':'Vidre temperat'})[o] || o,
      anadir:'Afegir', yaEnBolsa:'A la teva bossa', completa:'I per completar-lo', tambien:'Amb ell, també', otros:v => `Més de ${v}`, volver:z => `← Tornar a ${z}`, atras:'← Tornar', busqueda:'la cerca'},
    ck:{titulo:'Galetes', txt:'A J&M fem servir galetes pròpies i de Shopify, la plataforma de la botiga: unes perquè el web funcioni i d\'altres, si ens deixes, per mesurar les visites.',
      no:'Rebutjar', si:'Acceptar', cfg:'Configurar', mas:'Política de galetes', guardar:'Desar',
      nec:'Necessàries', necT:'perquè el web funcioni (sempre actives)', est:'Estadístiques', estT:'per mesurar les visites'},
    tel:{crumb:'Botiga · Andorra Telecom', title:'Andorra Telecom', sub:'Targetes de prepagament',
      lead:"La teva targeta de prepagament d'Andorra Telecom, a la nostra botiga de la planta −1. Per fer-la necessitem el teu DNI o el teu passaport.",
      what:'Tarifes de prepagament', tarifas:[['Tarifa S', '10 € al mes', '3 GB · 40 minuts · 10 SMS'], ['Tarifa M', '20 € al mes', '12 GB · 100 minuts · 10 SMS']],
      nota:"Preus amb l'IGI inclòs. Tarifes d'Andorra Telecom a l'octubre del 2026.", where:'On fer-la'},
    usado:{crumb:'Botiga · Segona mà', title:'Segona mà', lead:"Busques un aparell de segona mà? Digues-nos quin i te'l busquem.",
      how:'Com funciona', howL:[['1', "Escriu-nos per WhatsApp amb l'aparell que busques."], ['2', 'Et diem si el podem aconseguir, quant costa i quan arriba.'], ['3', "Te'l reservem i el reculls a la botiga."]],
      wa:"Pregunta-ho per WhatsApp", msg:'Hola, busco de segona mà: …', link:"El busques de segona mà? Pregunta'ns-ho →"},
    sub:'Veure →', subT:"Pregunta'ns →", subSat:'Demana pressupost →',
    sat: {
      crumb:'Botiga · Planta −1 · Servei tècnic', title:'Servei tècnic',
      lead:"Ho reparem aquí, a la planta −1 (J&M Informàtica i Serveis). La majoria de reparacions d'iPhone, Mac i altres dispositius es completen el mateix dia.",
      img:'Un tècnic de J&M reparant un mòbil',
      what:'Què reparem', whatL:[['Mòbils', "iPhone i d'altres marques. La majoria de reparacions, el mateix dia."], ['Tauletes', "iPad i d'altres marques."], ['Portàtils i ordinadors', 'Mac i PC de qualsevol marca.'], ['Televisors', 'També reparem televisors.'], ['Canvi de disc dur', "Te'n posem un de nou."], ['Formatatge i programes', 'Formatem el sistema i instal·lem el programari que necessitis.']],
      how:'Com demanar pressupost', howL:[['1', 'Escriu-nos per WhatsApp amb el model i què li passa.'], ['2', 'Et diem quant costa i quan pot estar.'], ['3', 'El portes a la planta −1 i ens hi posem.']],
      pb:"Pantalla o bateria d'iPhone", pbT:"Te la canviem en poc temps, amb pantalles i bateries homologades i amb garantia. Pregunta'ns el preu per WhatsApp.",
      where:'On som', wa:'Demana pressupost per WhatsApp', msg:"Hola, vull demanar pressupost per a una reparació. L'aparell és: …"
    },
    back:'← Tornar a la botiga', brand:'Marca', secL:'Secció', all:'Totes', sort:'Ordenar', sTop:'Destacats', sNew:'Novetats', sAsc:'Preu, de menys a més', sDesc:'Preu, de més a menys',
    more:n => `Mostra'n més · en queden ${n}`, ask:"Pregunta'ns-ho →", shop:'Botiga',
    cnt:(n, b) => `${n} ${n === 1 ? 'producte' : 'productes'}${b ? ' de ' + b : ''}`,
    chip:'El que busques', whereB:'On la trobes a la botiga', dirSub:n => `${n} marques, de la A a la Z`,
    sres:q => `Resultats per a «${q}»`, snone:"No el tenim a la web. Te l'aconseguim?",
    days:['diumenge','dilluns','dimarts','dimecres','dijous','divendres','dissabte'],

    about: {
      title:'Qui som', crumb:'Botiga · Qui som',
      lead:"J&M Electronics Store i J&M Informàtica i Serveis: dos espais especialitzats dins del Centre Comercial Illa Carlemany, el cor comercial d'Andorra.",
      hist:'La nostra història',
      histP:'Des de les nostres obertures el 2009 (Electronics) i el 2013 (Informàtica) hem acompanyat milers de clients que busquen tecnologia oficial, preus justos i un servei realment proper.',
      line:[['2009', "Obre J&M Electronics Store, a la planta baixa de l'Illa Carlemany."], ['2013', 'Obre J&M Informàtica i Serveis, a la planta −1.'], ['Avui', 'Dues botigues i aquest web, amb el mateix tracte.']],
      purpose:'El nostre propòsit',
      purposeP:"Que et sentis com a casa, a la botiga o en aquest web, i que trobis la solució al que necessites: comprar, reservar, reparar o simplement que t'aconsellem.",
      diff:'El que ens fa diferents',
      diffL:[['Atenció personalitzada', 'Un equip expert que respon ràpid i parla clar.'], ['Reparacions exprés', "La majoria de reparacions d'iPhone, Mac i altres dispositius es completen el mateix dia."], ['Garantia de 2 anys', "Ens encarreguem de tramitar-la, directament amb les marques."], ['Estoc real i cerca a mida', 'Si no ho veiem a la prestatgeria, ho localitzem en minuts.'], ["Preus transparents d'Andorra", 'Sense recàrrecs ocults ni lletra petita.'], ['Enviaments àgils i segurs', 'Cost raonable, embalatge protegit i seguiment en temps real.']],
      nums:"Des del 2009 · dues botigues i un web · desenes de milers d'equips venuts i reparats · milers de clients que repeteixen i ens recomanen.",
      where:'On som',
      stores:[['J&M Electronics Store', 'Planta baixa nord, local B7', '+376 864 864', 'jmelectronicsstore@andorra.ad'], ['J&M Informàtica i Serveis', 'Planta −1, local S4', '+376 864 008', 'jminformatica@andorra.ad']],
      mall:'Centre Comercial Illa Carlemany, Escaldes-Engordany', route:'Com arribar-hi →',
      hours:'Horari', week:[['De dilluns a dijous', '10:00 a 20:30'], ['Divendres i dissabte', '10:00 a 21:00'], ['Diumenge', '10:00 a 20:00']],
      closedP:"Tanquem tot el dia l'1 de gener, el 14 de març, el 8 de setembre i el 25 de desembre. La resta de festius obrim.",
      special:'Propers horaris especials', specClosed:'tancat', specUntil:c => `de 10:00 a ${c}`, months:['gener','febrer','març','abril','maig','juny','juliol','agost','setembre','octubre','novembre','desembre'],
      fecha:(dia, d, mes) => `${dia} ${d} ${/^[aeiouàèéíòóú]/i.test(mes) ? "d'" : 'de '}${mes}`,
      contact:'Escriu-nos', contactP:'Per WhatsApp et contestem abans: +376 322 501.',
      thanks:"Gràcies per acompanyar-nos. Si encara no ens coneixes, vine a veure'ns o escriu-nos i comprova per què tanta gent confia en J&M.", sign:"Tot l'equip de J&M"
    },
    moreInfo:"Veure'n més →", links:[['hist', 'Qui som'], ['where', 'On som'], ['hours', 'Horari']],
    hiFace:"Hola! Pregunta'm el que vulguis.",
    cart:{envio:p => `Enviament a Espanya: <b>${p}</b> (3-5 dies; comandes des de 100 €). Illes o fora d'Espanya? Pregunta'ns-ho per WhatsApp.`, add:'Afegir a la bossa', title:'La teva bossa', empty:'La teva bossa és buida. El que hi afegeixis apareix aquí.', pay:'Pagar', wa:'Demanar-la per WhatsApp', msg:x => `Hola, vull això: ${x}. M'ho prepareu?`, total:'Total', remove:'Treure', n:n => n === 1 ? '1 producte' : `${n} productes`, con:'amb'},
    qrWa:{titulo:'Escriu-nos per WhatsApp', cerrar:'Tancar', qr:"Escaneja'l amb la càmera del mòbil: s'obre WhatsApp amb la teva comanda ja escrita.", web:a => `Ja tens WhatsApp Web? ${a}.`, aqui:"Obre'l aquí", alt:'Codi QR: obre WhatsApp amb la teva comanda'},
    hs:{ph:'Busca per producte, marca o secció', hint:'Per exemple: «iPhone 18», «Samsung 55» o «auriculars».', all:n => `Veure els ${n} resultats →`, none:q => `«${q}» no el tenim a la web, però te l'aconseguim.`, get:'Demana-ho per WhatsApp', close:'Tancar', clear:'Esborrar'},
    closedToday:'Avui tanquem · demà obrim a les 10:00',
    hi:'Hola! ', q0:'Tinc una pregunta.', qp:t => `M'interessa: ${t}. El teniu a la botiga?`,
    as: {
      greet:h => h < 6 ? 'Bona nit.' : h < 14 ? 'Bon dia.' : h < 20 ? 'Bona tarda.' : 'Bona nit.',
      hi:'Què busques avui?', sub:"T'ajudo a trobar-ho. Si no, continuem per WhatsApp.",
      ph:'Busca un producte o una marca', close:'Tancar',
      root:{mobils:'Un mòbil', tv:'Una tele', tabrel:'Una tauleta o un rellotge', so:'Auriculars o un altaveu', consoles:'Una consola', drons:'Un dron o una càmera', pc:'Un ordinador o accessoris', llar:'Alguna cosa per a casa o el cotxe', otra:'Una altra cosa'},
      info:{horari:"Horari d'avui", on:'On som', qui:'Qui som'},
      pages:{sat:'Servei tècnic', tel:'Andorra Telecom', usado:'Segona mà'},
      back:'← Enrere', restart:'Tornar a començar', human:'Continuar per WhatsApp', any:"M'és igual",
      msgInfo:{horari:"Hola, tinc una pregunta sobre l'horari.", on:'Hola, tinc una pregunta sobre on sou.', qui:'Hola, tinc una pregunta sobre la botiga.'},
      res:'Mira, jo començaria per aquests:', seeAll:n => n === 1 ? 'Veure-ho a la botiga' : `Veure els ${n} que hi encaixen`, waAsk:"Pregunta'ns per WhatsApp",
      none:"Amb això ara mateix no tenim res a la web. Te l'aconseguim: escriu-nos i et diem preu i termini.",
      msg:(what, parts) => `Hola, busco ${what}${parts.length ? ' (' + parts.join(', ') + ')' : ''}. Què em recomaneu?`,
      lt:n => `Menys de ${n} €`, gt:n => `Més de ${n} €`, rg:(a, b) => `De ${a} a ${b} €`,
      slt:n => `menys de ${n} €`, sgt:n => `més de ${n} €`, srg:(a, b) => `de ${a} a ${b} €`,
      found:n => `${n} ${n === 1 ? 'resultat' : 'resultats'}`, seeRes:n => `Veure els ${n} resultats`,
      sNone:q => `«${q}» no el tenim a la web. Si vols, te l'aconseguim.`, sAsk:"Demanar-ho per WhatsApp",
      getIt:q => `Hola, busco: ${q}. Me'l podeu aconseguir?`,
      what:{mobils:'un mòbil', tv:'una tele', tab:'una tauleta', watch:'un rellotge intel·ligent', ear:'uns auriculars', spk:'un altaveu', tvh:'uns auriculars per a la tele',
            consoles:'una consola', drone:'un dron', action:"una càmera d'acció", vlog:'una càmera per a vídeos', secu:'una càmera de vigilància', pro:'equip de cinema',
            port:'un portàtil', desk:'un ordinador de sobretaula', mon:'un monitor', emmag:'emmagatzematge', impr:'una impressora o un escàner', comp:"accessoris per a l'ordinador", llar:'alguna cosa per a casa o el cotxe'},
      mobils:{brand:'Tens alguna marca al cap?', price:'Quant et vols gastar, més o menys?', fold:'El vols plegable?', fy:'Sí, plegable', fn:'No, normal', sfy:'plegable', sfn:'normal'},
      tv:{room:'On la posaràs?', rs:'En un dormitori o a la cuina', rm:'Al menjador', rl:'En un menjador gran', rk:'Ja sé les polzades',
          srs:'per a un dormitori o la cuina', srm:'per al menjador', srl:'per a un menjador gran',
          size:'De quantes polzades?', ssize:n => `${n} polzades`,
          use:'Per a què la faràs servir més?', ua:'La tele de sempre: sèries, notícies, futbol', uc:'Cinema, que es vegi espectacular', ug:'Per jugar a la consola',
          sua:'per a sèries i futbol', suc:'per a cinema', sug:'per jugar',
          aa:'Per a sèries i futbol no et cal el més car.', ac:'Per a cinema et convé una OLED o una Mini LED: els negres es veuen molt més profunds.', ag:"Per jugar, que vagi a 120 Hz o més. T'ensenyo només les que hi arriben.",
          price:'I de preu?'},
      tabrel:{kind:'Què busques?', tab:'Una tauleta', watch:'Un rellotge intel·ligent', os:'iPad o Android?', sios:'iPad', sand:'Android', price:'Quant et vols gastar?',
              who:'Per a qui és?', me:'Per a mi', kid:'Per a un nen o una nena', skid:'per a un nen',
              phone:'Quin mòbil tens?', ios:'iPhone', and:'Android', spi:'per a iPhone', spa:'per a Android',
              akid:'Per a un nen, un amb GPS i botó SOS, per saber sempre on és.', aios:"Amb iPhone, el que en treu més partit és l'Apple Watch.", aand:"L'Apple Watch només funciona amb iPhone, així que t'ensenyo els que van amb Android."},
      so:{kind:'Què busques?', ear:'Auriculars', spk:'Un altaveu', tvh:'Per sentir millor la tele',
          atv:'Per sentir la tele sense apujar el volum a tothom, uns auriculars sense fil per a la tele.',
          type:'Com els prefereixes?', tin:"De botó, dins de l'orella", tov:"De diadema, per sobre de l'orella", tsp:'Per fer esport', stin:'de botó', stov:'de diadema', stsp:'per fer esport',
          phone:'Quin mòbil tens?', pi:'iPhone', ps:'Un Samsung', po:'Un altre', spi:'per a iPhone', sps:'per a Samsung',
          api:'Amb iPhone, els AirPods es connecten sols.', aps:"Amb un Samsung, els Galaxy Buds s'emparellen sols.",
          where:'On el faràs servir?', wh:'A casa', wg:'Per portar-lo a tot arreu', wp:'Per a una festa', swh:'per a casa', swg:'per portar', swp:'per a festes'},
      consoles:{who:'Per a qui és?', me:'Per a mi', kid:'Per a un nen o una nena', fam:'Per jugar en família', sme:'per a mi', skid:'per a un nen', sfam:'per jugar en família',
                which:'En tens alguna al cap?', ps:'PlayStation', nin:'Nintendo Switch', adv:"No ho sé, aconsella'm",
                anin:'Per a nens i per jugar en família, una Nintendo: es juga a la tele i a la mà.',
                aps:'Si jugues molt i tens una tele 4K gran, la versió Pro. Si no, amb la normal en vas sobrat.'},
      drons:{what:'Què vols gravar?', dr:"Des de l'aire, amb un dron", ac:'Esport i aventura', vl:'Viatges i vídeos per a xarxes', se:'Vigilar la casa o el cotxe', pr:'Cinema professional',
             exp:"N'has volat mai cap?", ef:'Mai, seria el primer', ea:'Sí, en vull un de millor', ep:'Vull volar en primera persona', sef:'el primer', sea:'un de millor', sep:'per volar en FPV',
             aef:'Per començar, millor un de petit i lleuger.', aep:'Per volar en primera persona calen unes ulleres. També en tenim.',
             price:'Quant et vols gastar?', a360:'Normal o 360°?', an:'Normal', a3:'360°, per gravar-ho tot', san:'normal', sa3:'360°'},
      pc:{what:'Què necessites?', port:'Un portàtil', sobre:'Un sobretaula o un monitor', emmag:'Un disc o una memòria', impr:'Una impressora o un escàner', comp:'Teclat, cables i més',
          use:'Per a què el faràs servir?', ub:'El bàsic: internet, correu, classes', uw:'Treballar o estudiar a fons', ue:'Editar fotos o vídeo', ug:'Jugar',
          sub:'per al bàsic', suw:'per treballar o estudiar', sue:'per editar fotos o vídeo',
          aub:'Per al bàsic no cal gastar gaire.', aue:'Per editar, el que més es nota és la memòria: com més, millor.',
          nog:"Ara mateix no tenim portàtils per jugar a la web. Digues-nos què busques i te l'aconseguim.",
          os:'Mac o Windows?', mac:'Mac', win:'Windows',
          dw:'Què busques?', desk:'Un ordinador de sobretaula', mon:'Un monitor',
          mu:'Per a què el vols?', mo:'Per treballar o estudiar', mg:'Per jugar', md:'Per a disseny i fotos', smo:'per treballar', smg:'per jugar', smd:'per a disseny',
          amg:'Per jugar, com més hertzs, millor: a partir de 144 Hz es nota molt.', amd:'Per a disseny, millor 4K o una pantalla ampla.',
          sk:'Què necessites?', sext:'Un disc extern', sint:"Un SSD per dins de l'ordinador", scard:'Una targeta de memòria',
          pk:'Què faràs sobretot?', pl:'Imprimir textos', pi:'Imprimir en color i fotos', ps:'Escanejar documents',
          apl:'Si només imprimeixes textos, una làser.', api:'Si imprimeixes molt en color, una de tanc de tinta et surt més barata a la llarga.'},
      llar:{what:'Què busques?', robot:'Un robot aspirador', afeit:'Una afaitadora', gps:'Un GPS per al cotxe', power:'Una bateria portàtil', other:'Una altra cosa de la secció'},
      otra:{q:"Digues-me què busques i ho mirem. Si no el tenim, te l'aconseguim.", ph:'Per exemple: funda per a iPhone 17', send:'Demanar-ho per WhatsApp'},
      horari:(d, o, c) => `Avui, ${d}, obrim de ${o} a ${c}.`, isOpen:'Ara estem oberts.', isClosed:"Ara estem tancats; si ens escrius, et contestem quan obrim.",
      dayOff:f => `Avui tanquem tot el dia${f ? ' (' + f + ')' : ''}. Demà obrim a les 10:00.`, fest:f => `És ${f}, però obrim igualment.`, early:"Avui tanquem abans de l'habitual.",
      on:'Som al centre comercial Illa Carlemany, a Escaldes-Engordany: Electrònica a la planta baixa (local B7) i Informàtica a la planta −1 (local S4).', map:'Obrir el mapa', inside:'Veure la botiga per dins',
      qui:"Som J&M: J&M Electronics Store, des del 2009, i J&M Informàtica i Serveis, des del 2013, totes dues a l'Illa Carlemany. Et diem el que et convé, no el més car.",
      yes:"M'ha servit", no:'Vull parlar amb algú', bye:'Perfecte! Fins aviat.'
    }
  },
  ...(typeof T_FR !== 'undefined' ? {fr: T_FR} : {}),
  ...(typeof T_EN !== 'undefined' ? {en: T_EN} : {})
};
// los idiomas de la web, en este orden (Sergio, 21 oct: castellano, catalán, francés e inglés)
const IDIOMAS = ['es', 'ca', 'fr', 'en'].filter(l => T[l]);

/* ===== textos-seo.js ===== */
/* ---------- el texto plegado al pie de las secciones (Sergio, 3 nov 2026: «probemos el desplegable», aprobado con la prueba del simulador) ----------
   Para Google y los asistentes de IA: la búsqueda real en la línea que se ve («Comprar iPhone en Andorra…»), qué hay y desde cuánto (lo
   rellena pages.js: textoSeo con lo que la sección tiene a la venta hoy, Y {desde}), las preguntas que Google enseña y cómo se compra.
   Cerrado, solo se ve la línea gris; abierto, el título y los párrafos con la letra de la web. Reglas: nada de comparar con España ni de
   aduanas, la garantía es «2 años» a secas (en Apple, el segundo año lo tramita la tienda), la tienda física solo como opción.
   Claves: las secciones (pages.js: SECS) e «iphone» (Móviles con la marca Apple, la colección /collections/iphone). Lo que no está aquí,
   sin desplegable */
const SEO_TXT = {
  es: {
    iphone: {s: 'Comprar iPhone en Andorra: modelos, precios y garantía', h: 'iPhone en Andorra',
      p: ['En J&M tenemos iPhone a la venta, del iPhone 17e al 17 Pro Max y el iPhone Air, en sus capacidades y colores. Precios desde {desde}, con el IGI del 4,5 % incluido.'],
      qa: [['¿Cuánto cuesta un iPhone en Andorra?', 'Hoy, desde {desde}. Los precios de esta página son los de la tienda y se actualizan cada día.'],
        ['¿Qué garantía tiene?', '2 años. El primer año lo gestiona Apple y el segundo lo tramitamos nosotros.'],
        ['¿Cómo lo compro?', 'Resérvalo por WhatsApp y recógelo en la Illa Carlemany (Escaldes-Engordany), o te lo enviamos.']]},
    mobils: {s: 'Comprar móviles en Andorra: iPhone, Samsung Galaxy y Xiaomi', h: 'Móviles en Andorra',
      p: ['Móviles a la venta: iPhone, Samsung Galaxy (también los plegables Z Fold y Z Flip) y Xiaomi, libres y nuevos. Precios desde {desde}, con el IGI del 4,5 % incluido.',
        'Todos llevan garantía de 2 años. Resérvalo por WhatsApp y recógelo en la Illa Carlemany (Escaldes-Engordany), o te lo enviamos.']},
    tv: {s: 'Comprar televisores en Andorra: OLED, QLED y Mini LED', h: 'Televisores en Andorra',
      p: ['Televisores a la venta de Samsung, LG, Sony, Philips, Hisense y TCL, de 24 a 100 pulgadas: OLED, QLED, Mini LED y LED. Precios desde {desde}, con el IGI del 4,5 % incluido.'],
      qa: [['¿Me lo lleváis a casa?', 'Sí: te lo llevamos a casa en Andorra, o lo recoges en la Illa Carlemany (Escaldes-Engordany).'],
        ['¿Qué garantía tiene?', '2 años, en todos los televisores.']]},
    tabrel: {s: 'Comprar tablets y relojes en Andorra: iPad, Galaxy Tab y Apple Watch', h: 'Tablets y relojes en Andorra',
      p: ['Tablets y relojes a la venta: iPad, Samsung Galaxy Tab y Xiaomi Pad; Apple Watch, Galaxy Watch y relojes Xiaomi. Precios desde {desde}, con el IGI del 4,5 % incluido.',
        'Garantía de 2 años. Resérvalo por WhatsApp y recógelo en la Illa Carlemany (Escaldes-Engordany), o te lo enviamos.']},
    so: {s: 'Comprar auriculares y altavoces en Andorra: AirPods, Bose y JBL', h: 'Auriculares y altavoces en Andorra',
      p: ['Auriculares y altavoces a la venta: AirPods, Bose, JBL, Samsung Galaxy Buds y Xiaomi, de botón, de diadema y altavoces. Precios desde {desde}, con el IGI del 4,5 % incluido.',
        'Garantía de 2 años. Resérvalo por WhatsApp y recógelo en la Illa Carlemany (Escaldes-Engordany), o te lo enviamos.']},
    consoles: {s: 'Comprar consolas en Andorra: PlayStation 5 y Nintendo Switch 2', h: 'Consolas en Andorra',
      p: ['Consolas y accesorios a la venta: PlayStation 5, Nintendo Switch 2 y sus mandos. Precios desde {desde}, con el IGI del 4,5 % incluido.',
        'Garantía de 2 años. Si es para regalo, te la envolvemos gratis. Resérvala por WhatsApp y recógela en la Illa Carlemany (Escaldes-Engordany).']},
    drons: {s: 'Comprar drones y cámaras en Andorra: DJI e Insta360', h: 'Drones y cámaras en Andorra',
      p: ['Drones, cámaras y estabilizadores a la venta: DJI Mini, Neo, Flip, Air y Avata, cámaras Osmo y Insta360. Precios desde {desde}, con el IGI del 4,5 % incluido.',
        'Garantía de 2 años. Resérvalo por WhatsApp y recógelo en la Illa Carlemany (Escaldes-Engordany), o te lo enviamos.']},
    port: {s: 'Comprar portátiles en Andorra: MacBook y portátiles con Windows', h: 'Portátiles en Andorra',
      p: ['Portátiles a la venta: MacBook y portátiles con Windows. Precios desde {desde}, con el IGI del 4,5 % incluido.',
        'Garantía de 2 años. Te asesoramos en la tienda de informática de la planta −1 de la Illa Carlemany (Escaldes-Engordany), con servicio técnico propio.']}
  },
  ca: {
    iphone: {s: "Comprar iPhone a Andorra: models, preus i garantia", h: 'iPhone a Andorra',
      p: ["A J&M tenim iPhone a la venda, de l'iPhone 17e al 17 Pro Max i l'iPhone Air, en totes les capacitats i colors. Preus des de {desde}, amb l'IGI del 4,5 % inclòs."],
      qa: [["Quant costa un iPhone a Andorra?", "Avui, des de {desde}. Els preus d'aquesta pàgina són els de la botiga i s'actualitzen cada dia."],
        ['Quina garantia té?', "2 anys. El primer any el gestiona Apple i el segon el tramitem nosaltres."],
        ['Com el compro?', "Reserva'l per WhatsApp i recull-lo a l'Illa Carlemany (Escaldes-Engordany), o te l'enviem."]]},
    mobils: {s: 'Comprar mòbils a Andorra: iPhone, Samsung Galaxy i Xiaomi', h: 'Mòbils a Andorra',
      p: ["Mòbils a la venda: iPhone, Samsung Galaxy (també els plegables Z Fold i Z Flip) i Xiaomi, lliures i nous. Preus des de {desde}, amb l'IGI del 4,5 % inclòs.",
        "Tots porten garantia de 2 anys. Reserva'l per WhatsApp i recull-lo a l'Illa Carlemany (Escaldes-Engordany), o te l'enviem."]},
    tv: {s: 'Comprar televisors a Andorra: OLED, QLED i Mini LED', h: 'Televisors a Andorra',
      p: ["Televisors a la venda de Samsung, LG, Sony, Philips, Hisense i TCL, de 24 a 100 polzades: OLED, QLED, Mini LED i LED. Preus des de {desde}, amb l'IGI del 4,5 % inclòs."],
      qa: [["Me'l porteu a casa?", "Sí: te'l portem a casa a Andorra, o el reculls a l'Illa Carlemany (Escaldes-Engordany)."],
        ['Quina garantia té?', '2 anys, en tots els televisors.']]},
    tabrel: {s: 'Comprar tauletes i rellotges a Andorra: iPad, Galaxy Tab i Apple Watch', h: 'Tauletes i rellotges a Andorra',
      p: ["Tauletes i rellotges a la venda: iPad, Samsung Galaxy Tab i Xiaomi Pad; Apple Watch, Galaxy Watch i rellotges Xiaomi. Preus des de {desde}, amb l'IGI del 4,5 % inclòs.",
        "Garantia de 2 anys. Reserva'l per WhatsApp i recull-lo a l'Illa Carlemany (Escaldes-Engordany), o te l'enviem."]},
    so: {s: 'Comprar auriculars i altaveus a Andorra: AirPods, Bose i JBL', h: 'Auriculars i altaveus a Andorra',
      p: ["Auriculars i altaveus a la venda: AirPods, Bose, JBL, Samsung Galaxy Buds i Xiaomi, de botó, de diadema i altaveus. Preus des de {desde}, amb l'IGI del 4,5 % inclòs.",
        "Garantia de 2 anys. Reserva'l per WhatsApp i recull-lo a l'Illa Carlemany (Escaldes-Engordany), o te l'enviem."]},
    consoles: {s: 'Comprar consoles a Andorra: PlayStation 5 i Nintendo Switch 2', h: 'Consoles a Andorra',
      p: ["Consoles i accessoris a la venda: PlayStation 5, Nintendo Switch 2 i els seus comandaments. Preus des de {desde}, amb l'IGI del 4,5 % inclòs.",
        "Garantia de 2 anys. Si és per regalar, te l'emboliquem de franc. Reserva-la per WhatsApp i recull-la a l'Illa Carlemany (Escaldes-Engordany)."]},
    drons: {s: 'Comprar drons i càmeres a Andorra: DJI i Insta360', h: 'Drons i càmeres a Andorra',
      p: ["Drons, càmeres i estabilitzadors a la venda: DJI Mini, Neo, Flip, Air i Avata, càmeres Osmo i Insta360. Preus des de {desde}, amb l'IGI del 4,5 % inclòs.",
        "Garantia de 2 anys. Reserva'l per WhatsApp i recull-lo a l'Illa Carlemany (Escaldes-Engordany), o te l'enviem."]},
    port: {s: 'Comprar portàtils a Andorra: MacBook i portàtils amb Windows', h: 'Portàtils a Andorra',
      p: ["Portàtils a la venda: MacBook i portàtils amb Windows. Preus des de {desde}, amb l'IGI del 4,5 % inclòs.",
        "Garantia de 2 anys. T'assessorem a la botiga d'informàtica de la planta −1 de l'Illa Carlemany (Escaldes-Engordany), amb servei tècnic propi."]}
  },
  fr: {
    iphone: {s: 'Acheter un iPhone en Andorre : modèles, prix et garantie', h: 'iPhone en Andorre',
      p: ["Chez J&M, les iPhone sont en vente, de l'iPhone 17e au 17 Pro Max et l'iPhone Air, dans toutes les capacités et couleurs. Prix à partir de {desde}, IGI de 4,5 % inclus."],
      qa: [['Combien coûte un iPhone en Andorre ?', "Aujourd'hui, à partir de {desde}. Les prix de cette page sont ceux de la boutique et sont mis à jour chaque jour."],
        ['Quelle garantie ?', "2 ans. La première année est gérée par Apple et la deuxième, c'est nous qui nous en occupons."],
        ["Comment l'acheter ?", "Réservez-le par WhatsApp et retirez-le à l'Illa Carlemany (Escaldes-Engordany), ou nous vous l'envoyons."]]},
    mobils: {s: 'Acheter un smartphone en Andorre : iPhone, Samsung Galaxy et Xiaomi', h: 'Smartphones en Andorre',
      p: ['Smartphones en vente : iPhone, Samsung Galaxy (y compris les pliables Z Fold et Z Flip) et Xiaomi, neufs et débloqués. Prix à partir de {desde}, IGI de 4,5 % inclus.',
        "Garantie de 2 ans. Réservez-le par WhatsApp et retirez-le à l'Illa Carlemany (Escaldes-Engordany), ou nous vous l'envoyons."]},
    tv: {s: 'Acheter un téléviseur en Andorre : OLED, QLED et Mini LED', h: 'Téléviseurs en Andorre',
      p: ['Téléviseurs en vente : Samsung, LG, Sony, Philips, Hisense et TCL, de 24 à 100 pouces, OLED, QLED, Mini LED et LED. Prix à partir de {desde}, IGI de 4,5 % inclus.'],
      qa: [['Vous le livrez à domicile ?', "Oui : nous le livrons chez vous en Andorre, ou vous le retirez à l'Illa Carlemany (Escaldes-Engordany)."],
        ['Quelle garantie ?', '2 ans, sur tous les téléviseurs.']]},
    tabrel: {s: 'Acheter une tablette ou une montre en Andorre : iPad, Galaxy Tab et Apple Watch', h: 'Tablettes et montres en Andorre',
      p: ['Tablettes et montres en vente : iPad, Samsung Galaxy Tab et Xiaomi Pad ; Apple Watch, Galaxy Watch et montres Xiaomi. Prix à partir de {desde}, IGI de 4,5 % inclus.',
        "Garantie de 2 ans. Réservez par WhatsApp et retirez à l'Illa Carlemany (Escaldes-Engordany), ou nous vous l'envoyons."]},
    so: {s: 'Acheter des écouteurs et des enceintes en Andorre : AirPods, Bose et JBL', h: 'Écouteurs et enceintes en Andorre',
      p: ['Écouteurs et enceintes en vente : AirPods, Bose, JBL, Samsung Galaxy Buds et Xiaomi, intra-auriculaires, casques et enceintes. Prix à partir de {desde}, IGI de 4,5 % inclus.',
        "Garantie de 2 ans. Réservez par WhatsApp et retirez à l'Illa Carlemany (Escaldes-Engordany), ou nous vous l'envoyons."]},
    consoles: {s: 'Acheter une console en Andorre : PlayStation 5 et Nintendo Switch 2', h: 'Consoles en Andorre',
      p: ['Consoles et accessoires en vente : PlayStation 5, Nintendo Switch 2 et leurs manettes. Prix à partir de {desde}, IGI de 4,5 % inclus.',
        "Garantie de 2 ans. Pour un cadeau, paquet cadeau offert. Réservez par WhatsApp et retirez à l'Illa Carlemany (Escaldes-Engordany)."]},
    drons: {s: 'Acheter un drone ou une caméra en Andorre : DJI et Insta360', h: 'Drones et caméras en Andorre',
      p: ['Drones, caméras et stabilisateurs en vente : DJI Mini, Neo, Flip, Air et Avata, caméras Osmo et Insta360. Prix à partir de {desde}, IGI de 4,5 % inclus.',
        "Garantie de 2 ans. Réservez par WhatsApp et retirez à l'Illa Carlemany (Escaldes-Engordany), ou nous vous l'envoyons."]},
    port: {s: 'Acheter un ordinateur portable en Andorre : MacBook et PC Windows', h: 'Ordinateurs portables en Andorre',
      p: ['Ordinateurs portables en vente : MacBook et PC sous Windows. Prix à partir de {desde}, IGI de 4,5 % inclus.',
        "Garantie de 2 ans. Nous vous conseillons dans la boutique informatique du niveau −1 de l'Illa Carlemany (Escaldes-Engordany), avec notre propre service technique."]}
  },
  en: {
    iphone: {s: 'Buy an iPhone in Andorra: models, prices and warranty', h: 'iPhone in Andorra',
      p: ['At J&M we have iPhones for sale, from the iPhone 17e to the 17 Pro Max and the iPhone Air, in every capacity and colour. Prices from {desde}, with the 4.5% IGI included.'],
      qa: [['How much does an iPhone cost in Andorra?', "Today, from {desde}. The prices on this page are the store's own and are updated every day."],
        ['What warranty does it have?', '2 years. Apple handles the first year and we handle the second.'],
        ['How do I buy it?', 'Reserve it on WhatsApp and pick it up at Illa Carlemany (Escaldes-Engordany), or we ship it to you.']]},
    mobils: {s: 'Buy a phone in Andorra: iPhone, Samsung Galaxy and Xiaomi', h: 'Phones in Andorra',
      p: ['Phones for sale: iPhone, Samsung Galaxy (including the Z Fold and Z Flip foldables) and Xiaomi, new and unlocked. Prices from {desde}, with the 4.5% IGI included.',
        'All with a 2-year warranty. Reserve it on WhatsApp and pick it up at Illa Carlemany (Escaldes-Engordany), or we ship it to you.']},
    tv: {s: 'Buy a TV in Andorra: OLED, QLED and Mini LED', h: 'TVs in Andorra',
      p: ['TVs for sale from Samsung, LG, Sony, Philips, Hisense and TCL, from 24 to 100 inches: OLED, QLED, Mini LED and LED. Prices from {desde}, with the 4.5% IGI included.'],
      qa: [['Do you deliver to my home?', 'Yes: we deliver to your home in Andorra, or you pick it up at Illa Carlemany (Escaldes-Engordany).'],
        ['What warranty does it have?', '2 years, on every TV.']]},
    tabrel: {s: 'Buy tablets and watches in Andorra: iPad, Galaxy Tab and Apple Watch', h: 'Tablets and watches in Andorra',
      p: ['Tablets and watches for sale: iPad, Samsung Galaxy Tab and Xiaomi Pad; Apple Watch, Galaxy Watch and Xiaomi watches. Prices from {desde}, with the 4.5% IGI included.',
        '2-year warranty. Reserve on WhatsApp and pick it up at Illa Carlemany (Escaldes-Engordany), or we ship it to you.']},
    so: {s: 'Buy headphones and speakers in Andorra: AirPods, Bose and JBL', h: 'Headphones and speakers in Andorra',
      p: ['Headphones and speakers for sale: AirPods, Bose, JBL, Samsung Galaxy Buds and Xiaomi, earbuds, headphones and speakers. Prices from {desde}, with the 4.5% IGI included.',
        '2-year warranty. Reserve on WhatsApp and pick it up at Illa Carlemany (Escaldes-Engordany), or we ship it to you.']},
    consoles: {s: 'Buy consoles in Andorra: PlayStation 5 and Nintendo Switch 2', h: 'Consoles in Andorra',
      p: ['Consoles and accessories for sale: PlayStation 5, Nintendo Switch 2 and their controllers. Prices from {desde}, with the 4.5% IGI included.',
        "2-year warranty. If it's a gift, we'll gift-wrap it for free. Reserve on WhatsApp and pick it up at Illa Carlemany (Escaldes-Engordany)."]},
    drons: {s: 'Buy drones and cameras in Andorra: DJI and Insta360', h: 'Drones and cameras in Andorra',
      p: ['Drones, cameras and gimbals for sale: DJI Mini, Neo, Flip, Air and Avata, Osmo cameras and Insta360. Prices from {desde}, with the 4.5% IGI included.',
        '2-year warranty. Reserve on WhatsApp and pick it up at Illa Carlemany (Escaldes-Engordany), or we ship it to you.']},
    port: {s: 'Buy laptops in Andorra: MacBook and Windows laptops', h: 'Laptops in Andorra',
      p: ['Laptops for sale: MacBook and Windows laptops. Prices from {desde}, with the 4.5% IGI included.',
        '2-year warranty. Get advice at our computer store on level −1 of Illa Carlemany (Escaldes-Engordany), with our own repair service.']}
  }
};

/* ===== hours.js ===== */
/* ---------- el horario: el calendario oficial de la Illa Carlemany 2026, tal como está en n8n ----------
   (flujo «JM Horarios Tienda 2026», transcrito del Calendari2026.pdf). En la web real no se copia:
   se lee de un solo sitio para que web y bot digan siempre lo mismo. */
const H_OPEN = '10:00';
const H_DEFAULTS = {0: '20:00', 1: '20:30', 2: '20:30', 3: '20:30', 4: '20:30', 5: '21:00', 6: '21:00'};
const H_EXC = {
  '2026-01-01': 'CERRADO', '2026-01-04': '21:00', '2026-01-05': '21:00', '2026-03-14': 'CERRADO', '2026-04-02': '21:00', '2026-04-05': '21:00',
  '2026-07-20': '21:00', '2026-07-21': '21:00', '2026-07-22': '21:00', '2026-07-23': '21:00', '2026-07-27': '21:00', '2026-07-28': '21:00', '2026-07-29': '21:00', '2026-07-30': '21:00',
  '2026-08-03': '21:00', '2026-08-04': '21:00', '2026-08-05': '21:00', '2026-08-06': '21:00', '2026-08-10': '21:00', '2026-08-11': '21:00', '2026-08-12': '21:00', '2026-08-13': '21:00',
  '2026-08-17': '21:00', '2026-08-18': '21:00', '2026-08-19': '21:00', '2026-08-20': '21:00', '2026-08-24': '21:00', '2026-08-25': '21:00', '2026-08-26': '21:00', '2026-08-27': '21:00',
  '2026-09-08': 'CERRADO', '2026-10-11': '21:00',
  '2026-12-06': '21:00', '2026-12-07': '21:00', '2026-12-20': '21:00', '2026-12-21': '21:00', '2026-12-22': '21:00', '2026-12-23': '21:00', '2026-12-24': '19:00', '2026-12-25': 'CERRADO',
  '2026-12-27': '21:00', '2026-12-28': '21:00', '2026-12-29': '21:00', '2026-12-30': '21:00', '2026-12-31': '19:00',
  '2027-01-01': 'CERRADO', '2027-01-03': '21:00', '2027-01-04': '21:00', '2027-01-05': '21:00'
};
const H_FEST = {
  '01-01': ["Cap d'Any", "Cap d'Any", 'le Jour de l\'An', "New Year's Day"], '01-06': ['Reyes', 'Reis', 'l\'Épiphanie', 'Epiphany'], '03-14': ['Día de la Constitución', 'Dia de la Constitució', 'le Jour de la Constitution', 'Constitution Day'],
  '05-01': ['Fiesta del Trabajo', 'Festa del Treball', 'la Fête du Travail', 'Labour Day'], '08-15': ['la Asunción', "l'Assumpció", 'l\'Assomption', 'Assumption Day'], '09-08': ['Nuestra Señora de Meritxell', 'Nostra Senyora de Meritxell', 'Notre-Dame de Meritxell', 'Our Lady of Meritxell Day'],
  '10-12': ['Fiesta Nacional de España', "Festa Nacional d'Espanya", 'la Fête nationale espagnole', "Spain's National Day"], '11-01': ['Todos los Santos', 'Tots Sants', 'la Toussaint', "All Saints' Day"], '12-08': ['la Purísima', 'la Puríssima', 'l\'Immaculée Conception', 'the Immaculate Conception'],
  '12-25': ['Navidad', 'Nadal', 'Noël', 'Christmas Day'], '12-26': ['San Esteban', 'Sant Esteve', 'la Saint-Étienne', "St Stephen's Day"],
  '2026-02-16': ['Carnaval', 'Carnaval', 'le Carnaval', 'Carnival'], '2026-04-03': ['Viernes Santo', 'Divendres Sant', 'le Vendredi saint', 'Good Friday'], '2026-04-06': ['Lunes de Pascua', 'Dilluns de Pasqua', 'le Lundi de Pâques', 'Easter Monday'],
  '2026-05-25': ['Pentecostés', 'Pentecosta', 'le Lundi de Pentecôte', 'Whit Monday'], '2026-07-25': ["Fiesta Mayor d'Escaldes", "Festa Major d'Escaldes", 'la fête d\'Escaldes', 'the Escaldes festival'], '2026-07-26': ["Fiesta Mayor d'Escaldes", "Festa Major d'Escaldes", 'la fête d\'Escaldes', 'the Escaldes festival']
};
// (cada festivo, en castellano, catalán, francés e inglés: festDe da el del idioma de la web)
const FEST_IDIOMAS = ['es', 'ca', 'fr', 'en'];
const festDe = (f, lang) => f ? f[FEST_IDIOMAS.indexOf(lang)] || f[0] : '';
const H_FIXED = ['01-01', '03-14', '09-08', '12-25'];
const H_LAST = '2027-01-06';
const dkey = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
function dayInfo(d) {
  const key = dkey(d), md = key.slice(5), generic = key < '2026-01-01' || key > H_LAST, exc = H_EXC[key];
  const fest = H_FEST[key] || H_FEST[md] || null;
  if (exc === 'CERRADO' || (generic && H_FIXED.includes(md))) return {key, closed: true, fest, generic};
  return {key, closed: false, open: H_OPEN, close: exc || H_DEFAULTS[d.getDay()], fest, generic, early: exc === '19:00'};
}
function hours(d = new Date()) {
  const i = dayInfo(d), m = d.getHours() * 60 + d.getMinutes();
  const [ch, cm] = (i.close || '00:00').split(':').map(Number);
  return {day: d.getDay(), open: H_OPEN, close: i.close, dayOff: i.closed, fest: i.fest, early: i.early, isOpen: !i.closed && m >= 600 && m < ch * 60 + cm};
}
/* los próximos días con horario distinto del normal, para la página de horario */
function upcomingSpecial(from = new Date(), max = 4) {
  const out = [];
  for (let k = 0; k < 120 && out.length < max; k++) {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate() + k), i = dayInfo(d);
    if (i.generic) break;
    if (i.closed || i.close !== H_DEFAULTS[d.getDay()]) out.push([d, i]);
  }
  return out;
}

/* ===== scene.js ===== */
/* ---------- proyección: cenital en diagonal ---------- */
const NS = 'http://www.w3.org/2000/svg';
// la cámara de la tienda (cenital en diagonal); las imágenes de entrada usan otra más de frente
const U = 40;
let C, S, SP, CP;
function setCam(th, ph) { C = Math.cos(th * Math.PI / 180); S = Math.sin(th * Math.PI / 180); SP = Math.sin(ph * Math.PI / 180); CP = Math.cos(ph * Math.PI / 180); }
setCam(32, 54);
function withCam(th, ph, fn) { const prev = [C, S, SP, CP]; setCam(th, ph); try { return fn(); } finally { [C, S, SP, CP] = prev; } }
let REC = null;
const P = (x, y, z) => { if (REC) REC.push(x, y, z); return [(x * C - y * S) * U, (-(x * S + y * C) * SP - z * CP) * U]; };
const dep = (x, y) => x * S + y * C;
const el = (tag, attrs = {}, parent) => { const n = document.createElementNS(NS, tag); for (const k in attrs) n.setAttribute(k, attrs[k]); if (parent) parent.appendChild(n); return n; };
const pts = list => list.map(p => P(...p).map(v => v.toFixed(1)).join(',')).join(' ');
const poly = (g, list, attrs) => el('polygon', Object.assign({points: pts(list)}, attrs), g);
function box(g, [x0, y0, z0, x1, y1, z1], c) {
  poly(g, [[x0,y0,z0],[x0,y1,z0],[x0,y1,z1],[x0,y0,z1]], {fill: c.l});
  poly(g, [[x0,y0,z0],[x1,y0,z0],[x1,y0,z1],[x0,y0,z1]], {fill: c.f});
  poly(g, [[x0,y0,z1],[x1,y0,z1],[x1,y1,z1],[x0,y1,z1]], {fill: c.t});
}
const WHITE = {t:'#FFFFFF', f:'#E9E4DA', l:'#DCD5C8'};
const WOOD  = {t:'#E9DCC4', f:'#D2C1A3', l:'#C4B293'};
const DARK  = {t:'#3a3f4a', f:'#23262c', l:'#2c3038'};
const BLUE  = {t:'#F4EFE6', f:'#1d2a5c', l:'#16214a'};
const SAND  = {t:'#EFE3CC', f:'#DCCBA9', l:'#CDBB97'};
const NAVY  = {t:'#3b4f8f', f:'#1d2a5c', l:'#24336b'};
const WALL  = {t:'#C9C0B1', f:'#F6F2EA', l:'#D6CEC0'};
const WALLR = {t:'#C9C0B1', f:'#D6CEC0', l:'#EEE8DD'};
const SLAB  = {t:'#E4DCCD', f:'#D3C9B8', l:'#C7BCA9'};
const SILVER = {t:'#d9dce1', f:'#c3c8cf', l:'#b8bdc5'};
const onTop = (g, x, y, z, w, d, attrs) => poly(g, [[x,y,z],[x+w,y,z],[x+w,y+d,z],[x,y+d,z]], attrs);
const onFront = (g, x, y, z, w, h, attrs) => poly(g, [[x,y,z],[x+w,y,z],[x+w,y,z+h],[x,y,z+h]], attrs);
const onLeft = (g, x, y, z, d, h, attrs) => poly(g, [[x,y,z],[x,y+d,z],[x,y+d,z+h],[x,y,z+h]], attrs);
function wallMatrix(o, u, v) { const O = P(...o), A = P(o[0]+u[0], o[1]+u[1], o[2]+u[2]), B = P(o[0]+v[0], o[1]+v[1], o[2]+v[2]); return `matrix(${A[0]-O[0]} ${A[1]-O[1]} ${B[0]-O[0]} ${B[1]-O[1]} ${O[0]} ${O[1]})`; }
const SCR = v => ({fill:'#1a2147', class:'scr', 'data-v': v});

/* ---------- el edificio: las dos tiendas del editor, la planta baja arriba y la −1 debajo ----------
   tienda-editor.cjs las dibuja al montar la web (con el mismo motor y la misma cámara que el editor) y las deja aquí como SVG:
   cada mueble en su zona. Solo desde editor/datos/tienda.json: el reparto de la web es inventado a propósito */
const TIENDA = window.__JM_D.TIENDA;
const FLOORS = TIENDA.plantas;
const ZONES = TIENDA.zonas;
const ZONE_IDS = Object.keys(ZONES);
const zz = id => ZONES[id].z || 0;
// los iconos de la portada en 3D (webp, del montaje); si falta alguno, se dibuja como antes (MINI)
const ICONOS3D = window.__JM_D.ICONOS3D;
const labAt = id => { const z = ZONES[id]; return [z.lab[0], z.lab[1], zz(id) + z.lab[2]]; };
// una zona son varios muebles repartidos por el orden de dibujo: se mueven y se encienden juntos
function zoneGroup(els) {
  const each = fn => els.forEach(fn);
  return {
    els,
    setAttribute: (k, v) => each(e => e.setAttribute(k, v)),
    removeAttribute: k => each(e => e.removeAttribute(k)),
    classList: {add: c => each(e => e.classList.add(c)), remove: c => each(e => e.classList.remove(c)), toggle: (c, on) => each(e => e.classList.toggle(c, on))},
    querySelectorAll: q => els.flatMap(e => [...e.querySelectorAll(q)])
  };
}
// el logo de J&M tal como lo pinta el editor (el óvalo y las letras), para los carteles
function logoDefs(svg) {
  const L = TIENDA.logo, defs = el('defs', {}, svg), g = el('g', {id: 'jm-logo-ed'}, defs);
  el('ellipse', {cx: L.elipse.cx, cy: L.elipse.cy, rx: L.elipse.rx, ry: L.elipse.ry, fill: L.elipse.f}, g);
  L.trazos.forEach(t => el('path', {d: t.d, fill: t.f, 'fill-rule': 'evenodd', transform: `translate(${t.t[0]} ${t.t[1]}) scale(${t.t[2]})`}, g));
}

function buildScene(svg) {
  const F = {};
  if (!document.getElementById('jm-logo-ed')) logoDefs(svg);
  for (const f of ['b1', 'pb']) {
    const g = el('g', {class:'floor', 'data-f': f}, svg), fl = FLOORS[f];
    F[f] = {g};
    ['under','drops','shade','pools','items','beams'].forEach(k => F[f][k] = el('g', {class:'l-' + k}, g));
    if (f === 'b1') F.links = el('g', {class:'l-links'}, svg);
    F[f].under.innerHTML = fl.suelo;
    F[f].items.innerHTML = (fl.defs ? `<defs>${fl.defs}</defs>` : '') + fl.nodos;
    // lo del local (paredes y lo que no es de ninguna zona) entra con las paredes
    F[f].walls = zoneGroup([...F[f].items.querySelectorAll(':scope > .pw, :scope > .ow')]);
    // la sombra que aparece al pasar por una zona: el suelo y las dos paredes del fondo
    const {x, y, z, W, D, H} = fl, sh = el('g', {class:'shade'}, F[f].shade);
    poly(sh, [[x, y, z], [x + W, y, z], [x + W, y + D, z], [x, y + D, z]], {fill:'rgba(26,29,33,.09)'});
    poly(sh, [[x, y + D, z], [x + W, y + D, z], [x + W, y + D, z + H], [x, y + D, z + H]], {fill:'rgba(26,29,33,.07)'});
    poly(sh, [[x + W, y, z], [x + W, y + D, z], [x + W, y + D, z + H], [x + W, y, z + H]], {fill:'rgba(26,29,33,.07)'});
  }
  F.hits = el('g', {class:'l-hits'}, svg);
  const zg = {}, pools = {}, beams = {}, shadows = {};
  for (const id of ZONE_IDS) {
    const z = ZONES[id], f = z.f, Lf = F[f], z0 = zz(id), [x0, y0, x1, y1] = z.floor;
    zg[id] = zoneGroup([...svg.querySelectorAll(`.zg[data-z="${id}"]`)]);
    const [cx, cy] = P(z.light[0], z.light[1], z0);
    const c4 = [[x0,y0],[x1,y0],[x1,y1],[x0,y1]].map(([x, y]) => P(x, y, z0));
    const rx = (Math.max(...c4.map(p => p[0])) - Math.min(...c4.map(p => p[0]))) * 0.66;
    const ry = (Math.max(...c4.map(p => p[1])) - Math.min(...c4.map(p => p[1]))) * 0.78;
    pools[id] = el('ellipse', {class:'pool', 'data-z': id, cx, cy, rx, ry, fill:'url(#pool)'}, Lf.pools);
    shadows[id] = el('ellipse', {cx, cy, rx: rx * 0.5, ry: ry * 0.45, fill:'url(#drop)', opacity:0}, Lf.drops);
    const bh = z0 + FLOORS[f].H + 0.05;
    beams[id] = poly(Lf.beams, [[x0,y0,z0],[x1,y0,z0],[x1,y0,bh],[x1,y1,bh],[x0,y1,bh],[x0,y1,z0]], {class:'beam', 'data-z': id, fill:'url(#beam)'});
    // por dónde se pulsa: la silueta de cada mueble de la zona
    const hit = el('g', {class:'hit', 'data-z': id, 'data-f': f}, F.hits);
    z.hits.forEach(h => el('path', {d: 'M' + h.map(p => p.join(' ')).join('L') + 'Z'}, hit));
  }

  /* las aristas que unen las dos plantas: de las esquinas de la −1 a la losa de la planta baja */
  const b = FLOORS.b1, pz = FLOORS.pb.z - 0.45;
  [[b.x - 0.25, b.y - 0.25], [b.x + b.W + 0.25, b.y - 0.25], [b.x - 0.25, b.y + b.D + 0.25]].forEach(([x, y]) =>
    el('polyline', {points: pts([[x, y, pz], [x, y, b.z + 0.32]]), stroke:'#b3ab9e', 'stroke-width':1.2, 'stroke-dasharray':'4 6', fill:'none'}, F.links));
  return {F, zg, pools, beams, shadows};
}

function counterTop(g, x0, y0, z, x1) {
  box(g, [x0, y0, z, x1, y0 + 0.55, z + 1.05], BLUE);
  box(g, [x0 + 0.5, y0 + 0.15, z + 1.05, x0 + 0.8, y0 + 0.35, z + 1.12], DARK);
  onFront(g, x0 + 0.53, y0 + 0.15, z + 1.12, 0.24, 0.14, SCR(2));
}
function drone(g, x, y, z, k) {
  const a = 0.26 * k, b = 0.2 * k;
  el('polyline', {points: pts([[x - a, y - b, z], [x + a, y + b, z]]), stroke:'#3a3f4a', 'stroke-width':2.2 * k, fill:'none'}, g);
  el('polyline', {points: pts([[x - a, y + b, z], [x + a, y - b, z]]), stroke:'#3a3f4a', 'stroke-width':2.2 * k, fill:'none'}, g);
  [[-a,-b],[a,b],[-a,b],[a,-b]].forEach(([dx, dy]) => { const [px, py] = P(x + dx, y + dy, z); el('ellipse', {cx:px, cy:py, rx:5.2 * k, ry:5.2 * k * SP, fill:'rgba(58,63,74,.28)', stroke:'#3a3f4a', 'stroke-width':1}, g); });
  box(g, [x - 0.07 * k, y - 0.06 * k, z - 0.07, x + 0.07 * k, y + 0.06 * k, z + 0.01], DARK);
}
function ring(x, y, z, r, n = 28) { const c = []; for (let i = 0; i < n; i++) { const a = i / n * Math.PI * 2; c.push([x + Math.cos(a) * r, y + Math.sin(a) * r, z]); } return c; }
function puck(g, x, y, z, r) {
  for (let k = 0; k < 5; k++) poly(g, ring(x, y, z + k * 0.028, r), {fill: k < 4 ? '#23262c' : '#3a3f4a'});
  poly(g, ring(x, y, z + 0.115, r * 0.94), {fill:'#3a3f4a'});
  poly(g, ring(x + r * 0.35, y + r * 0.2, z + 0.12, r * 0.22), {fill:'#4f5663'});
}

/* ---------- los objetos de la lista (los mismos muebles, en pequeño) ---------- */
const MINI = {
  tv: g => { box(g, [0.55,0.12,0, 0.95,0.42,0.05], DARK); box(g, [0.72,0.27,0.05, 0.78,0.33,0.24], DARK); box(g, [0,0.28,0.24, 1.5,0.34,1.12], {t:'#2c3038', f:'#11163a', l:'#10142e'}); onFront(g, 0.04, 0.279, 0.28, 1.42, 0.8, SCR(1)); },
  mobils: g => { box(g, [-0.1,-0.12,0, 1.05,0.5,0.04], {t:'#F4EFE6', f:'#DCD5C8', l:'#D2CABC'}); box(g, [0.55,0.3,0.04, 0.9,0.34,0.76], {t:'#3a3f4a', f:'#2b2f38', l:'#23262c'}); onFront(g, 0.57, 0.299, 0.07, 0.31, 0.65, SCR(2)); box(g, [0.05,0.02,0.04, 0.4,0.06,0.76], {t:'#3a3f4a', f:'#2b2f38', l:'#23262c'}); onFront(g, 0.07, 0.019, 0.07, 0.31, 0.65, SCR(1)); },
  tabrel: g => { box(g, [0,0.3,0, 0.95,0.36,0.7], {t:'#3a3f4a', f:'#2b2f38', l:'#23262c'}); onFront(g, 0.04, 0.299, 0.04, 0.87, 0.62, SCR(3)); box(g, [1.12,0.02,0, 1.3,0.62,0.025], DARK); box(g, [1.06,0.16,0.025, 1.36,0.46,0.13], {t:'#3a3f4a', f:'#2b2f38', l:'#23262c'}); onTop(g, 1.09, 0.19, 0.131, 0.24, 0.24, SCR(2)); },
  so: g => { box(g, [0,0,0, 0.55,0.42,0.86], DARK); poly(g, circleFront(0.275, -0.001, 0.52, 0.16), {fill:'#4a505c'}); poly(g, circleFront(0.275, -0.002, 0.2, 0.08), {fill:'#4a505c'}); },
  consoles: g => { box(g, [0,0,0, 0.17,0.5,0.66], WHITE); onLeft(g, -0.001, 0.2, 0, 0.1, 0.66, {fill:'#23262c'}); box(g, [0.45,0.02,0, 0.82,0.24,0.08], DARK); },
  drons: g => { drone(g, 0.5, 0.4, 0.12, 2.2); },
  llar: g => { puck(g, 0.5, 0.5, 0, 0.5); },
  port: g => { box(g, [0,0,0, 0.95,0.62,0.035], SILVER); poly(g, [[0,0.6,0.035],[0.95,0.6,0.035],[0.95,0.78,0.66],[0,0.78,0.66]], {fill:'#9ea4ad'}); poly(g, [[0.04,0.598,0.07],[0.91,0.598,0.07],[0.91,0.776,0.62],[0.04,0.776,0.62]], SCR(3)); },
  sobre: g => { box(g, [0.4,0.2,0, 0.8,0.45,0.03], DARK); box(g, [0.57,0.3,0.03, 0.63,0.36,0.36], DARK); box(g, [0,0.3,0.36, 1.2,0.34,1.05], {t:'#2c3038', f:'#11163a', l:'#10142e'}); onFront(g, 0.03, 0.299, 0.39, 1.14, 0.62, SCR(2)); box(g, [1.4,0.05,0, 1.72,0.7,0.95], DARK); },
  emmag: g => { box(g, [0,0,0, 0.9,0.55,0.13], DARK); onTop(g, 0.12, 0.1, 0.131, 0.5, 0.35, {fill:'#4a505c'}); box(g, [1.1,0.05,0, 1.42,0.48,0.03], NAVY); onTop(g, 1.15, 0.1, 0.031, 0.22, 0.12, {fill:'#d9c27a'}); },
  impr: g => { box(g, [0,0,0, 1.15,0.8,0.45], {t:'#f7f5f1', f:'#e2ddd3', l:'#d3ccc0'}); poly(g, [[0.18,0.6,0.45],[0.97,0.6,0.45],[0.97,0.8,0.82],[0.18,0.8,0.82]], {fill:'#ffffff', stroke:'#d8d2c6', 'stroke-width':0.8}); onFront(g, 0.2, -0.002, 0.12, 0.75, 0.07, {fill:'#23262c'}); },
  comp: g => { box(g, [0,0,0, 1.25,0.45,0.05], SILVER); for (let i = 0; i < 5; i++) for (let j = 0; j < 3; j++) onTop(g, 0.08 + i * 0.23, 0.06 + j * 0.13, 0.051, 0.17, 0.09, {fill:'#eef0f3'}); box(g, [0.15,0.65,0, 1.25,0.92,0.32], DARK); [0.45, 0.95].forEach(x => poly(g, circleFront(x, 0.649, 0.16, 0.11), {fill:'#4a505c'})); },
  // el servicio técnico (si no hay 3D): la alfombrilla azul del taller, el móvil abierto (la placa y la batería) y el destornillador
  sat: g => { box(g, [0,0,0, 1.3,0.8,0.03], {t:'#2a9db0', f:'#1f7f91', l:'#1b7080'}); box(g, [0.12,0.12,0.03, 0.52,0.7,0.08], DARK); onTop(g, 0.17, 0.17, 0.081, 0.3, 0.18, {fill:'#1f3a2c'}); onTop(g, 0.17, 0.39, 0.081, 0.3, 0.26, {fill:'#a7adb5'}); box(g, [0.7,0.32,0.03, 1.12,0.4,0.1], {t:'#e2493f', f:'#c73a31', l:'#b5342c'}); box(g, [1.12,0.345,0.05, 1.26,0.375,0.08], SILVER); },
  // Andorra Telecom (si no está su logo): una tarjeta de su color
  tel: g => { box(g, [0,0,0, 1.1,0.7,0.03], {t:'#db006e', f:'#b7005c', l:'#a30052'}); },
  marcas: g => { box(g, [0,0,0, 0.7,0.55,0.42], SAND); box(g, [0.78,0.05,0, 1.38,0.5,0.6], WHITE); box(g, [0.1,0.05,0.42, 0.62,0.48,0.78], NAVY); },
  bag: g => { box(g, [0,0,0, 1.1,0.8,0.62], SAND); onTop(g, 0.47, 0, 0.621, 0.16, 0.8, {fill:'#c7b48e'}); onFront(g, 0.47, -0.001, 0.38, 0.16, 0.24, {fill:'#c7b48e'}); const bl = el('use', {href:'#jm-logo', x:0, y:0, width:0.34, height:0.11}, g); bl.setAttribute('transform', wallMatrix([0.08, -0.002, 0.22], [1,0,0], [0,0,-1])); }
};
function circleFront(x, y, z, r) { const c = []; for (let a = 0; a < Math.PI * 2; a += Math.PI / 10) c.push([x + Math.cos(a) * r, y, z + Math.sin(a) * r]); return c; }
function miniSVG(id) {
  const svg = el('svg', {class:'iso mini', 'aria-hidden':'true'});
  const g = el('g', {class:'zg'}, svg);
  MINI[id](g);
  return svg;
}
function fitMini(svg) {
  const b = svg.getBBox(), m = 4;
  svg.setAttribute('viewBox', `${b.x - m} ${b.y - m} ${b.width + m * 2} ${b.height + m * 2}`);
}
function lightScreens(g, on) { g.querySelectorAll('.scr').forEach(s => s.style.fill = on ? `url(#scr${s.dataset.v || 1})` : ''); }

/* ---------- la cara ---------- */
function faceSVG(cls = '', spark = false) {
  // la chispa del guiño (la misma de la opción 1), separada del ojo para que se lea el guiño
  const sp = spark ? `<g class="spark"><circle class="halo" cx="378" cy="690" r="118" fill="url(#halo)"/><circle class="ring" cx="378" cy="690" r="66" fill="none" stroke="#FFC93C" stroke-width="7"/><path class="rays" d="${rays(378, 690, 84, 126, 8)}" stroke="#1d2a5c" stroke-width="7" stroke-linecap="round" fill="none"/><path class="st st1" d="${star(378, 690, 72)}" fill="#FFC93C" stroke="#1d2a5c" stroke-width="7" stroke-linejoin="round"/><path class="st st2" d="${star(452, 606, 29)}" fill="#FFC93C" stroke="#1d2a5c" stroke-width="5" stroke-linejoin="round"/><path class="st st3" d="${star(330, 786, 18)}" fill="#1d2a5c"/></g>` : '';
  // la de la entrada (roomy) tiene margen alrededor: al asentir, la barbilla y la chispa no se salen del recuadro
  const vb = cls.includes('roomy') ? '235 333 688 772' : '305 353 588 707';
  return `<svg class="face ${cls}" viewBox="${vb}" aria-hidden="true"><g class="head"><path class="skin" d="${FACE_SKIN}" fill="#ffffff"/><path d="${FACE_MAIN}" fill="currentColor" fill-rule="evenodd"/><path class="wink" d="${FACE_WINK}" fill="currentColor"/><ellipse class="eyeL" cx="500" cy="757" rx="11.5" ry="17.5" fill="currentColor"/><g class="eyeR"><path d="${FACE_EYER}" fill="currentColor"/></g></g>${sp}</svg>`;
}
function rays(cx, cy, r1, r2, n) {
  let d = '';
  for (let i = 0; i < n; i++) { const a = (i / n) * Math.PI * 2 + Math.PI / n, q = i % 2 ? 0.8 : 1; d += `M${(cx + Math.cos(a) * r1).toFixed(1)} ${(cy + Math.sin(a) * r1).toFixed(1)}L${(cx + Math.cos(a) * r2 * q).toFixed(1)} ${(cy + Math.sin(a) * r2 * q).toFixed(1)}`; }
  return d;
}
function star(cx, cy, r) {
  const k = r * 0.16;
  return `M${cx} ${cy - r} C${cx + k} ${cy - k} ${cx + k} ${cy - k} ${cx + r} ${cy} C${cx + k} ${cy + k} ${cx + k} ${cy + k} ${cx} ${cy + r} C${cx - k} ${cy + k} ${cx - k} ${cy + k} ${cx - r} ${cy} C${cx - k} ${cy - k} ${cx - k} ${cy - k} ${cx} ${cy - r}Z`;
}

/* ---------- los iconos de la lista: los mismos objetos que en el expositor ---------- */
function put(g, k, v = 1, dx = 0, dy = 0, dz = 0, s = 1) {
  const sub = el('g', {}, g);
  OBJ[k](sub, v);
  const [tx, ty] = P(dx, dy, dz);
  sub.setAttribute('transform', `translate(${tx.toFixed(2)} ${ty.toFixed(2)}) scale(${s})`);
  return sub;
}
Object.assign(MINI, {
  mobils: g => { put(g, 'fold', 2, 0.55, 0.45, 0, 0.8); put(g, 'phone', 1, 0, 0, 0, 0.9); },
  tv: g => put(g, 'tv', 1),
  tabrel: g => { put(g, 'tablet', 3); put(g, 'watch', 2, 1.02, -0.22, 0, 0.8); },
  so: g => put(g, 'headphones'),
  consoles: g => { put(g, 'ps5'); put(g, 'pad', 1, 0.42, -0.42, 0, 0.75); },
  drons: g => put(g, 'drone'),
  llar: g => put(g, 'robot'),
  port: g => put(g, 'laptop', 1),
  sobre: g => { put(g, 'monitor', 2); put(g, 'minipc', 1, 1.12, -0.26, 0, 0.5); },
  emmag: g => { put(g, 'hdd'); put(g, 'card', 1, 0.78, -0.12, 0, 0.8); },
  impr: g => put(g, 'ecotank'),
  comp: g => { put(g, 'gpu', 1, 0.06, 0.62, 0, 0.75); put(g, 'keyboard'); },
  bag: g => put(g, 'bag')
});

/* ===== render3d.js ===== */
/* ---------- un pequeño motor 3D: sólidos convexos con luz, esquinas redondeadas y cilindros ---------- */
const V3 = {
  add: (a, b) => [a[0] + b[0], a[1] + b[1], a[2] + b[2]],
  sub: (a, b) => [a[0] - b[0], a[1] - b[1], a[2] - b[2]],
  mul: (a, k) => [a[0] * k, a[1] * k, a[2] * k],
  dot: (a, b) => a[0] * b[0] + a[1] * b[1] + a[2] * b[2],
  cross: (a, b) => [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]],
  norm: a => { const l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
};
const LIGHT = V3.norm([0.32, -0.56, 0.76]);
const viewDir = () => V3.norm([S, C, -SP / CP]);
const rgbOf = h => { const n = parseInt(h.slice(1), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
function shade(hex, n) {
  const k = 0.7 + 0.3 * (0.5 + 0.5 * V3.dot(n, LIGHT)), [r, g, b] = rgbOf(hex);
  return `rgb(${Math.round(r * k)},${Math.round(g * k)},${Math.round(b * k * 0.985)})`;
}
const centroid = list => V3.mul(list.reduce((s, p) => V3.add(s, p), [0, 0, 0]), 1 / list.length);

/* perfil 2D extruido: O + u·U + v·V + w·W, con w de 0 a 1 */
function extrude(g, prof, O, U, Vv, W, col, o = {}) {
  const at = (u, v, w) => V3.add(O, V3.add(V3.mul(U, u), V3.add(V3.mul(Vv, v), V3.mul(W, w))));
  const n = prof.length, A = prof.map(([u, v]) => at(u, v, 0)), B = prof.map(([u, v]) => at(u, v, 1));
  const cen = centroid(A.concat(B)), D = viewDir(), faces = [];
  const outward = (pts, nn) => V3.dot(nn, V3.sub(centroid(pts), cen)) < 0 ? V3.mul(nn, -1) : nn;
  const nc = V3.norm(V3.cross(U, Vv));
  faces.push({pts: A, n: outward(A, V3.mul(nc, -1)), cap: 0}, {pts: B, n: outward(B, nc), cap: 1});
  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n, q = [A[i], A[j], B[j], B[i]], c = V3.cross(V3.sub(A[j], A[i]), W);
    if (Math.hypot(...c) < 1e-9) continue;
    faces.push({pts: q, n: outward(q, V3.norm(c))});
  }
  const vis = {};
  faces.filter(f => V3.dot(f.n, D) < -1e-6).sort((a, b) => V3.dot(centroid(b.pts), D) - V3.dot(centroid(a.pts), D)).forEach(f => {
    const base = f.cap === 0 ? (o.cap0 || col) : f.cap === 1 ? (o.cap1 || col) : (o.side || col);
    poly(g, f.pts, {fill: shade(base, f.n)});
    if (f.cap !== undefined) vis['cap' + f.cap] = true;
  });
  return {at, vis, A, B};
}
/* dibuja un perfil 2D sobre una tapa (pantallas, botones, etiquetas) */
function decal(g, res, w, prof, attrs) { return poly(g, prof.map(([u, v]) => res.at(u, v, w)), attrs); }
function rr(w, h, r, seg = 4) {
  r = Math.min(r, w / 2, h / 2);
  const out = [], arc = (cx, cy, a0) => { for (let i = 0; i <= seg; i++) { const a = a0 + i / seg * Math.PI / 2; out.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]); } };
  if (r <= 0) return [[0, 0], [w, 0], [w, h], [0, h]];
  arc(w - r, r, -Math.PI / 2); arc(w - r, h - r, 0); arc(r, h - r, Math.PI / 2); arc(r, r, Math.PI);
  return out;
}
const circ = (r, n = 20, cx = 0, cy = 0) => Array.from({length: n}, (_, i) => { const a = i / n * Math.PI * 2; return [cx + Math.cos(a) * r, cy + Math.sin(a) * r]; });
const inset = (prof, k) => prof;

/* atajos */
// caja redondeada en planta (x-y), con altura en z
const rbox = (g, x, y, z, w, d, h, r, col, o) => extrude(g, rr(w, d, r), [x, y, z], [1,0,0], [0,1,0], [0,0,h], col, o);
// placa de pie mirando al frente (plano x-z en y), grosor hacia atrás; tilt = inclinación hacia atrás en grados
function rslab(g, x, y, z, w, h, t, r, col, o, tilt = 0) {
  const a = tilt * Math.PI / 180;
  return extrude(g, rr(w, h, r), [x, y, z], [1,0,0], [0, Math.sin(a), Math.cos(a)], [0, t * Math.cos(a), -t * Math.sin(a)], col, o);
}
const cylZ = (g, cx, cy, z, r, h, col, o, n = 22) => extrude(g, circ(r, n), [cx, cy, z], [1,0,0], [0,1,0], [0,0,h], col, o);
const cylX = (g, x, cy, cz, r, len, col, o, n = 22) => extrude(g, circ(r, n), [x, cy, cz], [0,1,0], [0,0,1], [len,0,0], col, o);
const cylY = (g, cx, y, cz, r, len, col, o, n = 22) => extrude(g, circ(r, n), [cx, y, cz], [1,0,0], [0,0,1], [0,len,0], col, o);
const screenOn = (g, res, w, x0, y0, x1, y1, r, v) => decal(g, res, w, rr(x1 - x0, y1 - y0, r).map(([u, q]) => [u + x0, q + y0]), SCR(v));
const tint = (g, res, w, prof, fill) => decal(g, res, w, prof, {fill});
const box2 = (x0, y0, x1, y1) => [[x0, y0], [x1, y0], [x1, y1], [x0, y1]];

/* ===== objects.js ===== */
/* ---------- los objetos: uno por tipo de producto que vende J&M ---------- */
const COL = {blk:'#2b2f38', gph:'#3a3f4a', drk:'#23262c', slv:'#d4d8de', sgr:'#8d939c', wht:'#f3f1ec', ppr:'#fbfaf7', nvy:'#1d2a5c', red:'#d9443a',
  jb:'#2f8fd8', jr:'#e2493f', pcb:'#2f7d4f', gold:'#d9b45a', lens:'#15181c', ring:'#4a505c', teal:'#3aa7a0', sky:'#9fc4e8', sand:'#e6d3ae'};
const SCRV = v => ((v - 1) % 4) + 1;
const OBJ = {};
const front = (g, x, y, z, w, h, fill) => onFront(g, x, y - 0.002, z, w, h, {fill});
const discF = (g, x, y, z, r, fill) => poly(g, circleFront(x, y - 0.003, z, r), {fill});

// móviles
OBJ.phone = (g, v = 1) => {
  const r = rslab(g, 0, 0, 0, 0.46, 0.94, 0.07, 0.07, COL.gph);
  if (r.vis.cap0) { screenOn(g, r, 0, 0.022, 0.022, 0.438, 0.918, 0.055, SCRV(v)); tint(g, r, 0, rr(0.12, 0.034, 0.017).map(([u, q]) => [u + 0.17, q + 0.86]), COL.drk); }
};
// los plegables, abiertos y todo pantalla (Sergio, 18 oct: «que sea todo pantalla, que no se vea la bisagra»): el Fold, ancho como un
// libro abierto, y el Flip, alto y estrecho, en lila; los dos con la cámara en un agujerito y sin raya en medio
OBJ.fold = (g, v = 2) => {
  const r = rslab(g, 0, 0, 0, 0.84, 0.94, 0.05, 0.06, COL.gph);
  if (r.vis.cap0) { screenOn(g, r, 0, 0.02, 0.02, 0.82, 0.92, 0.045, SCRV(v)); tint(g, r, 0, rr(0.036, 0.036, 0.018).map(([u, q]) => [u + 0.62, q + 0.855]), COL.drk); }
};
OBJ.flip = (g, v = 3) => {
  const r = rslab(g, 0, 0, 0, 0.42, 0.98, 0.06, 0.06, '#c9b6e3');
  if (r.vis.cap0) { screenOn(g, r, 0, 0.02, 0.02, 0.4, 0.96, 0.05, SCRV(v)); tint(g, r, 0, rr(0.034, 0.034, 0.017).map(([u, q]) => [u + 0.193, q + 0.905]), COL.drk); }
};
// tablets y relojes
OBJ.tablet = (g, v = 3) => {
  const r = rslab(g, 0, 0.14, 0, 1.0, 0.7, 0.045, 0.06, COL.gph, {}, 14);
  if (r.vis.cap0) screenOn(g, r, 0, 0.03, 0.03, 0.97, 0.67, 0.045, SCRV(v));
  cylX(g, 0.1, -0.08, 0.026, 0.026, 0.7, COL.wht, {}, 12);
};
OBJ.watch = (g, v = 2) => {
  rbox(g, 0.06, 0.1, 0, 0.42, 0.34, 0.22, 0.1, COL.wht);
  rslab(g, 0.17, 0.3, 0.22, 0.2, 0.36, 0.03, 0.02, COL.blk);
  const c = rslab(g, 0.1, 0.12, 0.25, 0.34, 0.4, 0.09, 0.09, COL.gph);
  if (c.vis.cap0) screenOn(g, c, 0, 0.03, 0.03, 0.31, 0.37, 0.07, SCRV(v));
  rslab(g, 0.17, 0.1, 0.18, 0.2, 0.08, 0.03, 0.01, COL.blk);
};
OBJ.band = (g, v = 1) => {
  rbox(g, 0.06, 0.1, 0, 0.36, 0.3, 0.18, 0.1, COL.wht);
  rslab(g, 0.15, 0.28, 0.18, 0.18, 0.34, 0.03, 0.02, '#e2493f');
  const c = rslab(g, 0.13, 0.11, 0.2, 0.22, 0.44, 0.07, 0.1, COL.blk);
  if (c.vis.cap0) screenOn(g, c, 0, 0.025, 0.04, 0.195, 0.4, 0.08, SCRV(v));
};
// sonido
OBJ.earbuds = g => {
  rbox(g, 0, 0, 0, 0.62, 0.42, 0.26, 0.16, COL.wht);
  rslab(g, 0.02, 0.36, 0.27, 0.58, 0.3, 0.05, 0.12, COL.wht, {}, -6);
  [[0.2, 0.2], [0.42, 0.2]].forEach(([x, y]) => { cylZ(g, x, y, 0.26, 0.075, 0.09, COL.wht, {}, 16); const [px, py] = P(x, y, 0.35); el('ellipse', {cx:px, cy:py, rx:0.04 * U, ry:0.04 * U * SP, fill:'#4a505c'}, g); });
};
OBJ.headphones = g => {
  cylX(g, 0.86, 0.2, 0.25, 0.2, 0.13, COL.gph, {cap0: COL.drk}, 24);
  const arc = []; for (let i = 0; i <= 20; i++) { const a = i / 20 * Math.PI; arc.push([0.5 - 0.43 * Math.cos(a), 0.2, 0.42 + 0.48 * Math.sin(a)]); }
  el('polyline', {points: pts(arc), stroke:'#2b2f38', 'stroke-width':6, fill:'none', 'stroke-linecap':'round'}, g);
  el('polyline', {points: pts(arc.slice(5, 16).map(([x, y, z]) => [x, y, z - 0.035])), stroke:'#4a505c', 'stroke-width':3, fill:'none', 'stroke-linecap':'round'}, g);
  cylX(g, 0.0, 0.2, 0.25, 0.2, 0.13, COL.gph, {cap0: COL.blk}, 24);
};
OBJ.speaker = (g, v = 2) => {
  const col = [COL.nvy, COL.teal, COL.red, COL.gph][(v - 1) % 4];
  const b = cylX(g, 0.04, 0.22, 0.21, 0.21, 0.92, col, {cap0: COL.drk, cap1: COL.drk}, 28);
  if (b.vis.cap0) { decal(g, b, 0, circ(0.14), {fill:'#4a505c'}); decal(g, b, 0, circ(0.06), {fill:'#2b2f38'}); }
};
OBJ.homepod = g => { const b = cylZ(g, 0.3, 0.3, 0, 0.3, 0.52, '#e3e1dc', {}, 30); if (b.vis.cap1) { decal(g, b, 1, circ(0.25), {fill:'#d4d1ca'}); decal(g, b, 1, circ(0.1), {fill:'url(#scr1)'}); } };
OBJ.mic = g => {
  [[0.0, 0.1], [0.36, 0.0]].forEach(([x, y]) => { const b = rbox(g, x, y, 0, 0.26, 0.2, 0.32, 0.08, COL.blk); if (b.vis.cap1) tint(g, b, 1, rr(0.18, 0.12, 0.05).map(([u, q]) => [u + 0.04, q + 0.04]), '#9aa1aa'); });
};
// consolas
OBJ.ps5 = g => {
  const prof = [[0, 0], [0.6, 0], [0.66, 0.36], [0.7, 0.98], [0.04, 1.04], [-0.03, 0.5]];
  extrude(g, prof, [0.25, 0, 0], [0, 1, 0], [0, 0, 1], [0.05, 0, 0], COL.wht);
  rbox(g, 0.05, 0.06, 0.03, 0.2, 0.52, 0.9, 0.04, COL.blk);
  extrude(g, prof, [0, 0, 0], [0, 1, 0], [0, 0, 1], [0.05, 0, 0], COL.wht);
  front(g, 0.075, 0.059, 0.86, 0.15, 0.012, '#5aa9ff');
};
OBJ.pad = g => {
  rbox(g, 0, 0, 0, 0.62, 0.38, 0.1, 0.16, COL.wht);
  const b = rbox(g, 0.18, 0.18, 0.1, 0.26, 0.14, 0.02, 0.03, COL.blk);
  [0.12, 0.5].forEach(x => cylZ(g, x, 0.14, 0.1, 0.045, 0.04, COL.drk, {}, 12));
};
OBJ.switch = g => {
  const tilt = 14;
  rslab(g, 0.86, 0.1, 0, 0.16, 0.5, 0.07, 0.07, COL.jb, {}, tilt);
  const s = rslab(g, 0.16, 0.1, 0, 0.7, 0.5, 0.06, 0.02, COL.blk, {}, tilt);
  if (s.vis.cap0) screenOn(g, s, 0, 0.04, 0.05, 0.66, 0.45, 0.02, 1);
  const l = rslab(g, 0, 0.1, 0, 0.16, 0.5, 0.07, 0.07, COL.jr, {}, tilt);
  if (l.vis.cap0) decal(g, l, 0, circ(0.035, 12, 0.08, 0.36), {fill:'#2b2f38'});
};
OBJ.game = g => {
  const b = rslab(g, 0.1, 0.12, 0, 0.44, 0.7, 0.07, 0.03, '#e2493f', {}, 10);
  if (b.vis.cap0) {
    tint(g, b, 0, box2(0.035, 0.6, 0.405, 0.665), '#ffffff');
    tint(g, b, 0, rr(0.37, 0.52, 0.02).map(([u, q]) => [u + 0.035, q + 0.05]), '#7fc4f0');
    tint(g, b, 0, [[0.035, 0.05], [0.405, 0.05], [0.405, 0.22], [0.3, 0.3], [0.2, 0.24], [0.035, 0.33]], '#6fbf73');
    tint(g, b, 0, circ(0.06, 14, 0.27, 0.42), '#f2d23a');
  }
};
OBJ.cart = g => {
  [[0.32, 0.12], [0.0, 0.0]].forEach(([x, y]) => {
    const c = extrude(g, [[0, 0], [0.26, 0], [0.26, 0.3], [0.05, 0.3], [0, 0.25]], [x, y, 0], [1, 0, 0], [0, 1, 0], [0, 0, 0.03], '#3a3f4a');
    if (c.vis.cap1) tint(g, c, 1, rr(0.2, 0.17, 0.02).map(([u, q]) => [u + 0.03, q + 0.03]), '#e2493f');
  });
};
OBJ.vr = g => {
  const band = []; for (let i = 0; i <= 18; i++) { const a = i / 18 * Math.PI; band.push([0.43 - 0.4 * Math.cos(a), 0.45 + 0.32 * Math.sin(a), 0.3]); }
  el('polyline', {points: pts(band), stroke:'#e9e6e0', 'stroke-width':7, fill:'none', 'stroke-linecap':'round'}, g);
  rbox(g, 0.02, 0.06, 0.12, 0.82, 0.4, 0.32, 0.14, COL.wht);
  rslab(g, 0.08, 0.04, 0.15, 0.7, 0.26, 0.03, 0.1, COL.blk);
};
// drones y cámaras
function rotor(g, cx, cy, mx, my, z) {
  el('polyline', {points: pts([[cx, cy, z + 0.04], [mx, my, z + 0.04]]), stroke:'#7d838c', 'stroke-width':5, 'stroke-linecap':'round', fill:'none'}, g);
  cylZ(g, mx, my, z, 0.05, 0.07, COL.gph, {}, 14);
  const [px, py] = P(mx, my, z + 0.08);
  el('ellipse', {cx:px, cy:py, rx:0.22 * U, ry:0.22 * U * SP, fill:'rgba(58,63,74,.16)', stroke:'rgba(58,63,74,.4)', 'stroke-width':0.8}, g);
  el('polyline', {points: pts([[mx - 0.2, my - 0.04, z + 0.08], [mx + 0.2, my + 0.04, z + 0.08]]), stroke:'rgba(43,47,56,.75)', 'stroke-width':2.2, fill:'none', 'stroke-linecap':'round'}, g);
}
OBJ.drone = g => {
  const cx = 0.5, cy = 0.42, z = 0.06, M = [[cx + 0.42, cy + 0.32], [cx - 0.42, cy + 0.32], [cx + 0.42, cy - 0.32], [cx - 0.42, cy - 0.32]];
  M.filter(m => m[1] > cy).forEach(([mx, my]) => rotor(g, cx, cy, mx, my, z));
  rbox(g, cx - 0.15, cy - 0.24, z - 0.03, 0.3, 0.5, 0.13, 0.1, '#9aa0a8');
  const c = cylY(g, cx, cy - 0.32, z + 0.01, 0.055, 0.08, COL.blk, {}, 14);
  if (c.vis.cap0) decal(g, c, 0, circ(0.03, 12), {fill:'#4a6fa8'});
  M.filter(m => m[1] < cy).forEach(([mx, my]) => rotor(g, cx, cy, mx, my, z));
};
OBJ.remote = (g, v = 2) => {
  const b = rbox(g, 0, 0.1, 0, 0.92, 0.42, 0.08, 0.12, COL.gph);
  if (b.vis.cap1) screenOn(g, b, 1, 0.24, 0.07, 0.68, 0.33, 0.03, SCRV(v));
  [0.12, 0.8].forEach(x => cylZ(g, x, 0.3, 0.08, 0.045, 0.06, COL.drk, {}, 12));
};
OBJ.goggles = g => {
  const strap = []; for (let i = 0; i <= 16; i++) { const a = i / 16 * Math.PI; strap.push([0.45 - 0.42 * Math.cos(a), 0.4 + 0.3 * Math.sin(a), 0.22]); }
  el('polyline', {points: pts(strap), stroke:'#23262c', 'stroke-width':6, fill:'none', 'stroke-linecap':'round'}, g);
  rbox(g, 0, 0.1, 0.05, 0.9, 0.34, 0.3, 0.1, COL.blk);
  [0.08, 0.78].forEach(x => cylZ(g, x, 0.36, 0.35, 0.02, 0.22, COL.drk, {}, 8));
  front(g, 0.12, 0.1, 0.14, 0.66, 0.12, '#4a505c');
};
OBJ.actioncam = g => {
  rbox(g, 0, 0.1, 0, 0.62, 0.34, 0.46, 0.06, COL.blk);
  front(g, 0.07, 0.1, 0.09, 0.2, 0.18, '#4a505c');
  const L = rslab(g, 0.32, 0.06, 0.11, 0.25, 0.25, 0.05, 0.05, COL.gph);
  if (L.vis.cap0) { decal(g, L, 0, circ(0.085, 18, 0.125, 0.125), {fill:'#15181c'}); decal(g, L, 0, circ(0.035, 12, 0.105, 0.145), {fill:'#3d5a8a'}); }
  cylZ(g, 0.48, 0.26, 0.46, 0.05, 0.03, '#2f6bff', {}, 12);
};
OBJ.pocket = (g, v = 1) => {
  const h = rslab(g, 0.08, 0.1, 0, 0.26, 0.62, 0.17, 0.1, COL.blk);
  if (h.vis.cap0) screenOn(g, h, 0, 0.04, 0.3, 0.22, 0.56, 0.03, SCRV(v));
  cylX(g, 0.1, 0.19, 0.7, 0.05, 0.22, COL.gph, {}, 12);
  const c = rslab(g, 0.13, 0.08, 0.66, 0.16, 0.18, 0.13, 0.05, COL.gph);
  if (c.vis.cap0) decal(g, c, 0, circ(0.045, 12, 0.08, 0.09), {fill:'#15181c'});
};
OBJ.gimbal = (g, v = 1) => {
  cylZ(g, 0.3, 0.3, 0, 0.075, 0.56, COL.gph, {}, 16);
  rbox(g, 0.26, 0.26, 0.56, 0.44, 0.08, 0.06, 0.03, COL.gph);
  rbox(g, 0.64, 0.26, 0.56, 0.08, 0.08, 0.2, 0.03, COL.gph);
  const ph = rslab(g, 0.06, 0.18, 0.72, 0.8, 0.36, 0.05, 0.05, COL.gph);
  if (ph.vis.cap0) screenOn(g, ph, 0, 0.025, 0.025, 0.775, 0.335, 0.04, SCRV(v));
};
OBJ.seccam = g => {
  rslab(g, 0.36, 0.62, 0.2, 0.3, 0.42, 0.06, 0.04, COL.wht);
  rbox(g, 0.47, 0.4, 0.38, 0.08, 0.24, 0.06, 0.02, COL.wht);
  const b = cylY(g, 0.51, 0.0, 0.42, 0.16, 0.45, COL.wht, {}, 22);
  if (b.vis.cap0) { decal(g, b, 0, circ(0.13), {fill:'#2b2f38'}); decal(g, b, 0, circ(0.05), {fill:'#3d5a8a'}); }
};
// informática
OBJ.laptop = (g, v = 1) => {
  const body = [COL.slv, COL.sgr, '#c3d2e6'][(v - 1) % 3];
  const lid = rslab(g, 0, 0.66, 0.045, 1.04, 0.68, 0.03, 0.04, body, {}, 16);
  if (lid.vis.cap0) { tint(g, lid, 0, rr(0.98, 0.62, 0.03).map(([u, q]) => [u + 0.03, q + 0.03]), '#15181c'); screenOn(g, lid, 0, 0.06, 0.06, 0.98, 0.62, 0.015, SCRV(v)); }
  const b = rbox(g, 0, 0, 0, 1.04, 0.7, 0.045, 0.05, body);
  if (b.vis.cap1) {
    tint(g, b, 1, rr(0.94, 0.32, 0.02).map(([u, q]) => [u + 0.05, q + 0.32]), '#1f2329');
    for (let r = 0; r < 4; r++) for (let c = 0; c < 13; c++) { const x = 0.07 + c * 0.069, y = 0.34 + r * 0.073; tint(g, b, 1, box2(x, y, x + 0.058, y + 0.06), '#3a3f4a'); }
    tint(g, b, 1, rr(0.36, 0.2, 0.02).map(([u, q]) => [u + 0.34, q + 0.06]), ['#c4c9d0', '#7f858e', '#b3c3d8'][(v - 1) % 3]);
  }
};
OBJ.monitor = (g, v = 2) => {
  rbox(g, 0.42, 0.2, 0, 0.42, 0.3, 0.03, 0.06, COL.gph);
  rbox(g, 0.6, 0.38, 0.03, 0.06, 0.06, 0.36, 0.02, COL.gph);
  const p = rslab(g, 0, 0.3, 0.28, 1.26, 0.76, 0.05, 0.03, COL.blk);
  if (p.vis.cap0) screenOn(g, p, 0, 0.022, 0.035, 1.238, 0.74, 0.012, SCRV(v));
};
OBJ.aio = (g, v = 1) => {
  const col = ['#8fb3df', '#9fd0b0', '#f0b7c4', '#c9c3e6'][(v - 1) % 4];
  rslab(g, 0.44, 0.42, 0, 0.42, 0.4, 0.035, 0.03, col, {}, 38);
  const p = rslab(g, 0, 0.26, 0.18, 1.3, 0.96, 0.045, 0.035, col);
  if (p.vis.cap0) { tint(g, p, 0, rr(1.3, 0.76, 0.035).map(([u, q]) => [u, q + 0.2]), '#f6f6f3'); screenOn(g, p, 0, 0.05, 0.24, 1.25, 0.92, 0.008, SCRV(v)); }
};
OBJ.minipc = g => {
  const b = rbox(g, 0.05, 0.05, 0, 0.74, 0.74, 0.16, 0.05, COL.blk);
  if (b.vis.cap1) for (let i = 0; i < 6; i++) for (let j = 0; j < 6; j++) tint(g, b, 1, circ(0.018, 8, 0.2 + i * 0.07, 0.2 + j * 0.07), '#4a505c');
  front(g, 0.12, 0.05, 0.06, 0.04, 0.03, '#7fd8ff');
};
OBJ.nvme = g => {
  const b = rbox(g, 0, 0.18, 0, 1.12, 0.3, 0.025, 0.012, COL.pcb);
  if (b.vis.cap1) { tint(g, b, 1, box2(1.0, 0.03, 1.11, 0.27), COL.gold); for (let i = 0; i < 8; i++) tint(g, b, 1, box2(1.005, 0.035 + i * 0.03, 1.105, 0.05 + i * 0.03), '#c7a24a'); }
  rbox(g, 0.1, 0.23, 0.025, 0.26, 0.2, 0.028, 0.01, COL.blk);
  rbox(g, 0.45, 0.22, 0.025, 0.42, 0.22, 0.028, 0.01, COL.blk);
};
OBJ.ssdext = g => {
  const b = rbox(g, 0, 0.1, 0, 0.66, 0.44, 0.09, 0.1, '#6f86b5');
  if (b.vis.cap1) tint(g, b, 1, rr(0.3, 0.1, 0.03).map(([u, q]) => [u + 0.18, q + 0.17]), '#5b6f99');
  front(g, 0.28, 0.1, 0.03, 0.1, 0.03, '#15181c');
};
// el disco duro de bolsillo (el Intenso): la caja negra, más grande que la de un SSD y de pie a lo largo, con el logo gris y el puerto
OBJ.hdd = g => {
  const b = rbox(g, 0, 0.06, 0, 0.6, 0.94, 0.12, 0.06, '#26292f');
  if (b.vis.cap1) tint(g, b, 1, rr(0.28, 0.06, 0.03).map(([u, q]) => [u + 0.16, q + 0.76]), '#5b606a');
  front(g, 0.14, 0.06, 0.04, 0.14, 0.035, '#0e1013');
};
OBJ.card = g => {
  const a = extrude(g, [[0, 0], [0.42, 0], [0.42, 0.56], [0.1, 0.56], [0, 0.46]], [0, 0.12, 0], [1, 0, 0], [0, 1, 0], [0, 0, 0.022], COL.blk);
  if (a.vis.cap1) { tint(g, a, 1, box2(0.04, 0.05, 0.38, 0.34), '#c62f27'); tint(g, a, 1, box2(0.04, 0.34, 0.38, 0.4), '#d9b45a'); }
  const m = extrude(g, rr(0.2, 0.28, 0.02), [0.56, 0.0, 0], [1, 0, 0], [0, 1, 0], [0, 0, 0.018], COL.blk);
  if (m.vis.cap1) tint(g, m, 1, box2(0.02, 0.03, 0.18, 0.16), '#c62f27');
};
OBJ.ecotank = g => {
  rslab(g, 0.24, 0.52, 0.3, 0.6, 0.34, 0.02, 0.01, COL.blk, {}, 22);
  rslab(g, 0.28, 0.5, 0.33, 0.52, 0.36, 0.006, 0.0, '#ffffff', {}, 22);
  rbox(g, 0, 0, 0, 1.08, 0.62, 0.32, 0.05, COL.blk);
  front(g, 0.12, 0, 0.13, 0.6, 0.05, '#15181c');
  rbox(g, 0.84, -0.03, 0, 0.24, 0.62, 0.3, 0.03, COL.gph);
  ['#2bb3e0', '#e0338a', '#f2d23a', '#15181c'].forEach((c, i) => front(g, 0.87 + i * 0.05, -0.03, 0.07, 0.035, 0.17, c));
};
OBJ.laser = g => {
  const b = rbox(g, 0, 0, 0, 0.98, 0.72, 0.5, 0.05, '#eceae6');
  if (b.vis.cap1) { tint(g, b, 1, box2(0.12, 0.28, 0.68, 0.62), '#3a3f4a'); tint(g, b, 1, rr(0.2, 0.12, 0.02).map(([u, q]) => [u + 0.74, q + 0.08]), '#2b2f38'); }
  front(g, 0.1, 0, 0.12, 0.7, 0.06, '#3a3f4a');
};
OBJ.pen = g => { cylX(g, 0.08, 0.2, 0.08, 0.075, 0.78, COL.wht, {}, 14); const t = cylX(g, 0.0, 0.2, 0.08, 0.05, 0.09, COL.blk, {}, 12); };
OBJ.keyboard = g => {
  const b = rbox(g, 0, 0, 0, 1.3, 0.44, 0.04, 0.03, '#eef0f2');
  if (b.vis.cap1) { tint(g, b, 1, box2(0.04, 0.04, 1.26, 0.4), '#c9cdd3'); for (let r = 0; r < 5; r++) for (let c = 0; c < 18; c++) { const x = 0.05 + c * 0.067, y = 0.05 + r * 0.068; tint(g, b, 1, box2(x, y, x + 0.058, y + 0.058), '#fafbfc'); } }
};
OBJ.trackpad = g => { const b = rbox(g, 0, 0, 0, 0.62, 0.46, 0.025, 0.04, '#e6e8eb'); if (b.vis.cap1) tint(g, b, 1, rr(0.56, 0.4, 0.03).map(([u, q]) => [u + 0.03, q + 0.03]), '#eff1f3'); };
OBJ.router = g => {
  [0.12, 0.38, 0.62, 0.88].forEach(x => rslab(g, x - 0.03, 0.5, 0.12, 0.06, 0.56, 0.03, 0.03, COL.blk, {}, 6));
  rbox(g, 0, 0, 0, 1.0, 0.62, 0.15, 0.08, COL.gph);
  front(g, 0.08, 0, 0.05, 0.84, 0.022, '#f2c230');
  [0.3, 0.42, 0.54, 0.66].forEach(x => front(g, x, 0, 0.1, 0.03, 0.02, '#7fd8ff'));
};
OBJ.gpu = g => {
  const b = rslab(g, 0, 0.12, 0.05, 1.3, 0.44, 0.17, 0.03, COL.blk);
  if (b.vis.cap0) {
    tint(g, b, 0, rr(1.24, 0.38, 0.03).map(([u, q]) => [u + 0.03, q + 0.03]), '#3a3f4a');
    [0.25, 0.65, 1.05].forEach(cx => { decal(g, b, 0, circ(0.15, 24, cx, 0.22), {fill:'#23262c'}); decal(g, b, 0, circ(0.05, 12, cx, 0.22), {fill:'#4a505c'}); });
    tint(g, b, 0, box2(0.03, 0.39, 1.27, 0.41), '#c62f27');
  }
  front(g, 0.32, 0.12, 0.0, 0.5, 0.05, COL.gold);
};
// hogar y más
OBJ.robot = g => {
  const b = cylZ(g, 0.5, 0.5, 0, 0.5, 0.1, '#3a3f4a', {}, 34);
  if (b.vis.cap1) { decal(g, b, 1, circ(0.44, 34), {fill:'#2b2f38'}); decal(g, b, 1, circ(0.11, 20), {fill:'#c9ced6'}); decal(g, b, 1, circ(0.05, 12, 0, -0.27), {fill:'#4a505c'}); }
};
OBJ.shaver = g => {
  rbox(g, 0.1, 0.1, 0, 0.4, 0.32, 0.06, 0.1, COL.wht);
  const b = rslab(g, 0.18, 0.16, 0.06, 0.24, 0.62, 0.16, 0.1, COL.blk);
  if (b.vis.cap0) { tint(g, b, 0, circ(0.035, 14, 0.12, 0.4), '#c9ced6'); tint(g, b, 0, box2(0.02, 0.08, 0.035, 0.52), '#9aa1aa'); }
  const h = rbox(g, 0.13, 0.15, 0.68, 0.34, 0.2, 0.14, 0.06, COL.slv);
  if (h.vis.cap1) [0.05, 0.12, 0.19, 0.26].forEach(x => tint(g, h, 1, box2(x + 0.015, 0.03, x + 0.05, 0.17), '#a3aab3'));
};
OBJ.gps = (g, v = 3) => {
  const s = cylZ(g, 0.36, 0.42, 0, 0.17, 0.05, '#c9ced6', {}, 18);
  el('polyline', {points: pts([[0.36, 0.42, 0.05], [0.36, 0.34, 0.3]]), stroke:'#2b2f38', 'stroke-width':5, 'stroke-linecap':'round', fill:'none'}, g);
  const p = rslab(g, 0, 0.22, 0.24, 0.74, 0.46, 0.06, 0.04, COL.blk, {}, 12);
  if (p.vis.cap0) {
    tint(g, p, 0, rr(0.68, 0.4, 0.02).map(([u, q]) => [u + 0.03, q + 0.03]), '#dfe9d6');
    tint(g, p, 0, [[0.1, 0.06], [0.2, 0.06], [0.42, 0.3], [0.62, 0.34], [0.62, 0.4], [0.4, 0.37], [0.18, 0.14], [0.1, 0.14]], '#cfdcc5');
    decal(g, p, 0, [[0.12, 0.1], [0.16, 0.1], [0.36, 0.28], [0.6, 0.32], [0.6, 0.35], [0.34, 0.31], [0.12, 0.13]], {fill:'#2f6bff'});
  }
};
OBJ.power = g => {
  rbox(g, 0, 0, 0, 0.98, 0.58, 0.6, 0.07, '#cfd3d8');
  front(g, 0.1, 0, 0.08, 0.78, 0.42, '#2b2f38');
  front(g, 0.16, 0, 0.32, 0.24, 0.12, '#d9f2e1');
  front(g, 0.18, 0, 0.35, 0.14, 0.05, '#3aa76d');
  [0.52, 0.72].forEach(x => { discF(g, x, 0, 0.26, 0.075, '#4a505c'); discF(g, x - 0.025, -0.001, 0.26, 0.012, '#15181c'); discF(g, x + 0.025, -0.001, 0.26, 0.012, '#15181c'); });
  [0.18, 0.27].forEach(x => front(g, x, 0, 0.14, 0.05, 0.03, '#15181c'));
  [0.2, 0.72].forEach(x => rbox(g, x, 0.22, 0.6, 0.06, 0.14, 0.12, 0.02, COL.gph));
  rbox(g, 0.2, 0.22, 0.7, 0.58, 0.14, 0.05, 0.02, COL.gph);
};
OBJ.frame = (g, v = 1) => {
  rslab(g, 0.38, 0.4, 0, 0.1, 0.42, 0.02, 0.01, COL.blk, {}, -30);
  const f = rslab(g, 0, 0.12, 0.02, 0.86, 0.64, 0.05, 0.02, COL.wht, {}, 12);
  if (f.vis.cap0) {
    tint(g, f, 0, box2(0.05, 0.05, 0.81, 0.59), '#a9cdec');
    tint(g, f, 0, [[0.05, 0.05], [0.81, 0.05], [0.81, 0.24], [0.62, 0.34], [0.44, 0.27], [0.24, 0.37], [0.05, 0.27]], '#7fa37a');
    tint(g, f, 0, circ(0.06, 14, 0.66, 0.46), '#f2d23a');
  }
};
OBJ.meteo = g => {
  const f = rslab(g, 0, 0.1, 0, 0.7, 0.54, 0.08, 0.04, COL.blk, {}, 10);
  if (f.vis.cap0) {
    tint(g, f, 0, rr(0.62, 0.46, 0.02).map(([u, q]) => [u + 0.04, q + 0.04]), '#eef3f7');
    tint(g, f, 0, circ(0.07, 14, 0.2, 0.32), '#f2c230');
    tint(g, f, 0, rr(0.2, 0.08, 0.04).map(([u, q]) => [u + 0.14, q + 0.2]), '#c9d3dd');
    const a = 10 * Math.PI / 180, o = f.at(0.36, 0.38, 0);
    faceText(g, '21°', o, [1, 0, 0], [0, -Math.sin(a), -Math.cos(a)], 0.17, '#1A1D21', 0.13, 0.15);
  }
};
OBJ.binoculars = g => {
  [[0.42, 0.0], [0.0, 0.0]].forEach(([x]) => { const b = cylY(g, x + 0.15, 0.0, 0.17, 0.15, 0.62, COL.blk, {}, 18); if (b.vis.cap0) { decal(g, b, 0, circ(0.11), {fill:'#4a505c'}); decal(g, b, 0, circ(0.06), {fill:'#3d5a8a'}); } });
  rbox(g, 0.28, 0.18, 0.12, 0.17, 0.26, 0.1, 0.02, COL.gph);
};
OBJ.tag = g => { [[0.42, 0.42], [0.0, 0.42], [0.42, 0.0], [0.0, 0.0]].forEach(([x, y]) => { const b = cylZ(g, x + 0.18, y + 0.18, 0, 0.18, 0.07, '#f4f4f2', {}, 22); if (b.vis.cap1) decal(g, b, 1, circ(0.14), {fill:'#fbfbfa'}); }); };
// la baliza V16 (FlashLED): la base gris, el cuerpo naranja, la faja gris, la cúpula clara y la tapa gris con el botón SOS naranja
OBJ.beacon = g => { cylZ(g, 0.3, 0.3, 0, 0.22, 0.03, '#8f9297', {}, 22); cylZ(g, 0.3, 0.3, 0.03, 0.28, 0.13, '#f26a1b', {}, 24); cylZ(g, 0.3, 0.3, 0.16, 0.29, 0.03, '#8f9297', {}, 24); cylZ(g, 0.3, 0.3, 0.19, 0.27, 0.1, '#e9eef2', {}, 24); cylZ(g, 0.3, 0.3, 0.29, 0.17, 0.02, '#80838a', {}, 22); cylZ(g, 0.3, 0.3, 0.31, 0.07, 0.015, '#f26a1b', {}, 16); };
// tele y salón
OBJ.tv = (g, v = 1) => {
  [0.14, 1.34].forEach(x => rbox(g, x, 0.1, 0, 0.12, 0.34, 0.03, 0.01, COL.blk));
  const p = rslab(g, 0, 0.22, 0.1, 1.6, 0.92, 0.04, 0.015, COL.blk);
  if (p.vis.cap0) screenOn(g, p, 0, 0.02, 0.03, 1.58, 0.9, 0.006, SCRV(v));
};
OBJ.projector = g => {
  rbox(g, 0, 0.06, 0, 0.86, 0.6, 0.32, 0.08, COL.wht);
  const l = cylY(g, 0.26, -0.02, 0.16, 0.11, 0.09, COL.gph, {}, 20);
  if (l.vis.cap0) { decal(g, l, 0, circ(0.08), {fill:'#15181c'}); decal(g, l, 0, circ(0.035), {fill:'#3d5a8a'}); }
};
OBJ.tvbox = g => {
  rbox(g, 0, 0.1, 0, 0.52, 0.52, 0.15, 0.08, '#2b2f38');
  const r = rbox(g, 0.68, 0.06, 0, 0.13, 0.5, 0.03, 0.05, '#c9ced6');
  if (r.vis.cap1) tint(g, r, 1, rr(0.11, 0.18, 0.05).map(([u, q]) => [u + 0.01, q + 0.3]), '#2b2f38');
};
// otros: la caja de envío y la bolsa de J&M
// los accesorios que antes eran una caja (Sergio, 19 oct: «si es un Pencil, que sea como un lápiz»): el lápiz, el cable, el protector, la
// funda del reloj, el palo de cámara, la cámara, el transmisor, el programa, el contador de monedas y el soporte de pared. Este dibujo es
// el de respaldo y el que da la escala; lo que se ve, en 3D, sale de editor/herramientas/tienda3d/iconos-accesorios.js
OBJ.pencil = g => { cylX(g, 0.08, 0.2, 0.06, 0.05, 0.86, COL.wht, {}, 14); cylX(g, 0.0, 0.2, 0.06, 0.03, 0.08, '#d9dbde', {}, 10); };
OBJ.cable = g => {
  cylZ(g, 0.36, 0.36, 0, 0.32, 0.04, '#1b1c1f', {}, 24);
  cylZ(g, 0.36, 0.36, 0.04, 0.2, 0.004, '#3a3d44', {}, 20);
  rbox(g, 0.66, 0.2, 0, 0.18, 0.08, 0.05, 0.02, '#2b2d31');
  rbox(g, 0.5, -0.06, 0, 0.08, 0.18, 0.05, 0.02, '#2b2d31');
};
OBJ.protector = g => { const r = rslab(g, 0, 0, 0, 0.46, 0.94, 0.012, 0.07, '#cfe6ee'); if (r.vis.cap0) tint(g, r, 0, rr(0.12, 0.034, 0.017).map(([u, q]) => [u + 0.17, q + 0.86]), '#121317'); };
// la funda de un móvil (transparente, algo ahumada) y el cargador (el cubo blanco con las dos patas), para el dibujo de antes y para
// que el expositor de su marca los cuente (exhibitItems solo cuenta lo que tiene dibujo)
OBJ.phonecase = g => { const r = rslab(g, 0, 0, 0, 0.48, 0.96, 0.06, 0.09, '#c3ced8'); if (r.vis.cap1) tint(g, r, 1, rr(0.4, 0.2, 0.06).map(([u, q]) => [u + 0.04, q + 0.72]), '#e9eef2'); };
OBJ.charger = g => { rbox(g, 0.1, 0.1, 0, 0.3, 0.3, 0.34, 0.05, '#f4f4f2'); cylZ(g, 0.18, 0.25, 0.34, 0.025, 0.2, '#c9ccd1', {}, 12); cylZ(g, 0.32, 0.25, 0.34, 0.025, 0.2, '#c9ccd1', {}, 12); };
OBJ.watchcase = (g, v = 1) => { const c = rslab(g, 0.04, 0.1, 0, 0.4, 0.46, 0.12, 0.11, COL.blk); if (c.vis.cap0) screenOn(g, c, 0, 0.06, 0.06, 0.34, 0.4, 0.06, SCRV(v)); };
OBJ.stick = g => {
  cylZ(g, 0.3, 0.3, 0, 0.035, 1.3, COL.blk, {}, 10);
  rbox(g, 0.16, 0.24, 1.3, 0.28, 0.14, 0.2, 0.03, COL.blk);
  [[0.08, 0.12], [0.52, 0.12], [0.3, 0.55]].forEach(([x, y]) => rbox(g, x, y, 0, 0.04, 0.04, 0.24, 0.01, COL.drk));
};
OBJ.camera = g => { rbox(g, 0, 0.1, 0, 0.8, 0.46, 0.52, 0.05, COL.blk); cylY(g, 0.36, -0.28, 0.26, 0.2, 0.38, COL.gph, {}, 20); rbox(g, 0.12, 0.22, 0.52, 0.56, 0.08, 0.14, 0.02, COL.blk); };
OBJ.transmitter = g => { rbox(g, 0, 0.1, 0, 0.9, 0.56, 0.32, 0.05, COL.gph); front(g, 0.1, 0.1, 0.1, 0.26, 0.12, '#7fd8ff'); [0.08, 0.82].forEach(x => cylZ(g, x, 0.55, 0.32, 0.035, 0.7, COL.blk, {}, 10)); };
OBJ.software = g => { const r = rslab(g, 0.05, 0.1, 0, 0.66, 0.84, 0.12, 0.01, '#1f5fc8'); if (r.vis.cap0) [[0.2, 0.42], [0.35, 0.42], [0.2, 0.57], [0.35, 0.57]].forEach(([u, q]) => tint(g, r, 0, box2(u, q, u + 0.13, q + 0.13), '#ffffff')); };
OBJ.coins = g => {
  rbox(g, 0, 0.1, 0, 1.2, 0.76, 0.42, 0.06, '#e4e6e9');
  rbox(g, 0.5, 0.3, 0.42, 0.5, 0.4, 0.16, 0.04, '#cfd3d8');
  for (let i = 0; i < 8; i++) cylZ(g, 0.12 + i * 0.13, 0.04, 0, 0.05, 0.2 + (i % 3) * 0.04, i < 3 ? '#c9ccd1' : '#d4a94b', {}, 10);
};
OBJ.mount = g => {
  rslab(g, 0.3, 0.6, 0.1, 0.4, 0.9, 0.05, 0.02, COL.blk);
  [0.35, 0.75].forEach(z => rbox(g, 0.44, 0.1, z, 0.08, 0.5, 0.06, 0.02, COL.blk));
  [0.0, 0.8].forEach(x => rslab(g, x, 0.0, 0.0, 0.1, 1.3, 0.04, 0.01, COL.blk));
};
OBJ.box = g => {
  const b = rbox(g, 0, 0, 0, 1.0, 0.72, 0.6, 0.02, COL.sand);
  if (b.vis.cap1) tint(g, b, 1, box2(0.43, 0, 0.57, 0.72), '#d6c08f');
  front(g, 0.43, 0, 0.38, 0.14, 0.22, '#d6c08f');
};
OBJ.bag = (g, v = 0, o = {}) => {
  const W0 = 1.0, D0 = 0.4, H0 = 1.34, hz = H0 - 0.02;
  // el asa: una cinta plana en forma de U con las esquinas redondeadas, como la de la bolsa de verdad
  const loop = y => { const a = [[0.31, y, hz - 0.02], [0.31, y, hz + 0.24]]; for (let i = 0; i <= 6; i++) { const t = Math.PI - i / 6 * Math.PI / 2; a.push([0.39 + 0.08 * Math.cos(t), y, hz + 0.24 + 0.08 * Math.sin(t)]); } for (let i = 0; i <= 6; i++) { const t = Math.PI / 2 - i / 6 * Math.PI / 2; a.push([0.61 + 0.08 * Math.cos(t), y, hz + 0.24 + 0.08 * Math.sin(t)]); } a.push([0.69, y, hz + 0.24], [0.69, y, hz - 0.02]); return a; };
  el('polyline', {points: pts(loop(D0 - 0.01)), stroke:'#16214a', 'stroke-width':3.6, fill:'none', 'stroke-linejoin':'round'}, g);
  poly(g, [[0, 0, H0], [W0, 0, H0], [W0, D0, H0], [0, D0, H0]], {fill:'#d6ccba'});
  const frontLoop = () => el('polyline', {points: pts(loop(-0.006)), stroke:'#1d2a5c', 'stroke-width':3.6, fill:'none', 'stroke-linejoin':'round'}, g);
  // en la bolsa del carrito, el asa va por detrás de lo que asoma, para que se vea lo que llevas
  if (o.handlesBehind) frontLoop();
  if (typeof v === 'function') v(g, W0, D0, H0);
  poly(g, [[0, 0, 0], [0, D0, 0], [0, D0, H0], [0, 0, H0]], {fill: shade(COL.ppr, [-1, 0, 0])});
  el('polyline', {points: pts([[0, D0 / 2, 0.05], [0, D0 / 2, H0]]), stroke:'#e6e1d6', 'stroke-width':1.4, fill:'none'}, g);
  poly(g, [[0, 0, 0], [W0, 0, 0], [W0, 0, H0], [0, 0, H0]], {fill: shade(COL.ppr, [0, -1, 0])});
  const k = 0.5 / 588;
  const f = el('g', {}, g);
  f.innerHTML = `<path d="${FACE_MAIN}" fill="#1d2a5c" fill-rule="evenodd"/><path d="${FACE_WINK}" fill="#1d2a5c"/><path d="${FACE_EYER}" fill="#1d2a5c"/>`;
  f.setAttribute('transform', `${wallMatrix([0.25, -0.003, 1.17], [1, 0, 0], [0, 0, -1])} scale(${k.toFixed(5)}) translate(-305 -353)`);
  faceText(g, 'hola andorra!', [0, -0.003, 0.38], [1, 0, 0], [0, 0, -1], 0.13, '#1d2a5c', 0.5, 0.0);
  const lg = el('use', {href:'#jm-logo', x:0, y:0, width:0.34, height:0.1}, g);
  lg.setAttribute('transform', wallMatrix([0.33, -0.003, 0.27], [1, 0, 0], [0, 0, -1]));
  if (!o.handlesBehind) frontLoop();
};

/* ===== scene2.js ===== */
/* ---------- el expositor: los objetos de verdad de cada sección y de cada marca ---------- */
// lo que se expone en cada sección, revisado contra el catálogo real
// las claves de los expositores que tienen su imagen (prototipo/v4/expositores/<clave>.webp; las mete build.cjs)
const EXPOS = window.__JM_D.EXPOS;
// los productos que tienen su imagen en 3D para la bolsa (prototipo/v4/productos/<clase>.webp, con su ancho y alto; los mete build.cjs)
const PRODUCTOS3D = window.__JM_D.PRODUCTOS3D;
// las fichas completas de algunos productos (fichas/*.json: precios por capacidad, colores, fotos y descripción, de Shopify)
const FICHAS = window.__JM_D.FICHAS;
// las fotos de los productos sin fondo y recortadas a lo que ocupa el producto (web-rediseno/fotos: fotos.py → fotos/g y fotos/p,
// al lado del simulador; las mete build.cjs): por la ruta de la foto de Shopify, [clave, ancho, alto]; [null] si en la de Shopify
// no sale el producto (entonces va su dibujo en 3D). Sergio, 20 oct: «las imágenes de casi todos los productos son malas,
// pixeladas o cortadas o con fondos blancos, tendrían que ser png»
const FOTOS = window.__JM_D.FOTOS;
// lo que la venta cruzada ofrece y no está publicado en Shopify (tienda-sin-shopify.json), por su título: qué es (tipo, color) y
// con qué móviles va (para). Y los tipos de los protectores de Shopify con su precio (variantes.json). Los mete build.cjs
const ACCESORIOS = window.__JM_D.ACCESORIOS;
const VARIANTES = window.__JM_D.VARIANTES;
const PROT_TABLET = window.__JM_D.PROT_TABLET;
// las variantes de Shopify de cada producto, por su handle (opciones.js; shop2/variantes-vivo.json)
const OPCIONES = window.__JM_D.OPCIONES;
// los nombres de los productos en catalán, francés e inglés, los de Shopify, por su handle (opciones.js: tituloDe)
const TITULOS = window.__JM_D.TITULOS;
const SEC_EXH = {
  mobils:   [['phone', 1], ['fold', 2], ['flip', 3]],
  tv:       [['tv', 1, 0.86], ['tv', 2, 1.06], ['tv', 3, 0.95]],
  tabrel:   [['tablet', 3], ['watch', 2], ['band', 1]],
  so:       [['earbuds', 1], ['headphones', 1], ['speaker', 2]],
  consoles: [['ps5', 1], ['switch', 1], ['game', 1], ['vr', 1]],
  drons:    [['drone', 1], ['actioncam', 1], ['gimbal', 2], ['goggles', 1]],
  llar:     [['robot', 1], ['shaver', 1], ['gps', 3], ['frame', 1], ['power', 1]],
  port:     [['laptop', 1], ['laptop', 2], ['laptop', 3]],
  sobre:    [['monitor', 2], ['aio', 1], ['minipc', 1]],
  emmag:    [['hdd', 1], ['nvme', 1], ['card', 1]],
  impr:     [['ecotank', 1], ['laser', 1], ['pen', 1]],
  comp:     [['keyboard', 1], ['gpu', 1], ['router', 1]]
};
const PRIORITY = ['phone','fold','flip','tablet','watch','band','laptop','earbuds','headphones','tv','ps5','switch','drone','actioncam','pocket','speaker','homepod','gimbal','goggles','vr','monitor','aio','minipc','nvme','hdd','ssdext','card','ecotank','laser','robot','shaver','gps','power','frame','keyboard','trackpad','gpu','router','remote','projector','tvbox','seccam','meteo','binoculars','tag','beacon','pen','mic','box'];
// mide un objeto en sus coordenadas del mundo (para apoyarlo bien en la peana)
const MEAS = {};
function measure(k, v) {
  const key = k + ':' + v;
  if (MEAS[key]) return MEAS[key];
  REC = [];
  (OBJ[k] || OBJ.box)(el('g'), v);
  const a = REC; REC = null;
  const b = {x0: Infinity, x1: -Infinity, y0: Infinity, y1: -Infinity, z0: Infinity, z1: -Infinity};
  for (let i = 0; i < a.length; i += 3) { b.x0 = Math.min(b.x0, a[i]); b.x1 = Math.max(b.x1, a[i]); b.y0 = Math.min(b.y0, a[i + 1]); b.y1 = Math.max(b.y1, a[i + 1]); b.z0 = Math.min(b.z0, a[i + 2]); b.z1 = Math.max(b.z1, a[i + 2]); }
  return (MEAS[key] = b);
}
// cuánto se encoge un objeto pequeño en el expositor (el tope de 1,35): el expositor en 3D lo usa para guardar las proporciones
function escalaExpo(k, v) {
  const b = measure(k, v), fw = b.x1 - b.x0 || 1, fd = b.y1 - b.y0 || 1, fh = b.z1 - b.z0 || 1, fit = Math.min(1.1 / fw, 1.1 / fd, 1.2 / fh);
  return Math.min(1.35, fit) / fit;
}
function exhibitSVG(items) {
  return withCam(20, 30, () => {
    const svg = el('svg', {class:'iso exh', 'aria-hidden':'true'});
    const n = items.length, pitch = 1.75, W0 = 1.3, hs = [0.5, 0.74, 0.42, 0.66, 0.56];
    const [cx, cy] = P((n - 1) * pitch / 2 + W0 / 2, W0 / 2, 0);
    el('ellipse', {cx, cy, rx: (n * pitch * 0.55 + 0.9) * U, ry: 1.25 * U * SP, fill:'url(#pool)', opacity:0.55}, svg);
    for (let i = n - 1; i >= 0; i--) {
      const x = i * pitch, h = hs[i % hs.length], [k, v = 1, sc = 1] = items[i];
      const [sx, sy] = P(x + W0 / 2, W0 / 2, 0);
      el('ellipse', {cx:sx, cy:sy + 4, rx:0.95 * U, ry:0.62 * U * SP, fill:'url(#drop)', opacity:0.3}, svg);
      box(svg, [x, 0, 0, x + W0, W0, h], {t:'#FFFFFF', f:'#ECE7DE', l:'#DED7CA'});
      const [gx, gy] = P(x + W0 / 2, W0 / 2, h);
      el('ellipse', {cx:gx, cy:gy, rx:0.6 * U, ry:0.6 * U * SP, fill:'url(#pool)', opacity:0.42}, svg);
      // el objeto, escalado para caber en la peana y apoyado en ella (centro abajo sobre el centro de la peana)
      const b = measure(k, v), fw = b.x1 - b.x0 || 1, fd = b.y1 - b.y0 || 1, fh = b.z1 - b.z0 || 1;
      const s = Math.min(1.35, 1.1 / fw, 1.1 / fd, 1.2 / fh) * sc;
      const [tx, ty] = P(x + W0 / 2, W0 / 2, h), [ox, oy] = P((b.x0 + b.x1) / 2, (b.y0 + b.y1) / 2, b.z0);
      const g = el('g', {}, svg);
      (OBJ[k] || OBJ.box)(g, v);
      g.setAttribute('transform', `translate(${(tx - s * ox).toFixed(2)} ${(ty - s * oy).toFixed(2)}) scale(${s.toFixed(4)})`);
    }
    return svg;
  });
}
/* para las marcas y las búsquedas: los tipos con más productos (sin accesorios) */
function exhibitItems(rows, max = 5) {
  const contar = conAcc => { const n = {}; rows.forEach(r => { if (!conAcc && r.tg.has('acc')) return; r.tg.forEach(t => { if (t.startsWith('k:')) n[t.slice(2)] = (n[t.slice(2)] || 0) + 1; }); }); return n; };
  // una marca que solo tiene accesorios (el proyector de COOL cuenta como accesorio de las teles): sus productos igualmente
  let cnt = contar(false);
  if (!Object.keys(cnt).some(k => OBJ[k] && k !== 'box')) cnt = contar(true);
  const pr = k => { const i = PRIORITY.indexOf(k); return i < 0 ? 99 : i; };
  const all = Object.keys(cnt), kinds = all.filter(k => OBJ[k] && (k !== 'box' || all.length === 1)).sort((a, b) => cnt[b] - cnt[a] || pr(a) - pr(b)).slice(0, max);
  if (!kinds.length) return [['box', 1]];
  // una marca de un solo tipo: si tiene compañeros naturales, se exponen con él (Nintendo: la consola, un juego y la tarjeta)
  const MATES = {switch: ['game', 'cart'], ps5: ['pad', 'vr']};
  if (kinds.length === 1 && MATES[kinds[0]]) return [kinds[0], ...MATES[kinds[0]]].map(k => [k, 1]);
  if (kinds.length === 1) return [[kinds[0], 1, 0.92], [kinds[0], 2, 1.05], [kinds[0], 3, 0.96]];
  return kinds.map((k, i) => [k, (i % 4) + 1]);
}
function fitSVG(svg, m = 8) {
  const b = svg.getBBox();
  svg.setAttribute('viewBox', `${(b.x - m).toFixed(1)} ${(b.y - m).toFixed(1)} ${(b.width + m * 2).toFixed(1)} ${(b.height + m * 2).toFixed(1)}`);
}

/* letras pintadas sobre una cara del mundo isométrico */
function faceText(g, txt, o, u, v, size, fill, cx, cyBase) {
  const t = el('text', {x: cx, y: cyBase, 'font-size': size, 'font-family':"'Familjen Grotesk',system-ui,sans-serif", 'font-weight':700, 'text-anchor':'middle', fill}, g);
  t.textContent = txt;
  t.setAttribute('transform', wallMatrix(o, u, v));
}
/* Marcas: tres cubos con letras, de la A a la Z */
MINI.marcas = g => {
  const cube = (x, y, z, s, col, ink, front, top) => {
    box(g, [x, y, z, x + s, y + s, z + s], col);
    faceText(g, front, [x, y - 0.003, z + s], [1,0,0], [0,0,-1], s * 0.66, ink, s / 2, s * 0.73);
    if (top) faceText(g, top, [x, y + s, z + s + 0.003], [1,0,0], [0,-1,0], s * 0.6, ink, s / 2, s * 0.72);
  };
  cube(0.62, 0.08, 0, 0.56, {t:'#3b4f8f', f:'#1d2a5c', l:'#24336b'}, '#FFFFFF', 'B');
  cube(0, 0, 0, 0.56, {t:'#FFFFFF', f:'#EFEAE1', l:'#DDD5C8'}, '#1d2a5c', 'A');
  cube(0.3, 0.04, 0.56, 0.56, {t:'#F4E7CC', f:'#E6D3AE', l:'#D5BF95'}, '#1A1D21', 'C', 'Z');
};

/* ---------- la imagen de entrada: el escaparate de J&M en la Illa Carlemany ---------- */
function faceOn(g, o, u, v, w) {
  const k = w / 588, f = el('g', {}, g);
  f.innerHTML = `<path d="${FACE_MAIN}" fill="#1d2a5c" fill-rule="evenodd"/><path d="${FACE_WINK}" fill="#1d2a5c"/><path d="${FACE_EYER}" fill="#1d2a5c"/>`;
  f.setAttribute('transform', `${wallMatrix(o, u, v)} scale(${k.toFixed(5)}) translate(-305 -353)`);
}
/* ---------- la cara pintada sobre un plano ---------- */
function faceOn(g, o, u, v, w) {
  const k = w / 588, f = el('g', {}, g);
  f.innerHTML = `<path d="${FACE_MAIN}" fill="#1d2a5c" fill-rule="evenodd"/><path d="${FACE_WINK}" fill="#1d2a5c"/><path d="${FACE_EYER}" fill="#1d2a5c"/>`;
  f.setAttribute('transform', `${wallMatrix(o, u, v)} scale(${k.toFixed(5)}) translate(-305 -353)`);
}

/* ---------- la imagen de entrada: la bolsa de J&M, con o sin productos asomando ---------- */
function heroBolsa(t, products) {
  return withCam(20, 16, () => {
    const g = el('svg', {class:'iso hart-svg', 'aria-hidden':'true'});
    const [cx, cy] = P(0.5, 0.2, 0);
    el('ellipse', {cx, cy, rx:1.6 * U, ry:0.62 * U, fill:'url(#pool)', opacity:0.6}, g);
    el('ellipse', {cx, cy:cy + 3, rx:0.78 * U, ry:0.2 * U, fill:'url(#drop)', opacity:0.5}, g);
    const bag = el('g', {}, g);
    // los productos asoman por la boca: se dibujan antes que la cara delantera de la bolsa
    OBJ.bag(bag, products ? (h, W0, D0, H0) => {
      put(h, 'tablet', 3, 0.04, 0.2, H0 - 0.2, 0.5);
      put(h, 'headphones', 1, 0.46, 0.08, H0 - 0.24, 0.6);
      put(h, 'phone', 2, 0.24, 0.1, H0 - 0.36, 0.72);
    } : 0);
    return g;
  });
}
/* la otra imagen de entrada: el expositor con lo último que ha llegado (sale de los datos, se actualiza solo) */
function heroUltimo() {
  const kinds = [];
  NEWS.forEach(r => { for (const t of r.tg) if (t.startsWith('k:') && OBJ[t.slice(2)] && !kinds.includes(t.slice(2))) kinds.push(t.slice(2)); });
  return exhibitSVG(kinds.slice(0, 4).map((k, i) => [k, (i % 4) + 1]));
}
const HEROES = {ultimo: () => heroUltimo()};

/* ===== cartbag.js ===== */
/* ---------- la bolsa del carrito: en 3D, como la de la tienda, o plana, de frente ---------- */
// dónde va cada producto en la boca de la bolsa; el más reciente, el primero (detrás y el que más asoma).
// x, y: posición en la boca · w: ancho máximo · up: cuánto asoma por encima del borde
const BAG3_SLOTS = {
  1: [{x:0.5, y:0.2, w:0.56, up:0.62}],
  2: [{x:0.33, y:0.26, w:0.46, up:0.64}, {x:0.69, y:0.13, w:0.42, up:0.48}],
  3: [{x:0.5, y:0.28, w:0.42, up:0.7}, {x:0.25, y:0.13, w:0.38, up:0.46}, {x:0.75, y:0.12, w:0.38, up:0.52}]
};
// en la plana, x y w van en partes del ancho de la bolsa, y up en partes de su alto
const BAG2_SLOTS = {
  1: [{x:0.5, w:0.5, up:0.5}],
  2: [{x:0.34, w:0.42, up:0.52}, {x:0.68, w:0.4, up:0.4}],
  3: [{x:0.5, w:0.38, up:0.56}, {x:0.24, w:0.36, up:0.38}, {x:0.77, w:0.36, up:0.44}]
};
let BAGN = 0;
const bbox2 = list => list.reduce((b, [x, y]) => ({x0: Math.min(b.x0, x), x1: Math.max(b.x1, x), y0: Math.min(b.y0, y), y1: Math.max(b.y1, y)}), {x0: Infinity, x1: -Infinity, y0: Infinity, y1: -Infinity});
const ptsStr = list => list.map(p => p.map(v => v.toFixed(1)).join(',')).join(' ');
function hull(points) {
  const p = points.slice().sort((a, b) => a[0] - b[0] || a[1] - b[1]), cr = (o, a, b) => (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
  const lo = [], up = [];
  for (const q of p) { while (lo.length > 1 && cr(lo[lo.length - 2], lo[lo.length - 1], q) <= 0) lo.pop(); lo.push(q); }
  for (const q of p.reverse()) { while (up.length > 1 && cr(up[up.length - 2], up[up.length - 1], q) <= 0) up.pop(); up.push(q); }
  return lo.slice(0, -1).concat(up.slice(0, -1));
}
// un producto que asoma por la boca de la bolsa: su imagen en 3D si la tiene (sacada de antemano, sin marca: un lápiz es un lápiz;
// Sergio, 19 oct: «hay artículos que cuando los añades a la bolsa son planos, haz un 3D para todos»); si no, dibujado aparte y medido
// en pantalla. Los planos (un teclado, una tarjeta) se ven desde arriba, que es como se ven de pie dentro de una bolsa
function sticker(parent, k, v, th, ph, phFlat) {
  const img = PRODUCTOS3D[k];
  if (img) {
    const [w, h] = img, g = el('g', {}, parent);
    el('image', {href: recurso('productos', k), x: 0, y: 0, width: w, height: h}, g);
    return {g, bb: {x0: 0, y0: 0, x1: w, y1: h}};
  }
  const m = measure(k, v), flat = (m.z1 - m.z0) / Math.max(m.x1 - m.x0, m.y1 - m.y0, 0.01) < 0.3;
  const cam = [th, flat ? phFlat : ph], g = el('g', {}, parent);
  REC = [];
  withCam(cam[0], cam[1], () => (OBJ[k] || OBJ.box)(g, v));
  const a = REC; REC = null;
  const onScreen = withCam(cam[0], cam[1], () => { const out = []; for (let i = 0; i < a.length; i += 3) out.push(P(a[i], a[i + 1], a[i + 2])); return out; });
  return {g, bb: bbox2(onScreen)};
}
// lo escala para que quepa y lo cuelga de su punto más alto; si es bajito, se hunde para no quedarse flotando
const isWide = ({bb}) => (bb.x1 - bb.x0) / (bb.y1 - bb.y0 || 1) > 1.15;
// mete los productos en la bolsa: cada uno en su sitio y, si es ancho (una tele, un portátil), al fondo y casi de lado a lado
function fillBag(inside, kinds, slots, make, put) {
  kinds.forEach((k, i) => {
    const wrap = el('g', {class: i ? 'op' : 'op np'}, inside), st = make(wrap, k, i + 1), wide = isWide(st);
    put(st, wide ? Object.assign({}, slots[i], {x: 0.5, y: 0.3, w: 0.82}) : slots[i]);
    if (wide) inside.insertBefore(wrap, inside.firstChild);
  });
}
function placeSticker({g, bb}, cx, topY, rimY, wMax, hMax, minIn) {
  const bw = bb.x1 - bb.x0 || 1, bh = bb.y1 - bb.y0 || 1, s = Math.min(wMax / bw, hMax / bh);
  const top = Math.max(topY, rimY + minIn - s * bh);
  g.setAttribute('transform', `translate(${(cx - s * (bb.x0 + bb.x1) / 2).toFixed(2)} ${(top - s * bb.y0).toFixed(2)}) scale(${s.toFixed(4)})`);
}
// en 3D: la bolsa de la tienda; los productos solo se ven por la boca, nada traspasa las paredes
function bag3D(kinds) {
  return withCam(20, 16, () => {
    const svg = el('svg', {class:'iso cbag-svg', 'aria-hidden':'true'}), W0 = 1.0, D0 = 0.4, H0 = 1.34;
    OBJ.bag(el('g', {}, svg), kinds.length ? h => {
      const id = 'cbclip' + (++BAGN), rim = [[0, 0], [W0, 0], [W0, D0], [0, D0]];
      el('polygon', {points: ptsStr(hull(rim.flatMap(([x, y]) => [P(x, y, H0), P(x, y, H0 + 3)])))}, el('clipPath', {id}, h));
      fillBag(el('g', {'clip-path': `url(#${id})`}, h), kinds, BAG3_SLOTS[kinds.length], (wrap, k, v) => sticker(wrap, k, v, 20, 16, 74), (st, sl) => {
        const [cx, topY] = P(sl.x, sl.y, H0 + sl.up), rimY = P(sl.x, sl.y, H0)[1];
        placeSticker(st, cx, topY, rimY, sl.w * U, (sl.up + 0.3) * U, 0.12 * U);
      });
    } : 0, {handlesBehind: true});
    // el marco es el de la bolsa vacía: no cambia de tamaño al llenarse (lo que asoma sale por encima)
    const corners = [];
    for (const x of [0, W0]) for (const y of [0, D0]) for (const z of [0, H0 + 0.36]) corners.push(P(x, y, z));
    const b = bbox2(corners), m = 2;
    svg.setAttribute('viewBox', `${(b.x0 - m).toFixed(1)} ${(b.y0 - m).toFixed(1)} ${(b.x1 - b.x0 + 2 * m).toFixed(1)} ${(b.y1 - b.y0 + 2 * m).toFixed(1)}`);
    return svg;
  });
}
// en 2D: la bolsa de frente, con el mismo trazo que la lupa y el menú
function bag2D(kinds) {
  const svg = el('svg', {class:'cbag-svg flat', 'aria-hidden':'true'}), W = 40, H = 46, ink = '#1d2a5c';
  // el asa, detrás de lo que asoma; la bolsa, delante
  el('path', {d: `M${W * 0.3} 6V-8Q${W * 0.3} -15 ${W * 0.38} -15H${W * 0.62}Q${W * 0.7} -15 ${W * 0.7} -8V6`, fill:'none', stroke: ink, 'stroke-width': 2.6, 'stroke-linecap':'round', 'stroke-linejoin':'round'}, svg);
  if (kinds.length) {
    const id = 'cbclip' + (++BAGN);
    el('rect', {x: 1.2, y: -40, width: W - 2.4, height: 40 + H - 2}, el('clipPath', {id}, svg));
    fillBag(el('g', {'clip-path': `url(#${id})`}, svg), kinds, BAG2_SLOTS[kinds.length], (wrap, k, v) => sticker(wrap, k, v, 0, 0, 89),
      (st, sl) => placeSticker(st, sl.x * W, -sl.up * H, 0, sl.w * W, (sl.up + 0.25) * H, 0.12 * H));
  }
  el('path', {d: `M0 0H${W}V${H - 4}Q${W} ${H} ${W - 4} ${H}H4Q0 ${H} 0 ${H - 4}Z`, fill:'#fff', stroke: ink, 'stroke-width': 2.4, 'stroke-linejoin':'round'}, svg);
  const f = el('g', {}, svg), fw = W * 0.46;
  f.innerHTML = `<path d="${FACE_MAIN}" fill="${ink}" fill-rule="evenodd"/><path d="${FACE_WINK}" fill="${ink}"/><path d="${FACE_EYER}" fill="${ink}"/>`;
  f.setAttribute('transform', `translate(${((W - fw) / 2).toFixed(2)} ${(H * 0.2).toFixed(2)}) scale(${(fw / 588).toFixed(5)}) translate(-305 -353)`);
  svg.setAttribute('viewBox', `-3 -18 ${W + 6} ${H + 21}`);
  return svg;
}
function cartBagSVG(kinds, style) { return style === '2d' ? bag2D(kinds) : bag3D(kinds); }

/* ===== vendor/qrcode.js ===== */
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------

var qrcode = function() {

  //---------------------------------------------------------------------
  // qrcode
  //---------------------------------------------------------------------

  /**
   * qrcode
   * @param typeNumber 1 to 40
   * @param errorCorrectionLevel 'L','M','Q','H'
   */
  var qrcode = function(typeNumber, errorCorrectionLevel) {

    var PAD0 = 0xEC;
    var PAD1 = 0x11;

    var _typeNumber = typeNumber;
    var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
    var _modules = null;
    var _moduleCount = 0;
    var _dataCache = null;
    var _dataList = [];

    var _this = {};

    var makeImpl = function(test, maskPattern) {

      _moduleCount = _typeNumber * 4 + 17;
      _modules = function(moduleCount) {
        var modules = new Array(moduleCount);
        for (var row = 0; row < moduleCount; row += 1) {
          modules[row] = new Array(moduleCount);
          for (var col = 0; col < moduleCount; col += 1) {
            modules[row][col] = null;
          }
        }
        return modules;
      }(_moduleCount);

      setupPositionProbePattern(0, 0);
      setupPositionProbePattern(_moduleCount - 7, 0);
      setupPositionProbePattern(0, _moduleCount - 7);
      setupPositionAdjustPattern();
      setupTimingPattern();
      setupTypeInfo(test, maskPattern);

      if (_typeNumber >= 7) {
        setupTypeNumber(test);
      }

      if (_dataCache == null) {
        _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
      }

      mapData(_dataCache, maskPattern);
    };

    var setupPositionProbePattern = function(row, col) {

      for (var r = -1; r <= 7; r += 1) {

        if (row + r <= -1 || _moduleCount <= row + r) continue;

        for (var c = -1; c <= 7; c += 1) {

          if (col + c <= -1 || _moduleCount <= col + c) continue;

          if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
              || (0 <= c && c <= 6 && (r == 0 || r == 6) )
              || (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
            _modules[row + r][col + c] = true;
          } else {
            _modules[row + r][col + c] = false;
          }
        }
      }
    };

    var getBestMaskPattern = function() {

      var minLostPoint = 0;
      var pattern = 0;

      for (var i = 0; i < 8; i += 1) {

        makeImpl(true, i);

        var lostPoint = QRUtil.getLostPoint(_this);

        if (i == 0 || minLostPoint > lostPoint) {
          minLostPoint = lostPoint;
          pattern = i;
        }
      }

      return pattern;
    };

    var setupTimingPattern = function() {

      for (var r = 8; r < _moduleCount - 8; r += 1) {
        if (_modules[r][6] != null) {
          continue;
        }
        _modules[r][6] = (r % 2 == 0);
      }

      for (var c = 8; c < _moduleCount - 8; c += 1) {
        if (_modules[6][c] != null) {
          continue;
        }
        _modules[6][c] = (c % 2 == 0);
      }
    };

    var setupPositionAdjustPattern = function() {

      var pos = QRUtil.getPatternPosition(_typeNumber);

      for (var i = 0; i < pos.length; i += 1) {

        for (var j = 0; j < pos.length; j += 1) {

          var row = pos[i];
          var col = pos[j];

          if (_modules[row][col] != null) {
            continue;
          }

          for (var r = -2; r <= 2; r += 1) {

            for (var c = -2; c <= 2; c += 1) {

              if (r == -2 || r == 2 || c == -2 || c == 2
                  || (r == 0 && c == 0) ) {
                _modules[row + r][col + c] = true;
              } else {
                _modules[row + r][col + c] = false;
              }
            }
          }
        }
      }
    };

    var setupTypeNumber = function(test) {

      var bits = QRUtil.getBCHTypeNumber(_typeNumber);

      for (var i = 0; i < 18; i += 1) {
        var mod = (!test && ( (bits >> i) & 1) == 1);
        _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
      }

      for (var i = 0; i < 18; i += 1) {
        var mod = (!test && ( (bits >> i) & 1) == 1);
        _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
      }
    };

    var setupTypeInfo = function(test, maskPattern) {

      var data = (_errorCorrectionLevel << 3) | maskPattern;
      var bits = QRUtil.getBCHTypeInfo(data);

      // vertical
      for (var i = 0; i < 15; i += 1) {

        var mod = (!test && ( (bits >> i) & 1) == 1);

        if (i < 6) {
          _modules[i][8] = mod;
        } else if (i < 8) {
          _modules[i + 1][8] = mod;
        } else {
          _modules[_moduleCount - 15 + i][8] = mod;
        }
      }

      // horizontal
      for (var i = 0; i < 15; i += 1) {

        var mod = (!test && ( (bits >> i) & 1) == 1);

        if (i < 8) {
          _modules[8][_moduleCount - i - 1] = mod;
        } else if (i < 9) {
          _modules[8][15 - i - 1 + 1] = mod;
        } else {
          _modules[8][15 - i - 1] = mod;
        }
      }

      // fixed module
      _modules[_moduleCount - 8][8] = (!test);
    };

    var mapData = function(data, maskPattern) {

      var inc = -1;
      var row = _moduleCount - 1;
      var bitIndex = 7;
      var byteIndex = 0;
      var maskFunc = QRUtil.getMaskFunction(maskPattern);

      for (var col = _moduleCount - 1; col > 0; col -= 2) {

        if (col == 6) col -= 1;

        while (true) {

          for (var c = 0; c < 2; c += 1) {

            if (_modules[row][col - c] == null) {

              var dark = false;

              if (byteIndex < data.length) {
                dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
              }

              var mask = maskFunc(row, col - c);

              if (mask) {
                dark = !dark;
              }

              _modules[row][col - c] = dark;
              bitIndex -= 1;

              if (bitIndex == -1) {
                byteIndex += 1;
                bitIndex = 7;
              }
            }
          }

          row += inc;

          if (row < 0 || _moduleCount <= row) {
            row -= inc;
            inc = -inc;
            break;
          }
        }
      }
    };

    var createBytes = function(buffer, rsBlocks) {

      var offset = 0;

      var maxDcCount = 0;
      var maxEcCount = 0;

      var dcdata = new Array(rsBlocks.length);
      var ecdata = new Array(rsBlocks.length);

      for (var r = 0; r < rsBlocks.length; r += 1) {

        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;

        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);

        dcdata[r] = new Array(dcCount);

        for (var i = 0; i < dcdata[r].length; i += 1) {
          dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
        }
        offset += dcCount;

        var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);

        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for (var i = 0; i < ecdata[r].length; i += 1) {
          var modIndex = i + modPoly.getLength() - ecdata[r].length;
          ecdata[r][i] = (modIndex >= 0)? modPoly.getAt(modIndex) : 0;
        }
      }

      var totalCodeCount = 0;
      for (var i = 0; i < rsBlocks.length; i += 1) {
        totalCodeCount += rsBlocks[i].totalCount;
      }

      var data = new Array(totalCodeCount);
      var index = 0;

      for (var i = 0; i < maxDcCount; i += 1) {
        for (var r = 0; r < rsBlocks.length; r += 1) {
          if (i < dcdata[r].length) {
            data[index] = dcdata[r][i];
            index += 1;
          }
        }
      }

      for (var i = 0; i < maxEcCount; i += 1) {
        for (var r = 0; r < rsBlocks.length; r += 1) {
          if (i < ecdata[r].length) {
            data[index] = ecdata[r][i];
            index += 1;
          }
        }
      }

      return data;
    };

    var createData = function(typeNumber, errorCorrectionLevel, dataList) {

      var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);

      var buffer = qrBitBuffer();

      for (var i = 0; i < dataList.length; i += 1) {
        var data = dataList[i];
        buffer.put(data.getMode(), 4);
        buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
        data.write(buffer);
      }

      // calc num max data.
      var totalDataCount = 0;
      for (var i = 0; i < rsBlocks.length; i += 1) {
        totalDataCount += rsBlocks[i].dataCount;
      }

      if (buffer.getLengthInBits() > totalDataCount * 8) {
        throw 'code length overflow. ('
          + buffer.getLengthInBits()
          + '>'
          + totalDataCount * 8
          + ')';
      }

      // end code
      if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
        buffer.put(0, 4);
      }

      // padding
      while (buffer.getLengthInBits() % 8 != 0) {
        buffer.putBit(false);
      }

      // padding
      while (true) {

        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(PAD0, 8);

        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(PAD1, 8);
      }

      return createBytes(buffer, rsBlocks);
    };

    _this.addData = function(data, mode) {

      mode = mode || 'Byte';

      var newData = null;

      switch(mode) {
      case 'Numeric' :
        newData = qrNumber(data);
        break;
      case 'Alphanumeric' :
        newData = qrAlphaNum(data);
        break;
      case 'Byte' :
        newData = qr8BitByte(data);
        break;
      case 'Kanji' :
        newData = qrKanji(data);
        break;
      default :
        throw 'mode:' + mode;
      }

      _dataList.push(newData);
      _dataCache = null;
    };

    _this.isDark = function(row, col) {
      if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) {
        throw row + ',' + col;
      }
      return _modules[row][col];
    };

    _this.getModuleCount = function() {
      return _moduleCount;
    };

    _this.make = function() {
      if (_typeNumber < 1) {
        var typeNumber = 1;

        for (; typeNumber < 40; typeNumber++) {
          var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
          var buffer = qrBitBuffer();

          for (var i = 0; i < _dataList.length; i++) {
            var data = _dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
            data.write(buffer);
          }

          var totalDataCount = 0;
          for (var i = 0; i < rsBlocks.length; i++) {
            totalDataCount += rsBlocks[i].dataCount;
          }

          if (buffer.getLengthInBits() <= totalDataCount * 8) {
            break;
          }
        }

        _typeNumber = typeNumber;
      }

      makeImpl(false, getBestMaskPattern() );
    };

    _this.createTableTag = function(cellSize, margin) {

      cellSize = cellSize || 2;
      margin = (typeof margin == 'undefined')? cellSize * 4 : margin;

      var qrHtml = '';

      qrHtml += '<table style="';
      qrHtml += ' border-width: 0px; border-style: none;';
      qrHtml += ' border-collapse: collapse;';
      qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
      qrHtml += '">';
      qrHtml += '<tbody>';

      for (var r = 0; r < _this.getModuleCount(); r += 1) {

        qrHtml += '<tr>';

        for (var c = 0; c < _this.getModuleCount(); c += 1) {
          qrHtml += '<td style="';
          qrHtml += ' border-width: 0px; border-style: none;';
          qrHtml += ' border-collapse: collapse;';
          qrHtml += ' padding: 0px; margin: 0px;';
          qrHtml += ' width: ' + cellSize + 'px;';
          qrHtml += ' height: ' + cellSize + 'px;';
          qrHtml += ' background-color: ';
          qrHtml += _this.isDark(r, c)? '#000000' : '#ffffff';
          qrHtml += ';';
          qrHtml += '"/>';
        }

        qrHtml += '</tr>';
      }

      qrHtml += '</tbody>';
      qrHtml += '</table>';

      return qrHtml;
    };

    _this.createSvgTag = function(cellSize, margin, alt, title) {

      var opts = {};
      if (typeof arguments[0] == 'object') {
        // Called by options.
        opts = arguments[0];
        // overwrite cellSize and margin.
        cellSize = opts.cellSize;
        margin = opts.margin;
        alt = opts.alt;
        title = opts.title;
      }

      cellSize = cellSize || 2;
      margin = (typeof margin == 'undefined')? cellSize * 4 : margin;

      // Compose alt property surrogate
      alt = (typeof alt === 'string') ? {text: alt} : alt || {};
      alt.text = alt.text || null;
      alt.id = (alt.text) ? alt.id || 'qrcode-description' : null;

      // Compose title property surrogate
      title = (typeof title === 'string') ? {text: title} : title || {};
      title.text = title.text || null;
      title.id = (title.text) ? title.id || 'qrcode-title' : null;

      var size = _this.getModuleCount() * cellSize + margin * 2;
      var c, mc, r, mr, qrSvg='', rect;

      rect = 'l' + cellSize + ',0 0,' + cellSize +
        ' -' + cellSize + ',0 0,-' + cellSize + 'z ';

      qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
      qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
      qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
      qrSvg += ' preserveAspectRatio="xMinYMin meet"';
      qrSvg += (title.text || alt.text) ? ' role="img" aria-labelledby="' +
          escapeXml([title.id, alt.id].join(' ').trim() ) + '"' : '';
      qrSvg += '>';
      qrSvg += (title.text) ? '<title id="' + escapeXml(title.id) + '">' +
          escapeXml(title.text) + '</title>' : '';
      qrSvg += (alt.text) ? '<description id="' + escapeXml(alt.id) + '">' +
          escapeXml(alt.text) + '</description>' : '';
      qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
      qrSvg += '<path d="';

      for (r = 0; r < _this.getModuleCount(); r += 1) {
        mr = r * cellSize + margin;
        for (c = 0; c < _this.getModuleCount(); c += 1) {
          if (_this.isDark(r, c) ) {
            mc = c*cellSize+margin;
            qrSvg += 'M' + mc + ',' + mr + rect;
          }
        }
      }

      qrSvg += '" stroke="transparent" fill="black"/>';
      qrSvg += '</svg>';

      return qrSvg;
    };

    _this.createDataURL = function(cellSize, margin) {

      cellSize = cellSize || 2;
      margin = (typeof margin == 'undefined')? cellSize * 4 : margin;

      var size = _this.getModuleCount() * cellSize + margin * 2;
      var min = margin;
      var max = size - margin;

      return createDataURL(size, size, function(x, y) {
        if (min <= x && x < max && min <= y && y < max) {
          var c = Math.floor( (x - min) / cellSize);
          var r = Math.floor( (y - min) / cellSize);
          return _this.isDark(r, c)? 0 : 1;
        } else {
          return 1;
        }
      } );
    };

    _this.createImgTag = function(cellSize, margin, alt) {

      cellSize = cellSize || 2;
      margin = (typeof margin == 'undefined')? cellSize * 4 : margin;

      var size = _this.getModuleCount() * cellSize + margin * 2;

      var img = '';
      img += '<img';
      img += '\u0020src="';
      img += _this.createDataURL(cellSize, margin);
      img += '"';
      img += '\u0020width="';
      img += size;
      img += '"';
      img += '\u0020height="';
      img += size;
      img += '"';
      if (alt) {
        img += '\u0020alt="';
        img += escapeXml(alt);
        img += '"';
      }
      img += '/>';

      return img;
    };

    var escapeXml = function(s) {
      var escaped = '';
      for (var i = 0; i < s.length; i += 1) {
        var c = s.charAt(i);
        switch(c) {
        case '<': escaped += '&lt;'; break;
        case '>': escaped += '&gt;'; break;
        case '&': escaped += '&amp;'; break;
        case '"': escaped += '&quot;'; break;
        default : escaped += c; break;
        }
      }
      return escaped;
    };

    var _createHalfASCII = function(margin) {
      var cellSize = 1;
      margin = (typeof margin == 'undefined')? cellSize * 2 : margin;

      var size = _this.getModuleCount() * cellSize + margin * 2;
      var min = margin;
      var max = size - margin;

      var y, x, r1, r2, p;

      var blocks = {
        '██': '█',
        '█ ': '▀',
        ' █': '▄',
        '  ': ' '
      };

      var blocksLastLineNoMargin = {
        '██': '▀',
        '█ ': '▀',
        ' █': ' ',
        '  ': ' '
      };

      var ascii = '';
      for (y = 0; y < size; y += 2) {
        r1 = Math.floor((y - min) / cellSize);
        r2 = Math.floor((y + 1 - min) / cellSize);
        for (x = 0; x < size; x += 1) {
          p = '█';

          if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) {
            p = ' ';
          }

          if (min <= x && x < max && min <= y+1 && y+1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) {
            p += ' ';
          }
          else {
            p += '█';
          }

          // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
          ascii += (margin < 1 && y+1 >= max) ? blocksLastLineNoMargin[p] : blocks[p];
        }

        ascii += '\n';
      }

      if (size % 2 && margin > 0) {
        return ascii.substring(0, ascii.length - size - 1) + Array(size+1).join('▀');
      }

      return ascii.substring(0, ascii.length-1);
    };

    _this.createASCII = function(cellSize, margin) {
      cellSize = cellSize || 1;

      if (cellSize < 2) {
        return _createHalfASCII(margin);
      }

      cellSize -= 1;
      margin = (typeof margin == 'undefined')? cellSize * 2 : margin;

      var size = _this.getModuleCount() * cellSize + margin * 2;
      var min = margin;
      var max = size - margin;

      var y, x, r, p;

      var white = Array(cellSize+1).join('██');
      var black = Array(cellSize+1).join('  ');

      var ascii = '';
      var line = '';
      for (y = 0; y < size; y += 1) {
        r = Math.floor( (y - min) / cellSize);
        line = '';
        for (x = 0; x < size; x += 1) {
          p = 1;

          if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) {
            p = 0;
          }

          // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
          line += p ? white : black;
        }

        for (r = 0; r < cellSize; r += 1) {
          ascii += line + '\n';
        }
      }

      return ascii.substring(0, ascii.length-1);
    };

    _this.renderTo2dContext = function(context, cellSize) {
      cellSize = cellSize || 2;
      var length = _this.getModuleCount();
      for (var row = 0; row < length; row++) {
        for (var col = 0; col < length; col++) {
          context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
          context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
        }
      }
    }

    return _this;
  };

  //---------------------------------------------------------------------
  // qrcode.stringToBytes
  //---------------------------------------------------------------------

  qrcode.stringToBytesFuncs = {
    'default' : function(s) {
      var bytes = [];
      for (var i = 0; i < s.length; i += 1) {
        var c = s.charCodeAt(i);
        bytes.push(c & 0xff);
      }
      return bytes;
    }
  };

  qrcode.stringToBytes = qrcode.stringToBytesFuncs['default'];

  //---------------------------------------------------------------------
  // qrcode.createStringToBytes
  //---------------------------------------------------------------------

  /**
   * @param unicodeData base64 string of byte array.
   * [16bit Unicode],[16bit Bytes], ...
   * @param numChars
   */
  qrcode.createStringToBytes = function(unicodeData, numChars) {

    // create conversion map.

    var unicodeMap = function() {

      var bin = base64DecodeInputStream(unicodeData);
      var read = function() {
        var b = bin.read();
        if (b == -1) throw 'eof';
        return b;
      };

      var count = 0;
      var unicodeMap = {};
      while (true) {
        var b0 = bin.read();
        if (b0 == -1) break;
        var b1 = read();
        var b2 = read();
        var b3 = read();
        var k = String.fromCharCode( (b0 << 8) | b1);
        var v = (b2 << 8) | b3;
        unicodeMap[k] = v;
        count += 1;
      }
      if (count != numChars) {
        throw count + ' != ' + numChars;
      }

      return unicodeMap;
    }();

    var unknownChar = '?'.charCodeAt(0);

    return function(s) {
      var bytes = [];
      for (var i = 0; i < s.length; i += 1) {
        var c = s.charCodeAt(i);
        if (c < 128) {
          bytes.push(c);
        } else {
          var b = unicodeMap[s.charAt(i)];
          if (typeof b == 'number') {
            if ( (b & 0xff) == b) {
              // 1byte
              bytes.push(b);
            } else {
              // 2bytes
              bytes.push(b >>> 8);
              bytes.push(b & 0xff);
            }
          } else {
            bytes.push(unknownChar);
          }
        }
      }
      return bytes;
    };
  };

  //---------------------------------------------------------------------
  // QRMode
  //---------------------------------------------------------------------

  var QRMode = {
    MODE_NUMBER :    1 << 0,
    MODE_ALPHA_NUM : 1 << 1,
    MODE_8BIT_BYTE : 1 << 2,
    MODE_KANJI :     1 << 3
  };

  //---------------------------------------------------------------------
  // QRErrorCorrectionLevel
  //---------------------------------------------------------------------

  var QRErrorCorrectionLevel = {
    L : 1,
    M : 0,
    Q : 3,
    H : 2
  };

  //---------------------------------------------------------------------
  // QRMaskPattern
  //---------------------------------------------------------------------

  var QRMaskPattern = {
    PATTERN000 : 0,
    PATTERN001 : 1,
    PATTERN010 : 2,
    PATTERN011 : 3,
    PATTERN100 : 4,
    PATTERN101 : 5,
    PATTERN110 : 6,
    PATTERN111 : 7
  };

  //---------------------------------------------------------------------
  // QRUtil
  //---------------------------------------------------------------------

  var QRUtil = function() {

    var PATTERN_POSITION_TABLE = [
      [],
      [6, 18],
      [6, 22],
      [6, 26],
      [6, 30],
      [6, 34],
      [6, 22, 38],
      [6, 24, 42],
      [6, 26, 46],
      [6, 28, 50],
      [6, 30, 54],
      [6, 32, 58],
      [6, 34, 62],
      [6, 26, 46, 66],
      [6, 26, 48, 70],
      [6, 26, 50, 74],
      [6, 30, 54, 78],
      [6, 30, 56, 82],
      [6, 30, 58, 86],
      [6, 34, 62, 90],
      [6, 28, 50, 72, 94],
      [6, 26, 50, 74, 98],
      [6, 30, 54, 78, 102],
      [6, 28, 54, 80, 106],
      [6, 32, 58, 84, 110],
      [6, 30, 58, 86, 114],
      [6, 34, 62, 90, 118],
      [6, 26, 50, 74, 98, 122],
      [6, 30, 54, 78, 102, 126],
      [6, 26, 52, 78, 104, 130],
      [6, 30, 56, 82, 108, 134],
      [6, 34, 60, 86, 112, 138],
      [6, 30, 58, 86, 114, 142],
      [6, 34, 62, 90, 118, 146],
      [6, 30, 54, 78, 102, 126, 150],
      [6, 24, 50, 76, 102, 128, 154],
      [6, 28, 54, 80, 106, 132, 158],
      [6, 32, 58, 84, 110, 136, 162],
      [6, 26, 54, 82, 110, 138, 166],
      [6, 30, 58, 86, 114, 142, 170]
    ];
    var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
    var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
    var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);

    var _this = {};

    var getBCHDigit = function(data) {
      var digit = 0;
      while (data != 0) {
        digit += 1;
        data >>>= 1;
      }
      return digit;
    };

    _this.getBCHTypeInfo = function(data) {
      var d = data << 10;
      while (getBCHDigit(d) - getBCHDigit(G15) >= 0) {
        d ^= (G15 << (getBCHDigit(d) - getBCHDigit(G15) ) );
      }
      return ( (data << 10) | d) ^ G15_MASK;
    };

    _this.getBCHTypeNumber = function(data) {
      var d = data << 12;
      while (getBCHDigit(d) - getBCHDigit(G18) >= 0) {
        d ^= (G18 << (getBCHDigit(d) - getBCHDigit(G18) ) );
      }
      return (data << 12) | d;
    };

    _this.getPatternPosition = function(typeNumber) {
      return PATTERN_POSITION_TABLE[typeNumber - 1];
    };

    _this.getMaskFunction = function(maskPattern) {

      switch (maskPattern) {

      case QRMaskPattern.PATTERN000 :
        return function(i, j) { return (i + j) % 2 == 0; };
      case QRMaskPattern.PATTERN001 :
        return function(i, j) { return i % 2 == 0; };
      case QRMaskPattern.PATTERN010 :
        return function(i, j) { return j % 3 == 0; };
      case QRMaskPattern.PATTERN011 :
        return function(i, j) { return (i + j) % 3 == 0; };
      case QRMaskPattern.PATTERN100 :
        return function(i, j) { return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0; };
      case QRMaskPattern.PATTERN101 :
        return function(i, j) { return (i * j) % 2 + (i * j) % 3 == 0; };
      case QRMaskPattern.PATTERN110 :
        return function(i, j) { return ( (i * j) % 2 + (i * j) % 3) % 2 == 0; };
      case QRMaskPattern.PATTERN111 :
        return function(i, j) { return ( (i * j) % 3 + (i + j) % 2) % 2 == 0; };

      default :
        throw 'bad maskPattern:' + maskPattern;
      }
    };

    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
      var a = qrPolynomial([1], 0);
      for (var i = 0; i < errorCorrectLength; i += 1) {
        a = a.multiply(qrPolynomial([1, QRMath.gexp(i)], 0) );
      }
      return a;
    };

    _this.getLengthInBits = function(mode, type) {

      if (1 <= type && type < 10) {

        // 1 - 9

        switch(mode) {
        case QRMode.MODE_NUMBER    : return 10;
        case QRMode.MODE_ALPHA_NUM : return 9;
        case QRMode.MODE_8BIT_BYTE : return 8;
        case QRMode.MODE_KANJI     : return 8;
        default :
          throw 'mode:' + mode;
        }

      } else if (type < 27) {

        // 10 - 26

        switch(mode) {
        case QRMode.MODE_NUMBER    : return 12;
        case QRMode.MODE_ALPHA_NUM : return 11;
        case QRMode.MODE_8BIT_BYTE : return 16;
        case QRMode.MODE_KANJI     : return 10;
        default :
          throw 'mode:' + mode;
        }

      } else if (type < 41) {

        // 27 - 40

        switch(mode) {
        case QRMode.MODE_NUMBER    : return 14;
        case QRMode.MODE_ALPHA_NUM : return 13;
        case QRMode.MODE_8BIT_BYTE : return 16;
        case QRMode.MODE_KANJI     : return 12;
        default :
          throw 'mode:' + mode;
        }

      } else {
        throw 'type:' + type;
      }
    };

    _this.getLostPoint = function(qrcode) {

      var moduleCount = qrcode.getModuleCount();

      var lostPoint = 0;

      // LEVEL1

      for (var row = 0; row < moduleCount; row += 1) {
        for (var col = 0; col < moduleCount; col += 1) {

          var sameCount = 0;
          var dark = qrcode.isDark(row, col);

          for (var r = -1; r <= 1; r += 1) {

            if (row + r < 0 || moduleCount <= row + r) {
              continue;
            }

            for (var c = -1; c <= 1; c += 1) {

              if (col + c < 0 || moduleCount <= col + c) {
                continue;
              }

              if (r == 0 && c == 0) {
                continue;
              }

              if (dark == qrcode.isDark(row + r, col + c) ) {
                sameCount += 1;
              }
            }
          }

          if (sameCount > 5) {
            lostPoint += (3 + sameCount - 5);
          }
        }
      };

      // LEVEL2

      for (var row = 0; row < moduleCount - 1; row += 1) {
        for (var col = 0; col < moduleCount - 1; col += 1) {
          var count = 0;
          if (qrcode.isDark(row, col) ) count += 1;
          if (qrcode.isDark(row + 1, col) ) count += 1;
          if (qrcode.isDark(row, col + 1) ) count += 1;
          if (qrcode.isDark(row + 1, col + 1) ) count += 1;
          if (count == 0 || count == 4) {
            lostPoint += 3;
          }
        }
      }

      // LEVEL3

      for (var row = 0; row < moduleCount; row += 1) {
        for (var col = 0; col < moduleCount - 6; col += 1) {
          if (qrcode.isDark(row, col)
              && !qrcode.isDark(row, col + 1)
              &&  qrcode.isDark(row, col + 2)
              &&  qrcode.isDark(row, col + 3)
              &&  qrcode.isDark(row, col + 4)
              && !qrcode.isDark(row, col + 5)
              &&  qrcode.isDark(row, col + 6) ) {
            lostPoint += 40;
          }
        }
      }

      for (var col = 0; col < moduleCount; col += 1) {
        for (var row = 0; row < moduleCount - 6; row += 1) {
          if (qrcode.isDark(row, col)
              && !qrcode.isDark(row + 1, col)
              &&  qrcode.isDark(row + 2, col)
              &&  qrcode.isDark(row + 3, col)
              &&  qrcode.isDark(row + 4, col)
              && !qrcode.isDark(row + 5, col)
              &&  qrcode.isDark(row + 6, col) ) {
            lostPoint += 40;
          }
        }
      }

      // LEVEL4

      var darkCount = 0;

      for (var col = 0; col < moduleCount; col += 1) {
        for (var row = 0; row < moduleCount; row += 1) {
          if (qrcode.isDark(row, col) ) {
            darkCount += 1;
          }
        }
      }

      var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
      lostPoint += ratio * 10;

      return lostPoint;
    };

    return _this;
  }();

  //---------------------------------------------------------------------
  // QRMath
  //---------------------------------------------------------------------

  var QRMath = function() {

    var EXP_TABLE = new Array(256);
    var LOG_TABLE = new Array(256);

    // initialize tables
    for (var i = 0; i < 8; i += 1) {
      EXP_TABLE[i] = 1 << i;
    }
    for (var i = 8; i < 256; i += 1) {
      EXP_TABLE[i] = EXP_TABLE[i - 4]
        ^ EXP_TABLE[i - 5]
        ^ EXP_TABLE[i - 6]
        ^ EXP_TABLE[i - 8];
    }
    for (var i = 0; i < 255; i += 1) {
      LOG_TABLE[EXP_TABLE[i] ] = i;
    }

    var _this = {};

    _this.glog = function(n) {

      if (n < 1) {
        throw 'glog(' + n + ')';
      }

      return LOG_TABLE[n];
    };

    _this.gexp = function(n) {

      while (n < 0) {
        n += 255;
      }

      while (n >= 256) {
        n -= 255;
      }

      return EXP_TABLE[n];
    };

    return _this;
  }();

  //---------------------------------------------------------------------
  // qrPolynomial
  //---------------------------------------------------------------------

  function qrPolynomial(num, shift) {

    if (typeof num.length == 'undefined') {
      throw num.length + '/' + shift;
    }

    var _num = function() {
      var offset = 0;
      while (offset < num.length && num[offset] == 0) {
        offset += 1;
      }
      var _num = new Array(num.length - offset + shift);
      for (var i = 0; i < num.length - offset; i += 1) {
        _num[i] = num[i + offset];
      }
      return _num;
    }();

    var _this = {};

    _this.getAt = function(index) {
      return _num[index];
    };

    _this.getLength = function() {
      return _num.length;
    };

    _this.multiply = function(e) {

      var num = new Array(_this.getLength() + e.getLength() - 1);

      for (var i = 0; i < _this.getLength(); i += 1) {
        for (var j = 0; j < e.getLength(); j += 1) {
          num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i) ) + QRMath.glog(e.getAt(j) ) );
        }
      }

      return qrPolynomial(num, 0);
    };

    _this.mod = function(e) {

      if (_this.getLength() - e.getLength() < 0) {
        return _this;
      }

      var ratio = QRMath.glog(_this.getAt(0) ) - QRMath.glog(e.getAt(0) );

      var num = new Array(_this.getLength() );
      for (var i = 0; i < _this.getLength(); i += 1) {
        num[i] = _this.getAt(i);
      }

      for (var i = 0; i < e.getLength(); i += 1) {
        num[i] ^= QRMath.gexp(QRMath.glog(e.getAt(i) ) + ratio);
      }

      // recursive call
      return qrPolynomial(num, 0).mod(e);
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // QRRSBlock
  //---------------------------------------------------------------------

  var QRRSBlock = function() {

    var RS_BLOCK_TABLE = [

      // L
      // M
      // Q
      // H

      // 1
      [1, 26, 19],
      [1, 26, 16],
      [1, 26, 13],
      [1, 26, 9],

      // 2
      [1, 44, 34],
      [1, 44, 28],
      [1, 44, 22],
      [1, 44, 16],

      // 3
      [1, 70, 55],
      [1, 70, 44],
      [2, 35, 17],
      [2, 35, 13],

      // 4
      [1, 100, 80],
      [2, 50, 32],
      [2, 50, 24],
      [4, 25, 9],

      // 5
      [1, 134, 108],
      [2, 67, 43],
      [2, 33, 15, 2, 34, 16],
      [2, 33, 11, 2, 34, 12],

      // 6
      [2, 86, 68],
      [4, 43, 27],
      [4, 43, 19],
      [4, 43, 15],

      // 7
      [2, 98, 78],
      [4, 49, 31],
      [2, 32, 14, 4, 33, 15],
      [4, 39, 13, 1, 40, 14],

      // 8
      [2, 121, 97],
      [2, 60, 38, 2, 61, 39],
      [4, 40, 18, 2, 41, 19],
      [4, 40, 14, 2, 41, 15],

      // 9
      [2, 146, 116],
      [3, 58, 36, 2, 59, 37],
      [4, 36, 16, 4, 37, 17],
      [4, 36, 12, 4, 37, 13],

      // 10
      [2, 86, 68, 2, 87, 69],
      [4, 69, 43, 1, 70, 44],
      [6, 43, 19, 2, 44, 20],
      [6, 43, 15, 2, 44, 16],

      // 11
      [4, 101, 81],
      [1, 80, 50, 4, 81, 51],
      [4, 50, 22, 4, 51, 23],
      [3, 36, 12, 8, 37, 13],

      // 12
      [2, 116, 92, 2, 117, 93],
      [6, 58, 36, 2, 59, 37],
      [4, 46, 20, 6, 47, 21],
      [7, 42, 14, 4, 43, 15],

      // 13
      [4, 133, 107],
      [8, 59, 37, 1, 60, 38],
      [8, 44, 20, 4, 45, 21],
      [12, 33, 11, 4, 34, 12],

      // 14
      [3, 145, 115, 1, 146, 116],
      [4, 64, 40, 5, 65, 41],
      [11, 36, 16, 5, 37, 17],
      [11, 36, 12, 5, 37, 13],

      // 15
      [5, 109, 87, 1, 110, 88],
      [5, 65, 41, 5, 66, 42],
      [5, 54, 24, 7, 55, 25],
      [11, 36, 12, 7, 37, 13],

      // 16
      [5, 122, 98, 1, 123, 99],
      [7, 73, 45, 3, 74, 46],
      [15, 43, 19, 2, 44, 20],
      [3, 45, 15, 13, 46, 16],

      // 17
      [1, 135, 107, 5, 136, 108],
      [10, 74, 46, 1, 75, 47],
      [1, 50, 22, 15, 51, 23],
      [2, 42, 14, 17, 43, 15],

      // 18
      [5, 150, 120, 1, 151, 121],
      [9, 69, 43, 4, 70, 44],
      [17, 50, 22, 1, 51, 23],
      [2, 42, 14, 19, 43, 15],

      // 19
      [3, 141, 113, 4, 142, 114],
      [3, 70, 44, 11, 71, 45],
      [17, 47, 21, 4, 48, 22],
      [9, 39, 13, 16, 40, 14],

      // 20
      [3, 135, 107, 5, 136, 108],
      [3, 67, 41, 13, 68, 42],
      [15, 54, 24, 5, 55, 25],
      [15, 43, 15, 10, 44, 16],

      // 21
      [4, 144, 116, 4, 145, 117],
      [17, 68, 42],
      [17, 50, 22, 6, 51, 23],
      [19, 46, 16, 6, 47, 17],

      // 22
      [2, 139, 111, 7, 140, 112],
      [17, 74, 46],
      [7, 54, 24, 16, 55, 25],
      [34, 37, 13],

      // 23
      [4, 151, 121, 5, 152, 122],
      [4, 75, 47, 14, 76, 48],
      [11, 54, 24, 14, 55, 25],
      [16, 45, 15, 14, 46, 16],

      // 24
      [6, 147, 117, 4, 148, 118],
      [6, 73, 45, 14, 74, 46],
      [11, 54, 24, 16, 55, 25],
      [30, 46, 16, 2, 47, 17],

      // 25
      [8, 132, 106, 4, 133, 107],
      [8, 75, 47, 13, 76, 48],
      [7, 54, 24, 22, 55, 25],
      [22, 45, 15, 13, 46, 16],

      // 26
      [10, 142, 114, 2, 143, 115],
      [19, 74, 46, 4, 75, 47],
      [28, 50, 22, 6, 51, 23],
      [33, 46, 16, 4, 47, 17],

      // 27
      [8, 152, 122, 4, 153, 123],
      [22, 73, 45, 3, 74, 46],
      [8, 53, 23, 26, 54, 24],
      [12, 45, 15, 28, 46, 16],

      // 28
      [3, 147, 117, 10, 148, 118],
      [3, 73, 45, 23, 74, 46],
      [4, 54, 24, 31, 55, 25],
      [11, 45, 15, 31, 46, 16],

      // 29
      [7, 146, 116, 7, 147, 117],
      [21, 73, 45, 7, 74, 46],
      [1, 53, 23, 37, 54, 24],
      [19, 45, 15, 26, 46, 16],

      // 30
      [5, 145, 115, 10, 146, 116],
      [19, 75, 47, 10, 76, 48],
      [15, 54, 24, 25, 55, 25],
      [23, 45, 15, 25, 46, 16],

      // 31
      [13, 145, 115, 3, 146, 116],
      [2, 74, 46, 29, 75, 47],
      [42, 54, 24, 1, 55, 25],
      [23, 45, 15, 28, 46, 16],

      // 32
      [17, 145, 115],
      [10, 74, 46, 23, 75, 47],
      [10, 54, 24, 35, 55, 25],
      [19, 45, 15, 35, 46, 16],

      // 33
      [17, 145, 115, 1, 146, 116],
      [14, 74, 46, 21, 75, 47],
      [29, 54, 24, 19, 55, 25],
      [11, 45, 15, 46, 46, 16],

      // 34
      [13, 145, 115, 6, 146, 116],
      [14, 74, 46, 23, 75, 47],
      [44, 54, 24, 7, 55, 25],
      [59, 46, 16, 1, 47, 17],

      // 35
      [12, 151, 121, 7, 152, 122],
      [12, 75, 47, 26, 76, 48],
      [39, 54, 24, 14, 55, 25],
      [22, 45, 15, 41, 46, 16],

      // 36
      [6, 151, 121, 14, 152, 122],
      [6, 75, 47, 34, 76, 48],
      [46, 54, 24, 10, 55, 25],
      [2, 45, 15, 64, 46, 16],

      // 37
      [17, 152, 122, 4, 153, 123],
      [29, 74, 46, 14, 75, 47],
      [49, 54, 24, 10, 55, 25],
      [24, 45, 15, 46, 46, 16],

      // 38
      [4, 152, 122, 18, 153, 123],
      [13, 74, 46, 32, 75, 47],
      [48, 54, 24, 14, 55, 25],
      [42, 45, 15, 32, 46, 16],

      // 39
      [20, 147, 117, 4, 148, 118],
      [40, 75, 47, 7, 76, 48],
      [43, 54, 24, 22, 55, 25],
      [10, 45, 15, 67, 46, 16],

      // 40
      [19, 148, 118, 6, 149, 119],
      [18, 75, 47, 31, 76, 48],
      [34, 54, 24, 34, 55, 25],
      [20, 45, 15, 61, 46, 16]
    ];

    var qrRSBlock = function(totalCount, dataCount) {
      var _this = {};
      _this.totalCount = totalCount;
      _this.dataCount = dataCount;
      return _this;
    };

    var _this = {};

    var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {

      switch(errorCorrectionLevel) {
      case QRErrorCorrectionLevel.L :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
      case QRErrorCorrectionLevel.M :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
      case QRErrorCorrectionLevel.Q :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
      case QRErrorCorrectionLevel.H :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
      default :
        return undefined;
      }
    };

    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {

      var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);

      if (typeof rsBlock == 'undefined') {
        throw 'bad rs block @ typeNumber:' + typeNumber +
            '/errorCorrectionLevel:' + errorCorrectionLevel;
      }

      var length = rsBlock.length / 3;

      var list = [];

      for (var i = 0; i < length; i += 1) {

        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];

        for (var j = 0; j < count; j += 1) {
          list.push(qrRSBlock(totalCount, dataCount) );
        }
      }

      return list;
    };

    return _this;
  }();

  //---------------------------------------------------------------------
  // qrBitBuffer
  //---------------------------------------------------------------------

  var qrBitBuffer = function() {

    var _buffer = [];
    var _length = 0;

    var _this = {};

    _this.getBuffer = function() {
      return _buffer;
    };

    _this.getAt = function(index) {
      var bufIndex = Math.floor(index / 8);
      return ( (_buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
    };

    _this.put = function(num, length) {
      for (var i = 0; i < length; i += 1) {
        _this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
      }
    };

    _this.getLengthInBits = function() {
      return _length;
    };

    _this.putBit = function(bit) {

      var bufIndex = Math.floor(_length / 8);
      if (_buffer.length <= bufIndex) {
        _buffer.push(0);
      }

      if (bit) {
        _buffer[bufIndex] |= (0x80 >>> (_length % 8) );
      }

      _length += 1;
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrNumber
  //---------------------------------------------------------------------

  var qrNumber = function(data) {

    var _mode = QRMode.MODE_NUMBER;
    var _data = data;

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return _data.length;
    };

    _this.write = function(buffer) {

      var data = _data;

      var i = 0;

      while (i + 2 < data.length) {
        buffer.put(strToNum(data.substring(i, i + 3) ), 10);
        i += 3;
      }

      if (i < data.length) {
        if (data.length - i == 1) {
          buffer.put(strToNum(data.substring(i, i + 1) ), 4);
        } else if (data.length - i == 2) {
          buffer.put(strToNum(data.substring(i, i + 2) ), 7);
        }
      }
    };

    var strToNum = function(s) {
      var num = 0;
      for (var i = 0; i < s.length; i += 1) {
        num = num * 10 + chatToNum(s.charAt(i) );
      }
      return num;
    };

    var chatToNum = function(c) {
      if ('0' <= c && c <= '9') {
        return c.charCodeAt(0) - '0'.charCodeAt(0);
      }
      throw 'illegal char :' + c;
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrAlphaNum
  //---------------------------------------------------------------------

  var qrAlphaNum = function(data) {

    var _mode = QRMode.MODE_ALPHA_NUM;
    var _data = data;

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return _data.length;
    };

    _this.write = function(buffer) {

      var s = _data;

      var i = 0;

      while (i + 1 < s.length) {
        buffer.put(
          getCode(s.charAt(i) ) * 45 +
          getCode(s.charAt(i + 1) ), 11);
        i += 2;
      }

      if (i < s.length) {
        buffer.put(getCode(s.charAt(i) ), 6);
      }
    };

    var getCode = function(c) {

      if ('0' <= c && c <= '9') {
        return c.charCodeAt(0) - '0'.charCodeAt(0);
      } else if ('A' <= c && c <= 'Z') {
        return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
      } else {
        switch (c) {
        case ' ' : return 36;
        case '$' : return 37;
        case '%' : return 38;
        case '*' : return 39;
        case '+' : return 40;
        case '-' : return 41;
        case '.' : return 42;
        case '/' : return 43;
        case ':' : return 44;
        default :
          throw 'illegal char :' + c;
        }
      }
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qr8BitByte
  //---------------------------------------------------------------------

  var qr8BitByte = function(data) {

    var _mode = QRMode.MODE_8BIT_BYTE;
    var _data = data;
    var _bytes = qrcode.stringToBytes(data);

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return _bytes.length;
    };

    _this.write = function(buffer) {
      for (var i = 0; i < _bytes.length; i += 1) {
        buffer.put(_bytes[i], 8);
      }
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrKanji
  //---------------------------------------------------------------------

  var qrKanji = function(data) {

    var _mode = QRMode.MODE_KANJI;
    var _data = data;

    var stringToBytes = qrcode.stringToBytesFuncs['SJIS'];
    if (!stringToBytes) {
      throw 'sjis not supported.';
    }
    !function(c, code) {
      // self test for sjis support.
      var test = stringToBytes(c);
      if (test.length != 2 || ( (test[0] << 8) | test[1]) != code) {
        throw 'sjis not supported.';
      }
    }('\u53cb', 0x9746);

    var _bytes = stringToBytes(data);

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return ~~(_bytes.length / 2);
    };

    _this.write = function(buffer) {

      var data = _bytes;

      var i = 0;

      while (i + 1 < data.length) {

        var c = ( (0xff & data[i]) << 8) | (0xff & data[i + 1]);

        if (0x8140 <= c && c <= 0x9FFC) {
          c -= 0x8140;
        } else if (0xE040 <= c && c <= 0xEBBF) {
          c -= 0xC140;
        } else {
          throw 'illegal char at ' + (i + 1) + '/' + c;
        }

        c = ( (c >>> 8) & 0xff) * 0xC0 + (c & 0xff);

        buffer.put(c, 13);

        i += 2;
      }

      if (i < data.length) {
        throw 'illegal char at ' + (i + 1);
      }
    };

    return _this;
  };

  //=====================================================================
  // GIF Support etc.
  //

  //---------------------------------------------------------------------
  // byteArrayOutputStream
  //---------------------------------------------------------------------

  var byteArrayOutputStream = function() {

    var _bytes = [];

    var _this = {};

    _this.writeByte = function(b) {
      _bytes.push(b & 0xff);
    };

    _this.writeShort = function(i) {
      _this.writeByte(i);
      _this.writeByte(i >>> 8);
    };

    _this.writeBytes = function(b, off, len) {
      off = off || 0;
      len = len || b.length;
      for (var i = 0; i < len; i += 1) {
        _this.writeByte(b[i + off]);
      }
    };

    _this.writeString = function(s) {
      for (var i = 0; i < s.length; i += 1) {
        _this.writeByte(s.charCodeAt(i) );
      }
    };

    _this.toByteArray = function() {
      return _bytes;
    };

    _this.toString = function() {
      var s = '';
      s += '[';
      for (var i = 0; i < _bytes.length; i += 1) {
        if (i > 0) {
          s += ',';
        }
        s += _bytes[i];
      }
      s += ']';
      return s;
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // base64EncodeOutputStream
  //---------------------------------------------------------------------

  var base64EncodeOutputStream = function() {

    var _buffer = 0;
    var _buflen = 0;
    var _length = 0;
    var _base64 = '';

    var _this = {};

    var writeEncoded = function(b) {
      _base64 += String.fromCharCode(encode(b & 0x3f) );
    };

    var encode = function(n) {
      if (n < 0) {
        // error.
      } else if (n < 26) {
        return 0x41 + n;
      } else if (n < 52) {
        return 0x61 + (n - 26);
      } else if (n < 62) {
        return 0x30 + (n - 52);
      } else if (n == 62) {
        return 0x2b;
      } else if (n == 63) {
        return 0x2f;
      }
      throw 'n:' + n;
    };

    _this.writeByte = function(n) {

      _buffer = (_buffer << 8) | (n & 0xff);
      _buflen += 8;
      _length += 1;

      while (_buflen >= 6) {
        writeEncoded(_buffer >>> (_buflen - 6) );
        _buflen -= 6;
      }
    };

    _this.flush = function() {

      if (_buflen > 0) {
        writeEncoded(_buffer << (6 - _buflen) );
        _buffer = 0;
        _buflen = 0;
      }

      if (_length % 3 != 0) {
        // padding
        var padlen = 3 - _length % 3;
        for (var i = 0; i < padlen; i += 1) {
          _base64 += '=';
        }
      }
    };

    _this.toString = function() {
      return _base64;
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // base64DecodeInputStream
  //---------------------------------------------------------------------

  var base64DecodeInputStream = function(str) {

    var _str = str;
    var _pos = 0;
    var _buffer = 0;
    var _buflen = 0;

    var _this = {};

    _this.read = function() {

      while (_buflen < 8) {

        if (_pos >= _str.length) {
          if (_buflen == 0) {
            return -1;
          }
          throw 'unexpected end of file./' + _buflen;
        }

        var c = _str.charAt(_pos);
        _pos += 1;

        if (c == '=') {
          _buflen = 0;
          return -1;
        } else if (c.match(/^\s$/) ) {
          // ignore if whitespace.
          continue;
        }

        _buffer = (_buffer << 6) | decode(c.charCodeAt(0) );
        _buflen += 6;
      }

      var n = (_buffer >>> (_buflen - 8) ) & 0xff;
      _buflen -= 8;
      return n;
    };

    var decode = function(c) {
      if (0x41 <= c && c <= 0x5a) {
        return c - 0x41;
      } else if (0x61 <= c && c <= 0x7a) {
        return c - 0x61 + 26;
      } else if (0x30 <= c && c <= 0x39) {
        return c - 0x30 + 52;
      } else if (c == 0x2b) {
        return 62;
      } else if (c == 0x2f) {
        return 63;
      } else {
        throw 'c:' + c;
      }
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // gifImage (B/W)
  //---------------------------------------------------------------------

  var gifImage = function(width, height) {

    var _width = width;
    var _height = height;
    var _data = new Array(width * height);

    var _this = {};

    _this.setPixel = function(x, y, pixel) {
      _data[y * _width + x] = pixel;
    };

    _this.write = function(out) {

      //---------------------------------
      // GIF Signature

      out.writeString('GIF87a');

      //---------------------------------
      // Screen Descriptor

      out.writeShort(_width);
      out.writeShort(_height);

      out.writeByte(0x80); // 2bit
      out.writeByte(0);
      out.writeByte(0);

      //---------------------------------
      // Global Color Map

      // black
      out.writeByte(0x00);
      out.writeByte(0x00);
      out.writeByte(0x00);

      // white
      out.writeByte(0xff);
      out.writeByte(0xff);
      out.writeByte(0xff);

      //---------------------------------
      // Image Descriptor

      out.writeString(',');
      out.writeShort(0);
      out.writeShort(0);
      out.writeShort(_width);
      out.writeShort(_height);
      out.writeByte(0);

      //---------------------------------
      // Local Color Map

      //---------------------------------
      // Raster Data

      var lzwMinCodeSize = 2;
      var raster = getLZWRaster(lzwMinCodeSize);

      out.writeByte(lzwMinCodeSize);

      var offset = 0;

      while (raster.length - offset > 255) {
        out.writeByte(255);
        out.writeBytes(raster, offset, 255);
        offset += 255;
      }

      out.writeByte(raster.length - offset);
      out.writeBytes(raster, offset, raster.length - offset);
      out.writeByte(0x00);

      //---------------------------------
      // GIF Terminator
      out.writeString(';');
    };

    var bitOutputStream = function(out) {

      var _out = out;
      var _bitLength = 0;
      var _bitBuffer = 0;

      var _this = {};

      _this.write = function(data, length) {

        if ( (data >>> length) != 0) {
          throw 'length over';
        }

        while (_bitLength + length >= 8) {
          _out.writeByte(0xff & ( (data << _bitLength) | _bitBuffer) );
          length -= (8 - _bitLength);
          data >>>= (8 - _bitLength);
          _bitBuffer = 0;
          _bitLength = 0;
        }

        _bitBuffer = (data << _bitLength) | _bitBuffer;
        _bitLength = _bitLength + length;
      };

      _this.flush = function() {
        if (_bitLength > 0) {
          _out.writeByte(_bitBuffer);
        }
      };

      return _this;
    };

    var getLZWRaster = function(lzwMinCodeSize) {

      var clearCode = 1 << lzwMinCodeSize;
      var endCode = (1 << lzwMinCodeSize) + 1;
      var bitLength = lzwMinCodeSize + 1;

      // Setup LZWTable
      var table = lzwTable();

      for (var i = 0; i < clearCode; i += 1) {
        table.add(String.fromCharCode(i) );
      }
      table.add(String.fromCharCode(clearCode) );
      table.add(String.fromCharCode(endCode) );

      var byteOut = byteArrayOutputStream();
      var bitOut = bitOutputStream(byteOut);

      // clear code
      bitOut.write(clearCode, bitLength);

      var dataIndex = 0;

      var s = String.fromCharCode(_data[dataIndex]);
      dataIndex += 1;

      while (dataIndex < _data.length) {

        var c = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;

        if (table.contains(s + c) ) {

          s = s + c;

        } else {

          bitOut.write(table.indexOf(s), bitLength);

          if (table.size() < 0xfff) {

            if (table.size() == (1 << bitLength) ) {
              bitLength += 1;
            }

            table.add(s + c);
          }

          s = c;
        }
      }

      bitOut.write(table.indexOf(s), bitLength);

      // end code
      bitOut.write(endCode, bitLength);

      bitOut.flush();

      return byteOut.toByteArray();
    };

    var lzwTable = function() {

      var _map = {};
      var _size = 0;

      var _this = {};

      _this.add = function(key) {
        if (_this.contains(key) ) {
          throw 'dup key:' + key;
        }
        _map[key] = _size;
        _size += 1;
      };

      _this.size = function() {
        return _size;
      };

      _this.indexOf = function(key) {
        return _map[key];
      };

      _this.contains = function(key) {
        return typeof _map[key] != 'undefined';
      };

      return _this;
    };

    return _this;
  };

  var createDataURL = function(width, height, getPixel) {
    var gif = gifImage(width, height);
    for (var y = 0; y < height; y += 1) {
      for (var x = 0; x < width; x += 1) {
        gif.setPixel(x, y, getPixel(x, y) );
      }
    }

    var b = byteArrayOutputStream();
    gif.write(b);

    var base64 = base64EncodeOutputStream();
    var bytes = b.toByteArray();
    for (var i = 0; i < bytes.length; i += 1) {
      base64.writeByte(bytes[i]);
    }
    base64.flush();

    return 'data:image/gif;base64,' + base64;
  };

  //---------------------------------------------------------------------
  // returns qrcode function.

  return qrcode;
}();

// multibyte support
!function() {

  qrcode.stringToBytesFuncs['UTF-8'] = function(s) {
    // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
    function toUTF8Array(str) {
      var utf8 = [];
      for (var i=0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
          utf8.push(0xc0 | (charcode >> 6),
              0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
          utf8.push(0xe0 | (charcode >> 12),
              0x80 | ((charcode>>6) & 0x3f),
              0x80 | (charcode & 0x3f));
        }
        // surrogate pair
        else {
          i++;
          // UTF-16 encodes 0x10000-0x10FFFF by
          // subtracting 0x10000 and splitting the
          // 20 bits of 0x0-0xFFFFF into two halves
          charcode = 0x10000 + (((charcode & 0x3ff)<<10)
            | (str.charCodeAt(i) & 0x3ff));
          utf8.push(0xf0 | (charcode >>18),
              0x80 | ((charcode>>12) & 0x3f),
              0x80 | ((charcode>>6) & 0x3f),
              0x80 | (charcode & 0x3f));
        }
      }
      return utf8;
    }
    return toUTF8Array(s);
  };

}();

(function (factory) {
  if (typeof define === 'function' && define.amd) {
      define([], factory);
  } else if (typeof exports === 'object') {
      module.exports = factory();
  }
}(function () {
    return qrcode;
}));

/* ===== clave-web.js ===== */
/* ---------- la marca del pedido web: para que el bot sepa que el WhatsApp viene de la web ----------
   (Sergio, 21 oct: «que cuando se envíe el WhatsApp al bot, el bot sepa que viene de la web»). Son unas letras invisibles justo
   después de «Hola»: el cliente no ve nada distinto y puede cambiar el texto. Llevan la versión, si viene de la bolsa o de una ficha
   y, por cada aparato, si dejó el color o la capacidad sin tocar (para que el bot pregunte solo eso). Probado el 21 oct: llegan enteras
   al bot por el QR en el iPhone y por WhatsApp Web. Este mismo código lo usa el bot (nodo «Extraer Datos Mensaje» de n8n): si se
   cambia aquí, se cambia allí.
   Forma: [3, versión, origen (0 bolsa, 1 ficha), aparatos (2 cifras), por aparato (1 color sin tocar + 2 capacidad sin tocar),
   control (2 cifras)], cada cifra de 0 a 3 en una letra invisible. Un emoji con uniones (👨‍👩‍👧) no se confunde: nunca junta 7. */
const MARCA_LETRAS = ['​', '‌', '‍', '⁠'];
const MARCA_VERSION = 1;
const MARCA_TRAMO = /[​‌‍⁠]{7,}/g;
function claveWeb(origen, lineas) {
  const n = Math.min(lineas.length, 15);
  const cifras = [MARCA_VERSION, origen === 'ficha' ? 1 : 0, n >> 2, n & 3,
    ...lineas.slice(0, n).map(l => (l && l.color ? 1 : 0) + (l && l.cap ? 2 : 0))];
  const control = cifras.reduce((a, b) => a + b, 0) % 16;
  return [3, ...cifras, control >> 2, control & 3].map(c => MARCA_LETRAS[c]).join('');
}
// la marca del texto, o null si no la lleva (o la lleva rota: entonces se trata como un mensaje normal)
function leerClave(texto) {
  for (const tramo of String(texto || '').match(MARCA_TRAMO) || []) {
    const c = [...tramo].map(x => MARCA_LETRAS.indexOf(x)), n = c[3] * 4 + c[4];
    if (c[0] !== 3 || c[1] !== MARCA_VERSION || c.length !== 7 + n) continue;
    if (c.slice(1, 5 + n).reduce((a, b) => a + b, 0) % 16 !== c[5 + n] * 4 + c[6 + n]) continue;
    return {version: c[1], origen: c[2] === 1 ? 'ficha' : 'bolsa',
      lineas: c.slice(5, 5 + n).map(x => ({color: !!(x & 1), cap: !!(x & 2)}))};
  }
  return null;
}
// el texto sin la marca (los emojis con uniones se quedan como están)
const quitarClave = texto => String(texto || '').replace(MARCA_TRAMO, '');
// la marca, justo después de «Hola» (o delante, si el mensaje no empieza así)
const conClave = (msg, clave) => /^\s*hola/i.test(msg) ? msg.replace(/^(\s*hola)/i, '$1' + clave) : clave + msg;
if (typeof module !== 'undefined' && module.exports) module.exports = {claveWeb, leerClave, quitarClave, conClave};

/* ===== contacto.js ===== */
/* ---------- pedir por WhatsApp desde el ordenador ---------- */
// (Sergio, 20 oct: «lo del QR me parece la mejor idea; dejamos los correos y el número de la tienda para otras cosas, que al final le
// llegará a mis padres y va en contra del principio que quería yo: yo lo llevo todo. Pedirlo por WhatsApp es la idea que más me
// gusta»; y «si detecta que está en un ordenador, al apretar en pedir por WhatsApp te genera el QR y abajo pone: si ya tienes WhatsApp
// Web, pulsa aquí»). En el móvil, el botón abre WhatsApp. En el ordenador, un código QR que lo abre en el móvil con el pedido ya escrito
// (lo dibuja vendor/qrcode.js: qrcode-generator 2.0.4, de Kazuhiko Arase, MIT) y, debajo, el enlace a WhatsApp Web. Aquí, «ordenador»
// es el «Ordenador» de arriba del simulador; en la web de verdad, lo que se maneja con ratón: matchMedia('(hover: hover) and (pointer: fine)')
const WA = '376322501';
// los portes a España (sin las islas, Ceuta ni Melilla): los mismos que cobra el bot (prompt de «Bot Javier»), y solo en pedidos desde 100 €
// (Sergio, 21 oct: por debajo no se envía, salvo un caso especial que se habla con ellos). Si cambian, se cambian los dos
const PORTES = '30 €';
const waUrl = msg => `https://wa.me/${WA}?text=${encodeURIComponent(msg)}`;
const waWebUrl = msg => `https://web.whatsapp.com/send?phone=${WA}&text=${encodeURIComponent(msg)}`;
// el código QR en SVG: 3 px por cuadro, con su margen blanco de 4 cuadros. Si el texto no cabe ni con la corrección más baja, nada
function qrSvg(texto, etiqueta) {
  let q = null;
  for (const nivel of ['M', 'L']) {
    try { q = qrcode(0, nivel); q.addData(texto, 'Byte'); q.make(); break; } catch (e) { q = null; }
  }
  if (!q) return '';
  const n = q.getModuleCount(), m = 4, lado = n + 2 * m;
  let d = '';
  for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (q.isDark(y, x)) d += `M${x + m} ${y + m}h1v1h-1z`;
  return `<svg class="qr" viewBox="0 0 ${lado} ${lado}" width="${lado * 3}" height="${lado * 3}" shape-rendering="crispEdges" role="img" aria-label="${esc(etiqueta)}"><rect width="${lado}" height="${lado}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
}
// el QR con su explicación y, debajo, el enlace para quien ya tiene WhatsApp Web (los dos, con el mismo pedido)
function panelQr(st, msg) {
  const W = T[st.lang].qrWa, svg = qrSvg(waUrl(msg), W.alt);
  const web = `<p class="qr-web">${W.web(`<a href="${waWebUrl(msg)}" target="_blank" rel="noopener">${W.aqui}</a>`)}</p>`;
  return `<div class="qr-wa">${svg ? `${svg}<div class="qr-t"><p>${W.qr}</p>${web}</div>` : web}</div>`;
}
// pedir o preguntar por WhatsApp desde cualquier botón de la web. Con el dedo, se abre WhatsApp con el mensaje; con ratón, el QR del
// sitio (enSitio: el de la ficha o el de la bolsa, que van debajo de sus botones) o, si no tiene, el QR en una ventanita encima de
// todo. En el simulador, el aviso de siempre (y el QR de la ficha y de la bolsa en «Ordenador»)
function abrirWa(st, msg, enSitio) {
  const movil = REAL ? conDedo() : st.isPhone;
  if (movil) {
    if (REAL) location.href = waUrl(msg); else toast(st, waMsg(msg));
    return;
  }
  if (enSitio && !st.isPhone) return enSitio();
  if (REAL) return verQrSuelto(st, msg);
  toast(st, waMsg(msg));
}
// la ventanita del QR: se cierra con su ×, pulsando fuera o con Escape (app.js)
function verQrSuelto(st, msg) {
  cerrarQrSuelto(st);
  const W = T[st.lang].qrWa, d = document.createElement('div');
  d.className = 'qr-suelto';
  d.setAttribute('role', 'dialog'); d.setAttribute('aria-modal', 'true'); d.setAttribute('aria-label', W.titulo);
  d.innerHTML = `<div class="qs-c"><button type="button" class="qs-x" aria-label="${esc(W.cerrar)}">×</button><p class="qs-t">${esc(W.titulo)}</p>${panelQr(st, msg)}</div>`;
  st.root.appendChild(d);
  d.querySelector('.qs-x').focus({preventScroll: true});
}
const cerrarQrSuelto = st => st.root.querySelectorAll('.qr-suelto').forEach(d => d.remove());
// cómo llegar a las tiendas: Google Maps con la Illa Carlemany (las dos están dentro: la planta baja, local B7, y la −1, local S4)
const MAPA = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('J&M Electronics, Illa Carlemany, Escaldes-Engordany, Andorra');
const abrirMapa = st => { if (REAL) window.open(MAPA, '_blank', 'noopener'); else toast(st, 'Aquí se abriría Google Maps con el camino a la tienda.'); };

/* ===== assist.js ===== */
/* ---------- el asistente: árbol de preguntas, sin IA ---------- */
const noAcc = r => !r.tg.has('acc');
const has = tag => r => r.tg.has(tag);
const ROOT = {
  mobils:  {list: () => rowsIn(['mobils']).filter(noAcc), what:'mobils', tile:'mobils'},
  tv:      {list: () => rowsIn(['tv']).filter(noAcc), what:'tv', sort:'asc', tile:'tv'},
  tabrel:  {list: () => rowsIn(['tabrel']).filter(noAcc), tile:'tabrel'},
  so:      {list: () => rowsIn(['so']).filter(noAcc), tile:'so'},
  consoles:{list: () => rowsIn(['consoles']).filter(noAcc), what:'consoles', sort:'asc', tile:'consoles'},
  drons:   {list: () => rowsIn(['drons']).filter(noAcc), tile:'drons'},
  pc:      {list: () => rowsIn(B1_SECS), tile:'port'},
  llar:    {list: () => rowsIn(['llar']), what:'llar', tile:'llar'},
  otra:    {tile:'bag'}
};
function priceStep(c, L, q, cuts) {
  const N = fmtN, last = cuts[cuts.length - 1], o = [{k:'p0', label:L.lt(N(cuts[0])), sum:L.slt(N(cuts[0])), f:r => r.p < cuts[0]}];
  for (let i = 1; i < cuts.length; i++) { const a = cuts[i - 1], b = cuts[i]; o.push({k:'p' + i, label:L.rg(N(a), N(b)), sum:L.srg(N(a), N(b)), f:r => r.p >= a && r.p < b}); }
  o.push({k:'pz', label:L.gt(N(last)), sum:L.sgt(N(last)), f:r => r.p >= last}, {k:'any', label:L.any});
  return {id:'price', q, opts:o};
}
const brandsIn = list => [...new Set(list.map(r => r.v))].sort((a, b) => a.localeCompare(b, 'es', {sensitivity:'base'}));
const FLOWS = {
  mobils(c, L) {
    const A = L.mobils, a = c.ans;
    if (!a.brand) return {id:'brand', q:A.brand, opts:[...brandsIn(c.list).map(b => ({k:b, label:b, sum:b, f:r => r.v === b})), {k:'any', label:L.any}]};
    if (!a.price) return priceStep(c, L, A.price, [300, 600, 1000]);
    if (!a.fold && c.list.some(has('fold')) && c.list.some(r => !r.tg.has('fold')))
      return {id:'fold', q:A.fold, opts:[{k:'y', label:A.fy, sum:A.sfy, f:has('fold')}, {k:'n', label:A.fn, sum:A.sfn, f:r => !r.tg.has('fold')}, {k:'any', label:L.any}]};
    return null;
  },
  tv(c, L) {
    const A = L.tv, a = c.ans;
    if (!a.room) return {id:'room', q:A.room, opts:[{k:'s', label:A.rs, sum:A.srs, f:has('room:s')}, {k:'m', label:A.rm, sum:A.srm, f:has('room:m')}, {k:'l', label:A.rl, sum:A.srl, f:has('room:l')}, {k:'k', label:A.rk, nocount:true}]};
    if (a.room === 'k' && !a.size) {
      const sizes = [...new Set(c.list.map(r => r.in))].filter(Boolean).sort((x, y) => x - y);
      return {id:'size', q:A.size, grid:true, opts:sizes.map(s => ({k:String(s), label:s + '"', sum:A.ssize(s), f:r => r.in === s}))};
    }
    if (!a.use) return {id:'use', q:A.use, opts:[{k:'a', label:A.ua, sum:A.sua, adv:A.aa}, {k:'c', label:A.uc, sum:A.suc, adv:A.ac, f:has('cine')}, {k:'g', label:A.ug, sum:A.sug, adv:A.ag, f:has('g120')}]};
    if (!a.price && c.list.length > 3) return priceStep(c, L, A.price, [400, 800, 1500]);
    return null;
  },
  tabrel(c, L) {
    const A = L.tabrel, a = c.ans;
    if (!a.kind) return {id:'kind', q:A.kind, opts:[{k:'tab', label:A.tab, what:L.what.tab, f:has('tab')}, {k:'watch', label:A.watch, what:L.what.watch, f:has('watch')}]};
    if (a.kind === 'tab') {
      if (!a.os) return {id:'os', q:A.os, opts:[{k:'ios', label:A.sios, sum:A.sios, f:has('os:ios')}, {k:'and', label:A.sand, sum:A.sand, f:has('os:and')}, {k:'any', label:L.any}]};
      if (!a.price && c.list.length > 3) return priceStep(c, L, A.price, [200, 400]);
      return null;
    }
    if (!a.who) return {id:'who', q:A.who, opts:[{k:'me', label:A.me, f:r => !r.tg.has('kids')}, {k:'kid', label:A.kid, sum:A.skid, adv:A.akid, f:has('kids')}]};
    if (a.who === 'me' && !a.phone) return {id:'phone', q:A.phone, opts:[{k:'ios', label:A.ios, sum:A.spi, adv:A.aios, f:has('w:ios')}, {k:'and', label:A.and, sum:A.spa, adv:A.aand, f:has('w:and')}]};
    return null;
  },
  so(c, L) {
    const A = L.so, a = c.ans;
    if (!a.kind) return {id:'kind', q:A.kind, opts:[
      {k:'ear', label:A.ear, what:L.what.ear, f:r => r.tg.has('inear') || r.tg.has('over') || r.tg.has('sport')},
      {k:'spk', label:A.spk, what:L.what.spk, f:has('spk')},
      {k:'tvh', label:A.tvh, what:L.what.tvh, adv:A.atv, f:has('tvh')}]};
    if (a.kind === 'ear') {
      if (!a.type) return {id:'type', q:A.type, opts:[{k:'in', label:A.tin, sum:A.stin, f:has('inear')}, {k:'ov', label:A.tov, sum:A.stov, f:has('over')}, {k:'sp', label:A.tsp, sum:A.stsp, f:has('sport')}, {k:'any', label:L.any}]};
      if (!a.phone) return {id:'phone', q:A.phone, opts:[
        {k:'i', label:A.pi, sum:A.spi, adv:c.list.some(has('eco:apple')) ? A.api : '', prefer:'eco:apple', nocount:true},
        {k:'s', label:A.ps, sum:A.sps, adv:c.list.some(has('eco:sam')) ? A.aps : '', prefer:'eco:sam', nocount:true},
        {k:'o', label:A.po, nocount:true}]};
      return null;
    }
    if (a.kind === 'spk' && !a.where) return {id:'where', q:A.where, opts:[{k:'h', label:A.wh, sum:A.swh, f:has('sp:home')}, {k:'g', label:A.wg, sum:A.swg, f:has('sp:go')}, {k:'p', label:A.wp, sum:A.swp, f:has('sp:party')}]};
    return null;
  },
  consoles(c, L) {
    const A = L.consoles, a = c.ans;
    if (!a.who) return {id:'who', q:A.who, opts:[{k:'me', label:A.me, sum:A.sme, nocount:true}, {k:'kid', label:A.kid, sum:A.skid, nocount:true}, {k:'fam', label:A.fam, sum:A.sfam, nocount:true}]};
    if (!a.which) {
      const mine = a.who === 'me';
      // consejo atemporal: no depende de qué modelos haya hoy en la tienda
      const adv = mine ? {f:has('c:ps'), adv:A.aps, sort:'asc'} : {f:has('c:nin'), adv:A.anin};
      return {id:'which', q:A.which, opts:[{k:'ps', label:A.ps, sum:A.ps, f:has('c:ps')}, {k:'nin', label:A.nin, sum:A.nin, f:has('c:nin')}, Object.assign({k:'adv', label:A.adv, nocount:true}, adv)]};
    }
    return null;
  },
  drons(c, L) {
    const A = L.drons, a = c.ans;
    if (!a.what) return {id:'what', q:A.what, opts:[
      {k:'dr', label:A.dr, what:L.what.drone, f:has('drone')}, {k:'ac', label:A.ac, what:L.what.action, f:has('action')},
      {k:'vl', label:A.vl, what:L.what.vlog, f:has('vlog')}, {k:'se', label:A.se, what:L.what.secu, f:has('secu')},
      {k:'pr', label:A.pr, what:L.what.pro, f:r => r.tg.has('pro') || r.tg.has('d:pro')}]};
    if (a.what === 'dr') {
      if (!a.exp) return {id:'exp', q:A.exp, opts:[{k:'f', label:A.ef, sum:A.sef, adv:A.aef, f:has('d:first')}, {k:'a', label:A.ea, sum:A.sea, f:has('d:adv')}, {k:'p', label:A.ep, sum:A.sep, adv:A.aep, f:has('d:fpv')}]};
      if (!a.price && c.list.length > 3) return priceStep(c, L, A.price, [300, 700]);
      return null;
    }
    if (a.what === 'ac' && !a.a360) return {id:'a360', q:A.a360, opts:[{k:'n', label:A.an, sum:A.san, f:has('a:norm')}, {k:'3', label:A.a3, sum:A.sa3, f:has('a:360')}, {k:'any', label:L.any}]};
    return null;
  },
  pc(c, L) {
    const A = L.pc, a = c.ans;
    if (!a.what) return {id:'what', q:A.what, opts:[
      {k:'port', label:A.port, what:L.what.port, sort:'asc', f:r => r.sec === 'port'}, {k:'sobre', label:A.sobre, sort:'asc', f:r => r.sec === 'sobre'},
      {k:'emmag', label:A.emmag, what:L.what.emmag, sort:'asc', f:r => r.sec === 'emmag'}, {k:'impr', label:A.impr, what:L.what.impr, sort:'asc', f:r => r.sec === 'impr'},
      {k:'comp', label:A.comp, what:L.what.comp, f:r => r.sec === 'comp'}]};
    if (a.what === 'port') {
      if (!a.use) return {id:'use', q:A.use, opts:[
        {k:'b', label:A.ub, sum:A.sub, adv:A.aub, f:has('l:basic')}, {k:'w', label:A.uw, sum:A.suw, f:has('l:work')},
        {k:'e', label:A.ue, sum:A.sue, adv:A.aue, f:has('l:edit')}, {k:'g', label:A.ug, sum:lc1(A.ug), none:A.nog, f:has('l:game'), keep:true}]};
      if (!a.os && !c.none && c.list.some(has('os:mac')) && c.list.some(has('os:win')))
        return {id:'os', q:A.os, opts:[{k:'mac', label:A.mac, sum:'Mac', f:has('os:mac')}, {k:'win', label:A.win, sum:'Windows', f:has('os:win')}, {k:'any', label:L.any}]};
      return null;
    }
    if (a.what === 'sobre') {
      if (!a.dw) return {id:'dw', q:A.dw, opts:[{k:'desk', label:A.desk, what:L.what.desk, f:has('desk')}, {k:'mon', label:A.mon, what:L.what.mon, f:has('mon')}]};
      if (a.dw === 'mon' && !a.mu) return {id:'mu', q:A.mu, opts:[{k:'o', label:A.mo, sum:A.smo, f:has('m:office')}, {k:'g', label:A.mg, sum:A.smg, adv:A.amg, f:has('m:game')}, {k:'d', label:A.md, sum:A.smd, adv:A.amd, f:has('m:design')}]};
      return null;
    }
    if (a.what === 'emmag' && !a.sk) return {id:'sk', q:A.sk, opts:[{k:'e', label:A.sext, what:lc1(A.sext), f:has('s:ext')}, {k:'i', label:A.sint, what:lc1(A.sint), f:has('s:int')}, {k:'c', label:A.scard, what:lc1(A.scard), f:has('s:card')}]};
    if (a.what === 'impr' && !a.pk) return {id:'pk', q:A.pk, opts:[{k:'l', label:A.pl, sum:lc1(A.pl), adv:A.apl, f:has('p:laser')}, {k:'i', label:A.pi, sum:lc1(A.pi), adv:A.api, f:has('p:ink')}, {k:'s', label:A.ps, sum:lc1(A.ps), f:has('p:scan')}]};
    return null;
  },
  llar(c, L) {
    const A = L.llar;
    if (!c.ans.what) return {id:'what', q:A.what, opts:['robot', 'afeit', 'gps', 'power'].map(k => ({k, label:A[k], what:lc1(A[k]), f:has('h:' + k)})).concat({k:'other', label:A.other, f:has('h:other')})};
    return null;
  }
};

function runFlow(st) {
  const L = T[st.lang].as, A = st.as, R = ROOT[A.flow];
  const c = {list:R.list(), ans:{}, parts:[], what:L.what[R.what] || '', adv:'', sort:R.sort || 'new', none:'', prefer:'', pin:null};
  const done = [];
  for (const k of A.answers) {
    const step = FLOWS[A.flow](c, L);
    const o = step && step.opts.find(o => o.k === k);
    if (!o) break;
    done.push({q:step.q, a:o.label});
    c.ans[step.id] = k;
    if (o.f) c.list = c.list.filter(o.f);
    if (o.sum) c.parts.push(o.sum);
    ['what', 'adv', 'sort', 'prefer', 'pin'].forEach(p => { if (o[p]) c[p] = o[p]; });
    if (o.none && !c.list.length) c.none = o.none;
  }
  return {c, done, step: c.none ? null : FLOWS[A.flow](c, L)};
}
function ordered(c) {
  const l = c.list.slice();
  if (c.sort === 'asc') l.sort((a, b) => a.p - b.p);
  if (c.prefer) l.sort((a, b) => b.tg.has(c.prefer) - a.tg.has(c.prefer));
  if (c.pin) { const ix = r => { const i = c.pin.indexOf(r.t); return i < 0 ? 99 : i; }; l.sort((a, b) => ix(a) - ix(b)); }
  return l;
}

/* ---------- el buscador (también sin IA: coincidencia de palabras) ---------- */
// palabras con las que la gente busca cada tipo de producto, en castellano y catalán
const KIND_WORDS = {
  phone:'movil mobil telefono smartphone phone mobile portable', fold:'movil mobil plegable phone foldable pliable', flip:'movil mobil plegable phone foldable pliable', tablet:'tablet tableta tauleta ipad tablette', watch:'reloj rellotge smartwatch watch montre', band:'pulsera polsera reloj rellotge band bracelet watch montre',
  earbuds:'auriculares auriculars cascos earbuds headphones earphones ecouteurs', headphones:'auriculares auriculars cascos diadema headphones casque', speaker:'altavoz altaveu bluetooth speaker enceinte', homepod:'altavoz altaveu speaker enceinte', mic:'microfono microfon microphone micro',
  ps5:'consola playstation', switch:'consola nintendo', vr:'gafas ulleres realidad realitat virtual headset reality lunettes casque realite', drone:'dron drone', remote:'mando comandament controller remote manette telecommande', goggles:'gafas ulleres fpv goggles lunettes',
  actioncam:'camara camera accion accio deportiva action sport', pocket:'camara camera', gimbal:'estabilizador estabilitzador gimbal stabiliser stabilizer stabilisateur', seccam:'camara camera vigilancia security surveillance',
  laptop:'portatil ordenador ordinador laptop computer notebook ordinateur portable', monitor:'monitor pantalla screen ecran', aio:'ordenador ordinador sobremesa sobretaula computer desktop ordinateur', minipc:'ordenador ordinador sobremesa sobretaula computer desktop ordinateur',
  nvme:'ssd disco disc drive disk disque', ssdext:'ssd disco disc externo extern drive disk external disque externe', card:'tarjeta targeta memoria microsd card memory carte memoire', ecotank:'impresora impressora printer imprimante', laser:'impresora impressora laser printer imprimante', pen:'escaner scanner',
  keyboard:'teclado teclat keyboard clavier', trackpad:'trackpad', router:'router wifi', gpu:'grafica graphics card carte graphique', robot:'robot aspirador vacuum aspirateur', shaver:'afeitadora afaitadora shaver rasoir', gps:'gps navegador',
  power:'bateria estacion estacio energia battery power station batterie', frame:'marco marc foto frame photo cadre', meteo:'estacion estacio meteorologica weather station meteo', binoculars:'prismaticos prismatics binoculars jumelles', tag:'localizador localitzador airtag tracker traceur', beacon:'baliza balisa v16 beacon balise',
  tv:'tele televisor televisio tv television televiseur', projector:'proyector projector projecteur', tvbox:'tele tv'
};
function searchRows(q) {
  const words = norm(q).split(/\s+/).filter(w => w.length > 1);
  if (!words.length) return [];
  const kindOfRow = r => { for (const t of r.tg) if (t.startsWith('k:')) return t.slice(2); return ''; };
  // primero lo que lo dice en el nombre, luego por el tipo de producto y al final por la sección
  // (el nombre, también con las letras y los números juntos y separados: «buds 4» encuentra «Buds4» y «s26» encuentra «S 26»; Sergio,
  // 22 oct 2026, buscaba los Buds 4 y no salían)
  const formas = s => { const n = norm(s); return `${n} ${n.replace(/([a-z])\s+(\d)/g, '$1$2')} ${n.replace(/([a-z])(\d)/g, '$1 $2')}`; };
  // (y por sus opciones: colores en los cuatro idiomas y con sus otros nombres, capacidades…; opciones.js: palabrasOpciones)
  const parts = r => r._p || (r._p = [formas(`${r.t} ${r.v}`), palabrasOpciones(r), norm(KIND_WORDS[kindOfRow(r)] || ''), norm(IDIOMAS.map(l => T[l].z[r.sec]).join(' '))]);
  const score = r => { const [a, o, k, z] = parts(r); let s = 0; for (const w of words) { if (a.includes(w)) s += 3; else if (o.includes(w) || k.includes(w)) s += 2; else if (z.includes(w)) s += 1; else return -1; } return s; };
  // (a igual nota, lo que se puede pedir delante)
  return VENTA.map(r => [r, score(r)]).filter(x => x[1] >= 0).sort((x, y) => y[1] - x[1] || productoSinStock(x[0]) - productoSinStock(y[0])).map(x => x[0]);
}

/* ---------- pintar el panel ---------- */
function asShell(st) {
  const L = T[st.lang].as;
  st.assist.innerHTML = `
    <div class="ah"><span class="ahf">${faceSVG()}</span><div><p>J&amp;M</p><small>${L.sub}</small></div><button class="ax" type="button" aria-label="${L.close}">×</button></div>
    <label class="asr"><svg class="ic"><use href="#jm-search"/></svg><input type="search" autocomplete="off" placeholder="${L.ph}" value="${esc(st.as.q)}"></label>
    <div class="alog" aria-live="polite"></div>
    <div class="afoot"><button type="button" class="a-restart">${L.restart}</button><button type="button" class="a-human">${L.human}</button></div>`;
  st.assist.querySelector('input').addEventListener('input', e => { st.as.q = e.target.value; asRender(st, true); });
  asRender(st, false);
}
const bub = (who, html, fresh) => `<div class="msg ${who}${fresh ? ' in' : ''}">${html}</div>`;
// un solo WhatsApp a la vista (Sergio, 22 oct): si el paso ya trae el suyo (resultados, «no lo tenemos», «otra cosa»), el del pie se
// esconde; en los demás pasos manda el del pie
const conWa = (st, log) => st.assist.classList.toggle('con-wa', !!log.querySelector('.a-wa, .a-ask, .a-osend'));
function resCard(st, r) {
  return `<button type="button" class="a-rc" data-n="${r.n}"><span class="im">${r.i ? `<img src="${src(r.i, 120)}" alt="" loading="lazy">` : ''}</span><span><span class="b">${esc(r.v)}</span><span class="t">${esc(tituloDe(r, st.lang))}</span></span><span class="price${claseAgotado(r)}">${precioTarjeta(st, r)}</span></button>`;
}
function asRender(st, typing) {
  const t = T[st.lang], L = t.as, A = st.as, log = st.assist.querySelector('.alog'), h = hours();
  const out = [];
  if (A.q.trim()) {
    const res = searchRows(A.q);
    if (res.length) {
      out.push(`<p class="a-found">${L.found(res.length)}</p><div class="ares">${res.slice(0, 5).map(r => resCard(st, r)).join('')}</div>`);
      if (res.length > 5) out.push(`<button type="button" class="a-all a-sall">${L.seeRes(res.length)}</button>`);
    } else out.push(bub('f', esc(L.sNone(A.q.trim()))) + `<a class="btn a-ask" href="#"><svg><use href="#jm-wa"/></svg>${L.sAsk}</a>`);
    log.innerHTML = out.join('');
    conWa(st, log);
    log.scrollTop = 0;
    return;
  }
  const fresh = !typing;
  out.push(bub('f', `${L.greet(new Date().getHours())} ${L.hi}`, false));
  if (A.info) {
    out.push(bub('u', L.info[A.info]));
    const fest = festDe(h.fest, st.lang);
    let body = A.info === 'horari' ? (h.dayOff ? L.dayOff(fest) : `${L.horari(t.days[h.day], h.open, h.close)} ${h.isOpen ? L.isOpen : L.isClosed}${fest ? ' ' + L.fest(fest) : ''}${h.early ? ' ' + L.early : ''}`) : L[A.info];
    const more = `<button type="button" class="lnk a-more" data-sec="${({horari:'hours', on:'where', qui:'hist'})[A.info]}">${t.moreInfo}</button>`;
    body += A.info === 'on' ? `<span class="lnks"><button type="button" class="lnk a-map">${L.map}</button><button type="button" class="lnk a-inside">${L.inside}</button>${more}</span>` : `<span class="lnks">${more}</span>`;
    out.push(bub('f', body, fresh));
    out.push(A.bye ? bub('f', L.bye, fresh) : `<div class="afb${fresh ? ' in' : ''}"><button type="button" class="lnk a-yes">${L.yes}</button></div>`);
  } else if (!A.flow) {
    out.push(`<div class="tiles${fresh ? ' in' : ''}">${Object.keys(ROOT).map(k => `<button type="button" class="a-tile" data-root="${k}"><span class="ms" data-m="${ROOT[k].tile}"></span>${L.root[k]}</button>`).join('')}</div>`);
    out.push(`<div class="ainfo${fresh ? ' in' : ''}">${Object.keys(L.info).map(k => `<button type="button" class="lnk a-info" data-info="${k}">${L.info[k]}</button>`).join('')}${Object.keys(L.pages).map(k => `<button type="button" class="lnk a-page" data-page="${k}">${L.pages[k]}</button>`).join('')}</div>`);
  } else if (A.flow === 'otra') {
    out.push(bub('u', L.root.otra), bub('f', L.otra.q, fresh));
    out.push(`<div class="aotra${fresh ? ' in' : ''}"><input type="text" class="a-otxt" placeholder="${L.otra.ph}" value="${esc(A.otra)}"><a class="btn a-osend" href="#"><svg><use href="#jm-wa"/></svg>${L.otra.send}</a></div>`);
    out.push(`<button type="button" class="lnk a-back">${L.back}</button>`);
  } else {
    const {c, done, step} = runFlow(st);
    out.push(bub('u', L.root[A.flow]));
    done.forEach(d => out.push(bub('f', d.q), bub('u', esc(d.a))));
    if (step) {
      const opts = step.opts.map(o => ({o, n: o.f ? c.list.filter(o.f).length : c.list.length})).filter(x => x.n > 0 || x.o.keep || x.o.k === 'any');
      out.push(bub('f', step.q, fresh));
      out.push(`<div class="aopts${step.grid ? ' grid' : ''}${fresh ? ' in' : ''}">${opts.map(({o, n}) => `<button type="button" class="a-opt" data-k="${esc(o.k)}"><span>${esc(o.label)}</span>${o.k === 'any' || o.nocount || o.keep ? '' : `<small>${n}</small>`}</button>`).join('')}</div>`);
    } else {
      const list = ordered(c);
      if (c.adv) out.push(bub('f', c.adv, fresh));
      if (!list.length) out.push(bub('f', c.none || L.none, fresh));
      else {
        out.push(bub('f', L.res, fresh));
        out.push(`<div class="ares${fresh ? ' in' : ''}">${list.slice(0, 3).map(r => resCard(st, r)).join('')}</div>`);
      }
      out.push(`<div class="aact${fresh ? ' in' : ''}">${list.length ? `<button type="button" class="a-all">${L.seeAll(list.length)}</button>` : ''}<a class="btn a-wa" href="#"><svg><use href="#jm-wa"/></svg>${L.waAsk}</a></div>`);
    }
    out.push(`<button type="button" class="lnk a-back">${L.back}</button>`);
  }
  log.innerHTML = out.join('');
  conWa(st, log);
  log.querySelectorAll('.ms[data-m]').forEach(s => { const m = miniSVG(s.dataset.m); s.replaceWith(m); fitMini(m); lightScreens(m, true); });
  if (fresh) requestAnimationFrame(() => { log.scrollTop = log.scrollHeight; });
}
function asSummary(st) {
  const L = T[st.lang].as, A = st.as;
  if (A.info) return L.msgInfo[A.info];
  if (!A.flow || A.flow === 'otra') return T[st.lang].hi + T[st.lang].q0;
  const {c} = runFlow(st);
  return L.msg(c.what || lc1(L.root[A.flow]), c.parts);
}

/* ---------- gestos de la cara ---------- */
function faces(st) { return st.root.querySelectorAll('.fab .face, .assist .ahf .face'); }
function nod(st) {
  if (reduce) return;
  faces(st).forEach(f => f.querySelector('.head').animate([{transform:'translateY(0) rotate(0deg)'}, {transform:'translateY(26px) rotate(-4deg)'}, {transform:'translateY(0) rotate(0deg)'}], {duration:440, easing:'ease-in-out'}));
}
function wink(st) {
  if (reduce) return;
  faces(st).forEach(f => { f.classList.add('winking'); setTimeout(() => f.classList.remove('winking'), 480); });
}

/* ---------- abrir y cerrar desde el ojo ---------- */
function eyeCenter(st) { const e = st.fab.querySelector('.eyeR').getBoundingClientRect(), r = st.assist.getBoundingClientRect(); return [e.left + e.width / 2 - r.left, e.top + e.height / 2 - r.top]; }
function openAssist(st, focus) {
  closeHS(st); closeCart(st);
  // el aviso que hubiera (añadido a la bolsa…) se va: ahora manda el asistente, y en un móvil pequeño le tapaba la parte de arriba
  clearTimeout(st.tt); st.toast.classList.remove('show');
  // el botón redondo se esconde mientras el panel está abierto: el panel «es» el botón, desplegado (Sergio, 22 oct)
  st.root.classList.add('assist-open');
  if (!st.assist.classList.contains('open')) {
    st.assist.classList.add('open');
    const [x, y] = eyeCenter(st), R = Math.hypot(st.assist.offsetWidth, st.assist.offsetHeight) + 60;
    if (reduce) st.assist.style.clipPath = 'none';
    else st.assist.animate([{clipPath:`circle(0px at ${x}px ${y}px)`}, {clipPath:`circle(${R}px at ${x}px ${y}px)`}], {duration:460, easing:'cubic-bezier(.2,.7,.2,1)', fill:'forwards'});
  }
  if (focus) setTimeout(() => st.assist.querySelector('.asr input').focus({preventScroll:true}), 120);
}
function closeAssist(st) {
  if (!st.assist.classList.contains('open')) return;
  st.root.classList.remove('assist-open');
  const [x, y] = eyeCenter(st), R = Math.hypot(st.assist.offsetWidth, st.assist.offsetHeight) + 60;
  const done = () => { st.assist.classList.remove('open'); if (typeof faceBack === 'function' && st.hface) faceBack(st); };
  if (reduce) return done();
  st.assist.animate([{clipPath:`circle(${R}px at ${x}px ${y}px)`}, {clipPath:`circle(0px at ${x}px ${y}px)`}], {duration:280, easing:'cubic-bezier(.5,0,.8,.4)', fill:'forwards'}).onfinish = done;
}
function toggleAssist(st) { st.assist.classList.contains('open') ? closeAssist(st) : openAssist(st); }
function asReset(st) { Object.assign(st.as, {flow:null, answers:[], info:null, q:'', week:false, bye:false, otra:''}); const i = st.assist.querySelector('.asr input'); if (i) i.value = ''; }
function asInfo(st, k) { asReset(st); st.as.info = k; asRender(st); nod(st); }

function onAssistClick(st, e) {
  const t = e.target, L = T[st.lang].as, A = st.as;
  if (t.closest('a[href="#"]')) e.preventDefault();
  if (t.closest('.ax')) return closeAssist(st);
  const tile = t.closest('.a-tile');
  if (tile) { A.flow = tile.dataset.root; A.answers = []; A.info = null; asRender(st); return nod(st); }
  const inf = t.closest('.a-info');
  if (inf) return asInfo(st, inf.dataset.info);
  // el servicio técnico, Andorra Telecom y la segunda mano: se abre su página
  const pgb = t.closest('.a-page');
  if (pgb) { closeAssist(st); return pickZone(st, pgb.dataset.page); }
  const opt = t.closest('.a-opt');
  if (opt) { A.answers.push(opt.dataset.k); asRender(st); const r = runFlow(st); return r.step ? nod(st) : (nod(st), setTimeout(() => wink(st), 420)); }
  if (t.closest('.a-back')) { if (A.answers.length) A.answers.pop(); else { A.flow = null; A.info = null; } return asRender(st); }
  if (t.closest('.a-restart')) { asReset(st); return asRender(st); }
  if (t.closest('.a-human')) return abrirWa(st, asSummary(st));
  if (t.closest('.a-wa')) return abrirWa(st, asSummary(st));
  if (t.closest('.a-ask')) return abrirWa(st, L.getIt(A.q.trim()));
  const rc = t.closest('.a-rc');
  if (rc) return openFicha(st, +rc.dataset.n, A.q);
  if (t.closest('.a-sall')) { closeAssist(st); return openSearch(st, A.q.trim()); }
  if (t.closest('.a-all')) { const {c} = runFlow(st); closeAssist(st); return openFromAssist(st, ordered(c), [c.what, ...c.parts].filter(Boolean).join(' · ')); }
  const more = t.closest('.a-more');
  if (more) { closeAssist(st); return openAbout(st, more.dataset.sec); }
  if (t.closest('.a-map')) return abrirMapa(st);
  if (t.closest('.a-inside')) { closeAssist(st); return scrollToFloor(st, 'all'); }
  if (t.closest('.a-yes')) {
    A.bye = true; asRender(st); wink(st);
    clearTimeout(st.byeT);
    st.byeT = setTimeout(() => { closeAssist(st); setTimeout(() => { asReset(st); asRender(st, true); }, 320); }, 1400);
    return;
  }
  if (t.closest('.a-osend')) { const v = st.assist.querySelector('.a-otxt').value.trim(); A.otra = v; return abrirWa(st, L.getIt(v || '…')); }
}

/* ===== pages.js ===== */
/* ---------- las páginas: sección, marca, todas las marcas y búsqueda ---------- */
const per = st => st.isPhone ? 12 : 24;
function openSec(st, id, extra = {}) {
  if (!Object.prototype.hasOwnProperty.call(BY_SEC, id)) return;
  // (lo que viene del asistente, en su orden)
  st.page = {kind:'sec', id, base:BY_SEC[id], custom:extra.list || null, chip:extra.chip || '', brand:'', sec:'', sort:extra.list ? 'new' : 'top', shown:per(st)};
  renderPage(st, true);
}
function openFromAssist(st, list, chip) {
  const secs = [...new Set(list.map(r => r.sec))];
  if (secs.length === 1) return openSec(st, secs[0], {list, chip});
  st.page = {kind:'search', q:chip, base:list, brand:'', sec:'', sort:'new', shown:per(st)};
  renderPage(st, true);
}
function openBrand(st, b) { st.page = {kind:'brand', id:b, base:VENTA.filter(r => r.v === b), brand:'', sec:'', sort:'top', shown:per(st)}; renderPage(st, true); }
function openDir(st) { st.page = {kind:'dir'}; renderPage(st, true); }
function openSearch(st, q) { st.page = {kind:'search', q, base:searchRows(q), brand:'', sec:'', sort:'new', shown:per(st)}; renderPage(st, true); }
function openAbout(st, sec = 'hist') { st.page = {kind:'about', sec}; renderPage(st, true); }
// las zonas nuevas de la tienda: los escaparates de novedades, la pared de accesorios y el rincón del Mac
const LISTS = {
  nov: () => NEWS,
  acc: () => VENTA.filter(r => r.tg.has('acc') && floorOf(r.sec) === 'pb'),
  mac: () => VENTA.filter(r => r.v === 'Apple' && (r.sec === 'port' || r.sec === 'sobre'))
};
function openList(st, id) { if (!Object.prototype.hasOwnProperty.call(LISTS, id)) return; st.page = {kind:'list', id, base:LISTS[id](), brand:'', sec:'', sort:'new', shown:per(st)}; renderPage(st, true); }
// el servicio técnico: la puerta abierta del fondo de la −1
function openSat(st) { st.page = {kind:'sat'}; renderPage(st, true); }
function openTel(st) { st.page = {kind:'tel'}; renderPage(st, true); }
function openUsado(st) { st.page = {kind:'usado'}; renderPage(st, true); }
function closePage(st) { dejarFicha(st); st.page = null; st.root.classList.remove('coll-open'); placeFace(st); sincronizarUrl(st); }
// el menú del móvil (el de las tres rayas): las secciones de las dos tiendas, las marcas, quiénes somos y, en la web de verdad, las
// páginas legales de Shopify
function openMenu(st) { st.page = {kind:'menu'}; renderPage(st, true); }
function renderMenu(st, c) {
  const t = T[st.lang], z = id => `<a href="#" data-z="${id}"><span>${t.z[id]}</span></a>`;
  const legal = REAL ? `<div class="dg"><b>${t.legales}</b>${t.legal.map(([h, l]) => `<a href="${urlLegal(h)}"><span>${l}</span></a>`).join('')}</div>` : '';
  c.innerHTML = `<div class="dhead"><p class="h1">${t.menu}</p></div>
    <div class="cbar"><button class="back" type="button">${t.back}</button><span class="sp"></span></div>
    <div class="dir2 menu2">
      <div class="dg"><b>${t.fl.pb} · ${t.store.pb}</b>${PB_SECS.map(z).join('')}</div>
      <div class="dg"><b>${t.fl.b1} · ${t.store.b1}</b>${[...B1_SECS, 'sat', 'tel'].map(z).join('')}</div>
      <div class="dg"><b>${t.z.marcas}</b><a href="#" data-dir><span>${t.dirSub(BRANDS.length)}</span></a></div>
      <div class="dg"><b>J&amp;M</b>${t.links.map(([k, l]) => `<a href="#" data-about="${k}"><span>${l}</span></a>`).join('')}</div>
      ${legal}
    </div>`;
}
function onMenu(st, e) {
  const t = e.target, z = t.closest('.coll [data-z]'), ab = t.closest('.coll [data-about]');
  if (z) { e.preventDefault(); pickZone(st, z.dataset.z); return true; }
  if (ab) { e.preventDefault(); openAbout(st, ab.dataset.about); return true; }
  if (t.closest('.coll [data-dir]')) { e.preventDefault(); openDir(st); return true; }
  return false;
}

// «Destacados», el orden de entrada de las secciones y de las marcas (Sergio, 23 oct 2026: «pon en orden las marcas, que los productos
// no estén desorganizados, ahora te sale un Redmi de 150 euros al lado del iPhone… de marca de mayor a menor popularidad»): en una
// sección, las marcas de la más conocida a la menos en lo suyo (las que no están aquí, detrás, la que más tiene primero); en una
// marca, por secciones. Y dentro, por tipo (en Apple, los iPad y luego los relojes; el tipo con lo más caro, antes) y del más caro
// al más barato
const MARCAS_SECCION = {
  mobils: ['Apple', 'Samsung', 'Xiaomi', 'Google'],
  tabrel: ['Apple', 'Samsung', 'Xiaomi', 'Lenovo', 'TCL', 'ZTE', 'Mibro', 'SaveFamily'],
  port: ['Apple', 'HP', 'Lenovo', 'Dell', 'ASUS', 'Acer', 'MSI'],
  sobre: ['Apple', 'Samsung', 'LG', 'Dell', 'Lenovo', 'HP', 'iiyama'],
  comp: ['Apple', 'Microsoft', 'ASUS', 'PowerColor'],
  tv: ['Samsung', 'LG', 'Sony', 'TCL', 'Hisense', 'Philips', 'Xiaomi', 'Haier', 'Metz', 'JVC', 'Engel', 'COOL', "Vogel's"],
  so: ['Apple', 'Samsung', 'Sony', 'JBL', 'Bose', 'Sennheiser'],
  consoles: ['Sony', 'Nintendo', 'Microsoft'],
  drons: ['DJI', 'GoPro', 'Insta360', 'Potensic'],
  emmag: ['Samsung', 'SanDisk', 'Western Digital', 'Kingston', 'Crucial', 'ADATA', 'Intenso'],
  impr: ['HP', 'Epson', 'Canon', 'IRIS'],
  llar: ['Apple', 'Philips', 'DJI', 'iRobot', 'Garmin', 'Braun', 'TomTom', 'Kodak', 'Bushnell', 'TFA Dostmann']
};
// (los plegables, con los demás móviles de su marca)
const TIPO_IGUAL = {fold: 'phone', flip: 'phone'};
function destacados(l, porSeccion) {
  const tipo = r => TIPO_IGUAL[claseDe(r)] || claseDe(r), cuantos = {}, tope = {};
  l.forEach(r => { cuantos[r.v] = (cuantos[r.v] || 0) + 1; const k = r.v + '|' + tipo(r); tope[k] = Math.max(tope[k] || 0, r.p); });
  const puesto = (lista, x) => { const i = lista.indexOf(x); return i < 0 ? lista.length : i; };
  const marca = (a, b) => puesto(MARCAS_SECCION[a.sec] || [], a.v) - puesto(MARCAS_SECCION[b.sec] || [], b.v) || cuantos[b.v] - cuantos[a.v] || a.v.localeCompare(b.v, 'es');
  const primero = porSeccion ? (a, b) => SECS.indexOf(a.sec) - SECS.indexOf(b.sec) : marca;
  return l.slice().sort((a, b) => primero(a, b) || tope[b.v + '|' + tipo(b)] - tope[a.v + '|' + tipo(a)] || tipo(a).localeCompare(tipo(b)) || b.p - a.p || a.n - b.n);
}
function pageList(pg) {
  let l = (pg.custom || pg.base).filter(r => (!pg.brand || r.v === pg.brand) && (!pg.sec || r.sec === pg.sec));
  if (pg.sort === 'top') l = destacados(l, pg.kind === 'brand');
  if (pg.sort === 'asc') l = l.slice().sort((a, b) => a.p - b.p);
  if (pg.sort === 'desc') l = l.slice().sort((a, b) => b.p - a.p);
  return conStockDelante(l);
}
// lo que se puede pedir, delante; lo sin stock, al final, en el mismo orden (Sergio, 22 oct 2026: «haz que las cosas sin stock estén
// más abajo, que predominen los productos con stock»)
const conStockDelante = l => [...l.filter(r => !productoSinStock(r)), ...l.filter(r => productoSinStock(r))];
function card(st, r) {
  const foto = fotoDe(st, r, st.isPhone ? 260 : 360);
  return `<a class="gi" href="${hrefFicha(r)}" data-n="${r.n}"><span class="im">${foto ? `<img src="${foto}" alt="${esc(tituloDe(r, st.lang))}" loading="lazy">` : ''}${addBtn(T[st.lang], r)}</span><span class="b">${esc(r.v)}</span><span class="t">${esc(tituloDe(r, st.lang))}</span><span class="price${claseAgotado(r)}">${precioTarjeta(st, r)}</span>${st.isPhone ? '' : `<span class="q">${T[st.lang].ask}</span>`}</a>`;
}
function renderPage(st, fresh) {
  const t = T[st.lang], pg = st.page, c = st.root.querySelector('.coll');
  if (!pg) return;
  // (una página nueva: su dirección; en el simulador no hace nada)
  if (fresh) sincronizarUrl(st);
  dejarFicha(st);
  if (pg.kind === 'ficha') { renderFicha(st, c); st.root.classList.add('coll-open'); placeFace(st); return; }
  const top = (pg.kind === 'sec' && !pg.custom) || pg.kind === 'brand' ? `<option value="top"${pg.sort === 'top' ? ' selected' : ''}>${t.sTop}</option>` : '';
  const sortSel = `<label>${t.sort}<select class="f-sort">${top}<option value="new"${pg.sort === 'new' ? ' selected' : ''}>${t.sNew}</option><option value="asc"${pg.sort === 'asc' ? ' selected' : ''}>${t.sAsc}</option><option value="desc"${pg.sort === 'desc' ? ' selected' : ''}>${t.sDesc}</option></select></label>`;
  const back = `<button class="back" type="button">${t.back}</button><span class="sp"></span>`;
  if (pg.kind === 'about') { renderAbout(st, c, pg); st.root.classList.add('coll-open'); placeFace(st); return; }
  if (pg.kind === 'sat') { renderSat(st, c); st.root.classList.add('coll-open'); placeFace(st); return; }
  if (pg.kind === 'tel') { renderTel(st, c); st.root.classList.add('coll-open'); placeFace(st); return; }
  if (pg.kind === 'usado') { renderUsado(st, c); st.root.classList.add('coll-open'); placeFace(st); return; }
  if (pg.kind === 'menu') { renderMenu(st, c); st.root.classList.add('coll-open'); placeFace(st); return; }
  if (pg.kind === 'dir') {
    const groups = {};
    BRANDS.forEach(([b, n]) => { const k = norm(b)[0].toUpperCase(); (groups[k] = groups[k] || []).push([b, n]); });
    c.innerHTML = `<div class="dhead"><p class="crumb">${t.shop} · ${t.z.marcas}</p><h1 class="h1">${t.z.marcas}</h1><p class="sm">${t.dirSub(BRANDS.length)}</p></div>
      <div class="cbar">${back}</div>
      <div class="dir2">${Object.keys(groups).sort().map(k => `<div class="dg"><b>${k}</b>${groups[k].map(([b, n]) => `<a href="#" data-b="${esc(b)}"><span>${esc(b)}</span><small>${n}</small></a>`).join('')}</div>`).join('')}</div>`;
  } else {
    const base = pg.custom || pg.base, isSec = pg.kind === 'sec';
    const secs = [...new Set(base.map(r => r.sec))].sort((a, b) => SECS.indexOf(a) - SECS.indexOf(b));
    const isList = pg.kind === 'list';
    const crumb = isSec ? `${t.shop} · ${t.fl[floorOf(pg.id)]} · ${t.z[pg.id]}` : isList ? `${t.shop} · ${t.fl[ZONES[pg.id].f]} · ${t.z[pg.id]}` : pg.kind === 'brand' ? `${t.shop} · ${t.z.marcas}` : t.shop;
    const title = isSec && pg.titulo ? esc(pg.titulo) : isSec || isList ? t.z[pg.id] : pg.kind === 'brand' ? esc(pg.id) : esc(t.sres(pg.q));
    const where = pg.kind === 'brand' ? `<p class="sm wh">${t.whereB}: ${secs.map(s => `<a href="#" data-z="${s}" data-bf="${esc(pg.id)}">${t.z[s]}</a>`).join(' · ')}</p>` : '';
    const filter = isSec
      ? `<label>${t.brand}<select class="f-brand"><option value="">${t.all}</option>${[...new Set(base.map(r => r.v))].sort((a, b) => a.localeCompare(b, 'es', {sensitivity:'base'})).map(b => `<option${b === pg.brand ? ' selected' : ''}>${esc(b)}</option>`).join('')}</select></label>`
      : `<label>${t.secL}<select class="f-sec"><option value="">${t.all}</option>${secs.map(s => `<option value="${s}"${s === pg.sec ? ' selected' : ''}>${t.z[s]}</option>`).join('')}</select></label>`;
    // en las secciones donde tiene sentido, el camino a la segunda mano
    const usd = isSec && ['mobils', 'tabrel', 'port'].includes(pg.id) ? `<p class="sm usd"><a href="#" data-usado>${t.usado.link}</a></p>` : '';
    c.innerHTML = `
      <div class="cbanner${isSec ? '' : ' tall'}"><div class="cb-art"></div><div class="cb-txt"><p class="crumb">${crumb}</p><h1 class="h1">${title}</h1><p class="sm cnt"></p>${where}${usd}</div></div>
      <div class="cbar">${back}${base.length ? filter + sortSel : ''}</div>
      ${pg.chip ? `<div class="chipr"><span class="chip">${t.chip}: ${esc(pg.chip)}<button type="button" class="chipx" aria-label="×">×</button></span></div>` : ''}
      <div class="cgrid"></div><div class="cfoot"><button class="cmore" type="button"></button></div><div class="cseo"></div>`;
    bannerArt(st, c.querySelector('.cb-art'), isSec && !pg.custom && SEC_EXH[pg.id] ? SEC_EXH[pg.id] : exhibitItems(base), marcaDe(pg, base), claveExpo(pg));
    renderGrid(st);
  }
  st.root.classList.add('coll-open');
  if (fresh) c.scrollTop = 0;
  placeFace(st);
}
function renderGrid(st) {
  const t = T[st.lang], pg = st.page, c = st.root.querySelector('.coll'), list = pageList(pg);
  c.querySelector('.cnt').textContent = t.cnt(list.length, pg.kind === 'sec' ? pg.brand : '');
  c.querySelector('.cgrid').innerHTML = list.length ? list.slice(0, pg.shown).map(r => card(st, r)).join('')
    : `<div class="cnone"><p>${t.snone}</p><a class="btn wa" href="#"><svg><use href="#jm-wa"/></svg>${t.wa}</a></div>`;
  const more = list.length - pg.shown, btn = c.querySelector('.cmore');
  btn.style.display = more > 0 ? '' : 'none';
  btn.textContent = t.more(more);
  const seo = c.querySelector('.cseo');
  if (seo) { const abierto = !!seo.querySelector('details[open]'); seo.innerHTML = textoSeo(st, pg, list); if (abierto && seo.firstChild) seo.firstChild.open = true; }
}
// el texto plegado al pie de la sección (textos-seo.js): la búsqueda en la línea que se ve y, dentro, qué hay y desde cuánto, con lo que
// la sección tiene a la venta hoy. Solo en las secciones enteras y en «iPhone» (Móviles con la marca Apple); con otra marca, sin texto
function textoSeo(st, pg, list) {
  if (pg.kind !== 'sec' || pg.custom || typeof SEO_TXT === 'undefined') return '';
  const clave = pg.id === 'mobils' && pg.brand === 'Apple' ? 'iphone' : pg.brand ? '' : pg.id;
  const x = clave && (SEO_TXT[st.lang] || SEO_TXT.es)[clave];
  const venta = list.filter(r => r.p > 0 && !productoSinStock(r));
  if (!x || !venta.length) return '';
  const desde = fmt(Math.min(...venta.map(r => r.p)));
  const pon = s => esc(s).replaceAll('{n}', String(venta.length)).replaceAll('{desde}', desde);
  return `<details class="ctexto"><summary>${pon(x.s)}</summary><h2>${pon(x.h)}</h2>${x.p.map(p => `<p>${pon(p)}</p>`).join('')}${(x.qa || []).map(([q, a]) => `<h3>${pon(q)}</h3><p>${pon(a)}</p>`).join('')}</details>`;
}
function fitVB(bb, pad, cw, ch) {
  const a = cw / ch, [x0, y0, x1, y1] = bb;
  let w = (x1 - x0) * (1 + pad), h = (y1 - y0) * (1 + pad);
  if (w / h > a) h = w / a; else w = h * a;
  return [(x0 + x1) / 2 - w / 2, (y0 + y1) / 2 - h / 2, w, h];
}
const unionBB = list => [Math.min(...list.map(b => b[0])), Math.min(...list.map(b => b[1])), Math.max(...list.map(b => b[2])), Math.max(...list.map(b => b[3]))];
// la marca de una página: la suya (una página de marca) o la de sus productos si son todos de una (la lista de los Mac...). Con ella,
// los productos del expositor llevan su forma y su logo (Sergio, 19 oct: «en Bose has puesto un altavoz JBL»)
function marcaDe(pg, base) {
  if (pg.kind === 'brand') return pg.id;
  const vs = new Set(base.map(r => r.v));
  return vs.size === 1 ? [...vs][0] : null;
}
// la clave de la imagen del expositor de una página: las secciones, las marcas y las listas de la tienda (las búsquedas, no)
const slug = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
// la foto del servicio técnico: en el simulador va dentro de los datos; en el tema, aparte (tema/construir.cjs: 'aparte'), para que la
// portada no la descargue si nadie abre esa página
const fotoSatDe = () => TIENDA.fotoSat === 'aparte' ? recurso('fotos', 'servicio-tecnico') : TIENDA.fotoSat;
// (Sergio, 21 oct: «los 3D tardan un poco en cargar») la imagen de una página se pide antes de abrirla: en cuanto el cursor o el dedo
// pasa por su sección, su lista o su marca. Y en el ordenador, con la tienda ya montada, las de todas las secciones, sin prisa
const precargados = new Set();
function precargar(url) {
  if (!url || precargados.has(url)) return;
  precargados.add(url);
  const im = new Image(); im.decoding = 'async'; im.src = url;
}
const tiene = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
const claveDeZona = id => tiene(SEC_EXH, id) ? 'sec-' + id : tiene(LISTS, id) ? 'lista-' + id : id === 'apple' ? 'marca-apple' : null;
const urlExpo = clave => clave && EXPOS[clave] ? recurso('expositores', clave) : null;
function precargarDesde(e) {
  const z = e.target.closest && e.target.closest('[data-z], [data-b]');
  if (!z) return;
  if (z.dataset.z === 'sat') return precargar(TIENDA.fotoSat === 'aparte' ? fotoSatDe() : null);
  precargar(urlExpo(z.dataset.z ? claveDeZona(z.dataset.z) : 'marca-' + slug(z.dataset.b)));
}
function precargarSecciones() {
  const urls = [...SECS.map(id => urlExpo(claveDeZona(id))), ...['nov', 'acc', 'mac'].map(id => urlExpo('lista-' + id))].filter(Boolean);
  const siguiente = () => { const u = urls.shift(); if (!u) return; precargar(u); (window.requestIdleCallback || (f => setTimeout(f, 300)))(siguiente, {timeout: 2000}); };
  siguiente();
}
function claveExpo(pg) {
  if (pg.custom) return null;
  if (pg.kind === 'sec') return SEC_EXH[pg.id] ? 'sec-' + pg.id : null;
  if (pg.kind === 'brand') return 'marca-' + slug(pg.id);
  if (pg.kind === 'list') return 'lista-' + pg.id;
  return null;
}
// el expositor de una página. Si tiene su imagen (sacada de antemano con los productos en 3D: render-expositores.cjs), esa y nada más;
// si no (una búsqueda), se pinta en 3D y aparece cuando está. El dibujo de antes, solo si no se puede (sin WebGL o tarda demasiado).
// Antes salía primero el dibujo y encima el 3D, y se veían los dos (Sergio, 19 oct: «se solapan y queda raro»)
function bannerArt(st, art, items, marca = null, clave = null) {
  soltarRobo(art);
  art.innerHTML = '';
  art.classList.remove('lista');
  const its = items.map(([k, v = 1, sc = 1]) => [k, v, +(escalaExpo(k, v) * sc).toFixed(3), marca]);
  art.dataset.expo = JSON.stringify(its);
  art.dataset.clave = clave || '';
  if (clave && EXPOS[clave]) {
    const im = new Image();
    im.className = 'exh-img'; im.alt = ''; im.decoding = 'async';
    im.onload = () => requestAnimationFrame(() => art.classList.add('lista'));
    im.onerror = () => { im.remove(); dibujoExpo(art, items); };
    im.src = recurso('expositores', clave);
    art.appendChild(im);
    capaRobo(art, () => recurso('expositores/robo', clave));
    return;
  }
  expo3D(art, its, () => dibujoExpo(art, items));
}
// el dibujo del expositor (el de antes, en SVG)
function dibujoExpo(art, items) {
  const svg = exhibitSVG(items);
  svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  art.appendChild(svg);
  lightScreens(svg, true);
  fitSVG(svg, 10);
  requestAnimationFrame(() => art.classList.add('lista'));
}
// el expositor en 3D (estudio.js, en el paquete de la tienda), del tamaño del recuadro en puntos del aparato. Si no se puede (sin el
// paquete o sin WebGL) o tarda más de 2,5 s, el dibujo (siNo)
/* ---------- la marca para quien se lleva una imagen ---------- */
// La web enseña las imágenes limpias; encima de cada una hay otra invisible, con la marca de J&M, y esa es la que se lleva quien la
// arrastra, la copia o la guarda (también con el dedo, en el móvil). Sergio, 19 oct: «no quiero que salga, me parece cutre; que en la
// web no tenga la marca de agua, tendría que tenerla el que la roba». Quien hace una captura de pantalla se la lleva limpia: eso no lo
// para nada que no se vea.
const VACIA = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
const ROBO = ['© 2026 J&M Electronics Andorra · Contenido exclusivo de J&M · Contingut exclusiu de J&M',
  '¿Quieres algo parecido? Habla con J&M o con SerVe Digital · Vols alguna cosa semblant? Parla amb J&M o amb SerVe Digital'];
// el logo de J&M en un lienzo 2D, de ancho w, con la elipse y las letras del símbolo #jm-logo de la página
function pintaLogoJm(c, x, y, w) {
  const s = document.getElementById('jm-logo');
  if (!s) return 0;
  const vb = s.viewBox.baseVal, k = w / vb.width;
  c.save(); c.translate(x, y); c.scale(k, k); c.translate(-vb.x, -vb.y);
  for (const el of s.children) {
    c.fillStyle = el.getAttribute('fill') || '#1d2a5c';
    if (el.tagName === 'ellipse') { c.beginPath(); c.ellipse(+el.getAttribute('cx'), +el.getAttribute('cy'), +el.getAttribute('rx'), +el.getAttribute('ry'), 0, 0, Math.PI * 2); c.fill(); }
    else if (el.tagName === 'path') {
      const m = el.transform.baseVal.consolidate();
      c.save(); if (m) { const t = m.matrix; c.transform(t.a, t.b, t.c, t.d, t.e, t.f); }
      c.fill(new Path2D(el.getAttribute('d')), el.getAttribute('fill-rule') || 'nonzero'); c.restore();
    }
  }
  c.restore();
  return w * vb.height / vb.width;
}
// la imagen con la marca: el logo grande y medio transparente en medio, y abajo una franja con de quién es y con quién hablar
function marcaRobo(fuente) {
  const w = fuente.naturalWidth || fuente.width, h = fuente.naturalHeight || fuente.height, cv = document.createElement('canvas');
  cv.width = w; cv.height = h;
  const c = cv.getContext('2d');
  c.drawImage(fuente, 0, 0, w, h);
  const asp = 282 / 955, grande = Math.min(w * 0.42, h * 0.5 / asp);
  c.globalAlpha = 0.3; pintaLogoJm(c, (w - grande) / 2, (h * 0.85 - grande * asp) / 2, grande); c.globalAlpha = 1;
  const fh = Math.max(46, Math.round(h * 0.15)), y = h - fh, aire = fh * 0.3;
  c.fillStyle = 'rgba(255,255,255,.92)'; c.fillRect(0, y, w, fh);
  const lw = fh * 0.5 / asp;
  pintaLogoJm(c, aire, y + fh * 0.25, lw);
  // las dos líneas, del tamaño que quepa
  const x = aire * 2 + lw, libre = w - x - aire;
  ROBO.forEach((txt, i) => {
    let tam = fh * (i ? 0.2 : 0.24);
    const fuenteDe = t => `${i ? 500 : 700} ${t}px "Helvetica Neue", Helvetica, Arial, sans-serif`;
    c.font = fuenteDe(tam);
    const ancho = c.measureText(txt).width;
    if (ancho > libre) { tam *= libre / ancho; c.font = fuenteDe(tam); }
    c.fillStyle = i ? '#3d4250' : '#1d2a5c'; c.textBaseline = 'middle';
    c.fillText(txt, x, y + fh * (i ? 0.68 : 0.36));
  });
  return cv;
}
// la imagen con la marca en un blob (webp; donde no se puede, png: Safari)
const aBlob = cv => new Promise(ok => cv.toBlob(b => ok(b ? URL.createObjectURL(b) : null), 'image/webp', 0.72));
const urlsRobo = new WeakMap();
const soltarRobo = caja => { const u = urlsRobo.get(caja); if (u) { URL.revokeObjectURL(u); urlsRobo.delete(caja); } };
// la capa invisible: su imagen se pide la primera vez que el ratón o el dedo se acercan (quien solo mira no la descarga); dame()
// devuelve la dirección de la imagen con la marca (o una promesa de ella)
function capaRobo(caja, dame) {
  soltarRobo(caja);
  const im = new Image();
  im.className = 'exh-robo'; im.alt = ''; im.src = VACIA;
  let pedida = false;
  const pedir = () => {
    if (pedida) return;
    pedida = true;
    Promise.resolve(dame()).then(u => { if (!u || !im.isConnected) return; if (u.startsWith('blob:')) urlsRobo.set(caja, u); im.src = u; }).catch(() => {});
  };
  for (const ev of ['pointerenter', 'touchstart', 'focusin', 'contextmenu']) caja.addEventListener(ev, pedir, {passive: true});
  // al arrastrarla, que se vea lo que se lleva (la capa es invisible)
  im.addEventListener('dragstart', e => {
    if (!e.dataTransfer || !im.naturalWidth || im.src === VACIA) return;
    const f = new Image(); f.src = im.src; f.style.cssText = `position:fixed;left:-10000px;top:0;width:${Math.min(320, im.naturalWidth)}px`;
    document.body.appendChild(f); e.dataTransfer.setDragImage(f, 24, 24); setTimeout(() => f.remove(), 0);
  });
  caja.appendChild(im);
}
function expo3D(art, its, siNo) {
  const mod = modulo3D(), r = art.getBoundingClientRect(), clave = art.dataset.expo;
  if (!mod || !r.width || !r.height) { siNo(); return; }
  const dpr = Math.min(window.devicePixelRatio || 1, 2), w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
  let hecho = false;
  const vale = () => !hecho && art.isConnected && art.dataset.expo === clave;
  const dibujo = () => { if (vale()) { hecho = true; siNo(); } };
  const plazo = setTimeout(dibujo, 2500);
  mod.then(m => m.expositor(its, w, h)).then(cv => {
    if (!vale()) return;
    hecho = true; clearTimeout(plazo);
    cv.className = 'exh3d';
    art.appendChild(cv);
    capaRobo(art, () => aBlob(marcaRobo(cv)));
    requestAnimationFrame(() => art.classList.add('lista'));
  }).catch(e => { console.warn('el expositor en 3D no se ha podido pintar', e); clearTimeout(plazo); dibujo(); });
}
function onPageEvent(st, e) {
  const t = e.target, pg = st.page;
  if (!pg) return false;
  if (pg.kind === 'ficha' && onFicha(st, e)) return true;
  if (pg.kind === 'menu' && onMenu(st, e)) return true;
  if (t.closest('.coll .back')) { closePage(st); return true; }
  const ab = t.closest('.coll [data-about]');
  if (ab) { e.preventDefault(); const s = c => c.querySelector(`.ab-sec[data-sec="${ab.dataset.about}"]`), box = st.root.querySelector('.coll'), sec = s(box); if (sec) box.scrollTo({top: sec.offsetTop - box.querySelector('.cbar').offsetHeight - 8, behavior: reduce ? 'auto' : 'smooth'}); return true; }
  if (t.closest('.coll .ab-route')) { e.preventDefault(); abrirMapa(st); return true; }
  if (t.closest('.coll .cmore')) { pg.shown += per(st); renderGrid(st); return true; }
  if (t.closest('.coll .chipx')) { pg.custom = null; pg.chip = ''; if (pg.sort === 'new') pg.sort = 'top'; renderPage(st); return true; }
  const bf = t.closest('.coll [data-bf]');
  if (bf) { e.preventDefault(); openSec(st, bf.dataset.z); st.page.brand = bf.dataset.bf; renderPage(st); return true; }
  return false;
}
function onPageChange(st, e) {
  const pg = st.page, t = e.target;
  if (!pg) return;
  if (t.matches('.f-brand')) { pg.brand = t.value; if (pg.titulo) { pg.titulo = ''; pg.shown = per(st); return renderPage(st); } }
  else if (t.matches('.f-sec')) pg.sec = t.value;
  else if (t.matches('.f-sort')) pg.sort = t.value;
  else return;
  pg.shown = per(st);
  renderGrid(st);
}

/* ---------- quiénes somos: la historia, dónde estamos, el horario y cómo escribirnos ---------- */
function renderAbout(st, c, pg) {
  const t = T[st.lang], A = t.about, h = hours();
  const fest = festDe(h.fest, st.lang);
  const today = h.dayOff ? t.as.dayOff(fest) : `${t.as.horari(t.days[h.day], h.open, h.close)} ${h.isOpen ? t.as.isOpen : t.as.isClosed}${fest ? ' ' + t.as.fest(fest) : ''}`;
  const spec = upcomingSpecial(new Date(), 5).map(([d, i]) => `<li><span>${A.fecha(t.days[d.getDay()], d.getDate(), A.months[d.getMonth()])}</span><b>${i.closed ? A.specClosed : A.specUntil(i.close)}</b></li>`).join('');
  c.innerHTML = `
    <div class="ab-head"><p class="crumb">${A.crumb}</p><p class="h1">${A.title}</p><p class="ab-lead">${A.lead}</p></div>
    <div class="cbar"><button class="back" type="button">${t.back}</button><span class="sp"></span><span class="ab-nav">${t.links.map(([k, l]) => `<a href="#" data-about="${k}">${l}</a>`).join('')}</span></div>
    <div class="about">
      <section class="ab-sec" data-sec="hist"><h2>${A.hist}</h2><p>${A.histP}</p>
        <ol class="ab-line">${A.line.map(([y, x]) => `<li><b>${y}</b><span>${x}</span></li>`).join('')}</ol></section>
      <section class="ab-sec"><h2>${A.purpose}</h2><p>${A.purposeP}</p></section>
      <section class="ab-sec"><h2>${A.diff}</h2><div class="ab-grid">${A.diffL.map(([a, b]) => `<div><b>${a}</b><p>${b}</p></div>`).join('')}</div><p class="ab-nums">${A.nums}</p></section>
      <section class="ab-sec" data-sec="where"><h2>${A.where}</h2><p class="sm">${A.mall}</p>
        <div class="ab-two"><div class="ab-stores">${A.stores.map(([n, f, tel, mail], i) => `<div class="ab-store"><p class="ab-fl">${t.fl[i ? 'b1' : 'pb']}</p><b>${n}</b><span>${f}</span><span>${tel} · ${mail}</span><a href="#" class="ab-route">${A.route}</a></div>`).join('')}</div><div class="ab-map"></div></div></section>
      <section class="ab-sec" data-sec="hours"><h2>${A.hours}</h2><p class="ab-today">${today}</p>
        <ul class="ab-week">${A.week.map(([d, x]) => `<li><span>${d}</span><b>${x}</b></li>`).join('')}</ul><p class="sm">${A.closedP}</p>
        ${spec ? `<p class="ab-st">${A.special}</p><ul class="ab-week ab-spec">${spec}</ul>` : ''}</section>
      <section class="ab-sec"><h2>${A.contact}</h2><p>${A.contactP}</p><a class="btn wa" href="#"><svg><use href="#jm-wa"/></svg>${t.wa}</a></section>
      <section class="ab-sec ab-end"><p>${A.thanks}</p><p class="sm">${A.sign}</p></section>
    </div>`;
  // el edificio con las dos plantas, ya montado
  const clone = st.svg.cloneNode(true);
  clone.querySelectorAll('.zg').forEach(g => { g.removeAttribute('transform'); g.setAttribute('opacity', 1); });
  clone.querySelectorAll('.floor > g, .l-links, .pw, .ow').forEach(g => { g.setAttribute('opacity', 1); g.removeAttribute('transform'); });
  clone.querySelectorAll('.l-drops ellipse').forEach(e => e.setAttribute('opacity', 0));
  clone.classList.remove('hov');
  const vbEd = fitVB(unionBB([floorBB('pb'), floorBB('b1')]), 0.04, 1, 1.2);
  clone.setAttribute('viewBox', vbEd.map(v => v.toFixed(1)).join(' '));
  lightScreens(clone, true);
  const mapa = c.querySelector('.ab-map');
  mapa.appendChild(clone);
  // con la tienda en 3D, su foto debajo del dibujo (que ya solo lleva las rayas entre las plantas)
  if (st.t3d) {
    const r = clone.getBoundingClientRect();
    if (r.width > 10) { const img = new Image(); img.className = 'ab-3d'; img.alt = ''; img.src = st.t3d.foto(vbEd, Math.round(r.width), Math.round(r.height)); mapa.insertBefore(img, clone); }
  }
  const target = c.querySelector(`.ab-sec[data-sec="${pg.sec}"]`);
  c.scrollTop = 0;
  if (target && pg.sec !== 'hist') requestAnimationFrame(() => { c.scrollTop = target.offsetTop - c.querySelector('.cbar').offsetHeight - 8; });
}

/* ---------- Andorra Telecom y la segunda mano ---------- */
// Andorra Telecom (Sergio, 19 oct: «el logo sí que se reconoce»): su logo, las dos tarifas de prepago (las de su web, octubre de 2026)
// y dónde hacerla: en la tienda de la −1, en persona y con el DNI (por WhatsApp no se puede). Se llega por su tarjeta de la −1 en la
// portada, por la cabecera de Informática y por el asistente
function renderTel(st, c) {
  const t = T[st.lang], S = t.tel, A = t.about, [nombre, planta, tel, mail] = A.stores[1];
  c.innerHTML = `
    <div class="ab-head"><p class="crumb">${S.crumb}</p><p class="h1">${S.title}</p><p class="ab-lead">${S.lead}</p></div>
    <div class="cbar"><button class="back" type="button">${t.back}</button><span class="sp"></span></div>
    <div class="about">
      ${ICONOS3D.tel ? `<p class="tel-logo"><img src="${ICONOS3D.tel}" alt="Andorra Telecom"></p>` : ''}
      <section class="ab-sec"><h2>${S.what}</h2><div class="ab-grid">${S.tarifas.map(([n, p, d]) => `<div><b>${n}</b><p class="tel-p">${p}</p><p>${d}</p></div>`).join('')}</div><p class="sm ab-nota">${S.nota}</p></section>
      <section class="ab-sec"><h2>${S.where}</h2><p class="sm">${A.mall}</p>
        <div class="ab-store"><p class="ab-fl">${t.fl.b1}</p><b>${nombre}</b><span>${planta}</span><span>${tel} · ${mail}</span><a href="#" class="ab-route">${A.route}</a></div></section>
    </div>`;
  c.scrollTop = 0;
}
// la segunda mano, con el camino abierto (Sergio, 19 oct: «aún estamos hablando con el proveedor»): por encargo y por WhatsApp. Se
// llega por el asistente y por la línea de las secciones de móviles, tablets y portátiles
function renderUsado(st, c) {
  const t = T[st.lang], S = t.usado;
  c.innerHTML = `
    <div class="ab-head"><p class="crumb">${S.crumb}</p><p class="h1">${S.title}</p><p class="ab-lead">${S.lead}</p></div>
    <div class="cbar cbar-wa"><button class="back" type="button">${t.back}</button><span class="sp"></span><a class="btn wa usado-wa" href="#"><svg><use href="#jm-wa"/></svg>${S.wa}</a></div>
    <div class="about">
      <section class="ab-sec"><h2>${S.how}</h2><ol class="ab-line">${S.howL.map(([n, x]) => `<li><b>${n}</b><span>${x}</span></li>`).join('')}</ol></section>
    </div>`;
  c.scrollTop = 0;
}

/* ---------- el servicio técnico: qué reparamos, cómo pedir presupuesto y dónde estamos ---------- */
function renderSat(st, c) {
  const t = T[st.lang], S = t.sat, A = t.about, [nombre, planta, tel, mail] = A.stores[1];
  // la foto del técnico trabajando, de frente (si no está, la que se ve por la puerta del taller)
  const img = st.svg.querySelector('[data-f="b1"] image'), foto = fotoSatDe() || (img && img.getAttribute('href'));
  c.innerHTML = `
    <div class="ab-head"><p class="crumb">${S.crumb}</p><p class="h1">${S.title}</p><p class="ab-lead">${S.lead}</p></div>
    <div class="cbar cbar-wa"><button class="back" type="button">${t.back}</button><span class="sp"></span><a class="btn wa sat-wa" href="#"><svg><use href="#jm-wa"/></svg>${S.wa}</a></div>
    <div class="about">
      ${foto ? `<figure class="sat-fig"><img src="${foto}" alt="${esc(S.img)}"></figure>` : ''}
      <section class="ab-sec"><h2>${S.what}</h2><div class="ab-grid">${S.whatL.map(([a, b]) => `<div><b>${a}</b><p>${b}</p></div>`).join('')}</div></section>
      <section class="ab-sec"><h2>${S.pb}</h2><p class="ab-p">${S.pbT}</p></section>
      <section class="ab-sec"><h2>${S.how}</h2><ol class="ab-line">${S.howL.map(([n, x]) => `<li><b>${n}</b><span>${x}</span></li>`).join('')}</ol></section>
      <section class="ab-sec"><h2>${S.where}</h2><p class="sm">${A.mall}</p>
        <div class="ab-store"><p class="ab-fl">${t.fl.b1}</p><b>${nombre}</b><span>${planta}</span><span>${tel} · ${mail}</span><a href="#" class="ab-route">${A.route}</a></div></section>
    </div>`;
  const fig = c.querySelector('.sat-fig'), foto1 = fig && fig.querySelector('img');
  if (foto1) capaRobo(fig, () => (foto1.complete ? Promise.resolve() : foto1.decode()).then(() => aBlob(marcaRobo(foto1))));
  c.scrollTop = 0;
}


/* ===== opciones.js ===== */
/* ---------- las opciones de cada producto: GB, colores, configuración, modelo… ----------
   (Sergio, 21 oct: «todas las fichas de teléfonos y de los demás dispositivos no tienen ni GB ni colores ni nada, no hay ninguna
   opción. Añade todo lo que falta»). Las variantes de Shopify (tema/exportar_variantes.py → shop2/variantes-vivo.json), por el
   handle de cada producto (OPCIONES, en scene2.js con los demás datos): sus opciones con sus valores y, de cada variante, qué valor lleva de cada opción, su precio y su foto.
   La ficha enseña una fila de botones por opción (los colores, con su muestra si se conoce el color); el precio y la foto son los de
   la variante elegida. No todas las combinaciones existen (el Galaxy S25 de 128 GB solo viene en tres colores): lo que no existe con
   lo elegido sale apagado y, al pulsarlo, se salta a la variante más parecida que sí existe. Las fichas completas (fichas/*.json,
   como la del iPhone 17 Pro) siguen con lo suyo */
const variantesDe = r => r && r.h && Object.prototype.hasOwnProperty.call(OPCIONES, r.h) ? OPCIONES[r.h] : null;
const esColor = nombre => /^colou?r$/i.test(String(nombre).trim());
// el nombre de un producto para enseñarlo: el de Shopify en el idioma de la web (TITULOS) y sin la referencia de núcleos del chip
// («MacBook Air 13" M5 10C/10G»), que se explica en la ficha (Sergio, 21 oct: «10C/10G ¿qué es eso?»)
const sinNucleos = t => String(t).replace(/\s+\d+C\/\d+G\b/i, '');
const tituloDe = (r, lang) => sinNucleos((lang && lang !== 'es' && TITULOS[lang] && r.h && TITULOS[lang][r.h]) || r.t);
// los núcleos del chip, del nombre de Shopify: {chip: 'M5', c: 10, g: 10}
const nucleosDe = t => { const m = /\b(\d+)C\/(\d+)G\b/i.exec(t || ''), chip = /\b(M\d+(?: (?:Pro|Max|Ultra))?)\b/.exec(t || ''); return m ? {chip: chip ? chip[1] : '', c: +m[1], g: +m[2]} : null; };
// los nombres de las opciones en cada idioma (los de Shopify están en castellano)
const NOMBRE_OPCION = {
  'almacenamiento': {ca: 'Emmagatzematge', fr: 'Stockage', en: 'Storage'}, 'capacidad': {ca: 'Capacitat', fr: 'Capacité', en: 'Capacity'},
  'color': {ca: 'Color', fr: 'Couleur', en: 'Colour'}, 'configuración': {ca: 'Configuració', fr: 'Configuration', en: 'Configuration'},
  'modelo': {ca: 'Model', fr: 'Modèle', en: 'Model'}, 'tipo': {ca: 'Tipus', fr: 'Type', en: 'Type'}, 'tamaño': {ca: 'Mida', fr: 'Taille', en: 'Size'},
  'correa': {ca: 'Corretja', fr: 'Bracelet', en: 'Strap'}, 'caja': {ca: 'Caixa', fr: 'Boîtier', en: 'Case'}, 'pack': {ca: 'Pack', fr: 'Pack', en: 'Pack'}
};
// (una «Configuración» que solo dice la capacidad, «1 TB», se llama «Capacidad»)
const soloCapacidad = vals => vals.every(v => /^\s*\d+(?:[.,]\d+)?\s*(GB|TB)\s*$/i.test(v));
const nombreOpcion = (nombre, lang, vals = []) => {
  const n = /^(configuración|modelo)$/i.test(String(nombre).trim()) && vals.length && soloCapacidad(vals) ? 'capacidad' : String(nombre).toLowerCase();
  return (NOMBRE_OPCION[n] || {})[lang] || (n === 'capacidad' ? 'Capacidad' : nombre);
};
// los colores: su muestra y su nombre en cada idioma (los que no están aquí salen con su nombre de Shopify y, si alguno de un producto
// no tiene muestra, los de ese producto van con su nombre escrito en vez de muestras)
const COLORES = {
  'negro': ['#1d1d1f', 'Negre', 'Noir', 'Black'], 'blanco': ['#f5f5f2', 'Blanc', 'Blanc', 'White'], 'azul': ['#2f6fd6', 'Blau', 'Bleu', 'Blue'],
  'plata': ['#dfe1e3', 'Plata', 'Argent', 'Silver'], 'rosa': ['#f2b8c6', 'Rosa', 'Rose', 'Pink'], 'morado': ['#7f5bb5', 'Morat', 'Violet', 'Purple'],
  'azul marino': ['#1f2f55', 'Blau marí', 'Bleu marine', 'Navy blue'], 'grafito': ['#46484d', 'Grafit', 'Graphite', 'Graphite'], 'rojo': ['#c62f2f', 'Vermell', 'Rouge', 'Red'],
  'azul cielo': ['#9ccaf0', 'Blau cel', 'Bleu ciel', 'Sky blue'], 'verde': ['#4c9a6a', 'Verd', 'Vert', 'Green'], 'amarillo': ['#f2d14b', 'Groc', 'Jaune', 'Yellow'],
  'blanco estrella': ['#f1eee6', 'Blanc estel·lar', 'Lumière stellaire', 'Starlight'], 'gris': ['#8d9096', 'Gris', 'Gris', 'Grey'], 'violeta': ['#8b6cd1', 'Violeta', 'Violet', 'Violet'],
  'negro espacial': ['#2a2a2d', 'Negre espacial', 'Noir sidéral', 'Space black'], 'naranja': ['#f2782f', 'Taronja', 'Orange', 'Orange'],
  'medianoche': ['#1e2430', 'Mitjanit', 'Minuit', 'Midnight'], 'gris espacial': ['#6c6d72', 'Gris espacial', 'Gris sidéral', 'Space grey'],
  'arena': ['#dcc9a6', 'Sorra', 'Sable', 'Sand'], 'lavanda': ['#c4b5e6', 'Lavanda', 'Lavande', 'Lavender'], 'verde azulado': ['#3c8c8c', 'Verd blavós', 'Bleu-vert', 'Teal'],
  'azul ultramar': ['#2a3db5', 'Blau ultramar', 'Bleu outremer', 'Ultramarine'], 'naranja cósmico': ['#f2782f', 'Taronja còsmic', 'Orange cosmique', 'Cosmic orange'],
  'azul oscuro': ['#2f3b52', 'Blau fosc', 'Bleu foncé', 'Dark blue'], 'negro medianoche': ['#1b1e25', 'Negre mitjanit', 'Noir minuit', 'Midnight black'],
  'menta': ['#b8e3cd', 'Menta', 'Menthe', 'Mint'], 'lila': ['#c8a6df', 'Lila', 'Lilas', 'Lilac'], 'azul lunar': ['#aebbd0', 'Blau lunar', 'Bleu lunaire', 'Moon blue'],
  'burdeos': ['#6b1e2a', 'Bordeus', 'Bordeaux', 'Burgundy'], 'azul glacial': ['#cde2f0', 'Blau glacial', 'Bleu glacier', 'Glacier blue'],
  'granate': ['#761c29', 'Granat', 'Grenat', 'Garnet'], 'azul hielo': ['#cbe5f2', 'Blau gel', 'Bleu glace', 'Icy blue'], 'azul neblina': ['#a7b7c8', 'Blau boirina', 'Bleu brume', 'Mist blue'],
  'verde salvia': ['#a5b799', 'Verd sàlvia', 'Vert sauge', 'Sage green'], 'rosa palo': ['#efcdd2', 'Rosa pàl·lid', 'Rose pâle', 'Pale pink'],
  'blanco nube': ['#f3f3f1', 'Blanc núvol', 'Blanc nuage', 'Cloud white'], 'dorado claro': ['#e6d2a6', 'Daurat clar', 'Or clair', 'Light gold'],
  'rojo coral': ['#f07c6c', 'Vermell corall', 'Rouge corail', 'Coral red'], 'negro azulado': ['#1f2633', 'Negre blavós', 'Noir bleuté', 'Blue black'],
  'dorado': ['#d4af6a', 'Daurat', 'Or', 'Gold'], 'oro': ['#d4af6a', 'Or', 'Or', 'Gold'], 'beige': ['#e2d4bb', 'Beix', 'Beige', 'Beige'], 'marrón': ['#6b4a32', 'Marró', 'Marron', 'Brown'],
  'turquesa': ['#3cc2c0', 'Turquesa', 'Turquoise', 'Turquoise'], 'celeste': ['#9dd0f0', 'Celeste', 'Bleu céleste', 'Light blue'], 'crema': ['#f1e6cf', 'Crema', 'Crème', 'Cream'],
  'titanio natural': ['#b9b2a6', 'Titani natural', 'Titane naturel', 'Natural titanium'], 'titanio negro': ['#3c3c3e', 'Titani negre', 'Titane noir', 'Black titanium'],
  'titanio blanco': ['#ecebe7', 'Titani blanc', 'Titane blanc', 'White titanium'], 'titanio desierto': ['#c9ad8c', 'Titani desert', 'Titane désert', 'Desert titanium'],
  // (21 oct, altas de la revisión: el Apple Watch S12 en «Dark Bronze» y la edición «Squad» de JBL)
  'bronce oscuro': ['#5a4535', 'Bronze fosc', 'Bronze foncé', 'Dark bronze'], 'camuflaje': ['#5d6b4a', 'Camuflatge', 'Camouflage', 'Camo'],
  // (22 oct, los colores repetidos juntados con el nombre de Xiaomi: Redmi Pad 2 y Redmi 15C)
  'gris grafito': ['#4a4c51', 'Gris grafit', 'Gris graphite', 'Graphite grey'], 'verde menta': ['#a9dcc3', 'Verd menta', 'Vert menthe', 'Mint green']
};
// (los que no están, por la palabra principal: «Azul pacífico» → azul)
const PALABRAS_COLOR = [['negr', 'negro'], ['blanc', 'blanco'], ['azul', 'azul'], ['plat', 'plata'], ['ros', 'rosa'], ['morad', 'morado'], ['viol', 'violeta'], ['lil', 'lila'],
  ['rojo', 'rojo'], ['roja', 'rojo'], ['verd', 'verde'], ['amarill', 'amarillo'], ['gris', 'gris'], ['grafit', 'grafito'], ['naranj', 'naranja'], ['dorad', 'dorado'], ['oro', 'oro'],
  ['beige', 'beige'], ['arena', 'arena'], ['marr', 'marrón'], ['titani', 'titanio natural'], ['menta', 'menta'], ['lavand', 'lavanda'], ['celest', 'celeste'], ['turques', 'turquesa'], ['crema', 'crema']];
const datosColor = valor => {
  const k = String(valor).trim().toLowerCase();
  if (COLORES[k]) return COLORES[k];
  const p = PALABRAS_COLOR.find(([w]) => k.startsWith(w) || k.includes(' ' + w));
  return p ? [COLORES[p[1]][0], null, null, null] : null;
};
const IDX_IDIOMA = {ca: 1, fr: 2, en: 3};
// el valor de una opción en el idioma de la web (solo los colores conocidos; lo demás, como en Shopify: 256 GB, 16/512 GB, Con funda…)
// la memoria y el disco juntos («16/1TB», «12/512GB») se escriben enteros: «16 GB de RAM · 1 TB»; y en francés, Go y To
const RAM_DISCO = /^(\d+)\s*\/\s*(\d+)\s*(GB|TB)$/i;
const unidad = (u, lang) => lang === 'fr' ? (/^tb$/i.test(u) ? 'To' : 'Go') : u.toUpperCase();
const RAM_TXT = {es: (a, b) => `${a} GB de RAM · ${b}`, ca: (a, b) => `${a} GB de RAM · ${b}`, fr: (a, b) => `${a} Go de RAM · ${b}`, en: (a, b) => `${a} GB RAM · ${b}`};
const valorEn = (nombre, valor, lang) => {
  const v = String(valor).trim(), m = RAM_DISCO.exec(v);
  // (primero, la traducción que tenga Shopify de ese valor: «Con funda» → «Amb funda»)
  const deShopify = lang !== 'es' && TITULOS._valores && TITULOS._valores[v] && TITULOS._valores[v][lang];
  if (deShopify && !m) return deShopify;
  if (m) return (RAM_TXT[lang] || RAM_TXT.es)(m[1], `${m[2]} ${unidad(m[3], lang)}`);
  if (!esColor(nombre)) return lang === 'fr' ? v.replace(/\b(\d+)\s*(GB|TB)\b/gi, (_, n, u) => `${n} ${unidad(u, 'fr')}`) : v;
  const c = IDX_IDIOMA[lang] && COLORES[v.toLowerCase()];
  return (c && c[IDX_IDIOMA[lang]]) || v;
};
/* ---------- los valores en el buscador ----------
   (Sergio, 22 oct 2026: los colores repetidos de un modelo se juntaron con el nombre que le da la marca, «Violeta» y no «Morado» en el
   S26, «que buscando con las 2 palabras sirva»). Un valor se encuentra por su nombre en los cuatro idiomas, por sus sinónimos y por
   el nombre que le daba la tienda; y la ficha abre en la variante buscada («s26 morado» abre el S26 en violeta) */
const SINONIMOS_COLOR = [['morado', 'violeta', 'purpura']];
const OTROS_NOMBRES_COLOR = {'galaxy-tab-a11-plus': {'gris': 'negro'}};  // (en Eurowin, «NEGRE»; Samsung lo llama gris)
const palabrasValor = (h, nombre, valor) => {
  const ws = [valor, ...IDIOMAS.map(l => valorEn(nombre, valor, l))];
  if (esColor(nombre)) {
    const n = norm(valor);
    for (const g of SINONIMOS_COLOR) if (g.some(w => n.includes(w))) ws.push(...g);
    ws.push((OTROS_NOMBRES_COLOR[h] || {})[n] || '');
  }
  return norm(ws.join(' '));
};
const palabrasOpciones = r => { const vo = variantesDe(r); return vo ? vo.o.map(([n, vals]) => vals.map(v => palabrasValor(r.h, n, v)).join(' ')).join(' ') : ''; };
// la variante con más palabras de lo buscado (a igualdad, la que se puede pedir), o null si lo buscado no nombra ningún valor
function varianteBuscada(r, vo, q) {
  const words = norm(q || '').split(/\s+/).filter(w => w.length > 1);
  if (!words.length) return null;
  const pal = vo.o.map(([n, vals]) => vals.map(v => palabrasValor(r.h, n, v)));
  let mejor = null, max = 0;
  for (const v of vo.v) {
    const aciertos = v[0].reduce((s, j, i) => s + words.filter(w => pal[i][j].includes(w)).length, 0);
    const nota = aciertos * 2 + (v[4] !== 0 ? 1 : 0);
    if (aciertos && nota > max) { mejor = v; max = nota; }
  }
  return mejor;
}
const iguales = (a, b) => a.length === b.length && a.every((x, i) => x === b[i]);
const varianteDe = (vo, sel) => vo.v.find(v => iguales(v[0], sel)) || null;
// al elegir el valor j de la opción i: la variante que lo lleva y más se parece a lo que ya estaba elegido (cuentan más las primeras
// opciones: con el almacenamiento elegido, se busca un color que exista con él)
function elegirValor(vo, sel, i, j) {
  const exacta = sel.map((x, k) => k === i ? j : x);
  if (varianteDe(vo, exacta)) return exacta;
  let mejor = null, puntos = -1;
  for (const [vals] of vo.v) {
    if (vals[i] !== j) continue;
    const p = vals.reduce((s, x, k) => s + (k !== i && x === sel[k] ? 2 ** (vals.length - k) : 0), 0);
    if (p > puntos) { mejor = vals; puntos = p; }
  }
  return mejor ? mejor.slice() : sel;
}
// ¿existe el valor j de la opción i con lo demás que hay elegido? (si no, su botón sale apagado)
const existeCon = (vo, sel, i, j) => vo.v.some(([vals]) => vals[i] === j && vals.every((x, k) => k === i || x === sel[k]));
// lo elegido: el precio, el texto (para el mensaje y la bolsa), la foto y lo que el cliente no ha tocado (para la marca del pedido)
function eleccionVariantes(pg, vo, lang) {
  const v = varianteDe(vo, pg.sel) || vo.v[0], sel = v[0], tocadas = pg.tocadas || [];
  const varias = vo.o.map(([, vals]) => vals.length > 1);
  // (el texto lleva todo lo de la variante, también lo que no se elige porque solo hay uno: «1 TB»)
  const o = vo.o.map(([n, vals], i) => valorEn(n, vals[sel[i]], lang)).filter(Boolean).join(', ');
  const se = {color: vo.o.some(([n], i) => esColor(n) && varias[i] && !tocadas[i]), cap: vo.o.some(([n], i) => !esColor(n) && varias[i] && !tocadas[i])};
  return {p: v[1], o, se, foto: v[2] || ''};
}
// las filas de botones (solo las opciones con más de un valor)
function htmlOpciones(st, vo, pg) {
  return vo.o.map(([n, vals], i) => {
    const nom = nombreOpcion(n, st.lang, vals);
    // (si solo hay un valor, no hay nada que elegir: se dice, «Capacidad: 1 TB»)
    if (vals.length < 2) return `<p class="fi-ol fi-fijo">${esc(nom)}: <b>${esc(valorEn(n, vals[0], st.lang))}</b></p>`;
    const muestras = esColor(n) && vals.every(x => datosColor(x));
    const boton = (x, j) => {
      // (si la variante a la que lleva está sin stock, se dice al pasar por encima y al lector de pantalla: «Azul · Sin stock ahora mismo»)
      const on = pg.sel[i] === j, no = !on && !existeCon(vo, pg.sel, i, j), destino = varianteDe(vo, elegirValor(vo, pg.sel, i, j));
      const texto = valorEn(n, x, st.lang) + (destino && destino[4] === 0 ? ' · ' + T[st.lang].ficha.sinStock : '');
      return muestras
        ? `<button type="button" class="fi-col${on ? ' on' : ''}${no ? ' no' : ''}" data-opt="${i}" data-val="${j}" style="--c:${datosColor(x)[0]}" aria-label="${esc(texto)}" title="${esc(texto)}"></button>`
        : `<button type="button" class="fi-cap${on ? ' on' : ''}${no ? ' no' : ''}" data-opt="${i}" data-val="${j}" title="${esc(texto)}">${esc(valorEn(n, x, st.lang))}</button>`;
    };
    return `<div class="fi-op"><p class="fi-ol">${esc(nom)}${muestras ? `: <b>${esc(valorEn(n, vals[pg.sel[i]], st.lang))}</b>` : ''}</p><div class="${muestras ? 'fi-cols' : 'fi-seg'}">${vals.map(boton).join('')}</div></div>`;
  }).join('');
}

/* ===== ficha.js ===== */
/* ---------- la ficha de un producto ---------- */
// (Sergio, 19 oct: «ahora nos ponemos con las fichas de productos… el iPhone para probarlo, sorpréndeme, que todo vaya en la misma
// línea»). A la izquierda, sus fotos (las de Shopify: una por color); a la derecha, lo que hace falta para decidir: el precio de lo
// elegido, la capacidad, el color, pedirlo por WhatsApp (lo primero) o a la bolsa, el envío y la garantía y, para quien prefiera
// la tienda, dónde está el mostrador. Debajo, lo que hay que saber, con qué protegerlo (con su argumento y su botón de añadir), lo
// que va con él y más de su marca. En el móvil, cuando los botones no se ven, una barra abajo con el precio y WhatsApp.
// La tienda online va sola (envía a España, sin las islas, Ceuta ni Melilla): nada de «ven a la tienda» como si hiciera falta ir (Sergio, 20 oct).
// El mismo día llevó el producto en 3D en su peana (visor-producto.js, que se queda aparcado en el editor) y se quitó: de cerca no da
// la talla y no se puede mantener para cada producto (Sergio: «es buena idea lo del 3D, pero así como está ahora la veo muy verde»).
// Los productos con su ficha completa (precios por capacidad, colores, fotos y descripción, de Shopify) están en fichas/*.json
// (FICHAS, en scene2.js con los demás datos); los demás salen con lo del catálogo
const claseDe = r => { for (const x of r.tg) if (x.startsWith('k:')) return x.slice(2); return 'box'; };
// la foto de un producto: la de Shopify o, si no tiene (lo de la tienda que aún no está en Shopify), su imagen en 3D
const fotoDe = (st, r, ancho) => r.i ? src(r.i, ancho) : PRODUCTOS3D[claseDe(r)] ? recurso('productos', claseDe(r)) : '';
// lo que no se puede elegir en la ficha de un producto sin ficha completa (sus opciones de Shopify con más de un valor: el color y
// lo demás, la capacidad, la configuración, el modelo…): para la marca del pedido, sin tocar, y el bot lo pregunta
const sinElegir = r => {
  const vo = variantesDe(r), op = vo ? vo.o.filter(([, vals]) => vals.length > 1).map(([n]) => n) : (r.op || '').split('|').filter(Boolean);
  return {color: op.some(n => esColor(n)), cap: op.some(n => !esColor(n))};
};

// con qué protegerlo, por orden (Sergio, 19 oct: «una inversión tan cara como un iPhone necesitará protección: ¿quieres un protector?
// ¿y una funda?… lo principal sería venderles el protector, una funda y el enchufe de carga si no lo tienen»). De cada cosa, un
// desplegable con lo que hay para ese móvil, cada opción con su porqué (Sergio, 20 oct: «tendrías que hacer como un desplegable que
// deje elegir al cliente el enchufe que quiere… lo mismo con las fundas y protectores… cada una con su argumento de venta sin generar
// fricción»). La primera, la que sale de entrada: en la funda, el pack de funda y cristal si lo hay («pon el pack de funda más
// protector en todos los modelos de iPhone»); en el cargador, el más barato («mejor pon de inicial el de 24,90»)
const PROTEGE = {
  phone: ['protector', 'phonecase', 'charger'], fold: ['protector', 'phonecase', 'charger'], flip: ['protector', 'phonecase', 'charger'],
  tablet: ['protector', 'tabletcase'], watch: ['watchcase', 'protector'], band: ['protector'], switch: ['protector']
};
// el protector: los seis tipos del «Protector de Pantalla» de Shopify, al mismo precio, en móviles, relojes y la Switch (Sergio, 20 oct:
// «estas opciones también están disponibles en todos los smartphones y iPads, todo lo que tiene pantalla excepto las teles se puede»;
// y luego: «en cámaras y GPS no pongas protectores»). En relojes y pulseras vienen 9 por el mismo precio («en los Apple Watch o
// smartwatch vienen 9 protectores por ese mismo precio») y en los plegables es solo para la pantalla de fuera («los plegables son muy
// delicados de poner un protector dentro y se puede romper la pantalla al colocarlo»). Además, el hecho a medida de un modelo, si lo
// hay. Las tablets llevan los suyos, los de Eurowin (opcionesTablet)
const PROTECTOR = 'Protector de Pantalla';
const RELOJ = new Set(['watch', 'band']), PLEGABLE = new Set(['fold', 'flip']), ART_UNA = new Set(['switch', 'band']);
const pantallaDe = r => RELOJ.has(claseDe(r)) ? 'reloj' : PLEGABLE.has(claseDe(r)) ? 'plegable' : '';
// lo que es cada cosa de «Protégelo» (en un reloj, que vienen 9; en un plegable, que es para la pantalla de fuera)
const nombreClase = (F, r, kx) => kx === 'protector' && pantallaDe(r) ? F.clasesPantalla[pantallaDe(r)] : F.clases[kx];
// y eso solo se vende con su aparato (Sergio, 20 oct: «el enchufe y los protectores, haz que no haya la opción de apretar en ellos,
// solo la posibilidad de apretar al + y a añadir de la bolsa, porque si no la gente comprará un enchufe solo, y no sale a cuenta
// vender un enchufe de 24,90 y enviarlo a España»): no tiene ficha ni sale en las listas, en la búsqueda o en las marcas; solo en
// «Protégelo» de su aparato (en su ficha y en la bolsa), y en la bolsa va en el bloque de su aparato y se va con él
const SOLO_CON = new Set(['protector', 'phonecase', 'tabletcase', 'charger', 'watchcase']);
// (y lo que cuesta menos de 100 €: no se puede enviar solo; Sergio, 21 oct: «haz como con los accesorios… extra de otro dispositivo pero
// no unitario, que no se pueda clicar ni en su ventana de producto»)
const BARATO = 100;
// (y lo que, aunque pase de 100 €, es un accesorio: Sergio, 23 oct, de la microSD Kingston de 159,90 €: «quítala, que sea solo un
// accesorio, pero no como compra normal»)
const SOLO_CON_FICHAS = new Set(['kingston-canvas-go-plus-microsd']);
const soloCon = r => SOLO_CON.has(claseDe(r)) || SOLO_CON_FICHAS.has(r.h) || (r.p > 0 && r.p < BARATO);
// lo que va con él, después (uno de cada)
const CON_EL = {
  phone: ['earbuds', 'watch', 'tag'], fold: ['earbuds', 'watch', 'tag'], flip: ['earbuds', 'watch', 'tag'],
  tablet: ['pencil', 'keyboard', 'earbuds'], watch: ['band', 'earbuds'], band: ['earbuds'],
  laptop: ['ssdext', 'monitor', 'router', 'card'], aio: ['keyboard', 'trackpad', 'ssdext', 'cable'], minipc: ['monitor', 'keyboard', 'ssdext', 'router'], monitor: ['minipc', 'keyboard', 'cable'],
  drone: ['card', 'goggles', 'remote', 'transmitter'], actioncam: ['card', 'stick', 'gimbal', 'mic'], pocket: ['card', 'mic', 'stick'], gimbal: ['mic', 'card'], camera: ['card', 'mic', 'transmitter'],
  ps5: ['vr', 'headphones', 'nvme'], switch: ['card', 'headphones'], tv: ['mount', 'tvbox', 'speaker', 'homepod'], projector: ['speaker', 'tvbox'],
  earbuds: ['speaker', 'headphones'], headphones: ['earbuds', 'speaker'], speaker: ['earbuds', 'headphones', 'homepod'], homepod: ['tvbox', 'tag']
};
// solo de su marca (un AirTag o un Apple Watch con un Android, no; el cargador de Apple, para lo de Apple)
const DE_MARCA = new Set(['protector', 'watchcase', 'tag', 'pencil', 'keyboard', 'trackpad', 'watch', 'band', 'goggles', 'remote', 'transmitter', 'vr', 'tvbox', 'homepod', 'charger']);
// la funda de un producto de Shopify, la de su modelo («… para iPhone 17 Pro» con el iPhone 17 Pro, no con el 17 Pro Max); lo de la
// tienda que no está publicado dice con qué móviles va (ACCESORIOS: para)
const paraModelo = x => { const m = / para (.+)$/.exec(x.t); return m ? m[1] : null; };
function encajaCon(r, x, kx) {
  const reloj = claseDe(r) === 'watch' || claseDe(r) === 'band', a = ACCESORIOS[x.t];
  if (x.n === r.n || (r.p > 0 && x.p > r.p * 0.6)) return false;
  if (a && a.para) return a.para.includes(r.t);
  if (DE_MARCA.has(kx) && x.v !== r.v) return false;
  if (kx === 'protector') return x.sec === r.sec && /watch/i.test(x.t) === reloj;
  if (kx === 'phonecase') return paraModelo(x) === r.t;
  return true;
}
// uno de cada clase de la lista, el primero que encaje (los de su marca antes)
function unoDeCada(r, lista) {
  const out = [];
  for (const kx of lista || []) {
    const x = ROWS.filter(y => claseDe(y) === kx && encajaCon(r, y, kx)).sort((a, b) => (b.v === r.v) - (a.v === r.v))[0];
    if (x) out.push(x);
  }
  return out;
}
// las opciones de una cosa de «Protégelo» para un aparato, la de entrada primero: cada una {n: el producto, o: su tipo (los
// protectores de Shopify tienen varios, con su precio: VARIANTES), p: el precio, c: el nombre corto, r: por qué}
const ORDEN_FUNDA = ['pack', 'teclado', 'magnetica', 'apple', 'folio', 'uag', 'anilla', 'tapa', 'silicona', 'basica'];
const MAX_OPCIONES = 7;
// (elegido: lo elegido de ese aparato, su texto, «11 pulgadas, 256GB WiFi, Plata»: el protector de una tablet, el de su medida)
function opcionesDe(st, r, kx, elegido = '') {
  const t = T[st.lang], out = [];
  if (kx === 'protector') {
    if (claseDe(r) === 'tablet') return r.p > 0 ? opcionesTablet(t, r, elegido) : [];
    const base = ROWS.find(y => y.t === PROTECTOR), F = t.ficha, tipo = pantallaDe(r);
    // (en la bolsa y en el mensaje, el tipo y, si toca, «9 unidades» o «pantalla exterior»: es lo que hay que preparar)
    if (base) VARIANTES[PROTECTOR].forEach(([o, p]) => out.push({n: base.n, o: o + (tipo ? ' · ' + F.pantalla[tipo] : ''), p, c: F.variante(o), r: F.razon.variantes[o] || F.razon.protector}));
    for (const x of ROWS.filter(y => claseDe(y) === 'protector' && ((ACCESORIOS[y.t] || {}).para || []).includes(r.t))) out.push({n: x.n, o: '', p: x.p, c: nombreCorto(t, x), r: razonDe(t, r, x)});
    return r.p > 0 ? out.slice(0, MAX_OPCIONES) : [];
  }
  for (const x of ROWS.filter(y => claseDe(y) === kx && encajaCon(r, y, kx))) {
    const vs = VARIANTES[x.t];
    if (vs) vs.forEach(([o, p]) => out.push({n: x.n, o, p, c: t.ficha.variante(o), r: t.ficha.razon.variantes[o] || t.ficha.razon.protector}));
    else out.push({n: x.n, o: '', p: x.p, c: nombreCorto(t, x), r: razonDe(t, r, x)});
  }
  const tipo = o => (ACCESORIOS[ROWS[o.n].t] || {}).tipo || '';
  const peso = o => kx === 'phonecase' || kx === 'tabletcase' ? ORDEN_FUNDA.indexOf(tipo(o) || 'basica') : kx === 'charger' ? o.p : tipo(o) === 'medida' ? 1 : 0;
  return out.map((o, i) => [o, i]).sort((a, b) => peso(a[0]) - peso(b[0]) || a[1] - b[1]).map(x => x[0]).slice(0, MAX_OPCIONES);
}
// en las tablets, los protectores de Eurowin (PROT_TABLET, de protectores-tablet.json; Sergio, 20 oct: «en el iPad está en el Eurowin,
// búscalo»): el cristal templado solo en los iPad y el hidrogel en todas, cada uno con el precio de sus pulgadas. Si la tablet tiene dos
// medidas (el iPad Air y el Pro: 11" y 13") y cuestan distinto, una opción por medida, con la medida en el nombre
const pulgadasDelTitulo = t => { const m = /(\d{1,2}(?:[.,]\d{1,2})?)\s*(?:"|”|''|pulgadas|polzades|pouces|inches|-inch)/i.exec(t || ''); return m ? [parseFloat(m[1].replace(',', '.'))] : null; };
// (si ya se ha elegido la medida, la de esa: el iPad Pro de 11" con el protector de 11")
function opcionesTablet(t, r, elegido = '') {
  const base = ROWS.find(y => y.t === PROTECTOR), F = t.ficha, medidas = pulgadasDelTitulo(elegido) || PROT_TABLET.pulgadas[r.t] || pulgadasDelTitulo(r.t), out = [];
  if (!base || !medidas) return out;
  for (const {tipo, marca, precios} of PROT_TABLET.tipos) {
    if (marca && marca !== r.v) continue;
    const porPrecio = new Map();
    for (const m of medidas) {
      const x = precios.find(([hasta]) => m <= hasta);
      if (x) porPrecio.set(x[1], [...(porPrecio.get(x[1]) || []), m]);
    }
    for (const [p, ms] of porPrecio) {
      // (la medida en el nombre si cuestan distinto o si la tablet viene en dos: el iPad Pro de 11" y de 13"; así se sabe cuál es)
      const medida = porPrecio.size > 1 || (PROT_TABLET.pulgadas[r.t] || []).length > 1 ? ms.map(m => m + '"').join(', ') : '';
      out.push({n: base.n, o: tipo + (medida ? ' · ' + medida : ''), p, c: F.variante(tipo) + (medida ? ` (${medida})` : ''), r: F.razon.variantes[tipo] || F.razon.protector});
    }
  }
  return out;
}
// cada cosa de «Protégelo» que hay para ese aparato, con sus opciones
const clasesDe = (st, r, elegido = '') => (PROTEGE[claseDe(r)] || []).map(kx => ({kx, opciones: opcionesDe(st, r, kx, elegido)})).filter(c => c.opciones.length);
// lo elegido en la ficha abierta (su texto), para las opciones de «Protégelo»
const elegidoEnFicha = (st, r, d) => st.page && st.page.kind === 'ficha' ? fichaEleccion(st.page, r, d, st.lang).o : '';
function conEl(r) {
  const lista = CON_EL[claseDe(r)];
  if (!lista) return VENTA.filter(x => x.n !== r.n && x.tg.has('acc') && x.sec === r.sec).sort((a, b) => (b.v === r.v) - (a.v === r.v)).slice(0, 4);
  return unoDeCada(r, lista).slice(0, 4);
}
// el nombre corto de una opción (el del desplegable, debajo de lo que es: «Funda», «Cargador»): su tipo, su color y su medida, o su
// título
function nombreCorto(t, x) {
  const a = ACCESORIOS[x.t];
  return a && a.tipo ? t.ficha.tipos[a.tipo] + (a.color ? ' ' + t.ficha.colores[a.color] : '') + (a.detalle ? ` (${a.detalle})` : '') : x.t;
}
// por qué cada cosa (el argumento de la venta cruzada, en una línea). El de 40 W de Apple, con lo que tarda ese iPhone, según Apple
const MINUTOS_40W = {'iPhone 17': 20, 'iPhone 17 Pro': 20, 'iPhone 17 Pro Max': 20, 'iPhone Duo': 20, 'iPhone Air': 30, 'iPhone 18 Pro': 15, 'iPhone 18 Pro Max': 15};
function razonDe(t, r, x) {
  const R = t.ficha.razon, k = claseDe(x), tipo = (ACCESORIOS[x.t] || {}).tipo;
  if (tipo === 'apple40') return MINUTOS_40W[r.t] ? R.apple40(MINUTOS_40W[r.t]) : R.apple40mas;
  if (tipo && R[tipo]) return R[tipo];
  if (k === 'phonecase' || k === 'tabletcase') return /cristal/i.test(x.t) ? R.pack : R.basica;
  if (k === 'charger') return r.v === 'Apple' && claseDe(r) === 'phone' ? R.apple20 : R.cargador;
  return R[k] || '';
}
// la línea de la bolsa de ese aparato con la que va lo que se añade: la última que lleva
const lineaDe = (st, r) => [...st.cart].reverse().find(l => l.n === r.n && !l.de);
// ¿ya lleva una cosa de esa clase en la bolsa, con este aparato? (una de cada)
const conEnLaBolsa = (st, r, kx) => st.cart.some(l => l.de && claseDe(ROWS[l.n]) === kx && st.cart.some(b => b.id === l.de && b.n === r.n));
// el botón de añadir de la venta cruzada: «Añadir» o, si ya lleva una de esas con él, «En tu bolsa»
const botonAnadir = (st, r, kx) => {
  const F = T[st.lang].ficha, ya = conEnLaBolsa(st, r, kx);
  return `<button type="button" class="fi-anadir${ya ? ' ya' : ''}" data-anadir="${kx}"${ya ? ' aria-disabled="true"' : ''}>${ya ? F.yaEnBolsa : F.anadir}</button>`;
};
// un extra de menos de 100 € (o de los que solo van con su aparato) en «Con él, también»: su tarjeta, sin enlace a una ficha que no
// tiene, y su botón de añadir, que lo pone en la bolsa con el aparato
const extraEnBolsa = (st, r, x) => st.cart.some(l => l.n === x.n && l.de && st.cart.some(b => b.id === l.de && b.n === r.n));
function extraSuelto(st, r, x) {
  const F = T[st.lang].ficha, foto = fotoDe(st, x, st.isPhone ? 260 : 360), ya = extraEnBolsa(st, r, x);
  return `<div class="gi gi-extra"><span class="im">${foto ? `<img src="${foto}" alt="" loading="lazy">` : ''}</span><span class="b">${esc(x.v)}</span>`
    + `<span class="t">${esc(tituloDe(x, st.lang))}</span><span class="price">${fmt(x.p)}</span>`
    + `<button type="button" class="fi-anadir${ya ? ' ya' : ''}" data-extra="${x.n}"${ya ? ' aria-disabled="true"' : ''}>${ya ? F.yaEnBolsa : F.anadir}</button></div>`;
}
// a la bolsa con el aparato de la ficha: con su última línea o, si aún no está en la bolsa, con él (con lo elegido), los dos a la vez
function anadirCon(st, r, o, eleccion) {
  const base = lineaDe(st, r), extra = {o: o.o, p: o.p};
  if (base) return addToCart(st, o.n, extra, base.id);
  const l = addToCart(st, r.n, eleccion, 0);
  addToCart(st, o.n, extra, l.id);
}

function openFicha(st, n, buscado = '') {
  if (soloCon(ROWS[n])) return;
  closeHS(st); closeCart(st); closeAssist(st);
  const prev = st.page && st.page.kind !== 'ficha' ? st.page : (st.page && st.page.prev) || null;
  // entra con el primer color y la primera capacidad marcados; «tocado» dice si el cliente los ha elegido él (para la marca del
  // pedido: el bot pregunta solo lo que no se tocó)
  const vo = FICHAS[ROWS[n].t] ? null : variantesDe(ROWS[n]);
  // (con variantes, la que se ha buscado o la primera que se puede pedir: el HomePod mini abre en el color que hay)
  const v0 = vo ? varianteBuscada(ROWS[n], vo, buscado) || vo.v.find(v => v[4] !== 0) || vo.v[0] : null;
  st.page = {kind: 'ficha', n, cap: 0, col: 0, capTocada: false, colTocado: false, foto: 0, opc: {}, prev, sel: v0 ? v0[0].slice() : null, tocadas: []};
  renderPage(st, true);
  // y el precio y el stock de ahora, si en Shopify ya no son los de la exportación (rutas.js: preciosEnVivo); solo si sigue en esa ficha
  // (y su descripción de Shopify, que llega en la misma respuesta: se pone debajo sin volver a pintar la ficha)
  preciosEnVivo(ROWS[n]).then(cambia => { if (st.page && st.page.kind === 'ficha' && st.page.n === n) { if (cambia) repintarFicha(st); else ponerDesc(st); } });
}
// «Lo que tienes que saber» de los productos sin ficha completa: su descripción de Shopify (los 516 la tienen, en los cuatro idiomas; hasta
// el 3 nov 2026 la web solo la enseñaba en el iPhone 17 Pro). Solo párrafos, listas y negritas: el resto se queda en su texto
const DESC_OK = {P: 'p', UL: 'ul', OL: 'ol', LI: 'li', STRONG: 'strong', B: 'strong', EM: 'em', I: 'em', H2: 'p', H3: 'p', H4: 'p'};
function limpiarDesc(html) {
  const pasa = nodo => [...nodo.childNodes].map(x => x.nodeType === 3 ? esc(x.textContent)
    : x.nodeType !== 1 || /^(SCRIPT|STYLE|IFRAME|TEMPLATE)$/.test(x.tagName) ? '' : x.tagName === 'BR' ? '<br>'
    : DESC_OK[x.tagName] ? `<${DESC_OK[x.tagName]}>${pasa(x)}</${DESC_OK[x.tagName]}>` : pasa(x)).join('');
  return pasa(new DOMParser().parseFromString(String(html), 'text/html').body).trim();
}
function descSec(st, r) {
  const html = r && r.descs && r.descs[st.lang] ? limpiarDesc(r.descs[st.lang]) : '';
  return html ? `<section class="fi-sec fi-desc"><h2>${T[st.lang].ficha ? T[st.lang].ficha.saber : 'Lo que tienes que saber'}</h2><div class="fi-intro fi-texto">${html}</div></section>` : '';
}
function ponerDesc(st) {
  const c = st.root.querySelector('.coll'), r = ROWS[st.page.n], d = FICHAS[r.t];
  if (!c || (d && d.intro) || c.querySelector('.fi-desc')) return;
  const h = descSec(st, r), f = c.querySelector('.ficha');
  if (h && f) f.insertAdjacentHTML('afterend', h);
}
// al salir de la ficha deja de mirarse la barra del móvil
function dejarFicha(st) {
  if (st.fichaIO) { st.fichaIO.disconnect(); st.fichaIO = null; }
}
// el botón de volver nombra la página de la que se viene (una sección, una lista, una marca, la búsqueda…); si no tiene nombre, «Volver»
function fichaVolver(t, p) {
  if (!p) return t.back;
  // (si vienes de una colección con su nombre, «iPhone», vuelves a ella con ese nombre, no al de la sección: Sergio, 3 nov 2026)
  const F = t.ficha, n = p.kind === 'sec' && p.titulo ? p.titulo : p.kind === 'brand' ? p.id : p.kind === 'dir' ? t.z.marcas : p.kind === 'search' ? F.busqueda : ['sec', 'list', 'sat', 'tel'].includes(p.kind) ? t.z[p.id || p.kind] : null;
  return n ? F.volver(esc(n)) : F.atras;
}
// el mensaje de WhatsApp de la ficha: el producto, lo elegido y su precio
// (con la marca para el bot: viene de una ficha y dice si el color o la capacidad se quedaron sin tocar)
// (sin stock, la pregunta de cuándo lo tendrán, sin la marca: no es un pedido)
const mensajeFicha = st => {
  const pg = st.page, r = ROWS[pg.n], el = fichaEleccion(pg, r, FICHAS[r.t] || null, st.lang), que = tituloDe(r, st.lang) + (el.o ? ', ' + el.o : '');
  return fichaSinStock(pg, r) ? T[st.lang].ficha.msgSinStock(que) : conClave(T[st.lang].ficha.msg(que, fmt(el.p)), claveWeb('ficha', [el.se]));
};
// sin stock (Sergio, 22 oct 2026: «los productos que estén a 0 de stock, que ponga "Sin stock ahora mismo", y el añadir a la bolsa,
// que ponga "Pregúntanos por WhatsApp"»): la variante elegida o, si no hay nada que elegir, el producto. El dato es el de Shopify, que
// pone ~/Servers/eurowin/stock_web.py y deja siempre a la venta los iPhone, los accesorios y lo de menos de 100 € («de accesorios siempre
// tenemos stock»); y lo que no sabe (datos de antes, el simulador) se puede pedir. Las fichas completas (el iPhone 17 Pro), nunca
// sin stock del todo (Sergio, 22 oct 2026, con la lista de consolas: «los productos que no tengan stock, que el precio no se muestre
// para no liar; en vez del precio, que ponga "Sin stock"», y que el «+» de la tarjeta no los ponga en la bolsa): ninguna variante se
// puede pedir. Lo que solo va con su aparato (accesorios y lo de menos de 100 €), nunca
function productoSinStock(r) {
  if (!r || FICHAS[r.t] || soloCon(r)) return false;
  const vo = variantesDe(r);
  return vo ? vo.v.length > 0 && vo.v.every(v => v[4] === 0) : r.a === 0;
}
// el precio de una tarjeta, de un resultado o de «Recién llegados»: o «Sin stock»
const precioTarjeta = (st, r) => productoSinStock(r) ? T[st.lang].ficha.sinStockCorto : fmt(r.p);
const claseAgotado = r => productoSinStock(r) ? ' agot' : '';
function fichaSinStock(pg, r) {
  if (!r || FICHAS[r.t]) return false;
  const vo = pg && pg.sel ? variantesDe(r) : null;
  if (vo) { const v = varianteDe(vo, pg.sel); return !!v && v[4] === 0; }
  return r.a === 0;
}
// en el ordenador, al pulsar WhatsApp: debajo de los botones, el QR que lo abre en el móvil y el enlace a WhatsApp Web; y al día con lo
// elegido (sin «abrir», solo si ya está)
function fichaQr(st, abrir) {
  const c = st.root.querySelector('.coll'), ya = c.querySelector('.fi-compra .qr-wa');
  if (st.isPhone || (!ya && !abrir)) return;
  const caja = document.createElement('div');
  caja.innerHTML = panelQr(st, mensajeFicha(st));
  if (!caja.firstElementChild) return;
  if (ya) ya.replaceWith(caja.firstElementChild); else c.querySelector('.fi-acc').after(caja.firstElementChild);
}
// lo elegido: el precio y el texto de la capacidad y el color
// los textos de una ficha completa en el idioma de la web (fichas/*.json: «idiomas»; si no los tiene, los de castellano)
const enIdioma = (d, lang) => (d && d.idiomas && d.idiomas[lang]) || {};
const nombreColor = (d, i, lang) => (enIdioma(d, lang).colores || [])[i] || d.colores[i][0];
function fichaEleccion(pg, r, d, lang = 'es') {
  const vo = !d && pg.sel ? variantesDe(r) : null;
  if (vo) return eleccionVariantes(pg, vo, lang);
  const cap = d && d.capacidad ? d.capacidad[pg.cap] : null, col = d && d.colores ? [nombreColor(d, pg.col, lang)] : null;
  // se: lo que se quedó sin tocar (solo cuenta si hay más de una opción)
  const se = d ? {color: !!(d.colores && d.colores.length > 1 && !pg.colTocado), cap: !!(d.capacidad && d.capacidad.length > 1 && !pg.capTocada)} : sinElegir(r);
  return {p: cap ? cap[1] : r.p, o: [cap && cap[0], col && col[0]].filter(Boolean).join(', '), se};
}
// las fotos: una por color (las de su ficha) o la del catálogo
const fotosDe = (r, d) => {
  if (d && d.colores) return d.colores.map(x => x[2]);
  const vo = variantesDe(r);
  return vo ? [...new Set([r.i, ...vo.v.map(v => v[2])].filter(Boolean))] : (r.i ? [r.i] : []);
};
// una cosa de «Protégelo»: su foto, qué es, el desplegable con sus opciones (o su nombre, si solo hay una), por qué, el precio y el
// botón. Lo único que se pulsa es el desplegable y el botón: no tiene ficha
const extra = (st, r, {kx, opciones}, i) => {
  const F = T[st.lang].ficha, o = opciones[i] || opciones[0], foto = fotoDe(st, ROWS[o.n], 200), clase = nombreClase(F, r, kx);
  const nombre = opciones.length > 1
    ? `<select class="fi-sel" data-opc="${kx}" aria-label="${esc(clase)}">${opciones.map((x, j) => `<option value="${j}"${x === o ? ' selected' : ''}>${esc(x.c)} · ${fmt(x.p)}</option>`).join('')}</select>`
    : `<span class="t">${esc(o.c)}</span>`;
  return `<div class="fi-x" data-clase="${kx}"><span class="im">${foto ? `<img src="${foto}" alt="" loading="lazy">` : ''}</span>
  <span class="fi-xt"><span class="fi-xk">${esc(clase)}</span>${nombre}<span class="fi-xr">${esc(o.r)}</span></span>
  <span class="fi-xb"><span class="fi-xp">${fmt(o.p)}</span>${botonAnadir(st, r, kx)}</span></div>`;
};

function renderFicha(st, c) {
  const t = T[st.lang], F = t.ficha, pg = st.page, r = ROWS[pg.n], d = FICHAS[r.t] || null;
  const el = fichaEleccion(pg, r, d, st.lang), fotos = fotosDe(r, d), vo = !d && pg.sel ? variantesDe(r) : null;
  if (vo && el.foto && fotos.includes(el.foto) && pg.fotoDe !== pg.sel.join()) { pg.foto = fotos.indexOf(el.foto); pg.fotoDe = pg.sel.join(); }
  const foto = fotos[pg.foto] || fotos[0];
  // (sin stock no se puede añadir nada a la bolsa: ni él ni, con él, lo de «Protégelo» o los extras de menos de 100 €)
  const agotada = fichaSinStock(pg, r);
  // (en las sugerencias también va delante lo que se puede pedir: Sergio, 22 oct 2026, con «Más de Sony»; pages.js: conStockDelante)
  const pro = agotada ? [] : clasesDe(st, r, el.o), rel = conStockDelante(conEl(r)), ya = new Set(rel), relV = agotada ? rel.filter(x => !soloCon(x)) : rel;
  const otros = conStockDelante(ROWS.filter(x => x.n !== r.n && x.sec === r.sec && x.v === r.v && !x.tg.has('acc') && !ya.has(x) && !soloCon(x))).slice(0, 4);
  const principal = foto ? src(foto, st.isPhone ? 700 : 1100) : fotoDe(st, r, 1100);
  const vistas = fotos.length > 1 ? `<div class="fi-vistas">${fotos.map((f, i) => `<button type="button" class="fi-v${i === pg.foto ? ' on' : ''}" data-vista="${i}" aria-label="${esc(tituloDe(r, st.lang))} · ${d && d.colores ? esc(nombreColor(d, i, st.lang)) : i + 1}"><img src="${src(f, 140)}" alt=""></button>`).join('')}</div>` : '';
  const wa = corto => `<a class="btn wa fi-wa" href="#"><svg><use href="#jm-wa"/></svg>${agotada ? (corto ? F.preguntarCorto : F.preguntar) : (corto ? F.waCorto : F.wa)}</a>`;
  const kinds = new Set(pro.map(c => c.kx === 'tabletcase' ? 'phonecase' : c.kx));
  c.innerHTML = `
    <div class="cbar"><button class="back" type="button">${fichaVolver(t, pg.prev)}</button><span class="sp"></span></div>
    <div class="ficha">
      <div class="fi-media">
        <div class="fi-escena">${principal ? `<img class="fi-foto" src="${principal}" alt="${esc(tituloDe(r, st.lang))}">` : ''}</div>
        ${vistas}
      </div>
      <div class="fi-compra">
        <p class="crumb">${t.shop} · ${t.z[r.sec]}</p>
        <p class="fi-marca">${esc(r.v)}</p>
        <h1 class="h1 fi-t">${esc(tituloDe(r, st.lang))}</h1>
        ${agotada ? `<p class="fi-precio fi-agotado">${F.sinStock}</p>` : `<p class="fi-precio">${fmt(el.p)}</p><p class="fi-igi">${F.igi}</p>`}
        ${nucleosDe(r.t) ? `<p class="fi-chip">${esc(F.chip(nucleosDe(r.t).chip, nucleosDe(r.t).c, nucleosDe(r.t).g))}</p>` : ''}
        ${vo ? htmlOpciones(st, vo, pg) : ''}
        ${d && d.capacidad ? `<div class="fi-op"><p class="fi-ol">${F.cap}</p><div class="fi-seg">${d.capacidad.map(([v], i) => `<button type="button" class="fi-cap${i === pg.cap ? ' on' : ''}" data-cap="${i}">${esc(v)}</button>`).join('')}</div></div>` : ''}
        ${d && d.colores ? `<div class="fi-op"><p class="fi-ol">${F.color}: <b class="fi-coln">${esc(nombreColor(d, pg.col, st.lang))}</b></p><div class="fi-cols">${d.colores.map(([, hex], i) => `<button type="button" class="fi-col${i === pg.col ? ' on' : ''}" data-col="${i}" style="--c:${/^#[0-9a-f]{6}$/i.test(hex) ? hex : '#cccccc'}" aria-label="${esc(nombreColor(d, i, st.lang))}" title="${esc(nombreColor(d, i, st.lang))}"></button>`).join('')}</div></div>` : ''}
        <div class="fi-acc">${wa(false)}${agotada ? '' : `<button type="button" class="fi-bolsa" data-add="${r.n}">${t.cart.add}</button>`}</div>
        <p class="fi-ven">${F.envio}</p>
        <p class="fi-ven">${F.garantia}</p>
        <p class="fi-ven fi-entienda">${F.enTienda} <button type="button" class="fi-tienda">${F.tienda}</button></p>
      </div>
    </div>
    ${d && d.intro ? `<section class="fi-sec"><h2>${F.saber}</h2><p class="fi-intro">${esc(enIdioma(d, st.lang).intro || d.intro)}</p>${(enIdioma(d, st.lang).puntos || d.puntos || []).length ? `<ul class="fi-puntos">${(enIdioma(d, st.lang).puntos || d.puntos).map(p => `<li>${esc(p)}</li>`).join('')}</ul>` : ''}</section>` : descSec(st, r)}
    ${pro.length ? `<section class="fi-sec fi-protege"><h2>${F.protege}</h2><p class="fi-lead">${F.lead(esc(tituloDe(r, st.lang)), kinds.has('protector'), kinds.has('phonecase') || kinds.has('watchcase'), pantallaDe(r), ART_UNA.has(claseDe(r)) ? F.una : F.un)}</p><div class="fi-xs">${pro.map(c => extra(st, r, c, pg.opc[c.kx] || 0)).join('')}</div></section>` : ''}
    ${relV.length ? `<section class="fi-sec"><h2>${pro.length ? F.completa : F.tambien}</h2><div class="cgrid fi-rel">${relV.map(x => soloCon(x) ? extraSuelto(st, r, x) : card(st, x)).join('')}</div></section>` : ''}
    ${otros.length ? `<section class="fi-sec"><h2>${F.otros(esc(r.v))}</h2><div class="cgrid fi-rel">${otros.map(x => card(st, x)).join('')}</div></section>` : ''}
    <div class="fi-pie"></div>
    <div class="fi-barra"><p class="fb-p"><b${agotada ? ' class="agot"' : ''}>${agotada ? F.sinStockCorto : fmt(el.p)}</b><small>${esc(el.o)}</small></p>${wa(true)}</div>`;
  c.scrollTop = 0;
  // la barra del móvil: sale cuando los botones de comprar no se ven
  if (st.isPhone && 'IntersectionObserver' in window) {
    const barra = c.querySelector('.fi-barra');
    // (lo que queda debajo de la barra de arriba, que se queda fija, ya no se ve)
    st.fichaIO = new IntersectionObserver(([en]) => barra.classList.toggle('on', !en.isIntersecting), {root: c, rootMargin: `-${c.querySelector('.cbar').offsetHeight}px 0px 0px 0px`});
    st.fichaIO.observe(c.querySelector('.fi-acc'));
  }
}
// una de las fotos (y, si son una por color, ese color)
function fichaVista(st, i) {
  const c = st.root.querySelector('.coll'), pg = st.page, r = ROWS[pg.n], d = FICHAS[r.t] || null, fotos = fotosDe(r, d);
  if (!fotos[i]) return;
  pg.foto = i;
  const im = c.querySelector('.fi-foto');
  if (im) im.src = src(fotos[i], st.isPhone ? 700 : 1100);
  c.querySelectorAll('.fi-v').forEach(b => b.classList.toggle('on', +b.dataset.vista === i));
}
// el color elegido: su muestra, su nombre y su foto
function fichaColor(st, i) {
  const c = st.root.querySelector('.coll'), pg = st.page, r = ROWS[pg.n], d = FICHAS[r.t] || null;
  if (!d || !d.colores || !d.colores[i]) return;
  pg.col = i;
  pg.colTocado = true;
  c.querySelectorAll('.fi-col').forEach(b => b.classList.toggle('on', +b.dataset.col === i));
  c.querySelector('.fi-coln').textContent = nombreColor(d, i, st.lang);
  fichaPrecio(st);
  fichaVista(st, i);
}
// elegir el valor j de la opción i (productos con variantes de Shopify): se salta a la variante que lo lleva y más se parece a lo
// elegido, y la ficha se repinta donde estaba, con el QR si estaba abierto
function elegirOpcion(st, i, j) {
  const pg = st.page, r = ROWS[pg.n], vo = variantesDe(r), c = st.root.querySelector('.coll');
  if (!vo || !pg.sel || !vo.o[i] || !(j >= 0 && j < vo.o[i][1].length)) return;
  pg.sel = elegirValor(vo, pg.sel, i, j);
  pg.tocadas = vo.o.map((_, k) => k === i || !!pg.tocadas[k]);
  repintarFicha(st);
}
// la ficha otra vez, donde estaba y con el QR si estaba abierto
function repintarFicha(st) {
  const c = st.root.querySelector('.coll'), y = c.scrollTop, qr = !!c.querySelector('.fi-compra .qr-wa');
  dejarFicha(st);
  renderFicha(st, c);
  c.scrollTop = y;
  if (qr) fichaQr(st, true);
}
// el precio y lo elegido, donde salen (arriba y en la barra del móvil)
function fichaPrecio(st) {
  const c = st.root.querySelector('.coll'), pg = st.page, r = ROWS[pg.n], el = fichaEleccion(pg, r, FICHAS[r.t] || null, st.lang);
  if (fichaSinStock(pg, r)) return repintarFicha(st);
  c.querySelector('.fi-precio').textContent = fmt(el.p);
  c.querySelector('.fb-p b').textContent = fmt(el.p);
  c.querySelector('.fb-p small').textContent = el.o;
  fichaQr(st, false);
}
// los botones de la venta cruzada, al día con la bolsa
function fichaBotones(st) {
  const F = T[st.lang].ficha, r = ROWS[st.page.n];
  st.root.querySelectorAll('.coll .fi-anadir').forEach(b => {
    const ya = conEnLaBolsa(st, r, b.dataset.anadir);
    b.classList.toggle('ya', ya);
    b.textContent = ya ? F.yaEnBolsa : F.anadir;
    if (ya) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
  });
}
// los clics de la ficha (antes que los de las demás páginas)
function onFicha(st, e) {
  const t = e.target, pg = st.page, r = ROWS[pg.n], d = FICHAS[r.t] || null;
  if (t.closest('.coll .back')) { dejarFicha(st); if (pg.prev) { st.page = pg.prev; renderPage(st, false); } else closePage(st); return true; }
  // (sin stock no se añade nada, aunque quede un botón de antes)
  if (fichaSinStock(pg, r) && t.closest('.coll [data-extra], .coll .fi-bolsa, .coll .fi-anadir')) return true;
  const ex = t.closest('.coll [data-extra]');
  if (ex) {
    const x = ROWS[+ex.dataset.extra];
    if (x && !extraEnBolsa(st, r, x)) anadirCon(st, r, {n: x.n, o: '', p: x.p}, d || pg.sel ? fichaEleccion(pg, r, d, st.lang) : null);
    st.root.querySelectorAll(`.coll [data-extra="${ex.dataset.extra}"]`).forEach(b => { b.classList.add('ya'); b.textContent = T[st.lang].ficha.yaEnBolsa; b.setAttribute('aria-disabled', 'true'); });
    return true;
  }
  const op = t.closest('.coll [data-opt]');
  if (op) { elegirOpcion(st, +op.dataset.opt, +op.dataset.val); return true; }
  const cap = t.closest('.fi-cap');
  if (cap) {
    pg.cap = +cap.dataset.cap;
    pg.capTocada = true;
    st.root.querySelectorAll('.coll .fi-cap').forEach(b => b.classList.toggle('on', b === cap));
    fichaPrecio(st);
    return true;
  }
  const col = t.closest('.fi-col');
  if (col) { fichaColor(st, +col.dataset.col); return true; }
  const vista = t.closest('.fi-v');
  if (vista) { if (d && d.colores) fichaColor(st, +vista.dataset.vista); else fichaVista(st, +vista.dataset.vista); return true; }
  // pedir por WhatsApp: en el móvil se abre WhatsApp; en el ordenador, el QR (y el enlace a WhatsApp Web)
  if (t.closest('.fi-wa')) {
    e.preventDefault();
    abrirWa(st, mensajeFicha(st), () => fichaQr(st, true));
    return true;
  }
  // a la bolsa, con lo elegido y su precio
  if (t.closest('.fi-bolsa')) { addToCart(st, r.n, d || pg.sel ? fichaEleccion(pg, r, d, st.lang) : null); return true; }
  // la venta cruzada: lo elegido en su desplegable, a la bolsa con este aparato, y el botón pasa a «En tu bolsa»
  const anadir = t.closest('.coll .fi-anadir');
  if (anadir) {
    const kx = anadir.dataset.anadir, ops = opcionesDe(st, r, kx, elegidoEnFicha(st, r, d));
    if (!anadir.classList.contains('ya') && ops.length) anadirCon(st, r, ops[pg.opc[kx] || 0] || ops[0], d || pg.sel ? fichaEleccion(pg, r, d, st.lang) : null);
    return true;
  }
  // para quien prefiere comprarlo en la tienda, dónde está el mostrador de la planta baja (Sergio, 19 oct: «que todos señalen al
  // mostrador, porque los estands no corresponden con la realidad»). Se cierra la ficha, se baja a la planta y, cuando se ve, se
  // enciende el mostrador un rato
  if (t.closest('.fi-tienda')) {
    const t0 = performance.now();
    scrollToFloor(st, floorOf('taulell'));
    if (ZONES.taulell) {
      const luz = () => { if (st.page) return; if (zoneReady(st, 'taulell')) iluminarUnRato(st, 'taulell', 3200); else if (performance.now() - t0 < 3000) requestAnimationFrame(luz); };
      setTimeout(() => requestAnimationFrame(luz), reduce ? 0 : 700);
    }
    return true;
  }
  return false;
}
// otra opción en un desplegable de «Protégelo»: su foto, su porqué y su precio (el botón añade la elegida)
function onFichaCambio(st, e) {
  const sel = e.target.closest && e.target.closest('.coll .fi-sel');
  if (!sel || !st.page || st.page.kind !== 'ficha') return false;
  const pg = st.page, r = ROWS[pg.n], kx = sel.dataset.opc, ops = opcionesDe(st, r, kx, elegidoEnFicha(st, r, FICHAS[r.t] || null)), o = ops[+sel.value];
  if (!o) return true;
  pg.opc[kx] = +sel.value;
  const card = sel.closest('.fi-x'), foto = fotoDe(st, ROWS[o.n], 200);
  let img = card.querySelector('.im img');
  if (foto) {
    if (!img) { img = document.createElement('img'); img.alt = ''; card.querySelector('.im').append(img); }
    img.src = foto;
  } else if (img) img.remove();
  card.querySelector('.fi-xr').textContent = o.r;
  card.querySelector('.fi-xp').textContent = fmt(o.p);
  return true;
}

/* ===== rutas.js ===== */
/* ---------- la web de verdad: cada página con su dirección, el botón de atrás y la bolsa que se recuerda ----------
   Solo en el tema (REAL, entorno.js); en el simulador no hace nada. Los productos van en su dirección de Shopify (/products/<handle>,
   la que ya conoce Google) y lo demás (secciones, marcas, la búsqueda, quiénes somos…) en la portada, detrás de #: #/seccion/mobils,
   #/marca/Apple, #/buscar/iphone. Cada página que se abre deja su paso en el historial: el botón de atrás del navegador (y el gesto
   del móvil) vuelve a la anterior en vez de salir de la web. Al entrar, se abre lo que pide la dirección: la ficha del producto, la
   sección de una colección de la web de antes, la búsqueda o la bolsa */

// la raíz del idioma que se ve: '' (el principal) o '/ca'. Cambia con el idioma, sin recargar
let raizActual = REAL ? REAL.raiz : '';
// las dos que son políticas de Shopify (/policies/…); las demás, páginas (/pages/…)
const POLITICAS_LEGALES = {privacidad: 'privacy-policy', condiciones: 'terms-of-service'};
const urlLegal = h => POLITICAS_LEGALES[h] ? `${raizActual}/policies/${POLITICAS_LEGALES[h]}` : `${raizActual}/pages/${h}`;
const hrefFicha = r => REAL && r.h ? `${raizActual}/products/${r.h}` : '#';
// el precio de ahora: la web lleva los precios de cuando se exportó (tema/exportar*.py) y, al abrir una ficha, le pregunta a Shopify los
// de ahora (/products/<handle>.js). Si alguno ha cambiado (el sync de Eurowin, un cambio a mano), la ficha enseña el nuevo (Sergio,
// 21 oct: «móntamelo»). Las variantes se cruzan por su id y no por el nombre, que Shopify da traducido en cada idioma. Una vez por
// producto y visita; si Shopify no contesta, se queda el de la exportación
const enVivo = new Map();
function preciosEnVivo(r) {
  if (!REAL || !r || !r.h || typeof fetch !== 'function') return Promise.resolve(false);
  const clave = raizActual + '|' + r.h;
  if (!enVivo.has(clave)) {
    enVivo.set(clave, fetch(`${raizActual}/products/${encodeURIComponent(r.h)}.js`, {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(x => x.ok ? x.json() : null).then(p => p ? aplicarEnVivo(r, p) : false).catch(() => false));
  }
  return enVivo.get(clave);
}
// pone en los datos de la web los precios de Shopify (en céntimos) y dice si ha cambiado alguno
function aplicarEnVivo(r, p) {
  // su descripción (la de Shopify, en el idioma de la dirección): la ficha la enseña en «Lo que tienes que saber» (ficha.js: descSec)
  if (typeof p.description === 'string' && p.description.trim()) {
    const lengua = Object.keys(REAL.idiomas || {}).find(l => REAL.idiomas[l] === raizActual) || REAL.idioma || 'es';
    r.descs = Object.assign({}, r.descs, {[lengua]: p.description});
  }
  const vs = Array.isArray(p.variants) ? p.variants.filter(v => v && +v.price > 0) : [];
  if (!vs.length) return false;
  const euros = c => Math.round(+c) / 100;
  let cambia = false;
  const poner = (obj, k, valor) => { if (valor > 0 && Math.abs((+obj[k] || 0) - valor) >= 0.005) { obj[k] = valor; cambia = true; } };
  const porId = new Map(vs.map(v => [String(v.id), euros(v.price)]));
  // y si se puede pedir (Shopify: «available»; ficha.js: fichaSinStock): 0 sin stock, 1 sí
  const disp = new Map(vs.map(v => [String(v.id), v.available === false ? 0 : 1]));
  const vo = variantesDe(r);
  if (vo) vo.v.forEach(v => {
    if (v[3] != null && porId.has(String(v[3]))) poner(v, 1, porId.get(String(v[3])));
    if (v[3] != null && disp.has(String(v[3])) && (v[4] === 0 ? 0 : 1) !== disp.get(String(v[3]))) { v[4] = disp.get(String(v[3])); cambia = true; }
  });
  if (!vo && !FICHAS[r.t] && vs.length === 1 && (r.a === 0 ? 0 : 1) !== disp.get(String(vs[0].id))) {
    if (disp.get(String(vs[0].id))) delete r.a; else r.a = 0;
    cambia = true;
  }
  // sin variantes que elegir, el precio del producto (con variantes, el de la tarjeta sigue la regla de los 100 €: datos-tienda.cjs)
  if (!vo && !(FICHAS[r.t] && FICHAS[r.t].capacidad) && vs.length === 1) poner(r, 'p', euros(vs[0].price));
  // las fichas completas (la del iPhone 17 Pro): el de cada capacidad, si todas sus variantes lo tienen igual
  const d = FICHAS[r.t], norm = s => String(s == null ? '' : s).replace(/\s+/g, '').toLowerCase();
  if (d && d.capacidad) d.capacidad.forEach(cap => {
    const ps = [...new Set(vs.filter(v => [v.option1, v.option2, v.option3].some(o => norm(o) === norm(cap[0]))).map(v => euros(v.price)))];
    if (ps.length === 1) poner(cap, 1, ps[0]);
  });
  return cambia;
}

// las colecciones de la web de antes (las que conoce Google) en la nueva: su sección, su lista o su marca
const COLECCIONES = {
  smartphones: 'sec:mobils', 'smartphones-galaxy': 'sec:mobils:samsung', 'smartphones-xiaomi': 'sec:mobils:xiaomi', 'smartphones-xiaomi-1': 'sec:mobils:xiaomi', iphone: 'sec:mobils:apple',
  tablets: 'sec:tabrel', ipad: 'sec:tabrel:apple', 'galaxy-tab': 'sec:tabrel:samsung', 'xiaomi-pad': 'sec:tabrel:xiaomi', 'xiaomi-pad-1': 'sec:tabrel:xiaomi',
  smartwatches: 'sec:tabrel', 'apple-watch': 'sec:tabrel:apple', 'galaxy-watch': 'sec:tabrel:samsung', 'xiaomi-watch': 'sec:tabrel:xiaomi', 'xiaomi-watch-1': 'sec:tabrel:xiaomi',
  televisores: 'sec:tv', 'todos-los-televisores': 'sec:tv', 'tv-y-casa': 'sec:tv',
  audio: 'sec:so', 'audio-1': 'sec:so', auriculares: 'sec:so', 'auriculares-in-ear': 'sec:so', altavoces: 'sec:so', airpods: 'sec:so:apple', 'airpods-1': 'sec:so:apple',
  'galaxy-buds': 'sec:so:samsung', 'xiaomi-buds': 'sec:so:xiaomi', 'xiaomi-buds-1': 'sec:so:xiaomi', 'bose-altavoces': 'sec:so:bose', 'bose-in-ear': 'sec:so:bose', 'bose-over-ear': 'sec:so:bose',
  'jbl-altavoces': 'sec:so:jbl', 'jbl-auriculares': 'sec:so:jbl',
  consolas: 'sec:consoles', playstation: 'sec:consoles', 'accesorios-playstation': 'sec:consoles', 'accesorios-nintendo': 'sec:consoles',
  drones: 'sec:drons', 'camaras-de-accion': 'sec:drons', estabilizadores: 'sec:drons', 'dji-power-bank': 'sec:llar', 'dji-power-stations': 'sec:llar',
  portatiles: 'sec:port', 'portatiles-pc': 'sec:port', informatica: 'sec:port', mac: 'list:mac', 'mac-1': 'list:mac',
  'ordenadores-de-sobremesa': 'sec:sobre', monitores: 'sec:sobre', impresoras: 'sec:impr',
  redes: 'sec:comp', software: 'sec:comp', 'tarjetas-graficas': 'sec:comp', 'accesorios-informatica': 'sec:comp',
  accesorios: 'list:acc', destacados: 'list:nov', frontpage: 'list:nov',
  apple: 'marca:Apple', samsung: 'marca:Samsung', xiaomi: 'marca:Xiaomi', bose: 'marca:Bose', jbl: 'marca:JBL', dji: 'marca:DJI', insta360: 'marca:Insta360',
  nintendo: 'marca:Nintendo', flashled: 'marca:FlashLED', 'flashled-1': 'marca:FlashLED', savefamily: 'marca:SaveFamily', 'savefamily-1': 'marca:SaveFamily'
};
function rutaColeccion(h) {
  // /collections/vendors?q=Apple: la página de una marca en Shopify
  const marca = h === 'vendors' ? new URLSearchParams(location.search).get('q') : null;
  // (solo las claves propias: una dirección como /collections/constructor no puede colarse por lo que hereda el objeto)
  // (las de una marca, «sec:mobils:apple»: la sección con esa marca elegida; las teles de una marca y DJI/Insta360, por el nombre)
  const c = marca ? 'marca:' + marca : tiene(COLECCIONES, h) ? COLECCIONES[h] : /-tv$/.test(h) ? 'sec:tv:' + h.slice(0, -3)
    : /^(dji|insta360)-/.test(h) ? 'sec:drons:' + h.split('-')[0] : '';
  if (!c) return {k: 'portada'};
  const [k, ...resto] = c.split(':');
  return k === 'sec' ? {k, id: resto[0], marcaSec: resto[1] || ''} : {k, id: resto.join(':')};
}
// lo que pide la dirección de ahora
function rutaDeUrl() {
  let camino = location.pathname;
  try { camino = decodeURIComponent(camino); } catch (e) { /* una dirección mal escrita: tal cual */ }
  if (raizActual && camino.startsWith(raizActual)) camino = camino.slice(raizActual.length) || '/';
  let m;
  if ((m = /^\/(?:collections\/[^/]+\/)?products\/([^/?#]+)/.exec(camino))) return {k: 'ficha', h: m[1]};
  if ((m = /^\/collections\/([^/?#]+)/.exec(camino))) return rutaColeccion(m[1]);
  if (/^\/search/.test(camino)) { const q = (new URLSearchParams(location.search).get('q') || '').slice(0, 120); return q ? {k: 'buscar', q} : {k: 'portada'}; }
  if (/^\/cart/.test(camino)) return {k: 'bolsa'};
  const almohadilla = location.hash.replace(/^#\/?/, '');
  if (!almohadilla) return {k: 'portada'};
  const [a, ...b] = almohadilla.split('/');
  let v = b.join('/');
  try { v = decodeURIComponent(v); } catch (e) { /* tal cual */ }
  const rutas = {seccion: {k: 'sec', id: v}, lista: {k: 'list', id: v}, marca: {k: 'marca', id: v}, marcas: {k: 'marcas'}, buscar: {k: 'buscar', q: v.slice(0, 120)},
    'quienes-somos': {k: 'about', sec: v || 'hist'}, 'servicio-tecnico': {k: 'sat'}, 'andorra-telecom': {k: 'tel'}, 'segunda-mano': {k: 'usado'},
    menu: {k: 'menu'}};
  return tiene(rutas, a) ? rutas[a] : {k: 'portada'};
}
// la dirección de lo que se ve
function urlDe(st) {
  const pg = st.page;
  if (!pg) return `${raizActual}/`;
  if (pg.kind === 'ficha') return ROWS[pg.n].h ? `${raizActual}/products/${ROWS[pg.n].h}` : null;
  const k = pg.kind === 'sec' ? 'seccion/' + pg.id : pg.kind === 'list' ? 'lista/' + pg.id : pg.kind === 'brand' ? 'marca/' + encodeURIComponent(pg.id)
    : pg.kind === 'dir' ? 'marcas' : pg.kind === 'search' ? 'buscar/' + encodeURIComponent(pg.q || '') : pg.kind === 'about' ? 'quienes-somos/' + (pg.sec || 'hist')
    : {sat: 'servicio-tecnico', tel: 'andorra-telecom', usado: 'segunda-mano', menu: 'menu'}[pg.kind];
  return k ? `${raizActual}/#/${k}` : null;
}
// el título de la pestaña, el de la página que se ve (la portada, el que trae Shopify)
const TITULO_PORTADA = typeof document !== 'undefined' ? document.title : '';
// Shopify da `shop.name` ya escapado para HTML («J&amp;M…») y en la pestaña salía tal cual (28 oct 2026): se pone su texto
const textoDeHtml = s => new DOMParser().parseFromString(s, 'text/html').documentElement.textContent;
function ponerTitulo(st) {
  const t = T[st.lang], pg = st.page;
  if (!pg) { document.title = REAL && REAL.tituloPortada ? textoDeHtml(REAL.tituloPortada) : TITULO_PORTADA; return; }
  const n = pg.kind === 'ficha' ? tituloDe(ROWS[pg.n], st.lang) : pg.kind === 'sec' || pg.kind === 'list' ? t.z[pg.id] : pg.kind === 'brand' ? pg.id
    : pg.kind === 'dir' ? t.z.marcas : pg.kind === 'search' ? pg.q : pg.kind === 'about' ? t.about.title : pg.kind === 'sat' ? t.z.sat
    : pg.kind === 'tel' ? t.tel.title : pg.kind === 'menu' ? t.menu : '';
  document.title = n ? `${n} · J&M Electronics Store Andorra` : TITULO_PORTADA;
}
// tras abrir o cerrar una página: su paso en el historial (no cuando se abre por el historial o al entrar)
function sincronizarUrl(st) {
  if (!REAL || st.enHistorial) return;
  const u = urlDe(st);
  if (!u) return;
  if (u !== location.pathname + location.search + location.hash) history.pushState(null, '', u);
  ponerTitulo(st);
}
// abrir lo que pide una dirección (al entrar o con atrás y adelante)
function irA(st, ruta) {
  st.enHistorial = true;
  try {
    if (ruta.k === 'ficha') {
      const n = ROWS.findIndex(r => r.h === ruta.h);
      if (n >= 0 && !soloCon(ROWS[n])) openFicha(st, n);
      // un protector, una funda o un cargador (de Google o de la web de antes): no tiene ficha, se vende con su aparato. Se abre la
      // sección de los aparatos con los que va (su sección en el catálogo), donde se añade desde «Protégelo»
      else if (n >= 0 && tiene(BY_SEC, ROWS[n].sec)) openSec(st, ROWS[n].sec);
      else if (ruta.titulo) openSearch(st, ruta.titulo);
      else if (st.page) closePage(st);
    } else if (ruta.k === 'sec' && tiene(BY_SEC, ruta.id)) {
      openSec(st, ruta.id);
      // una colección de una marca (/collections/iphone): la sección con esa marca y, arriba, el nombre de la colección («iPhone»), con la
      // sección en la miga (Sergio, 3 nov 2026: «que la colección de iPhone diga iPhone, y como secundaria móviles»)
      const fila = ruta.marcaSec && BY_SEC[ruta.id].find(r => norm(r.v) === norm(ruta.marcaSec));
      if (fila) { st.page.brand = fila.v; st.page.titulo = REAL && REAL.ruta && REAL.ruta.tipo === 'collection' ? REAL.ruta.titulo || '' : ''; renderPage(st); }
    }
    else if (ruta.k === 'list' && tiene(LISTS, ruta.id)) openList(st, ruta.id);
    else if (ruta.k === 'marca' && BRANDS.some(([b]) => norm(b) === norm(ruta.id))) openBrand(st, BRANDS.find(([b]) => norm(b) === norm(ruta.id))[0]);
    else if (ruta.k === 'marcas') openDir(st);
    else if (ruta.k === 'buscar' && ruta.q) openSearch(st, ruta.q);
    else if (ruta.k === 'about') openAbout(st, ['hist', 'where', 'hours'].includes(ruta.sec) ? ruta.sec : 'hist');
    else if (ruta.k === 'sat') openSat(st);
    else if (ruta.k === 'tel') openTel(st);
    else if (ruta.k === 'usado') openUsado(st);
    else if (ruta.k === 'menu') openMenu(st);
    else {
      if (st.page) closePage(st);
      if (ruta.k === 'bolsa' && st.cart.length) openCart(st);
    }
  } finally {
    st.enHistorial = false;
  }
}
// al entrar: lo de la dirección (y, si Shopify no la encuentra, el aviso y la portada)
function entrar(st) {
  const r = REAL.ruta || {}, ruta = rutaDeUrl();
  if (r.tipo === '404') { toast(st, T[st.lang].noExiste); return; }
  if (r.tipo === 'product' && ruta.k === 'ficha') ruta.titulo = r.titulo;
  if (ruta.k !== 'portada') irA(st, ruta);
}
// cambiar de idioma: la misma página con la raíz del otro idioma (sin recargar; si recarga, Shopify ya la sirve en ese idioma)
function idiomaEnUrl(l) {
  if (!REAL || !REAL.idiomas || !(l in REAL.idiomas)) return;
  const resto = location.pathname.startsWith(raizActual) ? location.pathname.slice(raizActual.length) || '/' : location.pathname;
  raizActual = REAL.idiomas[l];
  history.replaceState(null, '', (raizActual + resto).replace(/\/{2,}/g, '/') + location.search + location.hash);
  document.documentElement.lang = l;
}

// la bolsa se recuerda en este navegador (al recargar, al volver de WhatsApp, al pasar a una página legal): cada línea por su
// producto (su handle o, lo de la tienda que no está en Shopify, su nombre), no por su sitio en el catálogo, que cambia
const BOLSA = 'jm-bolsa';
const claveFila = r => r.h || r.t;
function guardarBolsa(st) {
  if (!REAL) return;
  try {
    localStorage.setItem(BOLSA, JSON.stringify(st.cart.map(l => ({id: l.id, k: claveFila(ROWS[l.n]), o: l.o, p: l.p, de: l.de, se: l.se}))));
  } catch (e) { /* sin almacenamiento: la bolsa dura lo que la página */ }
}
function leerBolsa(st) {
  if (!REAL) return;
  let guardada = [];
  try { guardada = JSON.parse(localStorage.getItem(BOLSA) || '[]'); } catch (e) { return; }
  if (!Array.isArray(guardada)) return;
  const porClave = new Map(ROWS.map(r => [claveFila(r), r.n]));
  // lo que ya no está en la web, fuera; el precio, el de ahora (si no se eligió una opción con su precio)
  const lineas = guardada.filter(l => l && porClave.has(l.k)).map(l => {
    const n = porClave.get(l.k);
    return {id: +l.id || 0, n, o: l.o || '', p: l.o ? +l.p || ROWS[n].p : ROWS[n].p, de: +l.de || 0, se: l.se || null};
  });
  const aparatos = new Set(lineas.filter(l => !l.de).map(l => l.id));
  st.cart = lineas.filter(l => !l.de || aparatos.has(l.de));
  st.lineas = Math.max(0, ...st.cart.map(l => l.id));
}

// las cookies: lo que elige el cliente en nuestro aviso, también para Shopify (sus estadísticas solo con su permiso)
function consentirShopify(v) {
  const cp = window.Shopify && window.Shopify.customerPrivacy;
  if (!REAL || !cp || !cp.setTrackingConsent) return;
  try {
    cp.setTrackingConsent({analytics: v === 'si', preferences: v === 'si', marketing: false, sale_of_data: false}, () => {});
  } catch (e) { /* sin la API de Shopify: solo lo nuestro */ }
}

/* ===== temporada.js ===== */
/* ---------- la Navidad: cuándo ----------
   Del 27 de noviembre (el día que Andorra enciende las luces de Navidad; lo decidió Sergio el 26 oct 2026) al 25 de diciembre,
   Navidad; del 26 de diciembre al 6 de enero, Reyes (el 31 y el 1, fin de año); el 7 de enero, la web de siempre, sin tocar nada.
   Va con la web todo el año: en esas fechas, app.js baja la capa de Navidad (navidad/: jm-navidad.js en el tema) y el regalo de la
   bolsa sale en rojo (regalo.js). La capa usa esta misma (window.JMTemporada) */
// probar el tema sin publicar en otra fecha (el iPhone de Sergio no deja cambiar la hora, 29 oct): con ?jm-fecha=2026-12-10 en la
// dirección hace como si fuera ese día (a la hora de ahora) hasta cerrar la pestaña, y ?jm-fecha=hoy lo quita. En la web publicada no hace nada
const hoy = (() => {
  let dif = 0;
  try {
    const publicada = window.Shopify && Shopify.theme && Shopify.theme.role === 'main';
    const q = new URLSearchParams(location.search).get('jm-fecha');
    if (!publicada) {
      if (q === 'hoy') sessionStorage.removeItem('jm-fecha');
      else if (/^\d{4}-\d{2}-\d{2}$/.test(q || '')) sessionStorage.setItem('jm-fecha', q);
      const f = sessionStorage.getItem('jm-fecha');
      if (f) { const a = new Date(), [y, m, d] = f.split('-').map(Number); dif = new Date(y, m - 1, d, a.getHours(), a.getMinutes(), a.getSeconds()) - a; }
    }
  } catch (e) {}
  return () => new Date(Date.now() + dif);
})();
function temporada(d = hoy()) {
  const m = d.getMonth() + 1, dia = d.getDate();
  // empieza el 27 de noviembre, el día que Andorra enciende las luces de Navidad (Sergio, 26 oct)
  if ((m === 11 && dia >= 27) || (m === 12 && dia <= 25)) return {fase: 'navidad', saludo: 'fiestas', plazo: m === 11 || dia <= 14 ? 'plazoNavidad' : 'plazoReyes'};
  if ((m === 12 && dia >= 26) || (m === 1 && dia <= 6)) {
    const nuevo = (m === 12 && dia === 31) || (m === 1 && dia === 1);
    // el 31 y el 1, fin de año: gorro de fiesta y confeti (fiesta: true)
    return {fase: 'reyes', saludo: nuevo ? 'anyo' : 'fiestas', fiesta: nuevo, plazo: null, anyo: m === 12 ? d.getFullYear() + 1 : d.getFullYear()};
  }
  return null;
}
window.JMTemporada = temporada;
window.JMHoy = hoy;

/* ===== regalo.js ===== */
/* La casilla «Es para regalo» de la bolsa (27 oct 2026; no está en Shopify). Sergio: «qué buena idea lo del regalo, añádelo», y
   luego «consérvalo durante todo el año, pero ahora que será Navidad pon un 3D o algo que inspire Navidad, un regalo». Va en la
   bolsa, encima del botón de pedir por WhatsApp; si está marcada, el mensaje del pedido acaba diciendo que es para regalo y pidiendo
   que lo envuelvan. Al lado lleva un regalo en 3D, sacado con el estudio de la tienda (render-regalo.cjs): sin marcar es una caja
   sin envolver y, al marcarla, da una vuelta y sale envuelta, con unas chispas. El papel, azul J&M todo el año y rojo en Navidad
   (Sergio, 29 oct: «en azul durante todo el año, en Navidad se pone en rojo»; la fecha la dice temporada.js). La bolsa (app.js) la
   pinta con casilla(), pone texto() al final del mensaje y llama a animar() al cambiar. Lo marcado se recuerda en este navegador,
   como la bolsa. */
(() => {
'use strict';
const TX = {
  // envolver es gratis (Sergio, 29 oct): la nota lo dice, para que nadie dude de si se cobra
  es: {casilla: 'Es para regalo', nota: 'Te lo envolvemos gratis.', msg: 'Es para regalo, ¿me lo envolvéis?'},
  ca: {casilla: 'És per a regal', nota: "T'ho emboliquem de franc.", msg: "És per a regal, m'ho emboliqueu?"},
  fr: {casilla: "C'est pour offrir", nota: 'Paquet cadeau offert.', msg: "C'est pour offrir, vous pouvez me faire un paquet cadeau ?"},
  en: {casilla: "It's a gift", nota: "We'll gift-wrap it for free.", msg: "It's a gift, could you gift-wrap it?"}
};
// el regalo en 3D: una tira por papel, con la vuelta de la caja sin envolver (fotos 0 a n-1) y la de la envuelta (n a 2n-1). En el
// simulador las tiras van dentro (imagenes); en el tema, en assets/ (jm-regalo-azul.webp…), y se bajan al abrir la bolsa
const REGALO3D = window.__JM_D.REGALO3D;
const R3D = typeof REGALO3D === 'object' ? REGALO3D : null;
const imagen = papel => R3D.imagenes ? R3D.imagenes[papel] : recurso('regalo', papel);
const CLAVE = 'jm-regalo';
const CSS = `
.nv-regalo{display:flex;align-items:flex-start;gap:9px;margin:2px 0 12px;cursor:pointer;font-size:13px;line-height:1.35;color:var(--ink,#1A1D21)}
.nv-regalo input{flex:none;width:17px;height:17px;margin:1px 0 0;accent-color:var(--ink,#1A1D21);cursor:pointer}
.nv-regalo b{display:block;font-weight:600}
.nv-regalo small{display:block;font-size:12px;color:var(--muted,#6B6F76)}
.phone .nv-regalo{font-size:14.5px}
.phone .nv-regalo small{font-size:13px}
.phone .nv-regalo input{width:19px;height:19px}
.nv-regalo.nv-3d{align-items:center;margin-top:0}
.nv-regalo-3d{--s:46px;position:relative;flex:none;width:var(--s);height:var(--s);margin:-6px 2px -6px auto}
.phone .nv-regalo-3d{--s:50px}
.nv-regalo-3d::before{content:'';position:absolute;left:16%;right:16%;bottom:9%;height:14%;border-radius:50%;background:radial-gradient(closest-side,rgba(29,42,92,.2),transparent)}
.nv-regalo-3d i{position:absolute;inset:0;background-repeat:no-repeat;background-size:calc(var(--s) * var(--n)) var(--s);background-position:calc(var(--f) * var(--s) * -1) 0}
.nv-chispa{position:absolute;left:50%;top:42%;width:7px;height:7px;margin:-3.5px;background:#E8B33C;clip-path:polygon(50% 0,62% 38%,100% 50%,62% 62%,50% 100%,38% 62%,0 50%,38% 38%);pointer-events:none;animation:nv-chispa .62s ease-out forwards}
@keyframes nv-chispa{0%{transform:translate(0,0) scale(.3);opacity:0}25%{opacity:1}100%{transform:translate(var(--x),var(--y)) scale(1) rotate(90deg);opacity:0}}
`;
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
const L = lang => TX[lang] || TX.es;
const reduce = () => typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
let activo = false, papel = 'azul', marcado = false;
try { marcado = localStorage.getItem(CLAVE) === '1'; } catch (e) { /* sin almacenamiento: empieza sin marcar */ }

// si: la casilla en la bolsa; enNavidad: el regalo, con el papel rojo (si no, el azul)
function activar(si, enNavidad = false) {
  activo = !!si; papel = enNavidad ? 'rojo' : 'azul';
  if (!activo) return;
  if (!document.getElementById('nv-regalo-css')) {
    const s = document.createElement('style'); s.id = 'nv-regalo-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }
  // (la tira, en una regla aparte: cambia con el papel; la imagen no se baja hasta que se pinta la bolsa)
  let t = document.getElementById('nv-regalo-tira');
  if (R3D && !t) { t = document.createElement('style'); t.id = 'nv-regalo-tira'; document.head.appendChild(t); }
  if (t) { const css = `.nv-regalo-3d i{background-image:url(${imagen(papel)});--n:${R3D.fotos * 2}}`; if (t.textContent !== css) t.textContent = css; }
}
// (guardar: false para las pruebas de la página de propuestas, que no toquen lo que recuerda la bolsa)
function marcar(si, guardar = true) {
  marcado = !!si;
  if (guardar) try { localStorage.setItem(CLAVE, marcado ? '1' : '0'); } catch (e) { /* solo se pierde al recargar */ }
}
// la casilla, para la bolsa ('' si está apagada), con el regalo quieto en su primera foto (sin envolver o envuelto)
function casilla(lang) {
  if (!activo) return '';
  const tx = L(lang), regalo = R3D ? `<span class="nv-regalo-3d" aria-hidden="true"><i style="--f:${marcado ? R3D.fotos : 0}"></i></span>` : '';
  return `<label class="nv-regalo${R3D ? ' nv-3d' : ''}"><input type="checkbox"${marcado ? ' checked' : ''}><span><b>${esc(tx.casilla)}</b><small>${esc(tx.nota)}</small></span>${regalo}</label>`;
}
// lo que se añade al final del mensaje del pedido ('' si no toca)
const texto = lang => activo && marcado ? L(lang).msg : '';
// al cambiar la casilla (ya repintada): la caja da una vuelta y, a mitad, se envuelve (o se desenvuelve); al envolverse, chispas
function animar(raiz) {
  const el = R3D && raiz && raiz.querySelector('.nv-regalo-3d'), i = el && el.querySelector('i');
  if (!i || reduce()) return;
  const n = R3D.fotos, desde = marcado ? 0 : n, hasta = marcado ? n : 0, T = 700, t0 = performance.now();
  // media vuelta con la de antes y la otra media con la de ahora, arrancando y frenando suave (el cambio, a mitad, cuando va más
  // deprisa); acaba en la primera foto de la de ahora
  const paso = ahora => {
    const u = Math.min(1, (ahora - t0) / T), e = u * u * (3 - 2 * u), k = Math.min(n, Math.floor(e * (n + 1)));
    i.style.setProperty('--f', k >= n ? hasta : (k < n / 2 ? desde : hasta) + k);
    i.style.transform = `translateY(${(-Math.sin(u * Math.PI) * 5).toFixed(1)}px)`;
    if (u < 1) requestAnimationFrame(paso); else i.style.transform = '';
  };
  requestAnimationFrame(paso);
  if (marcado) setTimeout(() => {
    for (let k = 0; k < 7; k++) {
      const a = -Math.PI / 2 + (k - 3) * 0.5, r = 20 + (k % 3) * 5, c = document.createElement('span');
      c.className = 'nv-chispa'; c.style.setProperty('--x', (Math.cos(a) * r).toFixed(1) + 'px'); c.style.setProperty('--y', (Math.sin(a) * r).toFixed(1) + 'px');
      c.style.animationDelay = (k % 3) * 40 + 'ms'; el.appendChild(c); setTimeout(() => c.remove(), 800);
    }
  }, T * 0.5);
}

window.JMRegalo = {activar, marcar, casilla, texto, animar, TX, get activo() { return activo; }, get papel() { return papel; }, get marcado() { return marcado; }};
})();

/* ===== app.js ===== */
/* ---------- datos y utilidades ---------- */
const IMG = 'https://cdn.shopify.com/s/files/1/0942/5839/7450/files/';
const norm = s => String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
const ROWS = CAT.rows.map((r, n) => {
  const tg = new Set(r[5].split(' ').filter(Boolean)); let inch = 0;
  tg.forEach(x => { if (x.startsWith('in:')) inch = +x.slice(3); });
  // si en su foto no sale el producto, sin foto (va su dibujo en 3D)
  // (a: 0 si está sin stock y no tiene variantes que elegir; ficha.js: fichaSinStock)
  return {n, t:r[0], v:r[1], p:r[2], i:FOTOS[r[3]] && !FOTOS[r[3]][0] ? '' : r[3], sec:r[4], tg, in:inch, h:r[6] || '', op:r[7] || '', ...(r[8] === 0 ? {a: 0} : {})};
});
// lo que se vende solo: todo menos lo que solo va con su aparato (los protectores, las fundas y los cargadores, ficha.js), que no
// sale en las listas, en la búsqueda ni en las marcas
const VENTA = ROWS.filter(r => !soloCon(r));
const BY_SEC = {};
VENTA.forEach(r => (BY_SEC[r.sec] = BY_SEC[r.sec] || []).push(r));
const rowsIn = secs => secs.flatMap(s => BY_SEC[s] || []);
const BRANDS = CAT.brands.map(([b]) => [b, VENTA.filter(r => r.v === b).length]).filter(([, n]) => n);
// (lo que se puede pedir, delante: Sergio, 22 oct 2026, «que predominen los productos con stock»)
const NEWS = (l => [...l.filter(r => !productoSinStock(r)), ...l.filter(r => productoSinStock(r))])(CAT.news.map(n => ROWS[n]).filter(r => !soloCon(r)));
const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const fmtN = n => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
const fmt = v => { const [i, d] = v.toFixed(2).split('.'); return fmtN(i) + ',' + d + ' €'; };
// la foto: la nueva, sin fondo (la grande para la ficha, la pequeña para lo demás) o, si no la hay, la de Shopify a ese ancho.
// Nunca se recorta: siempre entera dentro de su hueco
const src = (i, w) => { const f = FOTOS[i]; return f && f[0] ? recurso(w > 600 ? 'fotos/g' : 'fotos/p', f[0]) : IMG + i + (i.includes('?') ? '&' : '?') + 'width=' + w; };
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const lc1 = s => s.charAt(0).toLowerCase() + s.slice(1);
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
// las nuevas del editor no van en el menú: solo en la tienda (los escaparates, los accesorios, el rincón del Mac y el servicio técnico)
const EXTRA = {pb: ['nov', 'apple', 'acc'], b1: ['mac', 'sat']};
// cada una tarda 0,1 en caer: todas tienen que haber caído antes de que la planta se dé por montada (0,39 y 0,78)
const dropList = (secs, f, mostrador, t0, fin) => [...secs, ...EXTRA[f], mostrador].filter(id => ZONES[id]).map((id, i, a) => [id, t0 + i * Math.min(0.03, (fin - 0.1 - t0) / Math.max(1, a.length - 1))]);
const DROPS = dropList(PB_SECS, 'pb', 'taulell', 0.08, 0.385).concat(dropList(B1_SECS, 'b1', 'taulell1', 0.53, 0.775));
const insts = [];

// el aviso para quien abre la consola para ver cómo está hecha la web (Sergio, 19 oct: «por si alguien quiere robarnos la idea de la
// web 3D»): de quién es y, si quiere algo parecido, con quién hablar
console.info('%cJ&M Electronics Andorra%c\n© 2026 J&M Electronics Andorra. La tienda en 3D, sus modelos, las imágenes y el diseño de esta web son exclusivos de J&M: no se pueden copiar ni usar sin permiso. ¿Quieres algo parecido? Habla con J&M o con SerVe Digital, que ha diseñado la web.\nContingut exclusiu de J&M: no es pot copiar ni fer servir sense permís. Vols alguna cosa semblant? Parla amb J&M o amb SerVe Digital.', 'font:700 15px "Helvetica Neue",Arial,sans-serif;color:#1d2a5c', 'font:400 12px/1.5 "Helvetica Neue",Arial,sans-serif;color:#3d4250');

/* ---------- montaje ---------- */
function mount(root) {
  const st = {root, heroKind:root.dataset.hero || 'cara', cart:[], lineas:0, bolsaOpc:{}, isPhone:root.dataset.inst === 'phone', lang:REAL && T[REAL.idioma] ? REAL.idioma : 'es', p:0, hover:null, page:null, navF:'pb', userF:'pb', landed:{}, k2:0,
    as:{flow:null, answers:[], info:null, q:'', week:false, bye:false, otra:''}};
  root.innerHTML = `
    <div class="scroller">
      <div class="fijo arriba">${(root.dataset.hero || 'cara') === 'cara' ? `<div class="hface g-${root.dataset.greet || 'comic'}" role="button" aria-label="J&amp;M"><span class="hbub-w"><span class="hbub"><span class="dots"><i></i><i></i><i></i></span><span class="tx"></span></span></span>${faceSVG('roomy', true)}</div>` : ''}</div>
      <header class="hd"></header>
      <section class="hero"></section>
      ${st.isPhone ? '<div class="ptabs"></div>' : ''}
      <section class="store-wrap"><div class="store-sticky"><p class="store-cap"></p><div class="planbox"><svg class="iso" preserveAspectRatio="xMidYMid meet"></svg><div class="lbls"></div></div></div></section>
      <section class="news"></section>
      <footer class="ft"></footer>
      <div class="fijo abajo"><button class="fab" type="button" aria-label="Asistente">${faceSVG()}</button></div>
    </div>
    <div class="hsdrop"></div>
    <div class="cartdrop"></div>
    <div class="coll"></div>
    <div class="assist" role="dialog" aria-label="J&amp;M"></div>
    <div class="toast" role="status"></div>`;
  const q = s => root.querySelector(s);
  Object.assign(st, {sc:q('.scroller'), hd:q('.hd'), hero:q('.hero'), tabs:q('.ptabs'), wrap:q('.store-wrap'), sticky:q('.store-sticky'), box:q('.planbox'), svg:q('svg.iso'), lbls:q('.lbls'), cap:q('.store-cap'), hsdrop:q('.hsdrop'), cartdrop:q('.cartdrop'), hface:q('.hface'), fab:q('.fab'), assist:q('.assist'), toast:q('.toast')});
  Object.assign(st, buildScene(st.svg));
  // la bolsa de J&M: lo último que cae, sobre el mostrador de la planta baja
  st.bagG = el('g', {class:'zg'});
  const [bx, by, bz] = bagAt();
  put(st.bagG, 'bag', 1, bx - 0.15, by - 0.07, bz, 0.3);
  st.F.pb.items.appendChild(st.bagG);
  st.F.hits.querySelectorAll('[data-z^="taulell"]').forEach(h => h.setAttribute('data-asst', ''));
  st.hit = {};
  st.F.hits.querySelectorAll('.hit').forEach(h => { st.hit[h.dataset.z] = h; });
  st.lab = {}; st.flab = {}; st.lead = {};
  // las rayas de las etiquetas que salen a un lado (las de la −1, en la vista de las dos plantas), debajo de las etiquetas
  const rayas = el('svg', {class:'leaders', 'aria-hidden':'true'}, st.lbls);
  ZONE_IDS.forEach(id => { const d = document.createElement('div'); d.className = 'lbl hide'; d.dataset.z = id; st.lbls.appendChild(d); st.lab[id] = d; });
  ZONE_IDS.filter(id => ZONES[id].f === 'b1').forEach(id => { const g = el('g', {opacity:0}, rayas); st.lead[id] = {g, line:el('line', {}, g), dot:el('circle', {r:2.4}, g)}; });
  ['pb', 'b1'].forEach(f => { const d = document.createElement('div'); d.className = 'flab hide'; st.lbls.appendChild(d); st.flab[f] = d; });
  // en la web de verdad, la bolsa de la última vez (rutas.js)
  leerBolsa(st);
  render(st);
  layout(st);
  const frame = () => { cancelAnimationFrame(st.raf); st.raf = requestAnimationFrame(() => update(st)); };
  st.sc.addEventListener('scroll', frame, {passive:true});
  new ResizeObserver(() => { layout(st); update(st); }).observe(root);
  const zoneOf = e => e.target.closest('[data-z]');
  // pasar por una zona la enciende y, al pasar a un hueco de la tienda (sin zona), se apaga. Antes seguía encendida, con todo lo demás
  // en gris, hasta sacar el cursor del dibujo entero (Sergio, 19 oct: «el 3D se queda como en gris… a menos que reinicies la web»).
  // Con un respiro, para que pasar entre dos piezas de la misma zona no la haga parpadear
  st.svg.addEventListener('pointerover', e => {
    if (st.isPhone) return;
    const z = zoneOf(e);
    clearTimeout(st.hoverOff);
    if (z && zoneReady(st, z.dataset.z)) ponerHover(st, z.dataset.z);
    else if (st.hover) st.hoverOff = setTimeout(() => soltarHover(st), 90);
  });
  st.svg.addEventListener('pointerleave', () => { clearTimeout(st.hoverOff); soltarHover(st); });
  // dónde está el ratón: al bajar con la rueda sin moverlo, lo que queda debajo cambia y Safari no avisa; se vuelve a mirar al parar
  root.addEventListener('pointermove', e => { if (e.pointerType === 'mouse') st.ptr = [e.clientX, e.clientY]; }, {passive:true});
  st.sc.addEventListener('scroll', () => { if (st.isPhone || !st.ptr || !st.hover || performance.now() < (st.hoverHasta || 0)) return; clearTimeout(st.reHit); st.reHit = setTimeout(() => miraDebajo(st), 140); }, {passive:true});
  st.svg.addEventListener('click', e => { const z = zoneOf(e); if (z && zoneReady(st, z.dataset.z)) pickZone(st, z.dataset.z); });
  root.addEventListener('pointerover', e => { if (st.isPhone) return; const z = e.target.closest('.obj, .hd nav [data-z], .lbl[data-z]'); if (z && ZONES[z.dataset.z] && zoneReady(st, z.dataset.z)) ponerHover(st, z.dataset.z); });
  root.addEventListener('pointerout', e => { const z = e.target.closest('.obj, .hd nav [data-z], .lbl[data-z]'); if (!z || (e.relatedTarget && z.contains(e.relatedTarget))) return; soltarHover(st); });
  st.fab.addEventListener('click', () => toggleAssist(st));
  // la imagen de una página, pedida antes de abrirla (pages.js: precargarDesde)
  root.addEventListener('pointerover', precargarDesde, {passive:true});
  root.addEventListener('touchstart', precargarDesde, {passive:true});
  // solo guiña mientras el cursor está encima; el resto del tiempo, los ojos abiertos
  if (st.hface) { st.hface.addEventListener('click', () => faceToAssist(st)); st.hface.addEventListener('pointerenter', e => { if (pointerMoved || e.pointerType !== 'mouse') startWink(st); }); st.hface.addEventListener('pointerleave', () => endWink(st)); greetIntro(st); }
  st.fab.addEventListener('pointerenter', () => st.fab.querySelector('.face').classList.add('winking'));
  st.fab.addEventListener('pointerleave', () => st.fab.querySelector('.face').classList.remove('winking'));
  st.assist.addEventListener('click', e => onAssistClick(st, e));
  root.addEventListener('click', e => { if (!st.assist.contains(e.target)) onClick(st, e); });
  root.addEventListener('change', e => { if (!onFichaCambio(st, e) && !onBolsaCambio(st, e)) onPageChange(st, e); });
  update(st);
  insts.push(st);
  cookiesAlEntrar(st);
  if (root.dataset.tienda3d && TIENDA.d3) programar3D(st);
  // en la web de verdad: lo que pide la dirección (un producto, una colección…) y Escape cierra la ventanita del QR
  // (cuando el código ya está entero: mount corre a media carga y lo que se define después aún no existe, como bloques de la bolsa)
  if (REAL) {
    queueMicrotask(() => entrar(st));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrarQrSuelto(st); });
  }
}
const zoneReady = (st, id) => !!ZONES[id] && !!st.landed[id];

/* ---------- la tienda en 3D: se monta en el navegador, en un lienzo debajo del dibujo de las zonas ----------
   El código va en la página como texto (#jm-tienda3d) y no se lee hasta que la página ya está pintada y libre. Se monta por niveles:
   primero la básica (los muebles como en el editor, enseguida) y, si el aparato puede, la rica encima (ver niveles.js). Mientras se
   monta la básica, la tienda se ve vacía con un aviso; cuando está, toma el estado de la web (lo que ya ha caído, el encuadre...) */
// el paquete de la tienda en 3D (three, la tienda y el estudio de los expositores), cargado una sola vez para todo
// (en el tema, el paquete va en sus archivos de assets/, partido en trozos que se juntan aquí: REAL.tienda3d)
const hay3D = () => !!(document.getElementById('jm-tienda3d') || (REAL && REAL.tienda3d && REAL.tienda3d.length));
function modulo3D() {
  if (window.__jmTienda3d) return window.__jmTienda3d;
  const fuente = document.getElementById('jm-tienda3d');
  // (el CDN de Shopify intenta comprimir cada .js y, si no puede, le pone delante «/** Shopify CDN: Minification failed… **/»: en
  // un trozo del medio, ese comentario partiría el código en dos; se quita antes de juntarlos)
  const sinAviso = t => t.replace(/^\/\*\* Shopify CDN:[\s\S]*?\*\*\/\s*/, '');
  const texto = fuente ? Promise.resolve(fuente.textContent) : REAL && REAL.tienda3d ? Promise.all(REAL.tienda3d.map(u => fetch(u).then(r => { if (!r.ok) throw new Error('3D ' + r.status); return r.text(); }))).then(ts => ts.map(sinAviso).join('')) : null;
  if (!texto) return null;
  window.__jmTienda3d = texto.then(t => import(URL.createObjectURL(new Blob([t], {type: 'text/javascript'}))));
  return window.__jmTienda3d;
}
function programar3D(st) {
  if (!hay3D()) return;
  // el paquete se empieza a bajar ya (antes, cuando la página quedaba libre): mientras tanto se pinta lo demás. Montarlo sí espera
  const yaBajando = modulo3D();
  if (yaBajando) yaBajando.catch(() => {});
  const lienzo = document.createElement('canvas');
  lienzo.className = 'iso3d';
  st.box.insertBefore(lienzo, st.svg);
  st.box.classList.add('t3d');
  const empezar = async () => {
    const t0 = performance.now();
    try {
      const {crearTiendaPorNiveles} = await modulo3D();
      const fondo = getComputedStyle(st.root).getPropertyValue('--paper').trim() || '#f7f5f0', d3 = TIENDA.d3;
      const enMundo = f => ({pid: FLOORS[f].pid, x: FLOORS[f].x, y: FLOORS[f].y, z: FLOORS[f].z});
      // el nivel que se ve (básica o rica), por qué y lo que ha tardado cada una, para las pruebas
      const alCambiar = n => { st.t3dNivel = n; st.box.dataset.nivel = n.detalle; };
      st.t3d = await crearTiendaPorNiveles({canvas: lienzo, diseno: d3.diseno, plantas: {pb: enMundo('pb'), b1: enMundo('b1')}, zonas: ZONES, grupos: d3.grupos, taller: d3.taller, fondo, movil: st.isPhone}, alCambiar);
      st.t3dMs = Math.round(performance.now() - t0);
      st.box.classList.add('listo');
      // con la tienda ya montada, en el ordenador (y sin «ahorro de datos»): las imágenes de las secciones, sin prisa
      if (!st.isPhone && !(navigator.connection && navigator.connection.saveData)) setTimeout(precargarSecciones, 1500);
      ['pb', 'b1'].forEach(f => { st.F[f].animKey = null; });
      update(st);
      if (st.hover) { const h = st.hover; st.hover = null; setHover(st, h); }
    } catch (e) {
      console.error('la tienda en 3D no se ha podido montar', e);
      lienzo.remove(); st.box.classList.remove('t3d'); st.box.classList.add('sin3d');
    }
  };
  (window.requestIdleCallback || (f => setTimeout(f, 200)))(() => empezar(), {timeout: 900});
}

function layout(st) {
  const hh = st.hd.offsetHeight, th = st.tabs ? st.tabs.offsetHeight : 0, vh = st.sc.clientHeight, stage = vh - hh - th;
  if (st.tabs) st.tabs.style.top = hh + 'px';
  st.sticky.style.top = (hh + th) + 'px';
  st.sticky.style.height = stage + 'px';
  // lo que hay que bajar para que se monte la tienda: 1,6 pantallas (la del simulador). En la web de verdad, como mucho lo de una pantalla
  // de portátil: en una alta no hace falta bajar más (Sergio, 21 oct: «tienes que hacer más scroll que en el simulador»). En Navidad,
  // como ya no se monta, la tienda ocupa una pantalla
  st.wrap.style.height = Math.round(stage + (window.JMTiendaQuieta ? 0 : 1.6) * (REAL ? Math.min(stage, 760) : stage)) + 'px';
  st.root.querySelector('.coll').style.top = hh + 'px';
  st.stickyTop = hh + th;
  st.hero.style.minHeight = (vh - hh) + 'px';
  cams(st);
}
// (para la capa de Navidad: volver a medir la tienda cuando se queda quieta o vuelve a montarse)
window.JMRemedir = () => insts.forEach(st => { layout(st); update(st); });
function floorBB(f) {
  const {x, y, z, W, D, H} = FLOORS[f], x0 = x - 0.25, y0 = y - 0.25, x1 = x + W + 0.25, y1 = y + D + 0.25;
  const p = [P(x0, y0, z - 0.45), P(x1, y0, z - 0.45), P(x0, y1, z + H), P(x1, y1, z + H), P(x0, y1, z - 0.45), P(x1, y0, z + H)];
  return [Math.min(...p.map(v => v[0])), Math.min(...p.map(v => v[1])), Math.max(...p.map(v => v[0])), Math.max(...p.map(v => v[1]))];
}
// dónde cae la bolsa: encima del mostrador de la planta baja
const bagAt = () => FLOORS.pb.bolsa || [FLOORS.pb.x + FLOORS.pb.W / 2, FLOORS.pb.y + 1, FLOORS.pb.z + 1.05];
function cams(st) {
  const cw = st.box.clientWidth || 1, ch = st.box.clientHeight || 1;
  const fit = (bb, pad) => { const v = fitVB(bb, pad, cw, ch); v[1] -= v[3] * 0.04; return v; };
  const pb = floorBB('pb'), b1 = floorBB('b1');
  st.vbC = fit(unionBB([pb, b1]), st.isPhone ? 0.06 : 0.1);
  if (!st.isPhone) st.vbC = centrarConRotulos(st, st.vbC, cw, ch);
  st.vbA = st.isPhone ? st.vbC : fit(pb, 0.16);
  st.vbB = st.isPhone ? st.vbC : fit(b1, 0.16);
  st.vb = st.vb || st.vbA;
}
// la vista de las dos plantas, centrada con sus rótulos: el de cada planta a la izquierda y la columna de la −1 a la derecha (Sergio,
// 21 oct: «el plano general estaría bien que saliese centrado, ahora está un poco hacia la derecha»). Antes se corría el dibujo un 6 %
// fijo a la derecha para los rótulos de la izquierda, pero la columna de la derecha es más ancha y el conjunto quedaba descompensado
function centrarConRotulos(st, vb, cw, ch) {
  const [vx, vy, vw, vh] = vb, k = Math.min(cw / vw, ch / vh), ox = (cw - vw * k) / 2, enX = x => ox + (x - vx) * k;
  const izq = Math.min(...['pb', 'b1'].map(f => { const {x, y, z, D} = FLOORS[f]; return enX(P(x - 0.25, y + D + 0.25, z)[0]) - 16 - (st.flab[f].offsetWidth || 110); }));
  const columna = Math.max(0, ...ZONE_IDS.filter(id => ZONES[id].f === 'b1').map(id => st.lab[id].offsetWidth || 0));
  const der = enX(floorBB('b1')[2]) + 22 + columna;
  return [vx + ((izq + der) / 2 - cw / 2) / k, vy, vw, vh];
}
const lerpVB = (a, b, k) => a.map((v, i) => v + (b[i] - v) * k);

/* ---------- pintar ---------- */
function render(st) {
  const t = T[st.lang], h = hours(), isP = st.isPhone;
  const LN = {es:'Español', ca:'Català', fr:'Français', en:'English'};
  const langs = isP
    ? `<span class="langs">${IDIOMAS.map(l => `<span data-l="${l}" class="${l === st.lang ? 'on' : ''}">${l.toUpperCase()}</span>`).join('')}</span>`
    : `<span class="langs lsel-w"><button type="button" class="lsel" aria-label="${t.lang}">${st.lang.toUpperCase()}<svg class="chev" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4"/></svg></button><span class="lmenu">${IDIOMAS.map(l => `<span data-l="${l}" class="${l === st.lang ? 'on' : ''}">${LN[l]}</span>`).join('')}</span></span>`;
  const hsx = `<div class="hsx" role="search"><svg class="ic"><use href="#jm-search"/></svg><input type="search" autocomplete="off" enterkeyhint="search" placeholder="${t.hs.ph}"><button type="button" class="hs-x" aria-label="${t.hs.close}">×</button></div>`;
  const cart = `<button type="button" class="i-cart" aria-label="${t.cart.title}"><span class="cbag"></span><b class="cnum"></b></button>`;
  // la cuenta del cliente: la de Shopify (el inicio de sesión, los datos y los pedidos los guarda Shopify; aquí solo va el botón)
  // (en la web de verdad, de momento sin cuenta: todo se pide por WhatsApp)
  const cuenta = REAL ? '' : `<button type="button" class="i-cuenta" aria-label="${t.cuenta}" title="${t.cuenta}"><svg class="ic"><use href="#jm-user"/></svg></button>`;
  st.hd.innerHTML = isP
    ? `<svg class="logo" data-logo><use href="#jm-logo"/></svg>${hsx}<div class="r">${langs}${cuenta}<svg class="ic i-search"><use href="#jm-search"/></svg>${cart}<svg class="ic i-menu"><use href="#jm-menu"/></svg></div>`
    : `<svg class="logo" data-logo><use href="#jm-logo"/></svg><nav></nav>${hsx}<div class="r">${langs}${cuenta}<svg class="ic i-search"><use href="#jm-search"/></svg>${cart}</div>`;
  renderCart(st);
  renderNav(st);
  const slogan = `<p class="h1"><span>${t.s1}</span><span>${t.s2}</span></p>`;
  const cta = `<div class="cta"><a class="btn wa" href="#"><svg><use href="#jm-wa"/></svg>${isP ? t.waS : t.wa}</a><span class="sm">${h.dayOff ? t.closedToday : h.isOpen ? t.open(h.close) : t.closed(h.open)} · <a class="where" href="#" data-asst>${t.where}</a></span></div>`;
  const obj = id => `<button type="button" class="obj${id === 'marcas' ? ' obj-m' : ''}" data-z="${id}"><span class="ms" data-m="${id}"></span><b>${t.z[id]}</b><small>${id === 'marcas' ? t.nb(BRANDS.length) : t.n((BY_SEC[id] || []).length)}</small></button>`;
  const marcas = isP
    ? `<button type="button" class="mcard" data-z="marcas"><span class="ms" data-m="marcas"></span><span><b>${t.z.marcas}</b><small>${t.dirSub(BRANDS.length)}</small></span><i>→</i></button>`
    : `<button type="button" class="obj obj-m" data-z="marcas"><span class="ms" data-m="marcas"></span><b>${t.z.marcas}</b><small>${t.dirSub(BRANDS.length)}</small></button>`;
  // el servicio técnico, una opción más de la −1 (Sergio, 19 oct: «lo pondría entre las opciones de la planta −1, así es más visual»)
  const sat = `<button type="button" class="obj" data-z="sat"><span class="ms" data-m="sat"></span><b>${t.z.sat}</b><small>${t.satSub}</small></button>`;
  // y Andorra Telecom, con su logo (Sergio, 19 oct: «el logo sí que se reconoce»): en la −1, que es Informàtica i Serveis
  const tel = `<button type="button" class="obj" data-z="tel"><span class="ms" data-m="tel"></span><b>${t.tel.title}</b><small>${t.tel.sub}</small></button>`;
  const rows = `${marcas}<p class="rcap">${t.fl.pb} · ${t.store.pb}</p>${PB_SECS.map(obj).join('')}<p class="rcap">${t.fl.b1} · ${t.store.b1}</p>${B1_SECS.map(obj).join('')}${sat}${tel}`;
  const isFace = st.heroKind === 'cara';
  st.hero.innerHTML = `<div class="htop"><div class="htxt">${slogan}<p class="hsub">${t.hsub}</p>${cta}<p class="hven">${t.ven}</p></div><div class="hart${isFace ? ' is-face' : ''}">${isFace ? '<div class="hface-ph"></div>' : `<p class="hcap">${t.newT}</p>`}</div></div><div class="rows">${rows}</div><p class="hint">${t.hint}</p>`;
  // en el móvil la cara va dentro del hero (placeFace); el innerHTML de arriba la saca del DOM, así que se vuelve a meter cada vez
  if (isFace && st.isPhone) st.hero.querySelector('.hface-ph').appendChild(st.hface);
  if (isFace) { const [a, ...b] = t.hiFace.split('! '); st.hface.querySelector('.hbub .tx').innerHTML = b.length ? `<b>${esc(a)}!</b> ${esc(b.join('! '))}` : esc(t.hiFace); }
  else {
    const art = HEROES[st.heroKind](t);
    art.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    st.hero.querySelector('.hart').prepend(art);
    fitSVG(art, 6);
    lightScreens(art, true);
  }
  st.hero.querySelectorAll('.ms[data-m]').forEach(s => {
    const src = ICONOS3D[s.dataset.m];
    if (src) { const im = new Image(); im.className = 'ms3d'; im.alt = ''; im.decoding = 'async'; im.src = src; s.replaceWith(im); return; }
    const m = miniSVG(s.dataset.m); s.replaceWith(m); fitMini(m); lightScreens(m, true);
  });
  st.root.querySelector('.news').innerHTML = `<p class="t0">${t.newT}</p><div class="nrow">${NEWS.slice(0, isP ? 8 : 4).map(r => `<a class="nc" href="${hrefFicha(r)}" data-n="${r.n}"><span class="im">${r.i ? `<img src="${src(r.i, 300)}" alt="" loading="lazy">` : ''}${addBtn(t, r)}</span><span class="b">${esc(r.v)}</span><span class="t">${esc(tituloDe(r, st.lang))}</span><span class="p price${claseAgotado(r)}">${precioTarjeta(st, r)}</span></a>`).join('')}</div>`;
  // (en la web de verdad, las páginas legales de Shopify, pequeñas, entre las dos líneas: la venta a distancia las pide a mano)
  // y «Cookies», que vuelve a abrir el aviso: cambiar lo elegido tiene que ser fácil (Llei 20/2014, art. 20.5)
  const legal = REAL ? `<nav class="ft-legal">${t.legal.map(([h, l]) => `<a href="${urlLegal(h)}">${l}</a>`).join('')}<button type="button" class="ck-abrir">${t.ck.titulo}</button></nav>` : '';
  st.root.querySelector('.ft').innerHTML = `<span>${t.ft1}</span>${legal}<span>${t.ft2}</span>`;
  for (const id of ZONE_IDS) st.lab[id].innerHTML = `${t.z[id]}<small>${id.startsWith('taulell') ? t.subT : id === 'sat' ? t.subSat : t.sub}</small>`;
  for (const f of ['pb', 'b1']) st.flab[f].innerHTML = `<b>${t.fl[f]}</b><span>${t.store[f]}</span>`;
  st.root.lang = st.lang;
  asShell(st);
  hsShell(st);
  if (st.page) renderPage(st);
  placeFace(st);
}
function renderNav(st) {
  const t = T[st.lang], tab = z => `<span data-z="${z}">${t.z[z]}</span>`;
  // en Informática, también el servicio técnico (está en la −1; Sergio, 19 oct: «no está señalizado en la cabecera de informática»)
  const B1 = [...B1_SECS, 'sat', 'tel'];
  if (st.isPhone) { st.tabs.innerHTML = `${tab('marcas')}<i class="tdiv"></i><i class="tdiv">${t.store.pb}</i>${PB_SECS.map(tab).join('')}<i class="tdiv">${t.store.b1}</i>${B1.map(tab).join('')}`; return; }
  st.hd.querySelector('nav').innerHTML = `${tab('marcas')}<span class="fsw">${['pb', 'b1'].map(f => `<span data-f="${f}" class="${f === st.navF ? 'on' : ''}">${t.store[f]}</span>`).join('')}</span>${(st.navF === 'pb' ? PB_SECS : B1).map(tab).join('')}`;
}
const navNode = (st, id) => id.startsWith('taulell') ? null : (st.isPhone ? st.tabs.querySelector(`[data-z="${id}"]`) : st.hd.querySelector(`nav [data-z="${id}"]`));

/* ---------- la tienda se monta: primero la planta baja, luego la −1 ---------- */
function progress(st) {
  const vh = st.sticky.offsetHeight, start = st.wrap.offsetTop - st.stickyTop - vh * 0.55;
  return clamp((st.sc.scrollTop - start) / (st.wrap.offsetHeight - vh + vh * 0.55), 0, 1);
}
function scrollToFloor(st, f) {
  closePage(st);
  const vh = st.sticky.offsetHeight, start = st.wrap.offsetTop - st.stickyTop - vh * 0.55, range = st.wrap.offsetHeight - vh + vh * 0.55;
  st.sc.scrollTo({top: start + range * ({pb:0.41, b1:0.8, all:0.95})[f], behavior: reduce ? 'auto' : 'smooth'});
}
function update(st) {
  const hh = st.hd.offsetHeight;
  st.root.classList.toggle('nav-on', st.sc.scrollTop > st.hero.offsetTop + st.hero.offsetHeight - hh - 40);
  // (en Navidad la tienda sale montada y quieta, como con «reducir movimiento»: ya hay bastante movimiento arriba; capa-navidad.js)
  const p = reduce || window.JMTiendaQuieta ? 1 : progress(st);
  st.p = p;
  const E = (a, b) => clamp((p - a) / (b - a), 0, 1), ease = x => x < 0.5 ? 2 * x * x : 1 - (-2 * x + 2) ** 2 / 2;
  st.k2 = ease(E(0.78, 0.86));
  st.vb = lerpVB(lerpVB(st.vbA, st.vbB, ease(E(0.42, 0.52))), st.vbC, st.k2);
  st.svg.setAttribute('viewBox', st.vb.map(v => v.toFixed(1)).join(' '));
  if (st.t3d) st.t3d.vista(st.vb, st.box.clientWidth || 1, st.box.clientHeight || 1);
  floorAnim(st, 'pb', E(0, 0.06), E(0.03, 0.1));
  floorAnim(st, 'b1', E(0.45, 0.52), E(0.48, 0.56));
  st.F.links.setAttribute('opacity', E(0.74, 0.82).toFixed(3));
  const nf = p > 0 && p < 0.84 ? (p >= 0.47 ? 'b1' : 'pb') : st.userF;
  if (nf !== st.navF) { st.navF = nf; if (!st.isPhone) renderNav(st); }
  DROPS.forEach(([id, s0]) => dropItem(st, id, E(s0, s0 + 0.1)));
  dropBag(st, E(0.79, 0.86));
  const bpb = p >= 0.39, bb1 = p >= 0.78;
  if (bpb !== !!st.bpb) { st.bpb = bpb; st.root.classList.toggle('bpb', bpb); if (bpb) flashFloor(st, 'pb'); }
  if (bb1 !== !!st.bb1) { st.bb1 = bb1; st.root.classList.toggle('bb1', bb1); if (bb1) flashFloor(st, 'b1'); }
  if (st.hover && !zoneReady(st, st.hover)) setHover(st, null);
  const built = p >= 0.86;
  if (built && !st.built) { flashFloor(st, 'pb'); flashFloor(st, 'b1'); }
  st.built = built;
  st.root.classList.toggle('built', built);
  const t = T[st.lang];
  const l1 = p < 0.47 ? `${t.fl.pb} · ${t.store.pb}` : p < 0.84 ? `${t.fl.b1} · ${t.store.b1}` : (st.isPhone ? t.capFloors : t.capAll);
  const capTxt = l1 + (ZONE_IDS.some(id => st.landed[id]) ? `<small>${t.cap}</small>` : '');
  if (capTxt !== st.capTxt) { st.capTxt = capTxt; st.cap.innerHTML = capTxt; }
  st.cap.classList.toggle('on', p > 0.02);
  placeLabels(st);
  placeFace(st);
}
function floorAnim(st, f, fl, wl) {
  const L = st.F[f], Fl = FLOORS[f], [cx, cy] = P(Fl.x + Fl.W / 2, Fl.y + Fl.D / 2, Fl.z);
  // solo cuando cambia (las paredes son muchas piezas)
  const key = fl.toFixed(3) + '/' + wl.toFixed(3);
  if (L.animKey === key) return;
  L.animKey = key;
  L.under.setAttribute('opacity', fl.toFixed(3));
  L.under.setAttribute('transform', `translate(${cx} ${cy}) scale(${(0.94 + 0.06 * fl).toFixed(4)}) translate(${-cx} ${-cy})`);
  L.walls.setAttribute('opacity', wl.toFixed(3));
  L.walls.setAttribute('transform', `translate(0 ${((1 - wl) * 70).toFixed(1)})`);
  if (st.t3d) st.t3d.planta(f, fl, wl);
}
function originOf(st, id) {
  const n = id.startsWith('taulell') ? st.hd.querySelector('[data-logo]') : navNode(st, id);
  const b = st.box.getBoundingClientRect();
  const r = n ? n.getBoundingClientRect() : {left: b.left + b.width / 2, width: 0, bottom: b.top};
  const sx = clamp(r.left + r.width / 2 - b.left, 10, b.width - 10), sy = Math.min(r.bottom - b.top, 0);
  const [vx, vy, vw, vh] = st.vb, k = Math.min(b.width / vw, b.height / vh), ox = (b.width - vw * k) / 2, oy = (b.height - vh * k) / 2;
  return [vx + (sx - ox) / k, vy + (sy - oy) / k];
}
function dropItem(st, id, t) {
  const g = st.zg[id], nav = navNode(st, id), falling = t > 0 && t < 1;
  if (nav) {
    nav.classList.toggle('drop', falling && !st.page);
    if (falling && st.isPhone && (nav.offsetLeft < st.tabs.scrollLeft || nav.offsetLeft + nav.offsetWidth > st.tabs.scrollLeft + st.tabs.clientWidth)) st.tabs.scrollLeft = nav.offsetLeft - 40;
  }
  const landed = t >= 1;
  if (landed !== !!st.landed[id]) {
    st.landed[id] = landed;
    const n = st.lab[id];
    n.classList.toggle('hide', !landed);
    st.hit[id].classList.toggle('ready', landed);
    n.classList.remove('pop');
    if (landed && !reduce) { void n.offsetWidth; n.classList.add('pop'); }
  }
  if (t <= 0) { g.setAttribute('opacity', 0); st.shadows[id].setAttribute('opacity', 0); if (st.t3d) st.t3d.zona(id, {t: 0}); return; }
  if (landed) { g.removeAttribute('transform'); g.setAttribute('opacity', 1); st.shadows[id].setAttribute('opacity', 0); if (st.t3d) st.t3d.zona(id, {t: 1}); return; }
  const F = t < 0.82 ? (t / 0.82) ** 2 : 1 - 0.05 * Math.sin(Math.PI * (t - 0.82) / 0.18);
  const [ax, ay] = P(...labAt(id)), [ox, oy] = originOf(st, id);
  const dx = (ox - ax) * (1 - F), dy = (oy - ay) * (1 - F), s = 0.38 + 0.62 * Math.min(1, F);
  g.setAttribute('transform', `translate(${dx.toFixed(1)} ${dy.toFixed(1)}) translate(${ax.toFixed(1)} ${ay.toFixed(1)}) scale(${s.toFixed(3)}) translate(${(-ax).toFixed(1)} ${(-ay).toFixed(1)})`);
  g.setAttribute('opacity', Math.min(1, t * 10).toFixed(2));
  const sh = st.shadows[id], cx = +sh.getAttribute('cx'), cy = +sh.getAttribute('cy');
  sh.setAttribute('opacity', (0.34 * Math.min(1, F) ** 2).toFixed(3));
  sh.setAttribute('transform', `translate(${cx} ${cy}) scale(${(0.4 + 0.6 * Math.min(1, F)).toFixed(3)}) translate(${-cx} ${-cy})`);
  if (st.t3d) st.t3d.zona(id, {t, A: labAt(id), dx, dy, s, niebla: 1 - Math.min(1, t * 10), sombra: 0.34 * Math.min(1, F) ** 2, escSombra: 0.4 + 0.6 * Math.min(1, F)});
}
function flashFloor(st, f) {
  if (reduce) return;
  const ids = ZONE_IDS.filter(id => ZONES[id].f === f);
  ids.forEach(id => lightScreens(st.zg[id], true));
  clearTimeout(st['ft' + f]);
  st['ft' + f] = setTimeout(() => ids.forEach(id => { if (id !== st.hover) lightScreens(st.zg[id], false); }), 1300);
}
// la −1 es pequeña: con las dos plantas a la vista, sus etiquetas taparían la tienda. Salen a su derecha, en columna y en el orden
// en que están de arriba abajo, con una raya hasta su zona. En el móvil siempre se ven las dos plantas: siempre a un lado
function sideLabels(st, at, cw) {
  const k = st.isPhone ? 1 : st.k2, ids = ZONE_IDS.filter(id => ZONES[id].f === 'b1' && st.landed[id]);
  if (k <= 0 || !ids.length) return null;
  const [x0, y0, x1, y1] = floorBB('b1'), [, top] = at([x0, y0]), [right, bottom] = at([x1, y1]);
  const col = right + (st.isPhone ? 10 : 22), room = cw - col - (st.isPhone ? 6 : 14);
  if (room < 56) return null;
  const gap = st.isPhone ? 5 : 8, rows = ids.map(id => {
    const z = ZONES[id], n = st.lab[id];
    n.classList.add('side'); n.classList.toggle('tight', room < 100); n.style.maxWidth = room + 'px';
    return {id, w: n.offsetWidth, h: n.offsetHeight, end: at(P(z.light[0], z.light[1], zz(id) + Math.min(z.h, 2) * 0.55))};
  }).sort((a, b) => a.end[1] - b.end[1]);
  const H = rows.reduce((s, r) => s + r.h, 0) + gap * (rows.length - 1), mid = rows.reduce((s, r) => s + r.end[1], 0) / rows.length;
  // la cara de la esquina no tapa ninguna: si la columna llega hasta ella, la columna acaba encima. Se mide con la tienda en su sitio
  // (pegada bajo la cabecera), no donde está ahora: la cara va fija en la pantalla y, con la tienda quieta (Navidad), que baja con la
  // página, la columna se iba con la pantalla por toda la web (Sergio, 30 oct). Con la tienda que se monta es lo mismo: ya está en su sitio
  const B = st.box.getBoundingClientRect(), fc = st.fab.getBoundingClientRect(), anchoMax = Math.max(...rows.map(r => r.w));
  const arriba = st.sc.getBoundingClientRect().top, cajaEnSitio = st.stickyTop + B.top - st.sticky.getBoundingClientRect().top, caraEn = fc.top - arriba;
  const conCara = fc.width > 0 && cajaEnSitio < caraEn && fc.left - B.left < col + anchoMax + 6 ? caraEn - cajaEnSitio - 8 : Infinity;
  let y = clamp(mid - H / 2, top, Math.max(top, bottom - H));
  if (y + H > conCara) y = conCara - H;
  const pos = {};
  for (const r of rows) { pos[r.id] = {x: col + r.w / 2, y: y + r.h, from: [col - 5, y + r.h / 2], end: r.end}; y += r.h + gap; }
  return {k, pos};
}
function placeLabels(st) {
  const cw = st.box.clientWidth, ch = st.box.clientHeight, [vx, vy, vw, vh] = st.vb;
  const k = Math.min(cw / vw, ch / vh), ox = (cw - vw * k) / 2, oy = (ch - vh * k) / 2, at = p => [ox + (p[0] - vx) * k, oy + (p[1] - vy) * k];
  st.lbls.classList.toggle('small', k < 0.78);
  for (const id in st.lead) { st.lab[id].classList.remove('side', 'tight'); st.lab[id].style.maxWidth = ''; }
  const side = sideLabels(st, at, cw);
  const placed = [];
  ZONE_IDS.map(id => [id, at(P(...labAt(id)))]).sort((a, b) => a[1][1] - b[1][1]).forEach(([id, [x, y]]) => {
    const n = st.lab[id], w = n.offsetWidth, h = n.offsetHeight, s = side && side.pos[id];
    if (s) {
      // de su sitio en la tienda a la columna, a la vez que la cámara se aleja
      x += (s.x - x) * side.k; y += (s.y - y) * side.k;
    } else if (st.landed[id] && !n.classList.contains('hide')) {
      // si choca con una etiqueta ya puesta, se aparta hacia abajo
      for (const r of placed) if (Math.abs(x - r.x) < (w + r.w) / 2 + 4 && y - h < r.y && y > r.y - r.h) y = r.y + h + 3;
      placed.push({x, y, w, h});
    }
    n.style.left = x.toFixed(1) + 'px'; n.style.top = y.toFixed(1) + 'px';
    if (st.landed[id]) n.classList.toggle('hide', !(x > 20 && x < cw - 20 && y > 24 && y < ch + 30));
  });
  for (const [id, L] of Object.entries(st.lead)) {
    const s = side && side.pos[id];
    L.g.setAttribute('opacity', s ? side.k.toFixed(3) : 0);
    if (!s) continue;
    const [ax, ay] = s.from, [bx, by] = s.end;
    L.line.setAttribute('x1', ax.toFixed(1)); L.line.setAttribute('y1', ay.toFixed(1)); L.line.setAttribute('x2', bx.toFixed(1)); L.line.setAttribute('y2', by.toFixed(1));
    L.dot.setAttribute('cx', bx.toFixed(1)); L.dot.setAttribute('cy', by.toFixed(1));
  }
  for (const f of ['pb', 'b1']) {
    const {x: fx, y: fy, z, D} = FLOORS[f], n = st.flab[f];
    const x = at(P(fx - 0.25, fy + D + 0.25, z))[0], y = at(P(fx - 0.25, fy + D * 0.5, z))[1];
    n.style.left = x.toFixed(1) + 'px'; n.style.top = y.toFixed(1) + 'px';
    n.classList.toggle('hide', st.isPhone || !(st.k2 > 0.6 && (f === 'pb' ? st.bpb : st.bb1)));
  }
}
// encender la zona por la que pasa el cursor (si la web tenía otra encendida un rato, manda el cursor)
function ponerHover(st, id) { st.hoverHasta = 0; setHover(st, id); }
// apagar la zona encendida, salvo si la ha encendido la web un rato (iluminarUnRato): esa se apaga sola cuando acaba su rato
function soltarHover(st) {
  if (performance.now() < (st.hoverHasta || 0)) return;
  setHover(st, null);
}
// lo que hay debajo del ratón, mirado otra vez (tras bajar con la rueda o acabar el rato de una zona encendida por la web)
function miraDebajo(st) {
  const e = st.ptr && !st.isPhone ? document.elementFromPoint(st.ptr[0], st.ptr[1]) : null;
  const z = e && (st.svg.contains(e) ? e.closest('[data-z]') : e.closest('.obj, .hd nav [data-z], .lbl[data-z]'));
  setHover(st, z && ZONES[z.dataset.z] && zoneReady(st, z.dataset.z) && !st.page ? z.dataset.z : null);
}
// encender una zona un rato, sin que la apague el cursor mientras dura (la ficha enseña así el mostrador); al acabar se mira lo que
// hay debajo del ratón (en el móvil, que no tiene, se apaga). Antes se quedaba encendida y la tienda, gris, para siempre
function iluminarUnRato(st, id, ms = 2800) {
  st.hoverHasta = performance.now() + ms;
  setHover(st, id);
  clearTimeout(st.hoverRato);
  st.hoverRato = setTimeout(() => { if (st.hoverHasta) { st.hoverHasta = 0; miraDebajo(st); } }, ms);
}
function setHover(st, id) {
  if (st.hover === id) return;
  const off = h => { st.zg[h].classList.remove('on'); lightScreens(st.zg[h], false); st.lab[h].classList.remove('on'); st.pools[h].classList.remove('on'); st.beams[h].classList.remove('on'); if (st.lead[h]) st.lead[h].g.classList.remove('on'); };
  if (st.hover) off(st.hover);
  st.hover = id;
  st.svg.classList.toggle('hov', !!id);
  if (st.t3d) st.t3d.hover(id && st.zg[id] ? id : null);
  if (!id || !st.zg[id]) return;
  st.zg[id].classList.add('on'); lightScreens(st.zg[id], true);
  st.lab[id].classList.add('on'); st.pools[id].classList.add('on'); st.beams[id].classList.add('on');
  if (st.lead[id]) st.lead[id].g.classList.add('on');
}
function pickZone(st, id) {
  if (id.startsWith('taulell')) return openAssist(st);
  if (id === 'sat') return openSat(st);
  if (id === 'tel') return openTel(st);
  if (id === 'usado') return openUsado(st);
  if (id === 'apple') return openBrand(st, 'Apple');
  if (id === 'nov' || id === 'acc' || id === 'mac') return openList(st, id);
  openSec(st, id);
}

/* ---------- clics ---------- */
function onClick(st, e) {
  const t = e.target, a = t.closest('a');
  // un enlace de verdad con Cmd, Ctrl o Mayúsculas (abrir en otra pestaña): lo hace el navegador
  if (a && a.getAttribute('href') !== '#' && (e.metaKey || e.ctrlKey || e.shiftKey)) return;
  if (a && a.getAttribute('href') === '#') e.preventDefault();
  // la ventanita del QR: su × o fuera de ella la cierran
  if (t.closest('.qs-x') || t.classList.contains('qr-suelto')) return cerrarQrSuelto(st);
  if (t.closest('.qr-suelto')) return;
  if (onPageEvent(st, e)) return;
  // las etiquetas de la tienda también se pulsan: abren su zona
  const lb = t.closest('.lbl[data-z]');
  if (lb) { if (zoneReady(st, lb.dataset.z)) pickZone(st, lb.dataset.z); return; }
  const L = T[st.lang];
  const lsel = t.closest('.lsel');
  if (lsel) { lsel.parentNode.classList.toggle('open'); return; }
  const lang = t.closest('.langs [data-l]');
  if (lang) {
    const l = lang.dataset.l;
    if (T[l] && l !== st.lang) { st.lang = l; render(st); layout(st); update(st); idiomaEnUrl(l); }
    return;
  }
  // en la bolsa, lo que va con un aparato (lo elegido en su desplegable): a su bloque
  const anade = t.closest('[data-anade-clase]');
  if (anade) {
    e.preventDefault();
    const fila = anade.closest('.cd-s'), de = +fila.dataset.de, base = st.cart.find(l => l.id === de);
    const ops = base ? opcionesDe(st, ROWS[base.n], anade.dataset.anadeClase, base.o) : [], o = ops[st.bolsaOpc[de + anade.dataset.anadeClase] || 0] || ops[0];
    return o && addToCart(st, o.n, {o: o.o, p: o.p}, de);
  }
  const add = t.closest('[data-add]');
  if (add) { e.preventDefault(); return productoSinStock(ROWS[+add.dataset.add]) ? null : addToCart(st, +add.dataset.add); }
  if (t.closest('.i-cart')) return st.root.classList.contains('cart-open') ? closeCart(st) : openCart(st);
  const rm = t.closest('[data-rm]');
  if (rm) return quitarLinea(st, +rm.dataset.rm);
  if (t.closest('.cd-pay')) return toast(st, 'Aquí se iría al pago de Shopify. Va en segundo plano: lo primero es WhatsApp.');
  // pedir por WhatsApp: en el móvil se abre WhatsApp; en el ordenador, el QR que lo abre en el móvil (y el enlace a WhatsApp Web)
  if (t.closest('.cd-wa')) return abrirWa(st, mensajeBolsa(st), () => { if (!st.qrBolsa) { st.qrBolsa = true; renderCartDrop(st); } return verQrBolsa(st); });
  const ask = t.closest('.gi .q');
  if (ask) { e.preventDefault(); return abrirWa(st, L.hi + L.qp(ROWS[+ask.closest('.gi').dataset.n].t)); }
  const prod = t.closest('[data-n]');
  // (desde el buscador, la ficha abre en la variante buscada: «s26 morado», en violeta)
  if (prod) { e.preventDefault(); return openFicha(st, +prod.dataset.n, prod.closest('.hs-r') ? st.hsq : st.page && st.page.kind === 'search' ? st.page.q : ''); }
  const fsw = t.closest('.fsw [data-f]');
  if (fsw) { st.userF = fsw.dataset.f; st.navF = st.userF; renderNav(st); return scrollToFloor(st, st.userF); }
  const br = t.closest('[data-b]');
  if (br) return openBrand(st, br.dataset.b);
  if (t.closest('[data-dir]')) return openDir(st);
  // (en el móvil, «Marcas» es la tarjeta .mcard, no un .obj: hasta el 1 nov 2026 el toque no hacía nada)
  const z = t.closest('.obj, .mcard, .hd nav [data-z], .ptabs [data-z]');
  if (z && z.dataset.z) return z.dataset.z === 'marcas' ? openDir(st) : pickZone(st, z.dataset.z);
  if (t.closest('.where')) { openAssist(st); return asInfo(st, 'on'); }
  if (t.closest('.sat-wa')) return abrirWa(st, L.sat.msg);
  if (t.closest('.usado-wa')) return abrirWa(st, L.usado.msg);
  if (t.closest('[data-usado]')) { e.preventDefault(); return openUsado(st); }
  if (t.closest('.i-cuenta')) return toast(st, 'Aquí se abriría tu cuenta, la de Shopify: entras con un código que te llega al correo, y tus datos y tus pedidos los guarda Shopify.');
  if (t.closest('.ck-si')) { const d = t.closest('.cookies'); return cookiesElegir(st, d.dataset.cfg ? (d.querySelector('.ck-est').checked ? 'si' : 'no') : 'si'); }
  if (t.closest('.ck-no')) return cookiesElegir(st, 'no');
  if (t.closest('.ck-cfg')) { const d = t.closest('.cookies'); d.dataset.cfg = '1'; d.querySelector('.ck-conf').hidden = false; d.querySelector('.ck-si').textContent = T[st.lang].ck.guardar; t.closest('.ck-cfg').hidden = true; return; }
  if (t.closest('.ck-abrir')) { try { localStorage.removeItem(CK); } catch (err) { /* sin almacenamiento */ } st.root.querySelectorAll('.cookies').forEach(d => d.remove()); return cookiesAlEntrar(st); }
  if (t.closest('.ck-mas')) { e.preventDefault(); if (REAL) { location.href = urlLegal('privacidad'); return; } return toast(st, 'Aquí se abriría la política de cookies.'); }
  if (t.closest('.cnone .wa')) return abrirWa(st, L.as.getIt(st.page && st.page.q || '…'));
  if (t.closest('.wa')) return abrirWa(st, L.hi + L.q0);
  if (t.closest('.i-search')) return st.root.classList.contains('hs-open') ? closeHS(st) : openHS(st);
  if (t.closest('.hs-x')) return hsClear(st);
  if (t.closest('.hs-all')) { const q = (st.hsq || '').trim(); closeHS(st); return openSearch(st, q); }
  if (t.closest('.hs-get')) return abrirWa(st, L.as.getIt((st.hsq || '').trim()));
  const ab = t.closest('[data-about]');
  if (ab) return openAbout(st, ab.dataset.about);
  if (t.closest('.i-bag')) return toast(st, 'Aquí se abriría la cesta. Va en segundo plano: lo primero es WhatsApp.');
  if (t.closest('.i-menu')) { closeHS(st); closeCart(st); closeAssist(st); return st.page && st.page.kind === 'menu' ? closePage(st) : openMenu(st); }
  if (t.closest('[data-logo]')) { closePage(st); st.sc.scrollTo({top:0, behavior:'smooth'}); }
}
const waMsg = text => `Aquí se abriría WhatsApp con este mensaje ya escrito: «${text}»`;
// el aviso de cookies, al entrar la primera vez (Sergio, 19 oct: «lo de las cookies ponlo al iniciar la web»), como pide la guía de la
// AEPD: quién (J&M), propias y de terceros (Shopify), para qué, «Rechazar» y «Aceptar» igual de a mano, «Configurar» para elegir por
// tipo y el enlace a la política (la segunda capa). Lo elegido se recuerda en este navegador
const CK = 'jm-cookies';
function cookiesAlEntrar(st) {
  let elegido = null;
  try { elegido = localStorage.getItem(CK); } catch (err) { /* sin almacenamiento: se pregunta cada vez */ }
  if (elegido) return;
  const c = T[st.lang].ck, d = document.createElement('div');
  d.className = 'cookies'; d.setAttribute('role', 'dialog'); d.setAttribute('aria-label', c.titulo);
  d.innerHTML = `<p>${c.txt}</p>
    <div class="ck-conf" hidden><label><input type="checkbox" checked disabled><span><b>${c.nec}</b> ${c.necT}</span></label><label><input type="checkbox" class="ck-est"><span><b>${c.est}</b> ${c.estT}</span></label></div>
    <div class="ck-b"><button type="button" class="ck-no">${c.no}</button><button type="button" class="ck-si">${c.si}</button></div>
    <p class="ck-l"><button type="button" class="ck-cfg">${c.cfg}</button><a href="#" class="ck-mas">${c.mas}</a></p>`;
  st.root.appendChild(d);
}
function cookiesElegir(st, v) {
  try { localStorage.setItem(CK, v); } catch (err) { /* sin almacenamiento */ }
  consentirShopify(v);
  insts.forEach(i => i.root.querySelectorAll('.cookies').forEach(d => d.remove()));
}
function toast(st, msg) { st.toast.textContent = msg; st.toast.classList.add('show'); clearTimeout(st.tt); st.tt = setTimeout(() => st.toast.classList.remove('show'), 3600); }

/* ---------- los ojos siguen al ratón; Escape cierra ---------- */
// el ratón cuenta como movido cuando cambia de sitio (no basta con que la página aparezca debajo de él)
let pointerMoved = false, lastXY = null;
// los ojos van hacia el ratón poco a poco, a cada imagen de la pantalla (con el tiempo de verdad entre una y otra), y siguen mirándolo
// mientras la cara se mueve con la página aunque el ratón esté quieto (Sergio, 19 oct: «los ojos de la cara no se mueven con
// fluidez»: antes saltaban con cada movimiento del ratón, con una transición que volvía a empezar cada vez, y al bajar la página se
// quedaban quietos hasta mover el ratón)
const mirada = new WeakMap();
let mirando = 0, tPrev = 0, movidoEn = 0;
function mirar(t) {
  const dt = tPrev ? Math.min(0.05, (t - tPrev) / 1000) : 1 / 60, k = reduce ? 1 : 1 - Math.exp(-dt / 0.075);
  tPrev = t;
  let quietos = true;
  for (const st of insts) for (const [host, reach] of [[st.fab, 160], [st.hface, 420]]) {
    if (!host || !lastXY) continue;
    const r = host.getBoundingClientRect();
    if (!r.width) continue;
    const dx = lastXY[0] - (r.left + r.width * 0.5), dy = lastXY[1] - (r.top + r.height * 0.5), d = Math.hypot(dx, dy) || 1, m = Math.min(1, d / reach);
    const tx = dx / d * 11 * m, ty = dy / d * 9 * m, o = mirada.get(host) || {x: 0, y: 0};
    o.x += (tx - o.x) * k; o.y += (ty - o.y) * k;
    mirada.set(host, o);
    if (Math.abs(tx - o.x) > 0.02 || Math.abs(ty - o.y) > 0.02) quietos = false;
    const tr = `translate(${o.x.toFixed(2)} ${o.y.toFixed(2)})`;
    host.querySelector('.eyeR').setAttribute('transform', tr);
    host.querySelector('.eyeL').setAttribute('transform', tr);
  }
  // se para cuando los ojos han llegado y nada se mueve
  if (quietos && t - movidoEn > 250) { mirando = 0; tPrev = 0; return; }
  mirando = requestAnimationFrame(mirar);
}
const despertar = () => { movidoEn = performance.now(); if (!mirando) mirando = requestAnimationFrame(mirar); };
document.addEventListener('pointermove', e => {
  if (lastXY && (e.clientX !== lastXY[0] || e.clientY !== lastXY[1])) pointerMoved = true;
  lastXY = [e.clientX, e.clientY];
  despertar();
});
// la página se mueve (y la cara con ella, también al volar a su esquina): los ojos siguen mirando al ratón
document.addEventListener('scroll', despertar, {capture: true, passive: true});
document.addEventListener('keydown', e => { if (e.key === 'Escape') insts.forEach(st => { closeAssist(st); closeHS(st); closeCart(st); }); });
// tocar en cualquier otra parte cierra el asistente, sin tener que volver a la cara
document.addEventListener('pointerdown', e => {
  const t = e.target;
  for (const st of insts) {
    if (!st.assist.classList.contains('open') || st.assist.contains(t) || st.fab.contains(t)) continue;
    if (st.root.contains(t) && t.closest('[data-asst]')) continue;
    closeAssist(st);
  }
  document.querySelectorAll('.lsel-w.open').forEach(w => { if (!w.contains(t)) w.classList.remove('open'); });
  for (const st of insts) {
    if (st.root.classList.contains('hs-open') && !st.hd.querySelector('.hsx').contains(t) && !st.hsdrop.contains(t) && !t.closest('.i-search')) closeHS(st);
    if (st.root.classList.contains('cart-open') && !st.cartdrop.contains(t) && !t.closest('.i-cart') && !t.closest('[data-add]')) closeCart(st);
  }
}, true);

// la Navidad (temporada.js): en esas fechas, la tienda en 3D sale quieta y con sus adornos desde el principio (que la página no cambie
// de alto al llegar la capa), el regalo de la bolsa en rojo y, con la página ya cargada, se baja la capa de Navidad (navidad/: las
// luces, la cara, la nieve y lo que cruza el cielo; en el tema, jm-navidad.js). El resto del año no se baja nada. El simulador de
// Navidad la monta él, con la fecha que se elija (JMNavidadManual)
const NAVIDAD = !window.JMNavidadManual && !!temporada();
if (NAVIDAD) window.JMTiendaQuieta = window.JMNavidad3D = true;
JMRegalo.activar(true, NAVIDAD);
document.querySelectorAll('.jmx4 .site').forEach(mount);
if (NAVIDAD) cargarNavidad();
function cargarNavidad() {
  const fuente = document.getElementById('jm-navidad');
  if (!fuente && !(REAL && REAL.navidad)) return;
  const montar = () => { if (window.JMNavidad) insts.forEach(st => window.JMNavidad.montarEnLaWeb(st.root)); };
  const bajar = () => {
    const s = document.createElement('script');
    if (fuente) { s.textContent = fuente.textContent; document.head.appendChild(s); montar(); }
    else { s.src = REAL.navidad; s.onload = montar; s.onerror = () => console.error('la capa de Navidad no se ha podido bajar'); document.head.appendChild(s); }
  };
  if (document.readyState === 'complete') bajar(); else addEventListener('load', bajar, {once: true});
}
// en la web de verdad, atrás y adelante del navegador abren lo que dice la dirección (rutas.js)
if (REAL) addEventListener('popstate', () => insts.forEach(st => { irA(st, rutaDeUrl()); ponerTitulo(st); }));
// (las pruebas de tema/prueba-local abren páginas sin el historial, que Safari limita a 100 cambios cada 10 s: solo con JM_WEB.pruebas,
// que pone el servidor de pruebas y la web de verdad nunca lleva)
if (REAL && REAL.pruebas) window.__jmIr = ruta => insts.forEach(st => irA(st, ruta));
window.__jm4 = {insts, update, ROWS, runFlow, searchRows, scrollToFloor, OBJ, measure, cartBagSVG, addToCart, toast, openAbout, openBrand, openSec, openList, openSearch, openSat, LISTS, marcaRobo, openFicha};

/* ---------- el buscador de arriba: se abre barriendo la barra de categorías ---------- */
function hsShell(st) {
  const inp = st.hd.querySelector('.hsx input');
  inp.value = st.hsq || '';
  inp.addEventListener('input', e => { st.hsq = e.target.value; hsRender(st); });
  // con Enter, a la página de la búsqueda con todos los resultados, como «Ver los N resultados» (Sergio, 20 oct: «al apretar Enter, a
  // parte de salirte la previsualización, que pudieses ver el resultado de la búsqueda»); mientras escribes, la vista previa
  inp.addEventListener('keydown', e => {
    const q = (st.hsq || '').trim();
    if (e.key !== 'Enter' || e.isComposing || !q) return;
    e.preventDefault(); inp.blur(); closeHS(st); openSearch(st, q);
  });
  // la «×» no le quita el foco al campo (en el ordenador, al pulsarla se iría el teclado del campo)
  st.hd.querySelector('.hs-x').addEventListener('mousedown', e => e.preventDefault());
  hsRender(st);
}
// la «×» del buscador: con texto, lo borra y se sigue escribiendo (el teclado y el panel se quedan); sin texto, cierra. Antes
// cerraba siempre, y en el móvil era una lucha (Sergio, 22 oct)
function hsClear(st) {
  const inp = st.hd.querySelector('.hsx input');
  if (!(st.hsq || '').trim()) return closeHS(st);
  inp.value = ''; st.hsq = ''; hsRender(st);
  inp.focus({preventScroll:true});
}
function hsRender(st) {
  const H = T[st.lang].hs, q = (st.hsq || '').trim(), box = st.hsdrop;
  st.hd.querySelector('.hs-x').setAttribute('aria-label', q ? H.clear : H.close);
  if (!q) { box.innerHTML = `<p class="hs-hint">${H.hint}</p>`; return; }
  const res = searchRows(q);
  box.innerHTML = res.length
    ? `<div class="hs-list">${res.slice(0, 6).map(r => `<a href="${hrefFicha(r)}" class="hs-r" data-n="${r.n}"><span class="im">${r.i ? `<img src="${src(r.i, 120)}" alt="" loading="lazy">` : ''}</span><span><span class="b">${esc(r.v)}</span><span class="t">${esc(tituloDe(r, st.lang))}</span></span><span class="price${claseAgotado(r)}">${precioTarjeta(st, r)}</span></a>`).join('')}</div>${res.length > 6 ? `<button type="button" class="hs-all">${H.all(res.length)}</button>` : ''}`
    : `<p class="hs-none">${esc(H.none(q))}</p><a class="btn hs-get" href="#"><svg><use href="#jm-wa"/></svg>${H.get}</a>`;
}
function openHS(st) {
  closeAssist(st); closeCart(st);
  // la barra va del logo a la lupa y se despliega de derecha a izquierda, tapando las categorías
  const hd = st.hd.getBoundingClientRect(), logo = st.hd.querySelector('.logo').getBoundingClientRect(), lupa = st.hd.querySelector('.i-search').getBoundingClientRect(), x = st.hd.querySelector('.hsx');
  const left = (st.isPhone ? 10 : logo.right - hd.left + 16), right = hd.right - lupa.left + 10;
  x.style.left = left + 'px'; x.style.right = right + 'px';
  const R = st.root.getBoundingClientRect();
  st.hsdrop.style.top = (hd.bottom - R.top) + 'px';
  if (!st.isPhone) { st.hsdrop.style.left = (hd.left - R.left + left) + 'px'; st.hsdrop.style.right = (R.right - hd.right + right) + 'px'; }
  st.root.classList.add('hs-open');
  setTimeout(() => x.querySelector('input').focus({preventScroll:true}), 120);
}
function closeHS(st) { st.root.classList.remove('hs-open'); }

/* ---------- la bolsa del carrito: se va llenando con lo que añades ---------- */
// lo que hay en la bolsa, una línea por cosa: {id, n: el producto, o: lo elegido en su ficha, p: su precio, de: la línea del aparato
// con el que va, si es de lo que solo se vende con él (ficha.js: soloCon), o 0}
const nombreLinea = (l, lang) => tituloDe(ROWS[l.n], lang) + (l.o ? ` (${l.o})` : '');
// por bloques: cada aparato y, detrás, lo suyo
const bloques = st => st.cart.filter(l => !l.de).map(l => [l, st.cart.filter(x => x.de === l.id)]);
// (sin stock, sin «+»: no se puede poner en la bolsa; ficha.js: productoSinStock)
function addBtn(t, r) { return productoSinStock(r) ? '' : `<button type="button" class="addb" data-add="${r.n}" aria-label="${t.cart.add}" title="${t.cart.add}">+</button>`; }
function cartKinds(st) {
  const ks = [];
  for (let i = st.cart.length - 1; i >= 0 && ks.length < 3; i--) {
    const r = ROWS[st.cart[i].n];
    for (const t of r.tg) if (t.startsWith('k:')) { const k = t.slice(2); if ((OBJ[k] || PRODUCTOS3D[k]) && k !== 'bag' && !ks.includes(k)) ks.push(k); }
  }
  return ks;
}
function renderCart(st) {
  const host = st.hd.querySelector('.cbag'); if (!host) return;
  const svg = cartBagSVG(cartKinds(st), st.root.dataset.cart || '2d');
  host.replaceChildren(svg); lightScreens(svg, true);
  const n = st.hd.querySelector('.cnum'); n.textContent = st.cart.length || ''; n.classList.toggle('on', st.cart.length > 0);
}
// a la bolsa: un producto (con lo elegido en su ficha) o, con «de», lo que va con el aparato de esa línea. Devuelve la línea.
// Sin aviso de texto: la bolsa se mueve y el número sube (Sergio, 1 nov 2026: «Añadido a la bolsa… Llevas x productos, quita eso»)
function addToCart(st, n, eleccion, de) {
  const l = {id: ++st.lineas, n, o: eleccion ? eleccion.o : '', p: eleccion ? eleccion.p : ROWS[n].p, de: de || 0, se: eleccion && eleccion.se ? eleccion.se : null};
  st.cart = [...st.cart, l]; renderCart(st); guardarBolsa(st);
  const b = st.hd.querySelector('.cbag');
  if (!reduce) bagJiggle(b);
  if (st.root.classList.contains('cart-open')) renderCartDrop(st);
  if (st.page && st.page.kind === 'ficha') fichaBotones(st);
  return l;
}
// fuera de la bolsa: una línea y, si es un aparato, lo que va con él
function quitarLinea(st, id) {
  st.cart = st.cart.filter(l => l.id !== id && l.de !== id); renderCart(st); guardarBolsa(st);
  if (st.page && st.page.kind === 'ficha') fichaBotones(st);
  renderCartDrop(st);
}
// la bolsa se mueve un poco y lo último que has añadido cae dentro
function bagJiggle(b) {
  b.animate([{transform:'translateY(0) rotate(0)'}, {transform:'translateY(-5px) rotate(-6deg)', offset:.35}, {transform:'translateY(1px) rotate(3deg)', offset:.7}, {transform:'none'}], {duration:520, easing:'ease-out'});
  const np = b.querySelector('.np');
  if (np) np.animate([{transform:'translateY(-16px)', opacity:0}, {transform:'translateY(-16px)', opacity:1, offset:.2}, {transform:'none', opacity:1}], {duration:300, easing:'cubic-bezier(.4,0,.6,1)'});
}
// el QR recién abierto, a la vista: la bolsa baja hasta el final
const verQrBolsa = st => { if (st.qrBolsa) st.cartdrop.scrollTop = st.cartdrop.scrollHeight; };
// el mensaje de WhatsApp de la bolsa: cada aparato con lo suyo
// (con la marca para el bot: viene de la bolsa y, por cada aparato, si dejó el color o la capacidad sin tocar. Lo que se añadió sin
// pasar por su ficha no se eligió: cuenta como sin tocar si tiene más de una opción)
function mensajeBolsa(st) {
  const C = T[st.lang].cart, bs = bloques(st);
  const sinTocar = l => { const d = FICHAS[ROWS[l.n].t] || null; return l.se || (d ? {color: !!(d.colores && d.colores.length > 1), cap: !!(d.capacidad && d.capacidad.length > 1)} : sinElegir(ROWS[l.n])); };
  // (si es para regalo, acaba diciéndolo: regalo.js)
  const regalo = JMRegalo.texto(st.lang);
  return conClave(C.msg(bs.map(([l, suyos]) => nombreLinea(l, st.lang) + (suyos.length ? ` ${C.con} ${suyos.map(x => nombreLinea(x, st.lang)).join(', ')}` : '')).join('; ')) + (regalo ? ' ' + regalo : ''), claveWeb('bolsa', bs.map(([l]) => sinTocar(l))));
}
function renderCartDrop(st) {
  const C = T[st.lang].cart, F = T[st.lang].ficha, total = st.cart.reduce((s, l) => s + l.p, 0);
  const foto = r => fotoDe(st, r, 100) ? `<img src="${fotoDe(st, r, 100)}" alt="">` : '';
  const fila = l => { const r = ROWS[l.n]; return `<div class="cd-r"><span class="im">${foto(r)}</span><span class="t">${esc(tituloDe(r, st.lang))}${l.o ? `<small>${esc(l.o)}</small>` : ''}</span><span class="price">${fmt(l.p)}</span><button type="button" class="cd-x" data-rm="${l.id}" aria-label="${C.remove}">×</button></div>`; };
  // cada aparato con lo suyo debajo y un poco más adentro: lo que ya lleva y, de lo que aún no lleva, su desplegable con las opciones
  // y su botón de añadir (Sergio, 20 oct: «si está el iPhone, el iPhone en primera línea y, como si fuese una sangría, los productos
  // abajo un poco más adelantados, para que se entienda que esos van en el bloque del iPhone»)
  const sugerencia = (l, {kx, opciones}) => {
    const o = opciones[st.bolsaOpc[l.id + kx] || 0] || opciones[0];
    const nombre = opciones.length > 1
      ? `<select class="cd-sel" aria-label="${esc(nombreClase(F, ROWS[l.n], kx))}">${opciones.map((x, j) => `<option value="${j}"${x === o ? ' selected' : ''}>${esc(x.c)}</option>`).join('')}</select>`
      : `<span class="t">${esc(o.c)}</span>`;
    return `<div class="cd-s" data-de="${l.id}" data-clase="${kx}"><span class="im">${foto(ROWS[o.n])}</span><span class="cd-sv"><small>${esc(nombreClase(F, ROWS[l.n], kx))}</small>${nombre}</span><span class="cd-sb"><span class="price">${fmt(o.p)}</span><button type="button" class="cd-anadir" data-anade-clase="${kx}">${F.anadir}</button></span></div>`;
  };
  const bloque = ([l, suyos]) => {
    const faltan = clasesDe(st, ROWS[l.n], l.o).filter(c => !suyos.some(s => claseDe(ROWS[s.n]) === c.kx));
    const sub = suyos.map(fila).join('') + (faltan.length ? `<p class="cd-mt">${F.protege}</p>` + faltan.map(c => sugerencia(l, c)).join('') : '');
    return `<div class="cd-b">${fila(l)}${sub ? `<div class="cd-sub">${sub}</div>` : ''}</div>`;
  };
  const qr = !!(st.qrBolsa && !st.isPhone && st.cart.length);
  st.cartdrop.innerHTML = `<p class="cd-t">${C.title}<small>${st.cart.length ? C.n(st.cart.length) : ''}</small></p>` + (st.cart.length
    ? `<div class="cd-list">${bloques(st).map(bloque).join('')}</div>
       <p class="cd-sum"><span>${C.total}</span><b class="price">${fmt(total)}</b></p>
       <p class="cd-envio">${C.envio(PORTES)}</p>
       ${JMRegalo.casilla(st.lang)}<div class="cd-act"><a class="btn cd-wa" href="#"><svg><use href="#jm-wa"/></svg>${C.wa}</a>${REAL ? '' : `<button type="button" class="cd-pay">${C.pay}</button>`}</div>
       ${qr ? panelQr(st, mensajeBolsa(st)) : ''}`
    : `<p class="cd-empty">${C.empty}</p>`);
  // (con el QR abierto, la lista más corta: que la bolsa quepa entera)
  st.cartdrop.classList.toggle('con-qr', qr);
}
// otra opción en un desplegable de la bolsa: se recuerda y se repinta la bolsa (su foto y su precio). La casilla del regalo, igual: se
// repinta (que el QR abierto lleve el mensaje nuevo) y el regalo se envuelve o se desenvuelve
function onBolsaCambio(st, e) {
  const regalo = e.target.closest && e.target.closest('.cartdrop .nv-regalo input');
  if (regalo) {
    // (el foco vuelve a la casilla nueva solo si lo tenía la de antes: con el teclado)
    const conFoco = document.activeElement === regalo;
    JMRegalo.marcar(regalo.checked);
    renderCartDrop(st);
    const nueva = st.cartdrop.querySelector('.nv-regalo input'); if (nueva && conFoco) nueva.focus({preventScroll: true});
    JMRegalo.animar(st.cartdrop);
    return true;
  }
  const sel = e.target.closest && e.target.closest('.cartdrop .cd-sel');
  if (!sel) return false;
  const fila = sel.closest('.cd-s');
  st.bolsaOpc[+fila.dataset.de + fila.dataset.clase] = +sel.value;
  renderCartDrop(st);
  const nuevo = st.cartdrop.querySelector(`.cd-s[data-de="${fila.dataset.de}"][data-clase="${fila.dataset.clase}"] .cd-sel`);
  if (nuevo) nuevo.focus({preventScroll: true});
  return true;
}
function openCart(st) {
  closeHS(st); closeAssist(st);
  // el aviso de lo último que has añadido, fuera: lo que dice ya se ve en la bolsa
  st.toast.classList.remove('show');
  const R = st.root.getBoundingClientRect(), hd = st.hd.getBoundingClientRect();
  st.cartdrop.style.top = (hd.bottom - R.top) + 'px';
  // como mucho hasta abajo de la pantalla (con el QR abierto no cabe en una de portátil): lo que sobra, desplazando la bolsa
  st.cartdrop.style.maxHeight = Math.max(260, Math.min(R.bottom, innerHeight) - hd.bottom - 12) + 'px';
  renderCartDrop(st);
  st.root.classList.add('cart-open');
}
function closeCart(st) { st.root.classList.remove('cart-open'); st.qrBolsa = false; }

/* ---------- la cara de la entrada: guiña con chispa y, al bajar, vuela a su esquina ---------- */
function placeFace(st) {
  if (!st.hface) return;
  const ph = st.hero.querySelector('.hface-ph'); if (!ph) return;
  const R = st.root.getBoundingClientRect(), a = ph.getBoundingClientRect(), hdB = st.hd.getBoundingClientRect().bottom - R.top, fijo = !!(st.faceForced || st.page);
  // en el móvil la cara va dentro del hero y se desplaza con la página, sin capa fija (Sergio, 22 oct: en el iPhone se quedaba
  // clavada y pisaba el titular). Al empezar a bajar vuela a su esquina de una vez, como en el ordenador (vueloMovil; Sergio, 22 oct,
  // tarde: «en el teléfono no hace la animación de irse abajo a la derecha como el genio»); al subir se queda en la esquina hasta que su
  // hueco está entero a la vista y aparece ahí con un fundido
  if (st.isPhone) {
    if (st.vuelo) return;
    if (st.faceHome) {
      if (!fijo && a.top - R.top >= hdB + 6) {
        st.faceBase = st.sc.scrollTop;
        st.hface.classList.add('fading'); clearTimeout(st.fadeT); st.fadeT = setTimeout(() => st.hface.classList.remove('fading'), 350);
        faceState(st, false);
      }
      return;
    }
    if (st.page) return faceState(st, true);  // (con una página abierta la cara grande no se ve: a la esquina sin viaje)
    if (fijo || st.sc.scrollTop - (st.faceBase || 0) > 24 || a.bottom - R.top - hdB <= a.height * 0.4) return vueloMovil(st);
    if (st.faceHome !== false) faceState(st, false);  // (al entrar: la grande en el hero y el botón escondido)
    return;
  }
  const f = st.fab.getBoundingClientRect(), holeOut = a.top - R.top < hdB + 6;
  // vuela en cuanto empiezas a bajar, para no pasearse por encima de la lista; con una página abierta, está en su esquina.
  // Al subir no vuelve volando (cruzaba el texto, Sergio, 22 oct): se queda en la esquina hasta que su hueco está entero a la vista
  // y aparece ahí con un fundido; el siguiente vuelo arranca desde donde ha reaparecido. Con «reducir movimiento», o en el hueco o
  // en la esquina, sin recorrido
  let k, fade = false;
  if (fijo) k = 1;
  else if (reduce) k = holeOut ? 1 : 0;
  else if (st.facePark) { if (holeOut) k = 1; else { st.facePark = false; st.faceBase = st.sc.scrollTop; fade = true; k = 0; } }
  else k = clamp((st.sc.scrollTop - (st.faceBase || 0)) / 190, 0, 1);
  const e = k < 0.5 ? 2 * k * k : 1 - (-2 * k + 2) ** 2 / 2;
  // encoge y se va al margen derecho deprisa, y luego baja ya pequeña: así casi no pasa por delante de nada.
  // nunca sube por encima del borde de la cabecera
  const es = 1 - (1 - k) ** 4, h0 = a.height, h1 = f.height * 0.68, h = h0 + (h1 - h0) * es, w = h * 588 / 707;
  const x0 = a.left + a.width / 2 - R.left, y0 = a.top + a.height / 2 - R.top, x1 = f.left + f.width / 2 - R.left, y1 = f.top + f.height / 2 - R.top;
  const cx = x0 + (x1 - x0) * es, cy = Math.max(y0 + (y1 - y0) * e - Math.sin(Math.PI * e) * 24, hdB + 6 + h / 2);
  st.hface.style.width = w + 'px'; st.hface.style.height = h + 'px';
  st.hface.style.transform = `translate(${(cx - w / 2).toFixed(1)}px, ${(cy - h / 2).toFixed(1)}px) rotate(${(-Math.sin(Math.PI * e) * 11).toFixed(2)}deg)`;
  const arrived = e > 0.995;
  if (fade) { st.hface.classList.add('fading'); clearTimeout(st.fadeT); st.fadeT = setTimeout(() => st.hface.classList.remove('fading'), 350); }
  st.hface.classList.toggle('aloft', e > 0.005 && !arrived);
  faceState(st, arrived);
  if (arrived && !st.faceForced) st.facePark = true;
  st.hface.querySelector('.hbub-w').style.opacity = (1 - clamp(k * 8, 0, 1)).toFixed(2);
}
// el viaje del móvil: una copia de la cara sale de donde está, encoge y se va al margen derecho deprisa, y baja en curva hasta el botón
// (el mismo camino que placeFace en el ordenador). Es de una vez, no va atada al dedo: atada al desplazamiento, en el iPhone se quedaba
// clavada. Al llegar, el botón da su saltito; con «reducir movimiento», sin viaje
function vueloMovil(st, alAcabar) {
  if (st.vuelo) return;
  const llegar = () => { st.vuelo = false; faceState(st, true); if (alAcabar) alAcabar(); };
  const R = st.root.getBoundingClientRect(), a = st.hface.getBoundingClientRect(), f = st.fab.getBoundingClientRect();
  if (reduce || !a.width || !f.width || typeof st.hface.animate !== 'function') return llegar();
  st.vuelo = true;
  const g = st.hface.cloneNode(true);
  g.classList.remove('gone', 'saying', 'fading', 'flying');
  g.classList.add('vuelo', 'aloft');
  g.removeAttribute('id');
  Object.assign(g.style, {position: 'absolute', left: '0', top: '0', margin: '0', width: a.width + 'px', height: a.height + 'px', zIndex: '8',
    transform: `translate(${(a.left - R.left).toFixed(1)}px, ${(a.top - R.top).toFixed(1)}px)`});
  st.root.appendChild(g);
  // (la grande se va de golpe, sin su fundido: si no, se ven dos caras un momento)
  st.hface.style.transition = 'none';
  st.hface.classList.add('gone');
  void st.hface.offsetWidth;
  st.hface.style.transition = '';
  const s1 = f.height * 0.68 / a.height, cx0 = a.left + a.width / 2 - R.left, cy0 = a.top + a.height / 2 - R.top;
  const cx1 = f.left + f.width / 2 - R.left, cy1 = f.top + f.height / 2 - R.top, cuadros = [];
  for (let i = 0; i <= 18; i++) {
    const k = i / 18, e = k < 0.5 ? 2 * k * k : 1 - (-2 * k + 2) ** 2 / 2, es = 1 - (1 - k) ** 4, s = 1 + (s1 - 1) * es;
    const cx = cx0 + (cx1 - cx0) * es, cy = cy0 + (cy1 - cy0) * e - Math.sin(Math.PI * e) * 24;
    cuadros.push({transform: `translate(${(cx - a.width / 2).toFixed(1)}px, ${(cy - a.height / 2).toFixed(1)}px) scale(${s.toFixed(4)}) rotate(${(-Math.sin(Math.PI * e) * 11).toFixed(2)}deg)`});
  }
  const an = g.animate(cuadros, {duration: 560, easing: 'linear', fill: 'forwards'});
  an.onfinish = () => { g.remove(); llegar(); };
  an.oncancel = () => { g.remove(); llegar(); };
}
// la cara grande se va (.gone) y la de la esquina aparece, o al revés; el botón da un saltito al llegar
function faceState(st, arrived) {
  const was = st.faceHome;
  st.faceHome = arrived;
  st.hface.classList.toggle('gone', arrived);
  st.fab.classList.toggle('waiting', !arrived);
  if (arrived && !was && !reduce) st.fab.animate([{transform:'scale(.7)'}, {transform:'scale(1.1)', offset:.55}, {transform:'scale(1)'}], {duration:260, easing:'ease-out'});
}
function startWink(st) {
  const f = st.hface && st.hface.querySelector('.face');
  if (!f || st.faceHome || f.classList.contains('winking')) return;
  f.classList.add('winking');
  st.hface.classList.add('saying');
  if (reduce) return;
  const A = (n, k, o) => n.animate(k, Object.assign({fill:'both'}, o));
  A(f.querySelector('.head'), [{transform:'translateY(0) rotate(0)'}, {transform:'translateY(26px) rotate(-2.4deg)', offset:.42}, {transform:'translateY(-6px) rotate(.6deg)', offset:.76}, {transform:'none'}], {duration:400, easing:'ease-out'});
  const sp = f.querySelector('.spark');
  A(sp.querySelector('.halo'), [{opacity:0, transform:'scale(.3)'}, {opacity:.95, transform:'scale(1)', offset:.35}, {opacity:0, transform:'scale(1.25)'}], {delay:60, duration:420, easing:'ease-out'});
  A(sp.querySelector('.ring'), [{opacity:0, transform:'scale(.3)'}, {opacity:.95, transform:'scale(.42)', offset:.08}, {opacity:0, transform:'scale(1.65)'}], {delay:75, duration:380});
  A(sp.querySelector('.rays'), [{opacity:0, transform:'scale(.5) rotate(-8deg)'}, {opacity:1, transform:'scale(1) rotate(0)', offset:.35}, {opacity:0, transform:'scale(1.2) rotate(6deg)'}], {delay:85, duration:340});
  A(sp.querySelector('.st1'), [{opacity:0, transform:'scale(0) rotate(-30deg)'}, {opacity:1, transform:'scale(1.15) rotate(10deg)', offset:.4}, {opacity:0, transform:'scale(.2) rotate(45deg)'}], {delay:70, duration:400});
  A(sp.querySelector('.st2'), [{opacity:0, transform:'scale(0)'}, {opacity:1, transform:'scale(1.1) rotate(20deg)', offset:.45}, {opacity:0, transform:'scale(.2) rotate(40deg)'}], {delay:130, duration:330});
  A(sp.querySelector('.st3'), [{opacity:0, transform:'scale(0)'}, {opacity:1, transform:'scale(1)', offset:.5}, {opacity:0, transform:'scale(.3)'}], {delay:170, duration:280});
  const bub = st.hface.querySelector('.hbub');
  if (st.hface.classList.contains('g-comic')) A(bub, [{transform:'scale(1)'}, {transform:'scale(1.08)', offset:.4}, {transform:'scale(1)'}], {duration:320, easing:'ease-out'});
}
function endWink(st) {
  const f = st.hface && st.hface.querySelector('.face');
  if (f) f.classList.remove('winking');
  if (st.hface) st.hface.classList.remove('saying');
}
// el saludo: el de chat se escribe primero («...») y el de «solo al saludar» en el móvil se enseña un momento
function greetIntro(st) {
  const h = st.hface;
  if (h.classList.contains('g-chat')) { h.classList.add('typing'); setTimeout(() => h.classList.remove('typing'), reduce ? 0 : 1400); }
  if (h.classList.contains('g-hover') && st.isPhone) { h.classList.add('saying'); setTimeout(() => h.classList.remove('saying'), 3200); }
}
// tocar la cara grande: vuela a su esquina y el asistente se abre desde su ojo; al cerrarlo, vuelve
function faceToAssist(st) {
  // (en el móvil, el mismo viaje de una vez y, al llegar, el asistente sale del botón)
  if (st.faceHome) return openAssist(st);
  if (st.isPhone) { st.faceForced = true; return vueloMovil(st, () => openAssist(st)); }
  st.faceForced = true;
  st.hface.classList.add('flying');
  placeFace(st);
  setTimeout(() => { st.hface.classList.remove('flying'); openAssist(st); }, reduce ? 0 : 520);
}
// al cerrar el asistente, la vuelta: lo mismo que la ida, al revés (Sergio, 21 oct: «la cara vuelve instantánea… haz que haga lo mismo
// pero al revés»). Antes volvía invisible (heredaba el retraso de la ida) y aparecía de golpe al llegar: ahora sale de la esquina ya
// visible, crece mientras vuelve y el bocadillo sale cuando ha llegado
function faceBack(st) {
  if (!st.faceForced) return;
  st.faceForced = false; st.facePark = false;
  if (st.isPhone) return placeFace(st);
  st.hface.classList.add('flying', 'vuelve');
  placeFace(st);
  if (!st.faceHome) { st.hface.classList.add('aloft'); st.hface.querySelector('.hbub-w').style.opacity = 0; }
  setTimeout(() => { st.hface.classList.remove('flying', 'vuelve'); placeFace(st); }, reduce ? 0 : 560);
}

/* ---------- la bolsa cae la última: la tienda ya está montada ---------- */
function dropBag(st, t) {
  const g = st.bagG;
  if (t <= 0) { g.setAttribute('opacity', 0); st.bagLanded = false; return; }
  if (t >= 1) {
    g.removeAttribute('transform'); g.setAttribute('opacity', 1);
    if (!st.bagLanded) { st.bagLanded = true; wink(st); }
    return;
  }
  st.bagLanded = false;
  const F = t < 0.8 ? (t / 0.8) ** 2 : 1 - 0.06 * Math.sin(Math.PI * (t - 0.8) / 0.2);
  const [ax, ay] = P(...bagAt()), [ox, oy] = originOf(st, 'taulell');
  const dx = (ox - ax) * (1 - F), dy = (oy - ay) * (1 - F), s = 0.5 + 0.5 * Math.min(1, F);
  g.setAttribute('transform', `translate(${dx.toFixed(1)} ${dy.toFixed(1)}) translate(${ax.toFixed(1)} ${ay.toFixed(1)}) scale(${s.toFixed(3)}) translate(${(-ax).toFixed(1)} ${(-ay).toFixed(1)})`);
  g.setAttribute('opacity', Math.min(1, t * 8).toFixed(2));
}

})();
